//@ts-nocheck
import {
  JSXElementConstructor,
  Key,
  ReactElement,
  ReactNode,
  ReactPortal,
  useEffect,
  useRef,
  useState,
} from "react";
import {
  Card,
  Grid,
  CardContent,
  Typography,
  Divider,
  Button,
  FormControlLabel,
  Checkbox,
  Tab,
  Tabs,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  Paper,
  Chip,
  Avatar,
  Stack,
} from "@mui/material";

import "./style.css";

import { DataGrid, GridColDef, GridToolbar } from "@mui/x-data-grid";

import { PieChart } from "@mui/x-charts/PieChart";
import api from "../../utils/Url";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useTranslation } from "react-i18next";
import PrintIcon from "@mui/icons-material/Print";
import {
  GoogleMap,
  InfoWindow,
  LoadScript,
  Marker,
  Polyline,
} from "@react-google-maps/api";
import Tracking from "./Tracking";
import Geofacing from "./Geofacing";
import Kudaghar from "./Kudaghar";
import VehicleHistory from "./VehicleHistory";
import VehicleTravelled from "./VehicleTravelled";
import ProgressBar from "@ramonak/react-progress-bar";

import DashboardIcon from "@mui/icons-material/Dashboard";
import GpsFixedIcon from "@mui/icons-material/GpsFixed";
import PlaceIcon from "@mui/icons-material/Place";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import CarCrashIcon from "@mui/icons-material/CarCrash";
import EmojiTransportationIcon from "@mui/icons-material/EmojiTransportation";
import { motion, useSpring } from "framer-motion";
import CircularProgress from "@mui/material/CircularProgress";
import CloseIcon from "@mui/icons-material/Close";
import * as XLSX from "xlsx";
import {
  FaClock,
} from "react-icons/fa";

import {
  ListAlt,
  DirectionsCar,
  Work,
  DirectionsBike,
  CheckCircle,
  LocalGasStation,
  ReportProblem,
} from "@mui/icons-material";
import PersonIcon from "@mui/icons-material/Person";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "95%",
  height: "85%",
  bgcolor: "#f5f5f5",
  border: "1px solid #000",
  boxShadow: 24,
  p: 4,
  borderRadius: 10,
};
const dotStyle = {
  width: 12,
  height: 12,
  borderRadius: "50%",
  backgroundColor: "#1976D2",
  margin: "0 5px",
  display: "inline-block",
};

const containerStyle = {
  width: "100%",
  height: "500px",
};

interface Department {
  dept_id: number;
  dept_name: string;
  session_year: string;
}

export default function HomePage() {
  const [chartData, setChartData] = useState<any>([]);

  const [labelsData, setlabelsData] = useState<any>([]);

  const { t } = useTranslation();

  const [zones, setZones] = useState([]);
  const [columns, setColumns] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(true);

  const [currentMap, setCurrentMap] = useState(false);

  const [isVisible, setVisible] = useState(false);

  const [zones1, setZones1] = useState([]);
  const [columns1, setColumns1] = useState<any>([]);
  const [isLoading1, setIsLoading1] = useState(true);
  const [isChartLoading, setChartIsLoading] = useState(true);

  const [zones2, setZones2] = useState([]);
  const [columns2, setColumns2] = useState<any>([]);
  const [isLoading2, setIsLoading2] = useState(true);

  const [zones3, setZones3] = useState([]);
  const [columns3, setColumns3] = useState<any>([]);
  const [isLoading3, setIsLoading3] = useState(true);

  const [zones4, setZones4] = useState([]);
  const [columns4, setColumns4] = useState<any>([]);
  const [isLoading4, setIsLoading4] = useState(true);

  const [zones5, setZones5] = useState([]);
  const [columns5, setColumns5] = useState<any>([]);
  const [isLoading5, setIsLoading5] = useState(true);

  const [zones9, setZones9] = useState([]);
  const [columns9, setColumns9] = useState<any>([]);
  const [isLoading9, setIsLoading9] = useState(true);

  const [getTop, setGetTop] = useState(false);
  const [getTop1, setGetTop1] = useState(false);

  // UPDATED: Vehicle running status states from new API
  const [isRunn, setRunn] = useState<any>(0);
  const [isIdle, setIdle] = useState<any>(0);
  const [isStop, setStop] = useState<any>(0);
  const [totalVeh, setTotalVeh] = useState<any>(0);
  const [onRoadVeh, setOnRoadVeh] = useState<any>(0);
  const [gpsStatus, setGpsStatus] = useState<any>(0);
  const [totalDistance, setTotalDistance] = useState<any>(0);
  const [isModal, setModal] = useState<any>(false);
  const [isModal1, setModal1] = useState<any>(false);

  const [itemId, setItemId] = useState<any>();

  // New states for card modals
  const [fuelConsumedOpen, setFuelConsumedOpen] = useState(false);
  const [longIdleOpen, setLongIdleOpen] = useState(false);
  const [wireTemperingOpen, setWireTemperingOpen] = useState(false);
  const [fuelConsumedCount, setFuelConsumedCount] = useState(0);
  const [longIdleCount, setLongIdleCount] = useState(0);
  const [wireTemperingCount, setWireTemperingCount] = useState(0);

  const [accordionExpanded, setAccordionExpanded] = useState<any>({});
  const handleAccordionToggle = (index: any, isExpanded: any) => {
    setAccordionExpanded((prev: any) => ({
      ...prev,
      [index]: !prev[index],
    }));

    if (isExpanded) {
      if (index === 0) {
        FuelconsData();
      } else if (index === 1) {
        IdleData();
      } else if (index === 2) {
        TodayVData();
      } else if (index === 3) {
        fetchZonesData();
      }
    } else {
      console.log("function is not working");
    }
  };

  const [value, setValue] = useState<any>(
    parseInt(localStorage.getItem("dash") || "0", 10)
  );

  useEffect(() => {
    localStorage.setItem("dash", value.toString() || "0");
  }, [value]);

  const [isTable, setTable] = useState([]);
  const [isPrint, setPrint] = useState([]);
  const [isPrint1, setPrint1] = useState([]);

  const [isLabel, setlabel] = useState("");
  const [isStatus, setStatus] = useState<any>("");
  const [isStatus1, setStatus1] = useState("");

  const [engineOnCount, setEngineOnCount] = useState(0);
  const [engineOffCount, setEngineOffCount] = useState(0);

  const downloadExcel = () => {
    if (!isPrint || isPrint.length === 0) {
      console.error("No data to export to Excel.");
      return;
    }

    const ws = XLSX.utils.json_to_sheet(isPrint);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "vehicles");
    XLSX.writeFile(wb, "FuelConsumed.xlsx");
  };

  const downloadExcel1 = () => {
    if (!isPrint1 || isPrint1.length === 0) {
      console.error("No data to export to Excel.");
      return;
    }

    const ws = XLSX.utils.json_to_sheet(isPrint1);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "vehicles");
    XLSX.writeFile(wb, "Long_Idle.xlsx");
  };

  const handleTab = (event: any, newValue: any) => {
    console.log(newValue);
    setValue(newValue);
  };

  const items = [
  { 
    id: 0, 
    text: <strong>{t("text.Dashboard")}</strong>, 
    icon: <DashboardIcon sx={{ color: "#1976d2" }} /> 
  },
  { 
    id: 1, 
    text: <strong>{t("text.Tracking")}</strong>, 
    icon: <GpsFixedIcon sx={{ color: "#388e3c" }} /> 
  },
  { 
    id: 2, 
    text: <strong>{t("text.GeofacingCreate")}</strong>, 
    icon: <PlaceIcon sx={{ color: "#fbc02d" }} /> 
  },
  { 
    id: 3, 
    text: <strong>{t("text.KudagharLocation")}</strong>, 
    icon: <DeleteForeverIcon sx={{ color: "#d32f2f" }} /> 
  },
  { 
    id: 4, 
    text: <strong>{t("text.VehicleHistory")}</strong>, 
    icon: <CarCrashIcon sx={{ color: "#f57c00" }} /> 
  },
  { 
    id: 5, 
    text: <strong>{t("text.VehicleTravelled")}</strong>, 
    icon: <EmojiTransportationIcon sx={{ color: "#0288d1" }} /> 
  },
];

  const formatTrackTime = (tracktime: string) => {
    const trackTime = new Date(tracktime);
    if (isNaN(trackTime.getTime())) {
      return "Invalid Date";
    }

    const day = trackTime.getDate().toString().padStart(2, "0");
    const month = (trackTime.getMonth() + 1).toString().padStart(2, "0");
    const year = trackTime.getFullYear();
    const hours = trackTime.getHours().toString().padStart(2, "0");
    const minutes = trackTime.getMinutes().toString().padStart(2, "0");
    const seconds = trackTime.getSeconds().toString().padStart(2, "0");

    return `${day}-${month}-${year} (Time:- ${hours}:${minutes}:${seconds})`;
  };

  const [vehicles, setVehicles] = useState<any>([]);
  const [activeVehicle, setActiveVehicle] = useState<any>(null);
  const [center, setCenter] = useState({ lat: 26.447965, lng: 80.3432 });
  const mapRef: any = useRef(null);

  useEffect(() => {
    if (window.google && window.google.maps) {
      console.log("Google Maps API loaded");
    } else {
      console.error("Google Maps API not loaded");
    }
  }, []);

  // Function to get individual vehicle location data from DayVehOne API
  const getVehicleLocationData = async (itemMasterId: number, vehicleNo: string) => {
    try {
      const currentDate = new Date().toISOString();
      
      const requestData = {
        itemMasterId: itemMasterId,
        vehicleNo: vehicleNo,
        dayDate: currentDate
      };

      const response = await api.post(`Mng/DayVehOne`, requestData);
      const data = response?.data?.data || [];

      if (data.length > 0) {
        const arr = data.map((item: any, index: number) => ({
          lat: item.lattitude,
          lng: item.longitude,
          id: item.id || `vehicle-${itemMasterId}-${index}`,
          speed: item.speed || 0,
          tracktime: formatTrackTime(item.trackTime),
          distance: item.distance || 0,
          nearme: item?.nearme || "Unknown",
          vehicleNo: item.vehicleNo || vehicleNo,
          icon:
            item.speed === 0 || item.speed === 0
              ? "https://png.pngtree.com/png-vector/20240128/ourmid/pngtree-red-truck-transportation-png-image_11507611.png"
              : "https://png.pngtree.com/png-vector/20240128/ourmid/pngtree-green-truck-transport-png-image_11508688.png",
        }));
        
        setVehicles(arr);
        setCenter(calculateCenter(arr));
        setCurrentMap(true);
        
        if (arr.length > 0 && mapRef.current) {
          adjustZoomLevel(arr);
        }
      } else {
        // If no data from DayVehOne, try to use current vehicle data
        const vehicleData = zones3.find((v: any) => v.itemmasterid === itemMasterId);
        if (vehicleData) {
          const arr = [{
            lat: vehicleData.lattitude,
            lng: vehicleData.longitude,
            id: `vehicle-${itemMasterId}-single`,
            speed: vehicleData.speed || 0,
            tracktime: formatTrackTime(vehicleData.trackTime),
            distance: vehicleData.distance || 0,
            nearme: vehicleData?.nearme || "Unknown",
            vehicleNo: vehicleData.vehicleNo,
            icon:
              vehicleData.speed === 0 || vehicleData.speedDecimal === 0
                ? "https://png.pngtree.com/png-vector/20240128/ourmid/pngtree-red-truck-transportation-png-image_11507611.png"
                : "https://png.pngtree.com/png-vector/20240128/ourmid/pngtree-green-truck-transport-png-image_11508688.png",
          }];

          setVehicles(arr);
          setCenter({ lat: vehicleData.lattitude, lng: vehicleData.longitude });
          setCurrentMap(true);

          if (arr.length > 0 && mapRef.current) {
            const bounds = new window.google.maps.LatLngBounds();
            bounds.extend(new window.google.maps.LatLng(vehicleData.lattitude, vehicleData.longitude));
            mapRef.current.fitBounds(bounds);
          }
        }
      }
    } catch (error) {
      console.error("Error fetching vehicle location data:", error);
      
      // Fallback to current vehicle data
      const vehicleData = zones3.find((v: any) => v.itemmasterid === itemMasterId);
      if (vehicleData) {
        const arr = [{
          lat: vehicleData.lattitude,
          lng: vehicleData.longitude,
          id: `vehicle-${itemMasterId}-fallback`,
          speed: vehicleData.speed || 0,
          tracktime: formatTrackTime(vehicleData.trackTime),
          distance: vehicleData.distance || 0,
          nearme: vehicleData?.nearme || "Unknown",
          vehicleNo: vehicleData.vehicleNo,
          icon:
            vehicleData.speed === 0 || vehicleData.speedDecimal === 0
              ? "https://png.pngtree.com/png-vector/20240128/ourmid/pngtree-red-truck-transportation-png-image_11507611.png"
              : "https://png.pngtree.com/png-vector/20240128/ourmid/pngtree-green-truck-transport-png-image_11508688.png",
        }];

        setVehicles(arr);
        setCenter({ lat: vehicleData.lattitude, lng: vehicleData.longitude });
        setCurrentMap(true);
      }
    }
  };

  // Function to handle vehicle number click in the table
  const handleVehicleNumberClick = (row: any) => {
    if (row.itemmasterid) {
      getVehicleLocationData(row.itemmasterid, row.vehicleNo);
    }
  };

  const calculateCenter = (vehicles: any) => {
    if (vehicles.length === 0) {
      return { lat: 26.447965, lng: 80.3432 };
    }

    const latitudes = vehicles.map((vehicle: any) => vehicle.lat);
    const longitudes = vehicles.map((vehicle: any) => vehicle.lng);

    const avgLat =
      latitudes.reduce((sum: any, lat: any) => sum + lat, 0) / latitudes.length;
    const avgLng =
      longitudes.reduce((sum: any, lng: any) => sum + lng, 0) /
      longitudes.length;

    return { lat: avgLat, lng: avgLng };
  };

  // Adjust the zoom level based on the spread of the vehicles
  const adjustZoomLevel = (vehicles: any) => {
    const bounds = new window.google.maps.LatLngBounds();

    vehicles.forEach((vehicle: any) => {
      bounds.extend(new window.google.maps.LatLng(vehicle.lat, vehicle.lng));
    });

    if (mapRef.current) {
      mapRef.current.fitBounds(bounds);
    }
  };

  const handleMarkerMouseOver = (vehicle: any) => {
    setActiveVehicle(vehicle);
  };

  const handleMarkerMouseOut = () => {
    setActiveVehicle(null);
  };

  useEffect(() => {
    getZoneData();

    const interval = setInterval(() => {
      getZoneData();
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const handleClose = () => {
    setModal(false);
  };

  const handleClose1 = () => {
    setModal1(false);
  };

  const handleClose2 = () => {
    setVisible(false);
  };

  // Modal handlers for new cards
  const handleFuelConsumedOpen = () => {
    setFuelConsumedOpen(true);
    FuelconsData();
  };

  const handleFuelConsumedClose = () => {
    setFuelConsumedOpen(false);
  };

  const handleLongIdleOpen = () => {
    setLongIdleOpen(true);
    IdleData();
  };

  const handleLongIdleClose = () => {
    setLongIdleOpen(false);
  };

  const handleWireTemperingOpen = () => {
    setWireTemperingOpen(true);
    fetchZonesData();
  };

  const handleWireTemperingClose = () => {
    setWireTemperingOpen(false);
  };

  const zoneModal = async (Zone: any) => {
    setlabel(Zone.label);
    try {
      const response = await api.get(`NTRead/GetTopFuelConsNTS/zone=${Zone.label}`);
      const data = response.data.data;

      const zonesWithIds = data.map((zone: any, index: any) => ({
        ...zone,
        serialNo: index + 1,
        id: index + 1,
      }));
      setZones9(zonesWithIds);
      setIsLoading9(false);

      if (data.length > 0) {
        const columns9: GridColDef[] = [
          {
            field: "serialNo",
            headerName: t("text.SrNo"),
            flex: 0.5,
            cellClassName: "wrap-text",
          },
          {
            field: "vehicleNo",
            headerName: t("text.VehicleNo"),
            flex: 1,
            cellClassName: "wrap-text",
          },
          {
            field: "driver",
            renderHeader: () => (
              <>
                <PersonIcon
                  style={{ marginRight: 8, verticalAlign: "middle" }}
                />
                <span style={{ verticalAlign: "middle" }}>
                  {t("text.Driver")}
                </span>
              </>
            ),
            flex: 1.5,
            renderCell: (params) => {
              const { empName, empMobileNo } = params.row;
              return `${empName} (${empMobileNo})`;
            },
          },
          {
            field: "departmentName",
            headerName: t("text.DepartmentName"),
            flex: 1,
            cellClassName: "wrap-text",
          },
          {
            field: "vehicleTypename",
            headerName: t("text.VehicleTypeName"),
            flex: 1,
            cellClassName: "wrap-text",
          },
          {
            field: "flag",
            headerName: t("text.Status"),
            flex: 1,
            cellClassName: "wrap-text",
            align: "center",
            headerAlign: "center",
          },
          {
            field: "speed",
            headerName: t("text.Speed"),
            flex: 0.5,
            cellClassName: "wrap-text",
          },
          {
            field: "fuel",
            headerName: "Fuel",
            flex: 1,
            align: "center",
            headerAlign: "center",
            valueFormatter: ({ value }) => (value ? value.toFixed(2) : ""),
            cellClassName: "wrap-text",
          },
        ];
        setColumns9(columns9 as any);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const adjustedColumns10 = columns9.map((column: any) => ({
    ...column,
  }));

  // UPDATED: Fixed ignition data function with correct status display
  const IgnitionData = async (value: boolean) => {
    setModal1(true);
    setIsLoading5(true);
    try {
      console.log("Check value", value);
      const statusText = value ? "ON" : "OFF";
      setStatus(statusText);

      const response = await api.get(`Mng/EngineOnOff?onoff=${value}`);
      const data = response.data.data || [];

      const zonesWithIds = data.map((zone: any, index: any) => ({
        ...zone,
        serialNo: zone.sno || index + 1,
        id: zone.itemmasterid || index + 1,
        vehicleNo: zone.vehicleno,
        driver: zone.driver,
        acc: zone.acc ? "On" : "Off"
      }));

      setZones5(zonesWithIds);
      setIsLoading5(false);

      if (data.length > 0) {
        const columns2: GridColDef[] = [
          {
            field: "serialNo",
            renderHeader: () => (
              <>
                <ListAlt style={{ marginRight: 8, verticalAlign: "middle" }} />
                <span style={{ verticalAlign: "middle" }}>
                  {t("text.SrNo")}
                </span>
              </>
            ),
            cellClassName: "wrap-text",
            flex: 0.3,
            valueGetter: (params) => params.row.sno || params.row.serialNo,
          },
          {
            field: "vehicleNo",
            renderHeader: () => (
              <>
                <DirectionsCar
                  style={{ marginRight: 8, verticalAlign: "middle" }}
                />
                <span style={{ verticalAlign: "middle" }}>
                  {t("text.VehicleNo")}
                </span>
              </>
            ),
            cellClassName: "wrap-text",
            flex: 1,
            valueGetter: (params) => params.row.vehicleno || params.row.vehicleNo,
          },
          {
            field: "driver",
            cellClassName: "wrap-text",
            renderHeader: () => (
              <>
                <PersonIcon
                  style={{ marginRight: 8, verticalAlign: "middle" }}
                />
                <span style={{ verticalAlign: "middle" }}>
                  {t("text.Driver")}
                </span>
              </>
            ),
            flex: 1.5,
            valueGetter: (params) => params.row.driver,
          },
          {
            field: "acc",
            renderHeader: () => (
              <>
                <CheckCircle
                  style={{ marginRight: 8, verticalAlign: "middle" }}
                />
                <span style={{ verticalAlign: "middle" }}>
                  {t("text.Status")}
                </span>
              </>
            ),
            cellClassName: "wrap-text",
            flex: 0.5,
            valueGetter: (params) => params.row.acc ? "On" : "Off",
          },
        ];
        setColumns5(columns2 as any);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setIsLoading5(false);
    }
  };

  const adjustedColumns5 = columns5.map((column: any) => ({
    ...column,
    cellClassName: "wrap-text",
  }));

  // UPDATED: Function to fetch running status data from DayVehData API
  const runningData = async (statusType: string) => {
    setStatus1(statusType);
    setModal(true);
    setIsLoading4(true);

    try {
      const statusMap: { [key: string]: number } = {
        "running": 3,
        "idle": 4,
        "stop": 2
      };

      const statusParam = statusMap[statusType] || 1;

      const response = await api.get(`Mng/DayVehData?status=${statusParam}`);
      const data = response.data.data || [];

      const zonesWithIds = data.map((zone: any, index: any) => ({
        ...zone,
        serialNo: index + 1,
        id: index + 1,
        vehicleNo: zone.vehicleNo,
        departmentName: zone.department,
        vehicleTypename: zone.vehicleType || "N/A",
        driver: zone.driver,
        status: statusType.charAt(0).toUpperCase() + statusType.slice(1)
      }));

      setZones4(zonesWithIds);
      setIsLoading4(false);

      if (data.length > 0) {
        const columns2: GridColDef[] = [
          {
            field: "serialNo",
            renderHeader: () => (
              <>
                <ListAlt style={{ marginRight: 8, verticalAlign: "middle" }} />
                <span style={{ verticalAlign: "middle" }}>
                  {t("text.SrNo")}
                </span>
              </>
            ),
            flex: 0.5,
            cellClassName: "wrap-text",
          },
          {
            field: "vehicleNo",
            renderHeader: () => (
              <>
                <DirectionsCar
                  style={{ marginRight: 8, verticalAlign: "middle" }}
                />
                <span style={{ verticalAlign: "middle" }}>
                  {t("text.VehicleNo")}
                </span>
              </>
            ),
            flex: 1,
            cellClassName: "wrap-text",
          },
          {
            field: "driver",
            renderHeader: () => (
              <>
                <PersonIcon
                  style={{ marginRight: 8, verticalAlign: "middle" }}
                />
                <span style={{ verticalAlign: "middle" }}>
                  {t("text.Driver")}
                </span>
              </>
            ),
            flex: 1.5,
            cellClassName: "wrap-text",
            valueGetter: (params) => params.row.driver || "N/A",
          },
          {
            field: "departmentName",
            renderHeader: () => (
              <>
                <Work style={{ marginRight: 8, verticalAlign: "middle" }} />
                <span style={{ verticalAlign: "middle" }}>
                  {t("text.DepartmentName")}
                </span>
              </>
            ),
            flex: 1,
            cellClassName: "wrap-text",
            valueGetter: (params) => params.row.department || "N/A",
          },
          {
            field: "vehicleTypename",
            renderHeader: () => (
              <>
                <DirectionsBike
                  style={{ marginRight: 8, verticalAlign: "middle" }}
                />
                <span style={{ verticalAlign: "middle" }}>
                  {t("text.VehicleTypeName")}
                </span>
              </>
            ),
            flex: 1,
            cellClassName: "wrap-text",
            valueGetter: (params) => params.row.vehicleType || "N/A",
          },
          {
            field: "trackTime",
            renderHeader: () => (
              <>
                <FaClock style={{ marginRight: 8, verticalAlign: "middle" }} />
                <span style={{ verticalAlign: "middle" }}>
                  Last Update
                </span>
              </>
            ),
            flex: 1.5,
            cellClassName: "wrap-text",
            valueGetter: (params) => {
              if (!params.row.trackTime) return "N/A";
              const date = new Date(params.row.trackTime);
              return `${date.getDate().toString().padStart(2, '0')}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getFullYear()} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
            },
          },
        ];
        setColumns4(columns2 as any);
      }
    } catch (error) {
      console.error("Error fetching running status data:", error);
      setIsLoading4(false);
    }
  };

  const adjustedColumns4 = columns4.map((column: any) => ({
    ...column,
  }));

  useEffect(() => {
    fetchEngineStatus();
    setInterval(() => {
      fetchEngineStatus();
    }, 3000);
  }, []);

  // Function to fetch engine status counts
  const fetchEngineStatus = async () => {
    try {
      const onResponse = await api.get(`Mng/EngineOnOff?onoff=true`);
      const onData = onResponse.data.data || [];
      const onCount = onData.length;
      setEngineOnCount(onCount);

      const offResponse = await api.get(`Mng/EngineOnOff?onoff=false`);
      const offData = offResponse.data.data || [];
      const offCount = offData.length;
      setEngineOffCount(offCount);

      const pieChartData = [
        { id: 1, value: onCount, label: "On" },
        { id: 2, value: offCount, label: "Off" },
      ];
      setlabelsData(pieChartData);

    } catch (error) {
      console.error("Error fetching engine status:", error);
    }
  };

  // UPDATED: Get current statistics from new API
  const getZoneData = () => {
    api
      .get("Mng/CurrentStat")
      .then((res) => {
        const data = res.data.data;

        setRunn(data.moving);
        setIdle(data.idle);
        setStop(data.engOff);
        setTotalVeh(data.totVehicles);
        setTotalDistance(data.totDistance);

        setOnRoadVeh(data.moving + data.idle + data.engOff);
        setGpsStatus(data.totVehicles);

        setEngineOnCount(data.engOn);
        setEngineOffCount(data.engOff);

        const pieChartData = [
          { id: 1, value: data.engOn, label: "On" },
          { id: 2, value: data.engOff, label: "Off" },
        ];
        setlabelsData(pieChartData);

        if (data.zoneWise && data.zoneWise.length > 0) {
          const zoneCounts: { [key: string]: number } = {};
          data.zoneWise.forEach((zone: any) => {
            const zoneName = zone.zonename;
            zoneCounts[zoneName] = (zoneCounts[zoneName] || 0) + 1;
          });

          const chartData = Object.keys(zoneCounts).map((zoneName, index) => ({
            value: zoneCounts[zoneName],
            label: zoneName,
            id: index + 1
          }));

          const sortedChartData = chartData.sort((a: any, b: any) => {
            const zoneA = parseInt(a.label.split(" ")[1], 10);
            const zoneB = parseInt(b.label.split(" ")[1], 10);
            return zoneA - zoneB;
          });

          setChartData(sortedChartData);
          setChartIsLoading(false);
        } else {
          console.error("No zone data available.");
        }

        fetchCardCounts();

      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  const fetchCardCounts = async () => {
    try {
      const fuelResponse = await api.get(`NTRead/GetTopFuelCons/nos=50`);
      setFuelConsumedCount(fuelResponse.data.data.length);

      const idleResponse = await api.get(`Mng/LongIdleVehicles?maxno=100`);
      setLongIdleCount(idleResponse.data.data.length);

      const wireResponse = await api.get(`Mng/DayVehData`);
      setWireTemperingCount(wireResponse.data.data.length);
    } catch (error) {
      console.error("Error fetching card counts:", error);
    }
  };

  const formatDate = (date: any) => {
    const month = ("0" + (date.getMonth() + 1)).slice(-2);
    const day = ("0" + date.getDate()).slice(-2);
    const year = date.getFullYear();
    return `${month}-${day}-${year}`;
  };

  const formattedDate = formatDate(new Date());

  // UPDATED: Fetch zones data using new API (DayVehData)
  const fetchZonesData = async () => {
    try {
      const response = await api.get(`Mng/DayVehData`);
      const data = response.data.data;

      const zonesWithIds = data?.map((zone: any, index: any) => ({
        ...zone,
        serialNo: index + 1,
        id: index + 1,
        vehicleNo: zone.vehicleNo,
        departmentName: zone.department,
        date: zone.trackTime,
        devid: zone.deviceId
      }));
      setZones(zonesWithIds);
      setIsLoading(false);

      if (data.length > 0) {
        const columns: GridColDef[] = [
          {
            field: "serialNo",
            headerName: t("text.SrNo"),
            flex: 0.5,
          },
          {
            field: "vehicleNo",
            headerName: t("text.VehicleNo"),
            flex: 1,
          },
          {
            field: "departmentName",
            headerName: t("text.DepartmentName"),
            flex: 1,
          },
          {
            field: "date",
            headerName: t("text.Date"),
            flex: 1,
            valueGetter: (params) => {
              const date = new Date(params.value);
              const formattedDate = `${String(date.getDate()).padStart(
                2,
                "0"
              )}-${String(date.getMonth() + 1).padStart(
                2,
                "0"
              )}-${date.getFullYear()}`;
              const time = `${String(date.getHours()).padStart(
                2,
                "0"
              )}:${String(date.getMinutes()).padStart(2, "0")}:${String(
                date.getSeconds()
              ).padStart(2, "0")}`;
              return `${formattedDate} (Time: ${time})`;
            },
          },
          {
            field: "devid",
            headerName: t("text.Devid"),
            flex: 1,
          },
        ];
        setColumns(columns as any);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const adjustedColumns = columns.map((column: any) => ({
    ...column,
  }));

  useEffect(() => {
    FuelconsData();
  }, [getTop]);

  useEffect(() => {
    IdleData();
  }, [getTop1]);

  const FuelconsData = async () => {
    try {
      const recordsCount = getTop ? 10 : 50;
      const response = await api.get(`NTRead/GetTopFuelCons/nos=${recordsCount}`);
      const data = response.data.data;

      setPrint(data);
      setFuelConsumedCount(data.length);

      const zonesWithIds = data.map((zone: any, index: any) => ({
        ...zone,
        serialNo: index + 1,
        id: index + 1,
      }));
      setZones1(zonesWithIds);
      setIsLoading1(false);

      if (data.length > 0) {
        const columns1: GridColDef[] = [
          {
            field: "serialNo",
            headerName: t("text.SrNo"),
            flex: 0.5,
          },
          {
            field: "vehicleNo",
            headerName: t("text.VehicleNo"),
            flex: 1,
          },
          {
            field: "departmentname",
            headerName: t("text.DepartmentName"),
            flex: 1,
          },
          {
            field: "fuelConsumed",
            headerName: t("text.FuelConsumed"),
            flex: 1,
            align: "right",
            headerAlign: "right",
            valueFormatter: ({ value }) => (value ? value.toFixed(2) : ""),
          },
        ];
        setColumns1(columns1 as any);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const adjustedColumns1 = columns1.map((column: any) => ({
    ...column,
  }));

  // UPDATED: Long Idle Vehicles from new API
  const IdleData = async () => {
    try {
      const recordsCount = getTop1 ? 10 : 50;
      const response = await api.get(`Mng/LongIdleVehicles?maxno=${recordsCount}`);
      const data = response?.data?.data;

      setPrint1(data);
      setLongIdleCount(data.length);

      const zonesWithIds = data.map((zone: any, index: any) => ({
        ...zone,
        serialNo: index + 1,
        id: index + 1,
        vehicleNo: zone.vehicleNo,
        vehicleTypename: zone.vehtype,
        idleTime: zone.sduration,
        departmentname: zone.department,
        empName: "",
        empMobileNo: ""
      }));
      setZones2(zonesWithIds);
      setIsLoading2(false);

      if (data.length > 0) {
        const columns2: GridColDef[] = [
          {
            field: "vehicleNo",
            headerName: t("text.VehicleNo"),
            flex: 1,
            cellClassName: "wrap-text",
          },
          {
            field: "vehicleTypename",
            headerName: t("text.VehicleType"),
            flex: 2,
            cellClassName: "wrap-text",
          },
          {
            field: "idleTime",
            headerName: t("text.Duration"),
            flex: 1,
            cellClassName: "wrap-text",
          },
          {
            field: "departmentname",
            headerName: t("text.DepartmentName"),
            flex: 1,
            cellClassName: "wrap-text",
          },
          {
            field: "empName",
            headerName: t("text.Driver"),
            flex: 1.5,
            cellClassName: "wrap-text",
            renderCell: (params) => {
              const { empName, empMobileNo } = params.row;
              return `${empName} (${empMobileNo})`;
            },
          },
        ];
        setColumns2(columns2 as any);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const adjustedColumns2 = columns2.map((column: any) => ({
    ...column,
  }));

  const styles = `
  .wrap-text {
    white-space: normal !important;
    word-wrap: break-word !important;
    overflow-wrap: break-word !important;
  }
  
  .vehicle-number-link {
    color: #1976d2 !important;
    text-decoration: underline !important;
    cursor: pointer !important;
    font-weight: 600 !important;
    transition: all 0.2s ease-in-out !important;
  }
  
  .vehicle-number-link:hover {
    color: #0d47a1 !important;
    text-decoration: none !important;
    transform: scale(1.05) !important;
  }
  
  .marker-label {
    background-color: white !important;
    padding: 2px 4px !important;
    border-radius: 3px !important;
    border: 1px solid #ccc !important;
    font-weight: bold !important;
  }
`;

  document.head.insertAdjacentHTML("beforeend", `<style>${styles}</style>`);

  // UPDATED: Today Vehicle Status from DayVehData API with status:5 parameter
  const TodayVData = async () => {
    try {
      const response = await api.get(`Mng/DayVehData?status=5`);
      const data = response.data.data || [];

      const zonesWithIds = data.map((zone: any, index: any) => ({
        ...zone,
        serialNo: index + 1,
        id: zone.itemmasterid || index + 1,
        vehicleNo: zone.vehicleNo,
        trackTime: zone.trackTime,
        departmentName: zone.department,
        vehicleTypename: zone.vehicleType || "N/A",
        kmPerLitre: 0,
        ignition: zone.acc ? "On" : "Off",
        distance: zone.distance || 0,
        runtime: zone.secondsRun || 0,
        idletime: zone.secondsIdle || 0,
        lat: zone.lattitude,
        lon: zone.longitude,
        speed: zone.speed || zone.speedDecimal || 0,
        driver: zone.driver || "N/A",
        itemmasterid: zone.itemmasterid,
        deviceId: zone.deviceId,
        nearme: zone.nearme || "Unknown"
      }));
      setZones3(zonesWithIds);
      setIsLoading3(false);

      if (data.length > 0) {
        const columns2: GridColDef[] = [
          {
            field: "serialNo",
            headerName: t("text.SrNo"),
            flex: 0.5,
            cellClassName: "wrap-text",
          },
          {
            field: "vehicleNo",
            headerName: t("text.VehicleNo"),
            flex: 1,
            cellClassName: "wrap-text",
            renderCell: (params) => (
              <span
                onClick={() => handleVehicleNumberClick(params.row)}
                className="vehicle-number-link"
                title="Click to view vehicle location on map"
              >
                {params.value}
              </span>
            ),
          },
          {
            field: "trackTime",
            headerName: t("text.TrackTime"),
            flex: 1.5,
            cellClassName: "wrap-text",
            valueGetter: (params) => {
              if (!params.value) return "N/A";
              const date = new Date(params.value);
              const formattedDate = `${String(date.getDate()).padStart(
                2,
                "0"
              )}-${String(date.getMonth() + 1).padStart(
                2,
                "0"
              )}-${date.getFullYear()}`;
              const time = `${String(date.getHours()).padStart(
                2,
                "0"
              )}:${String(date.getMinutes()).padStart(2, "0")}:${String(
                date.getSeconds()
              ).padStart(2, "0")}`;
              return `${formattedDate} ${time}`;
            },
          },
          {
            field: "departmentName",
            headerName: t("text.DepartmentName"),
            flex: 1.2,
            cellClassName: "wrap-text",
          },
          {
            field: "vehicleTypename",
            headerName: t("text.VehicleTypeName"),
            flex: 1,
            cellClassName: "wrap-text",
          },
          {
            field: "ignition",
            headerName: t("text.Ignition"),
            flex: 0.8,
            cellClassName: "wrap-text",
            renderCell: (params) => (
              <Chip
                label={params.value}
                size="small"
                color={params.value === "On" ? "success" : "error"}
                variant="outlined"
                onClick={() => {
                  if (params.row.ignition === "On") {
                    IgnitionData(true);
                  } else if (params.row.ignition === "Off") {
                    IgnitionData(false);
                  }
                }}
                style={{ cursor: "pointer" }}
              />
            ),
          },
          {
            field: "distance",
            headerName: t("text.Distance (Km)"),
            flex: 1,
            align: "right",
            headerAlign: "right",
            valueFormatter: ({ value }) => value ? value.toFixed(2) : "0.00",
            cellClassName: "wrap-text",
          },
          {
            field: "speed",
            headerName: t("text.Speed (km/h)"),
            flex: 1,
            align: "right",
            headerAlign: "right",
            valueFormatter: ({ value }) => value ? value.toFixed(0) : "0",
            cellClassName: "wrap-text",
          },
          {
            field: "driver",
            headerName: t("text.Driver"),
            flex: 1.5,
            cellClassName: "wrap-text",
          },
        ];
        setColumns3(columns2 as any);
      }
    } catch (error) {
      console.error("Error fetching Today Vehicle Status data:", error);
      setIsLoading3(false);
    }
  };

  const adjustedColumns3 = columns3.map((column: any) => ({
    ...column,
  }));

  return (
    <div>
      {/* Summary Cards Section */}
      <Grid container spacing={2} style={{ marginBottom: "15px", marginTop: "5px" }}>
        {/* Fuel Consumed Card */}
        <Grid item xs={12} sm={6} md={4}>
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.4 }}
            whileHover={{ scale: 1.04 }}
          >
            <Card
              onClick={handleFuelConsumedOpen}
              sx={{
                height: 120,
                borderRadius: '22px',
                position: 'relative',
                cursor: 'pointer',
                overflow: 'hidden',
                background:
                  'linear-gradient(135deg, #e3f2fd, #bbdefb, #90caf9)',
                boxShadow:
                  '0 0 0 1px rgba(30,136,229,0.25), 0 15px 40px rgba(30,136,229,0.35)',
                transition: '0.4s',
                '&:hover': {
                  boxShadow:
                    '0 0 25px rgba(30,136,229,0.5), 0 30px 70px rgba(30,136,229,0.4)',
                },
              }}
            >
              <CardContent
                sx={{
                  height: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  px: 2,
                }}
              >
                <Box>
                  <Typography
                    sx={{
                      fontSize: '0.65rem',
                      letterSpacing: '2px',
                      color: '#1565c0',
                      fontWeight: 700,
                      mb: 0.5,
                    }}
                  >
                    FUEL CONSUMED
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: '2.4rem',
                      fontWeight: 900,
                      background:
                        'linear-gradient(90deg, #1e88e5, #0d47a1)',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      lineHeight: 1,
                    }}
                  >
                    {fuelConsumedCount}
                  </Typography>

                  <Typography sx={{ fontSize: '0.65rem', color: '#0d47a1', mt: 0.4 }}>
                    VEHICLES
                  </Typography>
                </Box>

                <motion.div animate={{ y: [0, -6, 0] }} transition={{ repeat: Infinity, duration: 2.5 }}>
                  <Box
                    sx={{
                      width: 70,
                      height: 70,
                      borderRadius: '50%',
                      background:
                        'radial-gradient(circle, #42a5f5, #1e88e5)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      boxShadow: '0 0 20px rgba(30,136,229,0.6)',
                    }}
                  >
                    <LocalGasStation sx={{ fontSize: 32, color: '#fff' }} />
                  </Box>
                </motion.div>
              </CardContent>
            </Card>
          </motion.div>
        </Grid>

        {/* Long Idle Vehicle Card */}
        <Grid item xs={12} sm={6} md={4}>
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.4, delay: 0.1 }}
            whileHover={{ scale: 1.04 }}
          >
            <Card
              onClick={handleLongIdleOpen}
              sx={{
                height: 120,
                borderRadius: '22px',
                position: 'relative',
                cursor: 'pointer',
                overflow: 'hidden',
                background:
                  'linear-gradient(135deg, #ede7f6, #d1c4e9, #b39ddb)',
                boxShadow:
                  '0 0 0 1px rgba(94,53,177,0.25), 0 15px 40px rgba(94,53,177,0.35)',
              }}
            >
              <CardContent
                sx={{
                  height: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  px: 2,
                }}
              >
                <Box>
                  <Typography
                    sx={{
                      fontSize: '0.65rem',
                      letterSpacing: '2px',
                      color: '#4527a0',
                      fontWeight: 700,
                      mb: 0.5,
                    }}
                  >
                    LONG IDLE
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: '2.4rem',
                      fontWeight: 900,
                      background:
                        'linear-gradient(90deg, #5e35b1, #311b92)',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      lineHeight: 1,
                    }}
                  >
                    {longIdleCount}
                  </Typography>

                  <Typography sx={{ fontSize: '0.65rem', color: '#311b92', mt: 0.4 }}>
                    VEHICLES
                  </Typography>
                </Box>

                <motion.div animate={{ rotate: 360 }} transition={{ repeat: Infinity, duration: 14, ease: 'linear' }}>
                  <Box
                    sx={{
                      width: 70,
                      height: 70,
                      borderRadius: '50%',
                      background:
                        'conic-gradient(#9575cd, #5e35b1, #9575cd)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      boxShadow: '0 0 20px rgba(94,53,177,0.6)',
                    }}
                  >
                    <FaClock style={{ fontSize: 28, color: '#fff' }} />
                  </Box>
                </motion.div>
              </CardContent>
            </Card>
          </motion.div>
        </Grid>

        {/* Probable Wire Tempering Card */}
        <Grid item xs={12} sm={6} md={4}>
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.4, delay: 0.2 }}
            whileHover={{ scale: 1.04 }}
          >
            <Card
              onClick={handleWireTemperingOpen}
              sx={{
                height: 120,
                borderRadius: '22px',
                position: 'relative',
                cursor: 'pointer',
                overflow: 'hidden',
                background:
                  'linear-gradient(135deg, #ffebee, #ffcdd2, #ef9a9a)',
                boxShadow:
                  '0 0 0 1px rgba(229,57,53,0.3), 0 15px 40px rgba(229,57,53,0.35)',
              }}
            >
              <CardContent
                sx={{
                  height: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  px: 2,
                }}
              >
                <Box>
                  <Typography
                    sx={{
                      fontSize: '0.65rem',
                      letterSpacing: '2px',
                      color: '#b71c1c',
                      fontWeight: 800,
                      mb: 0.5,
                    }}
                  >
                    SECURITY ALERT
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: '2.4rem',
                      fontWeight: 900,
                      background:
                        'linear-gradient(90deg, #e53935, #b71c1c)',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      lineHeight: 1,
                    }}
                  >
                    {wireTemperingCount}
                  </Typography>

                  <Typography sx={{ fontSize: '0.65rem', color: '#b71c1c', mt: 0.4 }}>
                    WIRE TAMPERING
                  </Typography>
                </Box>

                <motion.div
                  animate={{ scale: [1, 1.1, 1] }}
                  transition={{ repeat: Infinity, duration: 3, ease: 'easeInOut' }}
                >
                  <Box
                    sx={{
                      width: 70,
                      height: 70,
                      borderRadius: '50%',
                      background:
                        'radial-gradient(circle, #ef5350, #c62828)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      boxShadow: '0 0 25px rgba(229,57,53,0.6)',
                    }}
                  >
                    <ReportProblem sx={{ fontSize: 36, color: '#fff' }} />
                  </Box>
                </motion.div>
              </CardContent>
            </Card>
          </motion.div>
        </Grid>
      </Grid>

      {/* Tabs Section */}
      <div
        style={{
          backgroundColor: "#ebf2f5",
          borderRadius: "15px",
          marginTop: "5px",
          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
          borderTop: "2px solid",
          borderImage: "linear-gradient(45deg, #ff0000, #0000ff) 1",
          borderTopColor: "2px solid blue",
          borderLeft: "solid 2px transparent",
          borderRight: "solid 2px transparent",
          borderImageSlice: "1",
        }}
      >
        <CardContent>
          <Grid
            item
            sm={4}
            md={6}
            xs={12}
            alignItems="center"
            justifyContent="center"
            display="flex"
          >
            <Tabs
              value={value}
              onChange={handleTab}
              indicatorColor="primary"
              textColor="primary"
              variant="scrollable"
              scrollButtons="auto"
            >
              {items.map((item, index) => (
                <Tab
                  key={item.id}
                  icon={item.icon}
                  label={item.text}
                  iconPosition="start"
                />
              ))}
            </Tabs>
          </Grid>
        </CardContent>
      </div>

      <div
        style={{
          backgroundColor: "#ebf2f5",
          borderRadius: "5px",
          marginTop: "5px",
          position: "relative",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "2px",
            background: "linear-gradient(to right, transparent,rgb(0, 13, 255) 50%, transparent)",
            borderTopLeftRadius: "5px",
            borderTopRightRadius: "5px",
          }}
        ></div>
        <CardContent>
          {value === 0 && (
            <div>
              <Grid
                container
                spacing={1.5}
              >
                {/* Charts and Running Status Grid */}
                <Grid xs={12} sm={6} md={4} item>
                  <motion.div
                    initial="hidden"
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    <Card
                      elevation={4}
                      style={{
                        marginLeft: "1%",
                        border: ".5px solid transparent",
                        borderRadius: "10px",
                      }}
                    >
                      <Grid
                        style={{
                          width: "100%",
                          height: "53vh",
                          backgroundColor: "#e9f4f7",
                        }}
                      >
                        <Typography
                          variant="h6"
                          component="div"
                          sx={{
                            padding: "17px",
                            background: "linear-gradient(to right, #ffffff,rgb(27, 174, 253))",
                          }}
                        >
                          Zones
                        </Typography>
                        {isChartLoading ? (
                          <Box display="flex" justifyContent="center" alignItems="center" height={220}>
                            <motion.span
                              animate={{ opacity: [1, 0.3, 1] }}
                              transition={{ duration: 1, repeat: Infinity }}
                              style={dotStyle}
                            />
                            <motion.span
                              animate={{ opacity: [1, 0.3, 1] }}
                              transition={{ duration: 1, repeat: Infinity, delay: 0.2 }}
                              style={dotStyle}
                            />
                            <motion.span
                              animate={{ opacity: [1, 0.3, 1] }}
                              transition={{ duration: 1, repeat: Infinity, delay: 0.4 }}
                              style={dotStyle}
                            />
                          </Box>
                        ) : (
                          <PieChart
                            series={[
                              {
                                data: chartData,
                                highlightScope: {
                                  faded: "global",
                                  highlighted: "item",
                                },
                                faded: {
                                  innerRadius: 30,
                                  additionalRadius: -30,
                                  color: "gray",
                                },
                              },
                            ]}
                            height={220}
                            onItemClick={(e: any, d: any) => {
                              const clickedData = chartData[d.dataIndex];
                              zoneModal(clickedData);
                              setVisible(true);
                            }}
                          />
                        )}
                      </Grid>
                    </Card>
                  </motion.div>
                </Grid>

                <Grid xs={12} sm={6} md={4} item>
                  <motion.div
                    initial="hidden"
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    <Card
                      elevation={4}
                      style={{
                        marginLeft: "1%",
                        border: ".5px solid transparent",
                        borderRadius: "10px",
                      }}
                    >
                      <Grid
                        style={{
                          width: "100%",
                          height: "53vh",
                          backgroundColor: "#e9f4f7",
                        }}
                      >
                        <Typography
                          variant="h6"
                          component="div"
                          sx={{
                            padding: "17px",
                            background: "linear-gradient(to right, #ffffff,rgb(27, 174, 253))",
                          }}
                        >
                          Vehicles Ignition Status
                        </Typography>
                        {isChartLoading ? (
                          <Box display="flex" justifyContent="center" alignItems="center" height={220}>
                            <motion.span
                              animate={{ opacity: [1, 0.3, 1] }}
                              transition={{ duration: 1, repeat: Infinity }}
                              style={dotStyle}
                            />
                            <motion.span
                              animate={{ opacity: [1, 0.3, 1] }}
                              transition={{ duration: 1, repeat: Infinity, delay: 0.2 }}
                              style={dotStyle}
                            />
                            <motion.span
                              animate={{ opacity: [1, 0.3, 1] }}
                              transition={{ duration: 1, repeat: Infinity, delay: 0.4 }}
                              style={dotStyle}
                            />
                          </Box>
                        ) : (
                          <PieChart
                            series={[{ data: labelsData }]}
                            width={350}
                            height={200}
                            onItemClick={(e: any, d: any) => {
                              const clickedData = labelsData[d.dataIndex];
                              if (clickedData.label === "On") {
                                IgnitionData(true);
                              } else if (clickedData.label === "Off") {
                                IgnitionData(false);
                              }
                            }}
                          />
                        )}
                        <Box sx={{ p: 2, textAlign: "center" }}>
                          <Typography variant="body2" color="text.secondary">
                            Engine ON: {engineOnCount} | Engine OFF: {engineOffCount}
                          </Typography>
                        </Box>
                      </Grid>
                    </Card>
                  </motion.div>
                </Grid>

                {/* UPDATED: Vehicles Running Status Section */}
                <Grid xs={12} sm={6} md={4} item>
                  <motion.div
                    initial="hidden"
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    <Card
                      elevation={4}
                      style={{
                        marginLeft: "1%",
                        border: ".5px solid transparent",
                        borderRadius: "10px",
                      }}
                    >
                      <Grid
                        style={{
                          width: "100%",
                          height: "53vh",
                          backgroundColor: "#e9f4f7",
                          overflow: "auto",
                        }}
                      >
                        <Typography
                          variant="h6"
                          component="div"
                          sx={{
                            padding: "17px",
                            background: "linear-gradient(to right, #ffffff,rgb(27, 174, 253))",
                          }}
                        >
                          Vehicles Running Status
                        </Typography>
                        <div style={{ padding: "5px" }}>
                          <Typography
                            variant="h6"
                            sx={{
                              color: "green",
                              cursor: "pointer",
                              transition: "all 0.3s ease-in-out",
                              "&:hover": {
                                color: "blue",
                                transform: "translateY(-3px)",
                              },
                            }}
                            onClick={() => {
                              runningData("running");
                            }}
                          >
                            Running: {isRunn}
                          </Typography>
                          <ProgressBar
                            completed={Math.round((isRunn / totalVeh || 0) * 100)}
                            bgColor="green"
                          />

                          <Typography
                            variant="h6"
                            sx={{
                              color: "#EF9B0F",
                              cursor: "pointer",
                              transition: "all 0.3s ease-in-out",
                              "&:hover": {
                                color: "blue",
                                transform: "translateY(-3px)",
                              },
                            }}
                            onClick={() => {
                              runningData("idle");
                            }}
                          >
                            Idle: {isIdle}{" "}
                          </Typography>
                          <ProgressBar
                            completed={Math.round((isIdle / totalVeh || 0) * 100)}
                            bgColor="#e3be29"
                          />

                          <Typography
                            variant="h6"
                            sx={{
                              color: "#f04848",
                              cursor: "pointer",
                              transition: "all 0.3s ease-in-out",
                              "&:hover": {
                                color: "blue",
                                transform: "translateY(-3px)",
                              },
                            }}
                            onClick={() => {
                              runningData("stop");
                            }}
                          >
                            Stop: {isStop}
                          </Typography>
                          <ProgressBar
                            completed={Math.round((isStop / totalVeh || 0) * 100)}
                            bgColor="#f04848"
                          />

                          <Typography
                            variant="h6"
                            fontWeight="bold"
                            fontSize={"16px"}
                            style={{ color: "blue" }}
                          >
                            Total Vehicles:{" "}
                            <span style={{ color: "#474d54" }}>{totalVeh}</span>
                          </Typography>

                          <Typography
                            variant="h6"
                            fontWeight="bold"
                            fontSize={"16px"}
                            style={{ color: "blue" }}
                          >
                            Total Vehicles on Road:{" "}
                            <span style={{ color: "#474d54" }}>{onRoadVeh}</span>{" "}
                            out of{" "}
                            <span style={{ color: "#474d54" }}>{totalVeh}</span>
                          </Typography>

                          <Typography
                            variant="h6"
                            fontWeight="bold"
                            fontSize={"16px"}
                            style={{ color: "blue" }}
                          >
                            GPS Installation Status:{" "}
                            <span style={{ color: "#474d54" }}>{gpsStatus}</span>{" "}
                            out of{" "}
                            <span style={{ color: "#474d54" }}>{totalVeh}</span>
                          </Typography>

                          <Typography
                            variant="h6"
                            fontWeight="bold"
                            fontSize={"16px"}
                            style={{ color: "blue" }}
                          >
                            Total Distance Today:{" "}
                            <span style={{ color: "#474d54" }}>
                              {(totalDistance || 0).toFixed(2)}
                            </span>{" "}
                            Km
                          </Typography>
                        </div>
                      </Grid>
                    </Card>
                  </motion.div>
                </Grid>

                {/* Today Vehicle Status Accordion */}
                <Grid xs={12} lg={12} sm={12} item >
                  <Accordion
                    expanded={accordionExpanded[2]}
                    onChange={(e, expended) => {
                      handleAccordionToggle(2, expended);
                    }}
                  >
                    <AccordionSummary
                      expandIcon={<ArrowDropDownIcon />}
                      aria-controls="panel2-content"
                      id="panel2-header"
                      sx={{
                        background: "linear-gradient(to right, #ffffff,rgb(27, 174, 253))",
                      }}
                    >
                      <Typography style={{ fontWeight: 600, fontSize: "16px" }}>
                        Today Vehicle Status
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails style={{ background: "#f2f8fa" }}>
                      <Grid
                        item
                        xs={12}
                        container
                        spacing={2}
                        sx={{ marginTop: "5px" }}
                      >
                        <Grid item xs={12} sm={12} lg={12}>
                          {isLoading3 ? (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <CircularProgress />
                            </div>
                          ) : (
                            <>
                              {zones3 && zones3.length > 0 ? (
                                <DataGrid
                                  rows={zones3}
                                  columns={adjustedColumns3}
                                  rowSpacingType="border"
                                  autoHeight
                                  slots={{
                                    toolbar: GridToolbar,
                                  }}
                                  pageSizeOptions={[5, 10, 25, 50, 100].map(
                                    (size) => ({
                                      value: size,
                                      label: `${size}`,
                                    })
                                  )}
                                  initialState={{
                                    pagination: {
                                      paginationModel: { pageSize: 5 },
                                    },
                                  }}
                                  slotProps={{
                                    toolbar: {
                                      showQuickFilter: true,
                                    },
                                  }}
                                  sx={{
                                    border: 0,
                                    "& .MuiDataGrid-columnHeaders": {
                                      backgroundColor: "#42b6f5",
                                      color: "white",
                                    },
                                    "& .MuiDataGrid-columnHeaderTitle": {
                                      color: "white",
                                    },
                                    "& .MuiDataGrid-cell": {
                                      whiteSpace: "normal",
                                      wordWrap: "break-word",
                                      overflowWrap: "break-word",
                                    },
                                  }}
                                />
                              ) : (
                                <div>No data found</div>
                              )}
                            </>
                          )}
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                  <br />
                </Grid>

                {/* Map Section - FIXED: Only one InfoWindow renders */}
                {currentMap && (
                  <Grid item xs={12} sm={12} lg={12}>
                    <div
                      style={{
                        border: "1px solid black",
                        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                        marginBottom: "20px",
                      }}
                    >
                      <GoogleMap
                        mapContainerStyle={containerStyle}
                        center={center}
                        zoom={70}
                        onLoad={(map: any) => (mapRef.current = map)}
                      >
                        {vehicles.map((vehicle: any, index: any) => (
                          <Marker
                            key={vehicle.id}
                            position={{
                              lat: vehicle.lat,
                              lng: vehicle.lng,
                            }}
                            icon={{
                              url: vehicle.icon,
                              scaledSize: new window.google.maps.Size(
                                50,
                                50
                              ),
                              origin: new window.google.maps.Point(0, 0),
                              anchor: new window.google.maps.Point(25, 25),
                            }}
                            label={{
                              text: `${index + 1}`,
                              fontSize: "14px",
                              fontWeight: "bold",
                              color: "#f73905",
                              className: 'marker-label'
                            }}
                            onMouseOver={() => handleMarkerMouseOver(vehicle)}
                            onMouseOut={handleMarkerMouseOut}
                          />
                        ))}
                        
                        {/* FIXED: Only one InfoWindow renders outside of Marker components */}
                        {activeVehicle && (
                          <InfoWindow
                            position={{
                              lat: activeVehicle.lat,
                              lng: activeVehicle.lng,
                            }}
                            onCloseClick={() => setActiveVehicle(null)}
                          >
                            <div style={{ padding: "10px", maxWidth: "250px" }}>
                              <div>
                                <strong>Speed: </strong>
                                {activeVehicle.speed} km/h
                              </div>
                              <div>
                                <strong>Near By: </strong>
                                {activeVehicle.nearme}
                              </div>
                              <div>
                                <strong>Vehicle No: </strong>
                                {activeVehicle.vehicleNo}
                              </div>
                              <div>
                                <strong>Distance: </strong>
                                {activeVehicle.distance} km
                              </div>
                              <div>
                                <strong>Date & Time: </strong>
                                {activeVehicle.tracktime}
                              </div>
                            </div>
                          </InfoWindow>
                        )}
                        
                        <Polyline
                          path={vehicles.map((vehicle: any) => ({ lat: vehicle.lat, lng: vehicle.lng }))}
                          options={{
                            strokeColor: "#6190c9",
                            strokeOpacity: 1,
                            strokeWeight: 3,
                          }}
                        />
                      </GoogleMap>
                    </div>
                  </Grid>
                )}
              </Grid>

              {/* Modal Dialogs for Cards */}
              {/* Fuel Consumed Modal */}
              <Dialog
                open={fuelConsumedOpen}
                onClose={handleFuelConsumedClose}
                fullWidth
                maxWidth="lg"
                sx={{
                  "& .MuiDialogContent-root": {
                    padding: "20px",
                    height: "600px",
                  },
                }}
              >
                <DialogTitle
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "10px",
                    backgroundColor: `var(--grid-headerBackground, #42b6f5)`,
                    color: `var(--grid-headerColor, white)`,
                  }}
                >
                  <Stack direction="row" spacing={2} alignItems="center">
                    <LocalGasStation />
                    <Typography variant="h6">
                      Fuel Consumed Report
                    </Typography>
                  </Stack>
                  <IconButton
                    edge="end"
                    onClick={handleFuelConsumedClose}
                    sx={{ color: "white" }}
                  >
                    <CloseIcon />
                  </IconButton>
                </DialogTitle>
                <DialogContent>
                  <Grid container spacing={2} sx={{ mt: 1 }}>
                    <Grid item xs={12}>
                      <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={getTop}
                              onChange={(e) => {
                                setGetTop(e.target.checked);
                                setTimeout(() => { }, 500);
                              }}
                            />
                          }
                          label="Get Top 10 Records"
                        />
                        <Button
                          startIcon={<PrintIcon />}
                          variant="contained"
                          sx={{ bgcolor: "#42b6f5", '&:hover': { bgcolor: "#1976d2" } }}
                          onClick={downloadExcel}
                        >
                          Export to Excel
                        </Button>
                      </Stack>
                    </Grid>
                    <Grid item xs={12}>
                      {isLoading1 ? (
                        <Box display="flex" justifyContent="center" alignItems="center" height={400}>
                          <CircularProgress />
                        </Box>
                      ) : (
                        <>
                          {zones1 && zones1.length > 0 ? (
                            <DataGrid
                              rows={zones1}
                              columns={adjustedColumns1}
                              rowSpacingType="border"
                              autoHeight
                              slots={{
                                toolbar: GridToolbar,
                              }}
                              pageSizeOptions={[5, 10, 25, 50, 100]}
                              initialState={{
                                pagination: {
                                  paginationModel: { pageSize: 10 },
                                },
                              }}
                              slotProps={{
                                toolbar: {
                                  showQuickFilter: true,
                                },
                              }}
                              sx={{
                                border: 0,
                                "& .MuiDataGrid-columnHeaders": {
                                  backgroundColor: `var(--grid-headerBackground, #42b6f5)`,
                                  color: `var(--grid-headerColor, white)`,
                                },
                                "& .MuiDataGrid-columnHeaderTitle": {
                                  color: "white",
                                },
                              }}
                            />
                          ) : (
                            <Box display="flex" justifyContent="center" alignItems="center" height={400}>
                              <Typography>No data found</Typography>
                            </Box>
                          )}
                        </>
                      )}
                    </Grid>
                  </Grid>
                </DialogContent>
              </Dialog>

              {/* Long Idle Vehicle Modal */}
              <Dialog
                open={longIdleOpen}
                onClose={handleLongIdleClose}
                fullWidth
                maxWidth="lg"
                sx={{
                  "& .MuiDialogContent-root": {
                    padding: "20px",
                    height: "600px",
                  },
                }}
              >
                <DialogTitle
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "10px",
                    backgroundColor: `var(--grid-headerBackground, #42b6f5)`,
                    color: `var(--grid-headerColor, white)`,
                  }}
                >
                  <Stack direction="row" spacing={2} alignItems="center">
                    <FaClock style={{ fontSize: "24px" }} />
                    <Typography variant="h6">
                      Long Idle Vehicles
                    </Typography>
                  </Stack>
                  <IconButton
                    edge="end"
                    onClick={handleLongIdleClose}
                    sx={{ color: "white" }}
                  >
                    <CloseIcon />
                  </IconButton>
                </DialogTitle>
                <DialogContent>
                  <Grid container spacing={2} sx={{ mt: 1 }}>
                    <Grid item xs={12}>
                      <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={getTop1}
                              onChange={(e) => {
                                setGetTop1(e.target.checked);
                              }}
                            />
                          }
                          label="Get Top 10 Records"
                        />
                        <Button
                          startIcon={<PrintIcon />}
                          variant="contained"
                          sx={{ bgcolor: "#42b6f5", '&:hover': { bgcolor: "#1976d2" } }}
                          onClick={downloadExcel1}
                        >
                          Export to Excel
                        </Button>
                      </Stack>
                    </Grid>
                    <Grid item xs={12}>
                      {isLoading2 ? (
                        <Box display="flex" justifyContent="center" alignItems="center" height={400}>
                          <CircularProgress />
                        </Box>
                      ) : (
                        <>
                          {zones2 && zones2.length > 0 ? (
                            <DataGrid
                              rows={zones2}
                              columns={adjustedColumns2}
                              rowSpacingType="border"
                              slots={{
                                toolbar: GridToolbar,
                              }}
                              pageSizeOptions={[5, 10, 25, 50, 100]}
                              initialState={{
                                pagination: {
                                  paginationModel: { pageSize: 10 },
                                },
                              }}
                              slotProps={{
                                toolbar: {
                                  showQuickFilter: true,
                                },
                              }}
                              autoHeight={false}
                              sx={{
                                border: 0,
                                "& .MuiDataGrid-columnHeaders": {
                                  backgroundColor: `var(--grid-headerBackground, #42b6f5)`,
                                  color: `var(--grid-headerColor, white)`,
                                  position: "sticky",
                                  top: 0,
                                  zIndex: 1,
                                },
                                "& .MuiDataGrid-columnHeaderTitle": {
                                  color: "white",
                                },
                                "& .MuiDataGrid-cell": {
                                  whiteSpace: "normal",
                                  wordWrap: "break-word",
                                  overflowWrap: "break-word",
                                },
                                height: 400,
                              }}
                            />
                          ) : (
                            <Box display="flex" justifyContent="center" alignItems="center" height={400}>
                              <Typography>No data found</Typography>
                            </Box>
                          )}
                        </>
                      )}
                    </Grid>
                  </Grid>
                </DialogContent>
              </Dialog>

              {/* Probable Wire Tempering Modal */}
              <Dialog
                open={wireTemperingOpen}
                onClose={handleWireTemperingClose}
                fullWidth
                maxWidth="lg"
                sx={{
                  "& .MuiDialogContent-root": {
                    padding: "20px",
                    height: "600px",
                  },
                }}
              >
                <DialogTitle
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "10px",
                    backgroundColor: `var(--grid-headerBackground, #42b6f5)`,
                    color: `var(--grid-headerColor, white)`,
                  }}
                >
                  <Stack direction="row" spacing={2} alignItems="center">
                    <ReportProblem />
                    <Typography variant="h6">
                      Probable Wire Tempering Alerts
                    </Typography>
                  </Stack>
                  <IconButton
                    edge="end"
                    onClick={handleWireTemperingClose}
                    sx={{ color: "white" }}
                  >
                    <CloseIcon />
                  </IconButton>
                </DialogTitle>
                <DialogContent>
                  <Grid container spacing={2} sx={{ mt: 1 }}>
                    <Grid item xs={12}>
                      {isLoading ? (
                        <Box display="flex" justifyContent="center" alignItems="center" height={400}>
                          <CircularProgress />
                        </Box>
                      ) : (
                        <>
                          {zones && zones.length > 0 ? (
                            <DataGrid
                              rows={zones}
                              columns={adjustedColumns}
                              rowSpacingType="border"
                              autoHeight
                              slots={{
                                toolbar: GridToolbar,
                              }}
                              pageSizeOptions={[5, 10, 25, 50, 100]}
                              initialState={{
                                pagination: {
                                  paginationModel: { pageSize: 10 },
                                },
                              }}
                              slotProps={{
                                toolbar: {
                                  showQuickFilter: true,
                                },
                              }}
                              sx={{
                                border: 0,
                                "& .MuiDataGrid-columnHeaders": {
                                  backgroundColor: `var(--grid-headerBackground, #42b6f5)`,
                                  color: `var(--grid-headerColor, white)`,
                                },
                                "& .MuiDataGrid-columnHeaderTitle": {
                                  color: "white",
                                },
                              }}
                            />
                          ) : (
                            <Box display="flex" justifyContent="center" alignItems="center" height={400}>
                              <Typography>No data found</Typography>
                            </Box>
                          )}
                        </>
                      )}
                    </Grid>
                  </Grid>
                </DialogContent>
              </Dialog>

              {/* Existing Modals */}
              {/* UPDATED: Running Status Modal */}
              <Grid xs={12} lg={12} sm={12} item>
                <Dialog
                  open={isModal}
                  onClose={handleClose}
                  fullWidth
                  maxWidth="lg"
                  sx={{
                    "& .MuiDialogContent-root": {
                      padding: "20px",
                      height: "400px",
                    },
                  }}
                >
                  <DialogTitle
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px",
                      backgroundColor: `var(--grid-headerBackground, #42b6f5)`,
                      color: `var(--grid-headerColor, white)`,
                    }}
                  >
                    <Typography variant="h6" style={{ color: "#ffff" }}>
                      Vehicle Status :{" "}
                      <span style={{ color: "#474d54", fontWeight: "bold" }}>
                        {isStatus1?.charAt(0).toUpperCase() + isStatus1?.slice(1)}
                      </span>
                    </Typography>
                    <IconButton
                      edge="end"
                      onClick={handleClose}
                      sx={{
                        color: `var(--grid-headerColor, white)`,
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                  </DialogTitle>
                  <DialogContent>
                    <Grid
                      item
                      xs={12}
                      container
                      spacing={2}
                      sx={{
                        padding: "20px",
                        height: "400px",
                        overflow: "hidden",
                      }}
                    >
                      <Grid item sm={12} lg={12} xs={12}>
                        {isLoading4 ? (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <CircularProgress />
                          </div>
                        ) : (
                          <>
                            {zones4 && zones4.length > 0 ? (
                              <DataGrid
                                rows={zones4}
                                columns={adjustedColumns4}
                                rowSpacingType="border"
                                slots={{
                                  toolbar: GridToolbar,
                                }}
                                slotProps={{
                                  toolbar: {
                                    showQuickFilter: true,
                                  },
                                }}
                                autoHeight={false}
                                sx={{
                                  border: 0,
                                  "& .MuiDataGrid-columnHeaders": {
                                    backgroundColor: `var(--grid-headerBackground, #42b6f5)`,
                                    color: `var(--grid-headerColor, white)`,
                                    position: "sticky",
                                    top: 0,
                                    zIndex: 1,
                                  },
                                  "& .MuiDataGrid-columnHeaderTitle": {
                                    color: "white",
                                  },
                                  "& .MuiDataGrid-cell": {
                                    whiteSpace: "normal",
                                    wordWrap: "break-word",
                                    overflowWrap: "break-word",
                                  },
                                  height: 350,
                                  overflowY: "auto",
                                }}
                              />
                            ) : (
                              <div>No data found</div>
                            )}
                          </>
                        )}
                      </Grid>
                    </Grid>
                  </DialogContent>
                </Dialog>
              </Grid>

              <Grid xs={12} lg={12} sm={12} item>
                <Dialog
                  open={isModal1}
                  onClose={handleClose1}
                  fullWidth
                  maxWidth="lg"
                  sx={{
                    "& .MuiDialogContent-root": {
                      padding: "20px",
                      height: "400px",
                    },
                  }}
                >
                  <DialogTitle
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px",
                      backgroundColor: `var(--grid-headerBackground, #42b6f5)`,
                      color: `var(--grid-headerColor, white)`,
                    }}
                  >
                    <Typography variant="h6" style={{ color: "#ffff" }}>
                      Vehicle Ignition :{" "}
                      <span style={{ color: "#474d54", fontWeight: "bold" }}>
                        {isStatus}
                      </span>
                    </Typography>
                    <IconButton
                      edge="end"
                      onClick={handleClose1}
                      sx={{
                        color: `var(--grid-headerColor, white)`,
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                  </DialogTitle>
                  <DialogContent>
                    <Grid
                      item
                      xs={12}
                      container
                      spacing={2}
                      sx={{
                        padding: "20px",
                        height: "400px",
                        overflow: "hidden",
                      }}
                    >
                      <Grid item sm={12} lg={12} xs={12}>
                        {isLoading5 ? (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <CircularProgress />
                          </div>
                        ) : (
                          <>
                            {zones5 && zones5.length > 0 ? (
                              <DataGrid
                                rows={zones5}
                                columns={adjustedColumns5}
                                rowSpacingType="border"
                                slots={{
                                  toolbar: GridToolbar,
                                }}
                                pageSizeOptions={[5, 10, 25, 50, 100]}
                                initialState={{
                                  pagination: {
                                    paginationModel: { pageSize: 10 },
                                  },
                                }}
                                slotProps={{
                                  toolbar: {
                                    showQuickFilter: true,
                                  },
                                }}
                                autoHeight={false}
                                sx={{
                                  border: 0,
                                  "& .MuiDataGrid-columnHeaders": {
                                    backgroundColor: `var(--grid-headerBackground, #42b6f5)`,
                                    color: `var(--grid-headerColor, white)`,
                                    position: "sticky",
                                    top: 0,
                                    zIndex: 1,
                                  },
                                  "& .MuiDataGrid-columnHeaderTitle": {
                                    color: "white",
                                  },
                                  "& .MuiDataGrid-cell": {
                                    whiteSpace: "normal",
                                    wordWrap: "break-word",
                                    overflowWrap: "break-word",
                                  },
                                  height: 350,
                                  overflowY: "auto",
                                }} />
                            ) : (
                              <div>No data found</div>
                            )}
                          </>
                        )}
                      </Grid>
                    </Grid>
                  </DialogContent>
                </Dialog>
              </Grid>

              <Grid xs={12} lg={12} sm={12} item>
                <Dialog
                  open={isVisible}
                  onClose={handleClose2}
                  fullWidth
                  maxWidth="lg"
                  sx={{
                    "& .MuiDialogContent-root": {
                      padding: "20px",
                      height: "400px",
                    },
                  }}
                >
                  <DialogTitle
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px",
                      backgroundColor: `var(--grid-headerBackground, #42b6f5)`,
                      color: `var(--grid-headerColor, white)`,
                    }}
                  >
                    <Typography variant="h6" style={{ color: "#ffff" }}>
                      <span style={{ color: "#474d54", fontWeight: "bold" }}>
                        {isLabel}
                      </span>
                    </Typography>
                    <IconButton
                      edge="end"
                      onClick={handleClose2}
                      sx={{
                        color: `var(--grid-headerColor, white)`,
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                  </DialogTitle>
                  <DialogContent>
                    <Grid
                      item
                      xs={12}
                      container
                      spacing={2}
                      sx={{
                        padding: "20px",
                        height: "400px",
                        overflow: "hidden",
                      }}
                    >
                      <Grid item sm={12} lg={12} xs={12}>
                        {isLoading9 ? (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <CircularProgress />
                          </div>
                        ) : (
                          <>
                            {zones9 && zones9.length > 0 ? (
                              <DataGrid
                                rows={zones9}
                                columns={adjustedColumns10}
                                rowSpacingType="border"
                                slots={{
                                  toolbar: GridToolbar,
                                }}
                                pageSizeOptions={[5, 10, 25, 50, 100]}
                                initialState={{
                                  pagination: {
                                    paginationModel: { pageSize: 10 },
                                  },
                                }}
                                slotProps={{
                                  toolbar: {
                                    showQuickFilter: true,
                                  },
                                }}
                                autoHeight={false}
                                sx={{
                                  border: 0,
                                  "& .MuiDataGrid-columnHeaders": {
                                    backgroundColor: `var(--grid-headerBackground, #42b6f5)`,
                                    color: `var(--grid-headerColor, white)`,
                                    position: "sticky",
                                    top: 0,
                                    zIndex: 1,
                                  },
                                  "& .MuiDataGrid-columnHeaderTitle": {
                                    color: "white",
                                  },
                                  "& .MuiDataGrid-cell": {
                                    whiteSpace: "normal",
                                    wordWrap: "break-word",
                                    overflowWrap: "break-word",
                                  },
                                  height: 400,
                                  overflowY: "auto",
                                }}
                              />
                            ) : (
                              <div>No data found</div>
                            )}
                          </>
                        )}
                      </Grid>
                    </Grid>
                  </DialogContent>
                </Dialog>
              </Grid>
            </div>
          )}

          {value === 1 && <Tracking />}
          {value === 2 && <Geofacing />}
          {value === 3 && <Kudaghar />}
          {value === 4 && <VehicleHistory />}
          {value === 5 && <VehicleTravelled />}
        </CardContent>
      </div>
    </div>
  );
}






























// import {
//   JSXElementConstructor,
//   Key,
//   ReactElement,
//   ReactNode,
//   ReactPortal,
//   useEffect,
//   useRef,
//   useState,
// } from "react";
// import {
//   Card,
//   Grid,
//   CardContent,
//   Typography,
//   Divider,
//   Button,
//   FormControlLabel,
//   Checkbox,
//   Tab,
//   Tabs,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   IconButton,
//   Box,
//   Paper,
//   Chip,
//   Avatar,
//   Stack,
// } from "@mui/material";

// import "./style.css";

// import { DataGrid, GridColDef, GridToolbar } from "@mui/x-data-grid";

// // import { TableContainer, Table, TableHead, TableBody, TableRow, TableCell } from '@material-ui/core';

// import { PieChart } from "@mui/x-charts/PieChart";
// import api from "../../utils/Url";
// //import { IconButton, Progress, Table } from "rsuite";
// import Accordion from "@mui/material/Accordion";
// import AccordionSummary from "@mui/material/AccordionSummary";
// import AccordionDetails from "@mui/material/AccordionDetails";
// import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
// import { useTranslation } from "react-i18next";
// import PrintIcon from "@mui/icons-material/Print";
// import {
//   GoogleMap,
//   InfoWindow,
//   LoadScript,
//   Marker,
//   Polyline,
// } from "@react-google-maps/api";
// import Tracking from "./Tracking";
// import Geofacing from "./Geofacing";
// import Kudaghar from "./Kudaghar";
// import VehicleHistory from "./VehicleHistory";
// import VehicleTravelled from "./VehicleTravelled";
// import ProgressBar from "@ramonak/react-progress-bar";

// import DashboardIcon from "@mui/icons-material/Dashboard";
// import GpsFixedIcon from "@mui/icons-material/GpsFixed";
// import PlaceIcon from "@mui/icons-material/Place";
// import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
// import CarCrashIcon from "@mui/icons-material/CarCrash";
// import EmojiTransportationIcon from "@mui/icons-material/EmojiTransportation";
// import { motion, useSpring } from "framer-motion";
// import CircularProgress from "@mui/material/CircularProgress";
// import CloseIcon from "@mui/icons-material/Close";
// import { table } from "console";
// import ReactModal from "react-modal";
// import * as XLSX from "xlsx";
// import Modal from "react-animated-modal";
// import { animated } from "react-spring";
// import {
//   FaCar,
//   FaUser,
//   FaBuilding,
//   FaCog,
//   FaCircle,
//   FaTachometerAlt,
//   FaGasPump,
//   FaSortNumericDown,
//   FaCheckCircle,
//   FaHistory,
//   FaIdCard,
//   FaExclamationTriangle,
//   FaClock,
//   FaChartLine,
// } from "react-icons/fa";

// import {
//   ListAlt,
//   DirectionsCar,
//   Work,
//   DirectionsBike,
//   CheckCircle,
//   LocalGasStation,
//   Timeline,
//   ElectricBolt,
//   ReportProblem,
// } from "@mui/icons-material";
// import PersonIcon from "@mui/icons-material/Person";
// import decryptData from "../../utils/crypto";
// import VehicleComponent from "../../utils/VehicleComponent";
// import "./style.css"

// const style = {
//   position: "absolute" as "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: "95%",
//   height: "85%",
//   bgcolor: "#f5f5f5",
//   border: "1px solid #000",
//   boxShadow: 24,
//   p: 4,
//   borderRadius: 10,
// };
// const dotStyle = {
//   width: 12,
//   height: 12,
//   borderRadius: "50%",
//   backgroundColor: "#1976D2",
//   margin: "0 5px",
//   display: "inline-block",
// };

// const containerStyle = {
//   width: "100%",
//   height: "500px",
// };

// interface Department {
//   dept_id: number;
//   dept_name: string;
//   session_year: string;
//   // Add other properties here
// }

// export default function HomePage() {
//   const [chartData, setChartData] = useState<any>([]);

//   const [labelsData, setlabelsData] = useState<any>([]);
//   console.log("labelsData", labelsData);

//   const { t } = useTranslation();

//   const [zones, setZones] = useState([]);
//   const [columns, setColumns] = useState<any>([]);
//   const [isLoading, setIsLoading] = useState(true);

//   const [currentMap, setCurrentMap] = useState(false);

//   const [isVisible, setVisible] = useState(false);

//   const [zones1, setZones1] = useState([]);
//   const [columns1, setColumns1] = useState<any>([]);
//   const [isLoading1, setIsLoading1] = useState(true);
//   const [isChartLoading, setChartIsLoading] = useState(true);

//   const [zones2, setZones2] = useState([]);
//   const [columns2, setColumns2] = useState<any>([]);
//   const [isLoading2, setIsLoading2] = useState(true);

//   const [zones3, setZones3] = useState([]);
//   const [columns3, setColumns3] = useState<any>([]);
//   const [isLoading3, setIsLoading3] = useState(true);

//   const [zones4, setZones4] = useState([]);
//   const [columns4, setColumns4] = useState<any>([]);
//   const [isLoading4, setIsLoading4] = useState(true);

//   const [isLoading6, setIsLoading6] = useState(true);

//   const [zones5, setZones5] = useState([]);
//   const [columns5, setColumns5] = useState<any>([]);
//   const [isLoading5, setIsLoading5] = useState(true);

//   const [zones9, setZones9] = useState([]);
//   const [columns9, setColumns9] = useState<any>([]);
//   const [isLoading9, setIsLoading9] = useState(true);

//   const [getTop, setGetTop] = useState(false);

//   const [getTop1, setGetTop1] = useState(false);

//   // UPDATED: Vehicle running status states from new API
//   const [isRunn, setRunn] = useState<any>(0);       // moving
//   const [isIdle, setIdle] = useState<any>(0);       // idle
//   const [isStop, setStop] = useState<any>(0);       // engOff
//   const [totalVeh, setTotalVeh] = useState<any>(0); // totVehicles
//   const [onRoadVeh, setOnRoadVeh] = useState<any>(0);
//   const [gpsStatus, setGpsStatus] = useState<any>(0);
//   const [totalDistance, setTotalDistance] = useState<any>(0);
//   const [isModal, setModal] = useState<any>(false);

//   const [isModal1, setModal1] = useState<any>(false);

//   const [vehicleDrawer, setVehicleDrawer] = useState(false);

//   const [itemId, setItemId] = useState<any>();

//   // New states for card modals
//   const [fuelConsumedOpen, setFuelConsumedOpen] = useState(false);
//   const [longIdleOpen, setLongIdleOpen] = useState(false);
//   const [wireTemperingOpen, setWireTemperingOpen] = useState(false);
//   const [fuelConsumedCount, setFuelConsumedCount] = useState(0);
//   const [longIdleCount, setLongIdleCount] = useState(0);
//   const [wireTemperingCount, setWireTemperingCount] = useState(0);

//   const [accordionExpanded, setAccordionExpanded] = useState<any>({});
//   const handleAccordionToggle = (index: any, isExpanded: any) => {
//     setAccordionExpanded((prev: any) => ({
//       ...prev,
//       [index]: !prev[index],
//     }));

//     if (isExpanded) {
//       if (index === 0) {
//         FuelconsData();
//       } else if (index === 1) {
//         IdleData();
//       } else if (index === 2) {
//         TodayVData();
//       } else if (index === 3) {
//         fetchZonesData();
//       }
//     } else {
//       console.log("function is not working");
//     }
//   };

//   const [value, setValue] = useState<any>(
//     parseInt(localStorage.getItem("dash") || "0", 10)
//   );

//   useEffect(() => {
//     localStorage.setItem("dash", value.toString() || "0");
//   }, [value]);

//   const [isTable, setTable] = useState([]);
//   const [isPrint, setPrint] = useState([]);
//   const [isPrint1, setPrint1] = useState([]);

//   const [isLabel, setlabel] = useState("");
//   const [isStatus, setStatus] = useState<any>("");
//   const [isStatus1, setStatus1] = useState("");

//   const [engineOnCount, setEngineOnCount] = useState(0);
//   const [engineOffCount, setEngineOffCount] = useState(0);

//   const downloadExcel = () => {
//     if (!isPrint || isPrint.length === 0) {
//       console.error("No data to export to Excel.");
//       return;
//     }

//     const ws = XLSX.utils.json_to_sheet(isPrint);

//     const headers = Object.keys(isPrint[0]);

//     headers.forEach((header, index) => {
//       const cellAddress = `${String.fromCharCode(65 + index)}1`;
//     });

//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, "vehicles");

//     XLSX.writeFile(wb, "FuelConsumed.xlsx");
//   };

//   const downloadExcel1 = () => {
//     if (!isPrint1 || isPrint1.length === 0) {
//       console.error("No data to export to Excel.");
//       return;
//     }

//     const ws = XLSX.utils.json_to_sheet(isPrint1);

//     const headers = Object.keys(isPrint1[0]);

//     headers.forEach((header, index) => {
//       const cellAddress = `${String.fromCharCode(65 + index)}1`;
//     });

//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, "vehicles");

//     XLSX.writeFile(wb, "Long_Idle.xlsx");
//   };

//   const handleTab = (event: any, newValue: any) => {
//     console.log(newValue);
//     setValue(newValue);
//   };

//   const items = [
//     { id: 0, text: <strong>{t("text.Dashboard")}</strong>, icon: <DashboardIcon /> },
//     { id: 1, text: <strong>{t("text.Tracking")}</strong>, icon: <GpsFixedIcon /> },
//     { id: 2, text: <strong>{t("text.GeofacingCreate")}</strong>, icon: <PlaceIcon /> },
//     { id: 3, text: <strong>{t("text.KudagharLocation")}</strong>, icon: <DeleteForeverIcon /> },
//     { id: 4, text: <strong>{t("text.VehicleHistory")}</strong>, icon: <CarCrashIcon /> },
//     { id: 5, text: <strong>{t("text.VehicleTravelled")}</strong>, icon: <EmojiTransportationIcon /> },
//   ];

//   const formatTrackTime = (tracktime: string) => {
//     const trackTime = new Date(tracktime);

//     // Check if the date is valid
//     if (isNaN(trackTime.getTime())) {
//       return "Invalid Date"; // Return a fallback message or handle it as needed
//     }

//     const day = trackTime.getDate().toString().padStart(2, "0");
//     const month = (trackTime.getMonth() + 1).toString().padStart(2, "0");
//     const year = trackTime.getFullYear();
//     const hours = trackTime.getHours().toString().padStart(2, "0");
//     const minutes = trackTime.getMinutes().toString().padStart(2, "0");
//     const seconds = trackTime.getSeconds().toString().padStart(2, "0");

//     return `${day}-${month}-${year} (Time:- ${hours}:${minutes}:${seconds})`;
//   };

//   const [vehicles, setVehicles] = useState<any>([]);
//   const [activeVehicle, setActiveVehicle] = useState<any>(null);
//   const [center, setCenter] = useState({ lat: 26.447965, lng: 80.3432 });
//   const mapRef: any = useRef(null);

//   useEffect(() => {
//     if (window.google && window.google.maps) {
//       console.log("Google Maps API loaded");
//     } else {
//       console.error("Google Maps API not loaded");
//     }
//   }, []);

//   // Function to get individual vehicle location data from DayVehOne API
//   const getVehicleLocationData = async (itemMasterId: number, vehicleNo: string) => {
//     try {
//       const currentDate = new Date().toISOString();

//       const requestData = {
//         itemMasterId: itemMasterId,
//         vehicleNo: vehicleNo,
//         dayDate: currentDate
//       };

//       const response = await api.post(`Mng/DayVehOne`, requestData);
//       const data = response?.data?.data || [];

//       if (data.length > 0) {
//         const arr = data.map((item: any) => ({
//           lat: item.lattitude,
//           lng: item.longitude,
//           id: item.id || Date.now(),
//           speed: item.speed || 0,
//           tracktime: formatTrackTime(item.trackTime),
//           distance: item.distance || 0,
//           nearme: item?.nearme || "Unknown",
//           vehicleNo: item.vehicleNo || vehicleNo,
//           icon:
//             item.speed === 0 || item.speed === 0
//               ? "https://png.pngtree.com/png-vector/20240128/ourmid/pngtree-red-truck-transportation-png-image_11507611.png"
//               : "https://png.pngtree.com/png-vector/20240128/ourmid/pngtree-green-truck-transport-png-image_11508688.png",
//         }));

//         setVehicles(arr);
//         setCenter(calculateCenter(arr));
//         setCurrentMap(true);

//         if (arr.length > 0 && mapRef.current) {
//           adjustZoomLevel(arr);
//         }
//       } else {
//         // If no data from DayVehOne, try to use current vehicle data
//         const vehicleData = zones3.find((v: any) => v.itemmasterid === itemMasterId);
//         if (vehicleData) {
//           const arr = [{
//             lat: vehicleData.lattitude,
//             lng: vehicleData.longitude,
//             id: vehicleData.itemmasterid || Date.now(),
//             speed: vehicleData.speed || 0,
//             tracktime: formatTrackTime(vehicleData.trackTime),
//             distance: vehicleData.distance || 0,
//             nearme: vehicleData?.nearme || "Unknown",
//             vehicleNo: vehicleData.vehicleNo,
//             icon:
//               vehicleData.speed === 0 || vehicleData.speedDecimal === 0
//                 ? "https://png.pngtree.com/png-vector/20240128/ourmid/pngtree-red-truck-transportation-png-image_11507611.png"
//                 : "https://png.pngtree.com/png-vector/20240128/ourmid/pngtree-green-truck-transport-png-image_11508688.png",
//           }];

//           setVehicles(arr);
//           setCenter({ lat: vehicleData.lattitude, lng: vehicleData.longitude });
//           setCurrentMap(true);

//           if (arr.length > 0 && mapRef.current) {
//             const bounds = new window.google.maps.LatLngBounds();
//             bounds.extend(new window.google.maps.LatLng(vehicleData.lattitude, vehicleData.longitude));
//             mapRef.current.fitBounds(bounds);
//           }
//         }
//       }
//     } catch (error) {
//       console.error("Error fetching vehicle location data:", error);

//       // Fallback to current vehicle data
//       const vehicleData = zones3.find((v: any) => v.itemmasterid === itemMasterId);
//       if (vehicleData) {
//         const arr = [{
//           lat: vehicleData.lattitude,
//           lng: vehicleData.longitude,
//           id: vehicleData.itemmasterid || Date.now(),
//           speed: vehicleData.speed || 0,
//           tracktime: formatTrackTime(vehicleData.trackTime),
//           distance: vehicleData.distance || 0,
//           nearme: vehicleData?.nearme || "Unknown",
//           vehicleNo: vehicleData.vehicleNo,
//           icon:
//             vehicleData.speed === 0 || vehicleData.speedDecimal === 0
//               ? "https://png.pngtree.com/png-vector/20240128/ourmid/pngtree-red-truck-transportation-png-image_11507611.png"
//               : "https://png.pngtree.com/png-vector/20240128/ourmid/pngtree-green-truck-transport-png-image_11508688.png",
//         }];

//         setVehicles(arr);
//         setCenter({ lat: vehicleData.lattitude, lng: vehicleData.longitude });
//         setCurrentMap(true);
//       }
//     }
//   };

//   // Function to handle vehicle number click in the table
//   const handleVehicleNumberClick = (row: any) => {
//     if (row.itemmasterid) {
//       getVehicleLocationData(row.itemmasterid, row.vehicleNo);
//     } else {
//       // Fallback to original function if no itemmasterid
//       getCurrentDataFromDayVehData(row);
//     }
//   };

//   const calculateCenter = (vehicles: any) => {
//     if (vehicles.length === 0) {
//       return { lat: 26.447965, lng: 80.3432 }; // Default center if no vehicles
//     }

//     const latitudes = vehicles.map((vehicle: any) => vehicle.lat);
//     const longitudes = vehicles.map((vehicle: any) => vehicle.lng);

//     const avgLat =
//       latitudes.reduce((sum: any, lat: any) => sum + lat, 0) / latitudes.length;
//     const avgLng =
//       longitudes.reduce((sum: any, lng: any) => sum + lng, 0) /
//       longitudes.length;

//     return { lat: avgLat, lng: avgLng }; // Return the center point
//   };

//   // Adjust the zoom level based on the spread of the vehicles
//   const adjustZoomLevel = (vehicles: any) => {
//     const bounds = new window.google.maps.LatLngBounds();

//     vehicles.forEach((vehicle: any) => {
//       bounds.extend(new window.google.maps.LatLng(vehicle.lat, vehicle.lng));
//     });

//     if (mapRef.current) {
//       mapRef.current.fitBounds(bounds); // Fit the map to the bounds of all vehicles
//     }
//   };

//   const handleMarkerMouseOver = (vehicle: any) => {
//     setActiveVehicle(vehicle);
//   };

//   const handleMarkerMouseOut = () => {
//     setActiveVehicle(null);
//   };

//   useEffect(() => {
//     getZoneData();

//     const interval = setInterval(() => {
//       getZoneData();
//     }, 3000);

//     return () => clearInterval(interval);
//   }, []);

//   const handleClose = () => {
//     setModal(false);
//   };

//   const handleClose1 = () => {
//     setModal1(false);
//   };

//   const handleClose2 = () => {
//     setVisible(false);
//   };

//   // Modal handlers for new cards
//   const handleFuelConsumedOpen = () => {
//     setFuelConsumedOpen(true);
//     FuelconsData();
//   };

//   const handleFuelConsumedClose = () => {
//     setFuelConsumedOpen(false);
//   };

//   const handleLongIdleOpen = () => {
//     setLongIdleOpen(true);
//     IdleData();
//   };

//   const handleLongIdleClose = () => {
//     setLongIdleOpen(false);
//   };

//   const handleWireTemperingOpen = () => {
//     setWireTemperingOpen(true);
//     fetchZonesData();
//   };

//   const handleWireTemperingClose = () => {
//     setWireTemperingOpen(false);
//   };

//   const zoneModal = async (Zone: any) => {
//     setlabel(Zone.label);
//     try {
//       const response = await api.get(`NTRead/GetTopFuelConsNTS/zone=${Zone.label}`);
//       const data = response.data.data;

//       const zonesWithIds = data.map((zone: any, index: any) => ({
//         ...zone,
//         serialNo: index + 1,
//         id: index + 1,
//       }));
//       setZones9(zonesWithIds);
//       setIsLoading9(false);

//       if (data.length > 0) {
//         const columns9: GridColDef[] = [
//           {
//             field: "serialNo",
//             headerName: t("text.SrNo"),
//             flex: 0.5,
//             cellClassName: "wrap-text",
//           },
//           {
//             field: "vehicleNo",
//             headerName: t("text.VehicleNo"),
//             flex: 1,
//             cellClassName: "wrap-text",
//           },
//           {
//             field: "driver",
//             renderHeader: () => (
//               <>
//                 <PersonIcon
//                   style={{ marginRight: 8, verticalAlign: "middle" }}
//                 />
//                 <span style={{ verticalAlign: "middle" }}>
//                   {t("text.Driver")}
//                 </span>
//               </>
//             ),
//             flex: 1.5,
//             renderCell: (params) => {
//               const { empName, empMobileNo } = params.row;
//               return `${empName} (${empMobileNo})`;
//             },
//           },
//           {
//             field: "departmentName",
//             headerName: t("text.DepartmentName"),
//             flex: 1,
//             cellClassName: "wrap-text",
//           },
//           {
//             field: "vehicleTypename",
//             headerName: t("text.VehicleTypeName"),
//             flex: 1,
//             cellClassName: "wrap-text",
//           },
//           {
//             field: "flag",
//             headerName: t("text.Status"),
//             flex: 1,
//             cellClassName: "wrap-text",
//             align: "center",
//             headerAlign: "center",
//           },
//           {
//             field: "speed",
//             headerName: t("text.Speed"),
//             flex: 0.5,
//             cellClassName: "wrap-text",
//           },
//           {
//             field: "fuel",
//             headerName: "Fuel",
//             flex: 1,
//             align: "center",
//             headerAlign: "center",
//             valueFormatter: ({ value }) => (value ? value.toFixed(2) : ""),
//             cellClassName: "wrap-text",
//           },
//         ];
//         setColumns9(columns9 as any);
//       }
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   const adjustedColumns10 = columns9.map((column: any) => ({
//     ...column,
//   }));

//   // UPDATED: Fixed ignition data function with correct status display
//   const IgnitionData = async (value: boolean) => {
//     setModal1(true);
//     setIsLoading5(true);
//     try {
//       console.log("Check value", value);
//       const statusText = value ? "ON" : "OFF";
//       setStatus(statusText);

//       const response = await api.get(`Mng/EngineOnOff?onoff=${value}`);
//       const data = response.data.data || [];

//       const zonesWithIds = data.map((zone: any, index: any) => ({
//         ...zone,
//         serialNo: zone.sno || index + 1,
//         id: zone.itemmasterid || index + 1,
//         vehicleNo: zone.vehicleno,
//         driver: zone.driver,
//         acc: zone.acc ? "On" : "Off"
//       }));

//       setZones5(zonesWithIds);
//       setIsLoading5(false);

//       if (data.length > 0) {
//         const columns2: GridColDef[] = [
//           {
//             field: "serialNo",
//             renderHeader: () => (
//               <>
//                 <ListAlt style={{ marginRight: 8, verticalAlign: "middle" }} />
//                 <span style={{ verticalAlign: "middle" }}>
//                   {t("text.SrNo")}
//                 </span>
//               </>
//             ),
//             cellClassName: "wrap-text",
//             flex: 0.3,
//             valueGetter: (params) => params.row.sno || params.row.serialNo,
//           },
//           {
//             field: "vehicleNo",
//             renderHeader: () => (
//               <>
//                 <DirectionsCar
//                   style={{ marginRight: 8, verticalAlign: "middle" }}
//                 />
//                 <span style={{ verticalAlign: "middle" }}>
//                   {t("text.VehicleNo")}
//                 </span>
//               </>
//             ),
//             cellClassName: "wrap-text",
//             flex: 1,
//             valueGetter: (params) => params.row.vehicleno || params.row.vehicleNo,
//           },
//           {
//             field: "driver",
//             cellClassName: "wrap-text",
//             renderHeader: () => (
//               <>
//                 <PersonIcon
//                   style={{ marginRight: 8, verticalAlign: "middle" }}
//                 />
//                 <span style={{ verticalAlign: "middle" }}>
//                   {t("text.Driver")}
//                 </span>
//               </>
//             ),
//             flex: 1.5,
//             valueGetter: (params) => params.row.driver,
//           },
//           {
//             field: "acc",
//             renderHeader: () => (
//               <>
//                 <CheckCircle
//                   style={{ marginRight: 8, verticalAlign: "middle" }}
//                 />
//                 <span style={{ verticalAlign: "middle" }}>
//                   {t("text.Status")}
//                 </span>
//               </>
//             ),
//             cellClassName: "wrap-text",
//             flex: 0.5,
//             valueGetter: (params) => params.row.acc ? "On" : "Off",
//           },
//         ];
//         setColumns5(columns2 as any);
//       }
//     } catch (error) {
//       console.error("Error fetching data:", error);
//       setIsLoading5(false);
//     }
//   };

//   const adjustedColumns5 = columns5.map((column: any) => ({
//     ...column,
//     cellClassName: "wrap-text",
//   }));

//   // UPDATED: Function to fetch running status data from DayVehData API
//   const runningData = async (statusType: string) => {
//     setStatus1(statusType);
//     setModal(true);
//     setIsLoading4(true);

//     try {
//       // Map status types to API parameters
//       const statusMap: { [key: string]: number } = {
//         "running": 3,    // moving
//         "idle": 4,       // idle
//         "stop": 2        // off
//       };

//       const statusParam = statusMap[statusType] || 1;

//       const response = await api.get(`Mng/DayVehData?status=${statusParam}`);
//       const data = response.data.data || [];

//       const zonesWithIds = data.map((zone: any, index: any) => ({
//         ...zone,
//         serialNo: index + 1,
//         id: index + 1,
//         vehicleNo: zone.vehicleNo,
//         departmentName: zone.department,
//         vehicleTypename: zone.vehicleType || "N/A",
//         driver: zone.driver,
//         status: statusType.charAt(0).toUpperCase() + statusType.slice(1)
//       }));

//       setZones4(zonesWithIds);
//       setIsLoading4(false);

//       if (data.length > 0) {
//         const columns2: GridColDef[] = [
//           {
//             field: "serialNo",
//             renderHeader: () => (
//               <>
//                 <ListAlt style={{ marginRight: 8, verticalAlign: "middle" }} />
//                 <span style={{ verticalAlign: "middle" }}>
//                   {t("text.SrNo")}
//                 </span>
//               </>
//             ),
//             flex: 0.5,
//             cellClassName: "wrap-text",
//           },
//           {
//             field: "vehicleNo",
//             renderHeader: () => (
//               <>
//                 <DirectionsCar
//                   style={{ marginRight: 8, verticalAlign: "middle" }}
//                 />
//                 <span style={{ verticalAlign: "middle" }}>
//                   {t("text.VehicleNo")}
//                 </span>
//               </>
//             ),
//             flex: 1,
//             cellClassName: "wrap-text",
//           },
//           {
//             field: "driver",
//             renderHeader: () => (
//               <>
//                 <PersonIcon
//                   style={{ marginRight: 8, verticalAlign: "middle" }}
//                 />
//                 <span style={{ verticalAlign: "middle" }}>
//                   {t("text.Driver")}
//                 </span>
//               </>
//             ),
//             flex: 1.5,
//             cellClassName: "wrap-text",
//             valueGetter: (params) => params.row.driver || "N/A",
//           },
//           {
//             field: "departmentName",
//             renderHeader: () => (
//               <>
//                 <Work style={{ marginRight: 8, verticalAlign: "middle" }} />
//                 <span style={{ verticalAlign: "middle" }}>
//                   {t("text.DepartmentName")}
//                 </span>
//               </>
//             ),
//             flex: 1,
//             cellClassName: "wrap-text",
//             valueGetter: (params) => params.row.department || "N/A",
//           },
//           {
//             field: "vehicleTypename",
//             renderHeader: () => (
//               <>
//                 <DirectionsBike
//                   style={{ marginRight: 8, verticalAlign: "middle" }}
//                 />
//                 <span style={{ verticalAlign: "middle" }}>
//                   {t("text.VehicleTypeName")}
//                 </span>
//               </>
//             ),
//             flex: 1,
//             cellClassName: "wrap-text",
//             valueGetter: (params) => params.row.vehicleType || "N/A",
//           },
//           {
//             field: "trackTime",
//             renderHeader: () => (
//               <>
//                 <FaClock style={{ marginRight: 8, verticalAlign: "middle" }} />
//                 <span style={{ verticalAlign: "middle" }}>
//                   Last Update
//                 </span>
//               </>
//             ),
//             flex: 1.5,
//             cellClassName: "wrap-text",
//             valueGetter: (params) => {
//               if (!params.row.trackTime) return "N/A";
//               const date = new Date(params.row.trackTime);
//               return `${date.getDate().toString().padStart(2, '0')}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getFullYear()} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
//             },
//           },
//         ];
//         setColumns4(columns2 as any);
//       }
//     } catch (error) {
//       console.error("Error fetching running status data:", error);
//       setIsLoading4(false);
//     }
//   };

//   const adjustedColumns4 = columns4.map((column: any) => ({
//     ...column,
//   }));

//   useEffect(() => {
//     fetchEngineStatus();
//     setInterval(() => {
//       fetchEngineStatus();
//     }, 3000);
//   }, []);

//   // Function to fetch engine status counts
//   const fetchEngineStatus = async () => {
//     try {
//       // Fetch engine ON count
//       const onResponse = await api.get(`Mng/EngineOnOff?onoff=true`);
//       const onData = onResponse.data.data || [];
//       const onCount = onData.length;
//       setEngineOnCount(onCount);

//       // Fetch engine OFF count
//       const offResponse = await api.get(`Mng/EngineOnOff?onoff=false`);
//       const offData = offResponse.data.data || [];
//       const offCount = offData.length;
//       setEngineOffCount(offCount);

//       // Update pie chart data
//       const pieChartData = [
//         { id: 1, value: onCount, label: "On" },
//         { id: 2, value: offCount, label: "Off" },
//       ];
//       setlabelsData(pieChartData);

//     } catch (error) {
//       console.error("Error fetching engine status:", error);
//     }
//   };

//   // UPDATED: Get current statistics from new API
//   const getZoneData = () => {
//     api
//       .get("Mng/CurrentStat")
//       .then((res) => {
//         const data = res.data.data;

//         // UPDATED: Set values from new API
//         setRunn(data.moving);               // Running vehicles
//         setIdle(data.idle);                 // Idle vehicles
//         setStop(data.engOff);               // Stopped vehicles (engine off)
//         setTotalVeh(data.totVehicles);      // Total vehicles
//         setTotalDistance(data.totDistance); // Total distance

//         // Calculate vehicles on road: moving + idle
//         setOnRoadVeh(data.moving + data.idle + data.engOff);
//         setGpsStatus(data.totVehicles);

//         // Set engine status counts from API
//         setEngineOnCount(data.engOn);
//         setEngineOffCount(data.engOff);

//         // Update pie chart data for engine status
//         const pieChartData = [
//           { id: 1, value: data.engOn, label: "On" },
//           { id: 2, value: data.engOff, label: "Off" },
//         ];
//         setlabelsData(pieChartData);

//         // Process zone-wise data for pie chart
//         if (data.zoneWise && data.zoneWise.length > 0) {
//           // Group by zone to count vehicles per zone
//           const zoneCounts: { [key: string]: number } = {};
//           data.zoneWise.forEach((zone: any) => {
//             const zoneName = zone.zonename;
//             zoneCounts[zoneName] = (zoneCounts[zoneName] || 0) + 1;
//           });

//           // Convert to chart data format
//           const chartData = Object.keys(zoneCounts).map((zoneName, index) => ({
//             value: zoneCounts[zoneName],
//             label: zoneName,
//             id: index + 1
//           }));

//           // Sort by zone name
//           const sortedChartData = chartData.sort((a: any, b: any) => {
//             const zoneA = parseInt(a.label.split(" ")[1], 10);
//             const zoneB = parseInt(b.label.split(" ")[1], 10);
//             return zoneA - zoneB;
//           });

//           setChartData(sortedChartData);
//           setChartIsLoading(false);
//         } else {
//           console.error("No zone data available.");
//         }

//         // Fetch counts for cards
//         fetchCardCounts();

//       })
//       .catch((error) => {
//         console.error("Error fetching data:", error);
//       });
//   };

//   const fetchCardCounts = async () => {
//     try {
//       // Fetch Fuel Consumed count (using existing API)
//       const fuelResponse = await api.get(`NTRead/GetTopFuelCons/nos=50`);
//       setFuelConsumedCount(fuelResponse.data.data.length);

//       // UPDATED: Fetch Long Idle count from new API
//       const idleResponse = await api.get(`Mng/LongIdleVehicles?maxno=100`);
//       setLongIdleCount(idleResponse.data.data.length);

//       // UPDATED: Fetch Wire Tempering count from new API (using DayVehData)
//       const wireResponse = await api.get(`Mng/DayVehData`);
//       setWireTemperingCount(wireResponse.data.data.length);
//     } catch (error) {
//       console.error("Error fetching card counts:", error);
//     }
//   };

//   const formatDate = (date: any) => {
//     const month = ("0" + (date.getMonth() + 1)).slice(-2);
//     const day = ("0" + date.getDate()).slice(-2);
//     const year = date.getFullYear();
//     return `${month}-${day}-${year}`;
//   };

//   const formattedDate = formatDate(new Date());

//   // UPDATED: Fetch zones data using new API (DayVehData)
//   const fetchZonesData = async () => {
//     try {
//       const response = await api.get(`Mng/DayVehData`);
//       const data = response.data.data;

//       const zonesWithIds = data?.map((zone: any, index: any) => ({
//         ...zone,
//         serialNo: index + 1,
//         id: index + 1,
//         vehicleNo: zone.vehicleNo,
//         departmentName: zone.department,
//         date: zone.trackTime,
//         devid: zone.deviceId
//       }));
//       setZones(zonesWithIds);
//       setIsLoading(false);

//       if (data.length > 0) {
//         const columns: GridColDef[] = [
//           {
//             field: "serialNo",
//             headerName: t("text.SrNo"),
//             flex: 0.5,
//           },
//           {
//             field: "vehicleNo",
//             headerName: t("text.VehicleNo"),
//             flex: 1,
//           },
//           {
//             field: "departmentName",
//             headerName: t("text.DepartmentName"),
//             flex: 1,
//           },
//           {
//             field: "date",
//             headerName: t("text.Date"),
//             flex: 1,
//             valueGetter: (params) => {
//               const date = new Date(params.value);
//               const formattedDate = `${String(date.getDate()).padStart(
//                 2,
//                 "0"
//               )}-${String(date.getMonth() + 1).padStart(
//                 2,
//                 "0"
//               )}-${date.getFullYear()}`;
//               const time = `${String(date.getHours()).padStart(
//                 2,
//                 "0"
//               )}:${String(date.getMinutes()).padStart(2, "0")}:${String(
//                 date.getSeconds()
//               ).padStart(2, "0")}`;
//               return `${formattedDate} (Time: ${time})`;
//             },
//           },
//           {
//             field: "devid",
//             headerName: t("text.Devid"),
//             flex: 1,
//           },
//         ];
//         setColumns(columns as any);
//       }
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   const adjustedColumns = columns.map((column: any) => ({
//     ...column,
//   }));

//   useEffect(() => {
//     FuelconsData();
//   }, [getTop]);

//   useEffect(() => {
//     IdleData();
//   }, [getTop1]);

//   const FuelconsData = async () => {
//     try {
//       const recordsCount = getTop ? 10 : 50;
//       const response = await api.get(`NTRead/GetTopFuelCons/nos=${recordsCount}`);
//       const data = response.data.data;

//       setPrint(data);
//       setFuelConsumedCount(data.length);

//       const zonesWithIds = data.map((zone: any, index: any) => ({
//         ...zone,
//         serialNo: index + 1,
//         id: index + 1,
//       }));
//       setZones1(zonesWithIds);
//       setIsLoading1(false);

//       if (data.length > 0) {
//         const columns1: GridColDef[] = [
//           {
//             field: "serialNo",
//             headerName: t("text.SrNo"),
//             flex: 0.5,
//           },
//           {
//             field: "vehicleNo",
//             headerName: t("text.VehicleNo"),
//             flex: 1,
//           },
//           {
//             field: "departmentname",
//             headerName: t("text.DepartmentName"),
//             flex: 1,
//           },
//           {
//             field: "fuelConsumed",
//             headerName: t("text.FuelConsumed"),
//             flex: 1,
//             align: "right",
//             headerAlign: "right",
//             valueFormatter: ({ value }) => (value ? value.toFixed(2) : ""),
//           },
//         ];
//         setColumns1(columns1 as any);
//       }
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   const adjustedColumns1 = columns1.map((column: any) => ({
//     ...column,
//   }));

//   // UPDATED: Long Idle Vehicles from new API
//   const IdleData = async () => {
//     try {
//       const recordsCount = getTop1 ? 10 : 50;
//       const response = await api.get(`Mng/LongIdleVehicles?maxno=${recordsCount}`);
//       const data = response?.data?.data;

//       setPrint1(data);
//       setLongIdleCount(data.length);

//       const zonesWithIds = data.map((zone: any, index: any) => ({
//         ...zone,
//         serialNo: index + 1,
//         id: index + 1,
//         vehicleNo: zone.vehicleNo,
//         vehicleTypename: zone.vehtype,
//         idleTime: zone.sduration,
//         departmentname: zone.department,
//         empName: "", // Not available in new API response
//         empMobileNo: "" // Not available in new API response
//       }));
//       setZones2(zonesWithIds);
//       setIsLoading2(false);

//       if (data.length > 0) {
//         const columns2: GridColDef[] = [
//           {
//             field: "vehicleNo",
//             headerName: t("text.VehicleNo"),
//             flex: 1,
//             cellClassName: "wrap-text",
//           },
//           {
//             field: "vehicleTypename",
//             headerName: t("text.VehicleType"),
//             flex: 2,
//             cellClassName: "wrap-text",
//           },
//           {
//             field: "idleTime",
//             headerName: t("text.Duration"),
//             flex: 1,
//             cellClassName: "wrap-text",
//           },
//           {
//             field: "departmentname",
//             headerName: t("text.DepartmentName"),
//             flex: 1,
//             cellClassName: "wrap-text",
//           },
//           {
//             field: "empName",
//             headerName: t("text.Driver"),
//             flex: 1.5,
//             cellClassName: "wrap-text",
//             renderCell: (params) => {
//               const { empName, empMobileNo } = params.row;
//               return `${empName} (${empMobileNo})`;
//             },
//           },
//         ];
//         setColumns2(columns2 as any);
//       }
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   const adjustedColumns2 = columns2.map((column: any) => ({
//     ...column,
//   }));

//   const styles = `
//   .wrap-text {
//     white-space: normal !important;
//     word-wrap: break-word !important;
//     overflow-wrap: break-word !important;
//   }
  
//   .vehicle-number-link {
//     color: #1976d2 !important;
//     text-decoration: underline !important;
//     cursor: pointer !important;
//     font-weight: 600 !important;
//     transition: all 0.2s ease-in-out !important;
//   }
  
//   .vehicle-number-link:hover {
//     color: #0d47a1 !important;
//     text-decoration: none !important;
//     transform: scale(1.05) !important;
//   }
// `;

//   document.head.insertAdjacentHTML("beforeend", `<style>${styles}</style>`);

//   // UPDATED: Today Vehicle Status from DayVehData API with status:5 parameter
//   const TodayVData = async () => {
//     try {
//       const response = await api.get(`Mng/DayVehData?status=5`);
//       const data = response.data.data || [];

//       const zonesWithIds = data.map((zone: any, index: any) => ({
//         ...zone,
//         serialNo: index + 1,
//         id: zone.itemmasterid || index + 1,
//         vehicleNo: zone.vehicleNo,
//         trackTime: zone.trackTime,
//         departmentName: zone.department,
//         vehicleTypename: zone.vehicleType || "N/A",
//         kmPerLitre: 0, // Not available in DayVehData API response
//         ignition: zone.acc ? "On" : "Off", // Use acc field for ignition status
//         distance: zone.distance || 0,
//         runtime: zone.secondsRun || 0, // In seconds
//         idletime: zone.secondsIdle || 0, // In seconds
//         lat: zone.lattitude,
//         lon: zone.longitude,
//         speed: zone.speed || zone.speedDecimal || 0,
//         driver: zone.driver || "N/A",
//         itemmasterid: zone.itemmasterid,
//         deviceId: zone.deviceId,
//         nearme: zone.nearme || "Unknown"
//       }));
//       setZones3(zonesWithIds);
//       setIsLoading3(false);

//       if (data.length > 0) {
//         const columns2: GridColDef[] = [
//           {
//             field: "serialNo",
//             headerName: t("text.SrNo"),
//             flex: 0.5,
//             cellClassName: "wrap-text",
//           },
//           {
//             field: "vehicleNo",
//             headerName: t("text.VehicleNo"),
//             flex: 1,
//             cellClassName: "wrap-text",
//             renderCell: (params) => (
//               <span
//                 onClick={() => handleVehicleNumberClick(params.row)}
//                 className="vehicle-number-link"
//                 title="Click to view vehicle location on map"
//               >
//                 {params.value}
//               </span>
//             ),
//           },
//           {
//             field: "trackTime",
//             headerName: t("text.TrackTime"),
//             flex: 1.5,
//             cellClassName: "wrap-text",
//             valueGetter: (params) => {
//               if (!params.value) return "N/A";
//               const date = new Date(params.value);
//               const formattedDate = `${String(date.getDate()).padStart(
//                 2,
//                 "0"
//               )}-${String(date.getMonth() + 1).padStart(
//                 2,
//                 "0"
//               )}-${date.getFullYear()}`;
//               const time = `${String(date.getHours()).padStart(
//                 2,
//                 "0"
//               )}:${String(date.getMinutes()).padStart(2, "0")}:${String(
//                 date.getSeconds()
//               ).padStart(2, "0")}`;
//               return `${formattedDate} ${time}`;
//             },
//           },
//           {
//             field: "departmentName",
//             headerName: t("text.DepartmentName"),
//             flex: 1.2,
//             cellClassName: "wrap-text",
//           },
//           {
//             field: "vehicleTypename",
//             headerName: t("text.VehicleTypeName"),
//             flex: 1,
//             cellClassName: "wrap-text",
//           },
//           {
//             field: "ignition",
//             headerName: t("text.Ignition"),
//             flex: 0.8,
//             cellClassName: "wrap-text",
//             renderCell: (params) => (
//               <Chip
//                 label={params.value}
//                 size="small"
//                 color={params.value === "On" ? "success" : "error"}
//                 variant="outlined"
//                 onClick={() => {
//                   if (params.row.ignition === "On") {
//                     IgnitionData(true);
//                   } else if (params.row.ignition === "Off") {
//                     IgnitionData(false);
//                   }
//                 }}
//                 style={{ cursor: "pointer" }}
//               />
//             ),
//           },
//           {
//             field: "distance",
//             headerName: t("text.Distance (Km)"),
//             flex: 1,
//             align: "right",
//             headerAlign: "right",
//             valueFormatter: ({ value }) => value ? value.toFixed(2) : "0.00",
//             cellClassName: "wrap-text",
//           },
//           {
//             field: "speed",
//             headerName: t("text.Speed (km/h)"),
//             flex: 1,
//             align: "right",
//             headerAlign: "right",
//             valueFormatter: ({ value }) => value ? value.toFixed(0) : "0",
//             cellClassName: "wrap-text",
//           },
//           {
//             field: "driver",
//             headerName: t("text.Driver"),
//             flex: 1.5,
//             cellClassName: "wrap-text",
//           },
//         ];
//         setColumns3(columns2 as any);
//       }
//     } catch (error) {
//       console.error("Error fetching Today Vehicle Status data:", error);
//       setIsLoading3(false);
//     }
//   };

//   const adjustedColumns3 = columns3.map((column: any) => ({
//     ...column,
//   }));

//   return (
//     <div>
//       {/* Summary Cards Section - Placed above the tabs */}
//       <Grid container spacing={2} style={{ marginBottom: "15px", marginTop: "5px" }}>
//         {/* Fuel Consumed Card */}
//         <Grid item xs={12} sm={6} md={4}>
//           <motion.div
//             whileHover={{
//               scale: 1.05,
//               y: -5,
//               transition: { duration: 0.2 }
//             }}
//             whileTap={{ scale: 0.98 }}
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.3 }}
//           >
//             <Card
//               sx={{
//                 height: '120px',
//                 cursor: 'pointer',
//                 border: '1px solid rgba(66, 182, 245, 0.2)',
//                 borderRadius: '12px',
//                 background: 'linear-gradient(135deg, #ffffff 0%, #f8fbff 100%)',
//                 transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
//                 position: 'relative',
//                 overflow: 'hidden',
//                 '&:before': {
//                   content: '""',
//                   position: 'absolute',
//                   top: 0,
//                   left: 0,
//                   width: '100%',
//                   height: '4px',
//                   background: 'linear-gradient(90deg, #42b6f5, #2196f3)',
//                   transform: 'scaleX(0)',
//                   transformOrigin: 'left',
//                   transition: 'transform 0.4s ease',
//                 },
//                 '&:hover': {
//                   boxShadow: '0 10px 25px rgba(66, 182, 245, 0.2)',
//                   borderColor: 'rgba(66, 182, 245, 0.4)',
//                   transform: 'translateY(-4px)',
//                   '&:before': {
//                     transform: 'scaleX(1)',
//                   },
//                   '& .icon-container': {
//                     transform: 'scale(1.1) rotate(5deg)',
//                     boxShadow: '0 8px 20px rgba(66, 182, 245, 0.3)',
//                   }
//                 }
//               }}
//               onClick={handleFuelConsumedOpen}
//             >
//               <CardContent sx={{
//                 p: 2.5,
//                 height: '100%',
//                 display: 'flex',
//                 alignItems: 'center',
//                 position: 'relative',
//                 zIndex: 1
//               }}>
//                 <Box
//                   className="icon-container"
//                   sx={{
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     width: 70,
//                     height: 70,
//                     borderRadius: '12px',
//                     background: 'linear-gradient(135deg, rgba(66, 182, 245, 0.1) 0%, rgba(66, 182, 245, 0.2) 100%)',
//                     marginRight: 2.5,
//                     flexShrink: 0,
//                     transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
//                     position: 'relative',
//                     overflow: 'hidden',
//                     '&:after': {
//                       content: '""',
//                       position: 'absolute',
//                       top: 0,
//                       left: 0,
//                       width: '100%',
//                       height: '100%',
//                       background: 'linear-gradient(135deg, transparent 30%, rgba(255, 255, 255, 0.4) 100%)',
//                       borderRadius: '12px',
//                     }
//                   }}
//                 >
//                   <LocalGasStation
//                     fontSize="large"
//                     sx={{
//                       color: ' #12286d',
//                       filter: 'drop-shadow(0 2px 4px rgba(66, 182, 245, 0.3))',
//                       zIndex: 1,
//                       position: 'relative'
//                     }}
//                   />
//                 </Box>
//                 <Box sx={{ flexGrow: 1, textAlign: 'left' }}>
//                   <Typography
//                     variant="h6"
//                     sx={{
//                       fontWeight: 700,
//                       color: '#1a237e',
//                       fontSize: '1.1rem',
//                       letterSpacing: '0.5px',
//                       mb: 1,
//                       textTransform: 'uppercase'
//                     }}
//                   >
//                     Fuel Consumed
//                   </Typography>
//                   <Box sx={{ display: 'flex', alignItems: 'baseline' }}>
//                     <Typography
//                       variant="h3"
//                       sx={{
//                         fontWeight: 800,
//                         color: '#12286d',
//                         fontSize: '2.5rem',
//                         lineHeight: 1,
//                         mr: 1,
//                         textShadow: '0 2px 4px rgba(66, 182, 245, 0.2)'
//                       }}
//                     >
//                       {fuelConsumedCount}
//                     </Typography>
//                     <Typography
//                       variant="caption"
//                       sx={{
//                         fontWeight: 600,
//                         color: '#666',
//                         fontSize: '0.75rem',
//                         letterSpacing: '0.5px'
//                       }}
//                     >
//                       Vehicles
//                     </Typography>
//                   </Box>
//                 </Box>
//               </CardContent>
//             </Card>
//           </motion.div>
//         </Grid>

//         {/* Long Idle Vehicle Card */}
//         <Grid item xs={12} sm={6} md={4}>
//           <motion.div
//             whileHover={{
//               scale: 1.05,
//               y: -5,
//               transition: { duration: 0.2 }
//             }}
//             whileTap={{ scale: 0.98 }}
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.3, delay: 0.1 }}
//           >
//             <Card
//               sx={{
//                 height: '120px',
//                 cursor: 'pointer',
//                 border: '1px solid rgba(66, 182, 245, 0.2)',
//                 borderRadius: '12px',
//                 background: 'linear-gradient(135deg, #ffffff 0%, #f8fbff 100%)',
//                 transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
//                 position: 'relative',
//                 overflow: 'hidden',
//                 '&:before': {
//                   content: '""',
//                   position: 'absolute',
//                   top: 0,
//                   left: 0,
//                   width: '100%',
//                   height: '4px',
//                   background: 'linear-gradient(90deg, #42b6f5, #2196f3)',
//                   transform: 'scaleX(0)',
//                   transformOrigin: 'left',
//                   transition: 'transform 0.4s ease',
//                 },
//                 '&:hover': {
//                   boxShadow: '0 10px 25px rgba(66, 182, 245, 0.2)',
//                   borderColor: 'rgba(66, 182, 245, 0.4)',
//                   transform: 'translateY(-4px)',
//                   '&:before': {
//                     transform: 'scaleX(1)',
//                   },
//                   '& .icon-container': {
//                     transform: 'scale(1.1) rotate(5deg)',
//                     boxShadow: '0 8px 20px rgba(66, 182, 245, 0.3)',
//                   }
//                 }
//               }}
//               onClick={handleLongIdleOpen}
//             >
//               <CardContent sx={{
//                 p: 2.5,
//                 height: '100%',
//                 display: 'flex',
//                 alignItems: 'center',
//                 position: 'relative',
//                 zIndex: 1
//               }}>
//                 <Box
//                   className="icon-container"
//                   sx={{
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     width: 70,
//                     height: 70,
//                     borderRadius: '12px',
//                     background: 'linear-gradient(135deg, rgba(66, 182, 245, 0.1) 0%, rgba(66, 182, 245, 0.2) 100%)',
//                     marginRight: 2.5,
//                     flexShrink: 0,
//                     transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
//                     position: 'relative',
//                     overflow: 'hidden',
//                     '&:after': {
//                       content: '""',
//                       position: 'absolute',
//                       top: 0,
//                       left: 0,
//                       width: '100%',
//                       height: '100%',
//                       background: 'linear-gradient(135deg, transparent 30%, rgba(255, 255, 255, 0.4) 100%)',
//                       borderRadius: '12px',
//                     }
//                   }}
//                 >
//                   <FaClock
//                     style={{
//                       fontSize: "28px",
//                       color: '#12286d',
//                       filter: 'drop-shadow(0 2px 4px rgba(66, 182, 245, 0.3))',
//                       zIndex: 1,
//                       position: 'relative'
//                     }}
//                   />
//                 </Box>
//                 <Box sx={{ flexGrow: 1, textAlign: 'left' }}>
//                   <Typography
//                     variant="h6"
//                     sx={{
//                       fontWeight: 700,
//                       color: '#1a237e',
//                       fontSize: '1.1rem',
//                       letterSpacing: '0.5px',
//                       mb: 1,
//                       textTransform: 'uppercase'
//                     }}
//                   >
//                     Long Idle Vehicle
//                   </Typography>
//                   <Box sx={{ display: 'flex', alignItems: 'baseline' }}>
//                     <Typography
//                       variant="h3"
//                       sx={{
//                         fontWeight: 800,
//                         color: '#12286d',
//                         fontSize: '2.5rem',
//                         lineHeight: 1,
//                         mr: 1,
//                         textShadow: '0 2px 4px rgba(66, 182, 245, 0.2)'
//                       }}
//                     >
//                       {longIdleCount}
//                     </Typography>
//                     <Typography
//                       variant="caption"
//                       sx={{
//                         fontWeight: 600,
//                         color: '#666',
//                         fontSize: '0.75rem',
//                         letterSpacing: '0.5px'
//                       }}
//                     >
//                       Vehicles
//                     </Typography>
//                   </Box>
//                 </Box>
//               </CardContent>
//             </Card>
//           </motion.div>
//         </Grid>

//         {/* Probable Wire Tempering Card */}
//         <Grid item xs={12} sm={6} md={4}>
//           <motion.div
//             whileHover={{
//               scale: 1.05,
//               y: -5,
//               transition: { duration: 0.2 }
//             }}
//             whileTap={{ scale: 0.98 }}
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.3, delay: 0.2 }}
//           >
//             <Card
//               sx={{
//                 height: '120px',
//                 cursor: 'pointer',
//                 border: '1px solid rgba(66, 182, 245, 0.2)',
//                 borderRadius: '12px',
//                 background: 'linear-gradient(135deg, #ffffff 0%, #f8fbff 100%)',
//                 transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
//                 position: 'relative',
//                 overflow: 'hidden',
//                 '&:before': {
//                   content: '""',
//                   position: 'absolute',
//                   top: 0,
//                   left: 0,
//                   width: '100%',
//                   height: '4px',
//                   background: 'linear-gradient(90deg, #42b6f5, #2196f3)',
//                   transform: 'scaleX(0)',
//                   transformOrigin: 'left',
//                   transition: 'transform 0.4s ease',
//                 },
//                 '&:hover': {
//                   boxShadow: '0 10px 25px rgba(66, 182, 245, 0.2)',
//                   borderColor: 'rgba(66, 182, 245, 0.4)',
//                   transform: 'translateY(-4px)',
//                   '&:before': {
//                     transform: 'scaleX(1)',
//                   },
//                   '& .icon-container': {
//                     transform: 'scale(1.1) rotate(5deg)',
//                     boxShadow: '0 8px 20px rgba(66, 182, 245, 0.3)',
//                   }
//                 }
//               }}
//               onClick={handleWireTemperingOpen}
//             >
//               <CardContent sx={{
//                 p: 2.5,
//                 height: '100%',
//                 display: 'flex',
//                 alignItems: 'center',
//                 position: 'relative',
//                 zIndex: 1
//               }}>
//                 <Box
//                   className="icon-container"
//                   sx={{
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     width: 70,
//                     height: 70,
//                     borderRadius: '12px',
//                     background: 'linear-gradient(135deg, rgba(66, 182, 245, 0.1) 0%, rgba(66, 182, 245, 0.2) 100%)',
//                     marginRight: 2.5,
//                     flexShrink: 0,
//                     transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
//                     position: 'relative',
//                     overflow: 'hidden',
//                     '&:after': {
//                       content: '""',
//                       position: 'absolute',
//                       top: 0,
//                       left: 0,
//                       width: '100%',
//                       height: '100%',
//                       background: 'linear-gradient(135deg, transparent 30%, rgba(255, 255, 255, 0.4) 100%)',
//                       borderRadius: '12px',
//                     }
//                   }}
//                 >
//                   <ReportProblem
//                     fontSize="large"
//                     sx={{
//                       color: '#12286d',
//                       filter: 'drop-shadow(0 2px 4px rgba(66, 182, 245, 0.3))',
//                       zIndex: 1,
//                       position: 'relative'
//                     }}
//                   />
//                 </Box>
//                 <Box sx={{ flexGrow: 1, textAlign: 'left' }}>
//                   <Typography
//                     variant="h6"
//                     sx={{
//                       fontWeight: 700,
//                       color: '#1a237e',
//                       fontSize: '1.1rem',
//                       letterSpacing: '0.5px',
//                       mb: 1,
//                       textTransform: 'uppercase'
//                     }}
//                   >
//                     Wire Tempering
//                   </Typography>
//                   <Box sx={{ display: 'flex', alignItems: 'baseline' }}>
//                     <Typography
//                       variant="h3"
//                       sx={{
//                         fontWeight: 800,
//                         color: '#12286d',
//                         fontSize: '2.5rem',
//                         lineHeight: 1,
//                         mr: 1,
//                         textShadow: '0 2px 4px rgba(66, 182, 245, 0.2)'
//                       }}
//                     >
//                       {wireTemperingCount}
//                     </Typography>
//                     <Typography
//                       variant="caption"
//                       sx={{
//                         fontWeight: 600,
//                         color: '#666',
//                         fontSize: '0.75rem',
//                         letterSpacing: '0.5px'
//                       }}
//                     >
//                       Alerts
//                     </Typography>
//                   </Box>
//                 </Box>
//               </CardContent>
//             </Card>
//           </motion.div>
//         </Grid>
//       </Grid>

//       {/* Tabs Section */}
//       <div
//         style={{
//           backgroundColor: "#ebf2f5",
//           borderRadius: "15px",
//           marginTop: "5px",
//           boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
//           borderTop: "2px solid",
//           borderImage: "linear-gradient(45deg, #ff0000, #0000ff) 1",
//           borderTopColor: "2px solid blue",
//           borderLeft: "solid 2px transparent",
//           borderRight: "solid 2px transparent",
//           borderImageSlice: "1",
//         }}
//       >
//         <CardContent>
//           <Grid
//             item
//             sm={4}
//             md={6}
//             xs={12}
//             alignItems="center"
//             justifyContent="center"
//             display="flex"
//           >
//             <Tabs
//               value={value}
//               onChange={handleTab}
//               indicatorColor="primary"
//               textColor="primary"
//               variant="scrollable"
//               scrollButtons="auto"
//             >
//               {items.map((item, index) => (
//                 <Tab
//                   key={item.id}
//                   icon={item.icon}
//                   label={item.text}
//                   iconPosition="start"
//                 />
//               ))}
//             </Tabs>
//           </Grid>
//         </CardContent>
//       </div>

//       <div
//         style={{
//           backgroundColor: "#ebf2f5",
//           borderRadius: "5px",
//           marginTop: "5px",
//           position: "relative",
//         }}
//       >
//         <div
//           style={{
//             position: "absolute",
//             top: 0,
//             left: 0,
//             width: "100%",
//             height: "2px",
//             background: "linear-gradient(to right, transparent,rgb(0, 13, 255) 50%, transparent)",
//             borderTopLeftRadius: "5px",
//             borderTopRightRadius: "5px",
//           }}
//         ></div>
//         <CardContent>
//           {value === 0 && (
//             <div>
//               <Grid
//                 container
//                 spacing={1.5}
//               >
//                 {/* Charts and Running Status Grid */}
//                 <Grid xs={12} sm={6} md={4} item>
//                   <motion.div
//                     initial="hidden"
//                     whileHover={{ scale: 1.05 }}
//                     whileTap={{ scale: 0.95 }}
//                   >
//                     <Card
//                       elevation={4}
//                       style={{
//                         marginLeft: "1%",
//                         border: ".5px solid transparent",
//                         borderRadius: "10px",
//                       }}
//                     >
//                       <Grid
//                         style={{
//                           width: "100%",
//                           height: "53vh",
//                           backgroundColor: "#e9f4f7",
//                         }}
//                       >
//                         <Typography
//                           variant="h6"
//                           component="div"
//                           sx={{
//                             padding: "17px",
//                             background: "linear-gradient(to right, #ffffff,rgb(27, 174, 253))",
//                           }}
//                         >
//                           Zones
//                         </Typography>
//                         {isChartLoading ? (
//                           <Box display="flex" justifyContent="center" alignItems="center" height={220}>
//                             <motion.span
//                               animate={{ opacity: [1, 0.3, 1] }}
//                               transition={{ duration: 1, repeat: Infinity }}
//                               style={dotStyle}
//                             />
//                             <motion.span
//                               animate={{ opacity: [1, 0.3, 1] }}
//                               transition={{ duration: 1, repeat: Infinity, delay: 0.2 }}
//                               style={dotStyle}
//                             />
//                             <motion.span
//                               animate={{ opacity: [1, 0.3, 1] }}
//                               transition={{ duration: 1, repeat: Infinity, delay: 0.4 }}
//                               style={dotStyle}
//                             />
//                           </Box>
//                         ) : (
//                           <PieChart
//                             series={[
//                               {
//                                 data: chartData,
//                                 highlightScope: {
//                                   faded: "global",
//                                   highlighted: "item",
//                                 },
//                                 faded: {
//                                   innerRadius: 30,
//                                   additionalRadius: -30,
//                                   color: "gray",
//                                 },
//                               },
//                             ]}
//                             height={220}
//                             onItemClick={(e: any, d: any) => {
//                               const clickedData = chartData[d.dataIndex];
//                               zoneModal(clickedData);
//                               setVisible(true);
//                             }}
//                           />
//                         )}
//                       </Grid>
//                     </Card>
//                   </motion.div>
//                 </Grid>

//                 <Grid xs={12} sm={6} md={4} item>
//                   <motion.div
//                     initial="hidden"
//                     whileHover={{ scale: 1.05 }}
//                     whileTap={{ scale: 0.95 }}
//                   >
//                     <Card
//                       elevation={4}
//                       style={{
//                         marginLeft: "1%",
//                         border: ".5px solid transparent",
//                         borderRadius: "10px",
//                       }}
//                     >
//                       <Grid
//                         style={{
//                           width: "100%",
//                           height: "53vh",
//                           backgroundColor: "#e9f4f7",
//                         }}
//                       >
//                         <Typography
//                           variant="h6"
//                           component="div"
//                           sx={{
//                             padding: "17px",
//                             background: "linear-gradient(to right, #ffffff,rgb(27, 174, 253))",
//                           }}
//                         >
//                           Vehicles Ignition Status
//                         </Typography>
//                         {isChartLoading ? (
//                           <Box display="flex" justifyContent="center" alignItems="center" height={220}>
//                             <motion.span
//                               animate={{ opacity: [1, 0.3, 1] }}
//                               transition={{ duration: 1, repeat: Infinity }}
//                               style={dotStyle}
//                             />
//                             <motion.span
//                               animate={{ opacity: [1, 0.3, 1] }}
//                               transition={{ duration: 1, repeat: Infinity, delay: 0.2 }}
//                               style={dotStyle}
//                             />
//                             <motion.span
//                               animate={{ opacity: [1, 0.3, 1] }}
//                               transition={{ duration: 1, repeat: Infinity, delay: 0.4 }}
//                               style={dotStyle}
//                             />
//                           </Box>
//                         ) : (
//                           <PieChart
//                             series={[{ data: labelsData }]}
//                             width={350}
//                             height={200}
//                             onItemClick={(e: any, d: any) => {
//                               const clickedData = labelsData[d.dataIndex];
//                               if (clickedData.label === "On") {
//                                 IgnitionData(true);
//                               } else if (clickedData.label === "Off") {
//                                 IgnitionData(false);
//                               }
//                             }}
//                           />
//                         )}
//                         <Box sx={{ p: 2, textAlign: "center" }}>
//                           <Typography variant="body2" color="text.secondary">
//                             Engine ON: {engineOnCount} | Engine OFF: {engineOffCount}
//                           </Typography>
//                         </Box>
//                       </Grid>
//                     </Card>
//                   </motion.div>
//                 </Grid>

//                 {/* UPDATED: Vehicles Running Status Section */}
//                 <Grid xs={12} sm={6} md={4} item>
//                   <motion.div
//                     initial="hidden"
//                     whileHover={{ scale: 1.05 }}
//                     whileTap={{ scale: 0.95 }}
//                   >
//                     <Card
//                       elevation={4}
//                       style={{
//                         marginLeft: "1%",
//                         border: ".5px solid transparent",
//                         borderRadius: "10px",
//                       }}
//                     >
//                       <Grid
//                         style={{
//                           width: "100%",
//                           height: "53vh",
//                           backgroundColor: "#e9f4f7",
//                           overflow: "auto",
//                         }}
//                       >
//                         <Typography
//                           variant="h6"
//                           component="div"
//                           sx={{
//                             padding: "17px",
//                             background: "linear-gradient(to right, #ffffff,rgb(27, 174, 253))",
//                           }}
//                         >
//                           Vehicles Running Status
//                         </Typography>
//                         <div style={{ padding: "5px" }}>
//                           <Typography
//                             variant="h6"
//                             sx={{
//                               color: "green",
//                               cursor: "pointer",
//                               transition: "all 0.3s ease-in-out",
//                               "&:hover": {
//                                 color: "blue",
//                                 transform: "translateY(-3px)",
//                               },
//                             }}
//                             onClick={() => {
//                               runningData("running");
//                             }}
//                           >
//                             Running: {isRunn}
//                           </Typography>
//                           <ProgressBar
//                             completed={Math.round((isRunn / totalVeh || 0) * 100)}
//                             bgColor="green"
//                           />

//                           <Typography
//                             variant="h6"
//                             sx={{
//                               color: "#EF9B0F",
//                               cursor: "pointer",
//                               transition: "all 0.3s ease-in-out",
//                               "&:hover": {
//                                 color: "blue",
//                                 transform: "translateY(-3px)",
//                               },
//                             }}
//                             onClick={() => {
//                               runningData("idle");
//                             }}
//                           >
//                             Idle: {isIdle}{" "}
//                           </Typography>
//                           <ProgressBar
//                             completed={Math.round((isIdle / totalVeh || 0) * 100)}
//                             bgColor="#e3be29"
//                           />

//                           <Typography
//                             variant="h6"
//                             sx={{
//                               color: "#f04848",
//                               cursor: "pointer",
//                               transition: "all 0.3s ease-in-out",
//                               "&:hover": {
//                                 color: "blue",
//                                 transform: "translateY(-3px)",
//                               },
//                             }}
//                             onClick={() => {
//                               runningData("stop");
//                             }}
//                           >
//                             Stop: {isStop}
//                           </Typography>
//                           <ProgressBar
//                             completed={Math.round((isStop / totalVeh || 0) * 100)}
//                             bgColor="#f04848"
//                           />

//                           <Typography
//                             variant="h6"
//                             fontWeight="bold"
//                             fontSize={"16px"}
//                             style={{ color: "blue" }}
//                           >
//                             Total Vehicles:{" "}
//                             <span style={{ color: "#474d54" }}>{totalVeh}</span>
//                           </Typography>

//                           <Typography
//                             variant="h6"
//                             fontWeight="bold"
//                             fontSize={"16px"}
//                             style={{ color: "blue" }}
//                           >
//                             Total Vehicles on Road:{" "}
//                             <span style={{ color: "#474d54" }}>{onRoadVeh}</span>{" "}
//                             out of{" "}
//                             <span style={{ color: "#474d54" }}>{totalVeh}</span>
//                           </Typography>

//                           <Typography
//                             variant="h6"
//                             fontWeight="bold"
//                             fontSize={"16px"}
//                             style={{ color: "blue" }}
//                           >
//                             GPS Installation Status:{" "}
//                             <span style={{ color: "#474d54" }}>{gpsStatus}</span>{" "}
//                             out of{" "}
//                             <span style={{ color: "#474d54" }}>{totalVeh}</span>
//                           </Typography>

//                           <Typography
//                             variant="h6"
//                             fontWeight="bold"
//                             fontSize={"16px"}
//                             style={{ color: "blue" }}
//                           >
//                             Total Distance Today:{" "}
//                             <span style={{ color: "#474d54" }}>
//                               {(totalDistance || 0).toFixed(2)}
//                             </span>{" "}
//                             Km
//                           </Typography>
//                         </div>
//                       </Grid>
//                     </Card>
//                   </motion.div>
//                 </Grid>

//                 {/* Today Vehicle Status Accordion */}
//                 <Grid xs={12} lg={12} sm={12} item >
//                   <Accordion
//                     expanded={accordionExpanded[2]}
//                     onChange={(e, expended) => {
//                       handleAccordionToggle(2, expended);
//                     }}
//                   >
//                     <AccordionSummary
//                       expandIcon={<ArrowDropDownIcon />}
//                       aria-controls="panel2-content"
//                       id="panel2-header"
//                       sx={{
//                         background: "linear-gradient(to right, #ffffff,rgb(27, 174, 253))",
//                       }}
//                     >
//                       <Typography style={{ fontWeight: 600, fontSize: "16px" }}>
//                         Today Vehicle Status
//                       </Typography>
//                     </AccordionSummary>
//                     <AccordionDetails style={{ background: "#f2f8fa" }}>
//                       <Grid
//                         item
//                         xs={12}
//                         container
//                         spacing={2}
//                         sx={{ marginTop: "5px" }}
//                       >
//                         <Grid item xs={12} sm={12} lg={12}>
//                           {isLoading3 ? (
//                             <div
//                               style={{
//                                 display: "flex",
//                                 justifyContent: "center",
//                                 alignItems: "center",
//                               }}
//                             >
//                               <CircularProgress />
//                             </div>
//                           ) : (
//                             <>
//                               {zones3 && zones3.length > 0 ? (
//                                 <DataGrid
//                                   rows={zones3}
//                                   columns={adjustedColumns3}
//                                   rowSpacingType="border"
//                                   autoHeight
//                                   slots={{
//                                     toolbar: GridToolbar,
//                                   }}
//                                   pageSizeOptions={[5, 10, 25, 50, 100].map(
//                                     (size) => ({
//                                       value: size,
//                                       label: `${size}`,
//                                     })
//                                   )}
//                                   initialState={{
//                                     pagination: {
//                                       paginationModel: { pageSize: 5 },
//                                     },
//                                   }}
//                                   slotProps={{
//                                     toolbar: {
//                                       showQuickFilter: true,
//                                     },
//                                   }}
//                                   sx={{
//                                     border: 0,
//                                     "& .MuiDataGrid-columnHeaders": {
//                                       backgroundColor: "#42b6f5", // Header background color
//                                       color: "white", // Header text color
//                                     },
//                                     "& .MuiDataGrid-columnHeaderTitle": {
//                                       color: "white", // Header title text color
//                                     },
//                                     "& .MuiDataGrid-cell": {
//                                       whiteSpace: "normal", // Ensure text wraps inside the cell
//                                       wordWrap: "break-word", // Break words to avoid overflow
//                                       overflowWrap: "break-word", // Ensure long words wrap correctly
//                                     },
//                                   }}
//                                 />
//                               ) : (
//                                 <div>No data found</div>
//                               )}
//                             </>
//                           )}
//                         </Grid>

//                         {currentMap && (
//                           <Grid item xs={12} sm={12} lg={12}>
//                             <div
//                               style={{
//                                 border: "1px solid black",
//                                 boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
//                               }}
//                             >
//                               <GoogleMap
//                                 mapContainerStyle={containerStyle}
//                                 center={center}
//                                 zoom={70} // Default zoom, will be adjusted by `fitBounds`
//                                 onLoad={(map: any) => (mapRef.current = map)}
//                               >
//                                 {vehicles.map((vehicle: any, index: any) => (
//                                   <Marker
//                                     key={vehicle.id}
//                                     position={{
//                                       lat: vehicle.lat,
//                                       lng: vehicle.lng,
//                                     }}
//                                     icon={{
//                                       url: vehicle.icon,
//                                       scaledSize: new window.google.maps.Size(
//                                         50,
//                                         50
//                                       ),
//                                       origin: new window.google.maps.Point(0, 0),
//                                       anchor: new window.google.maps.Point(25, 25),
//                                     }}

//                                     label={{
//                                       text: `${index + 1}`,
//                                       fontSize: "14px",
//                                       fontWeight: "bold",
//                                       color: "#f73905",
//                                       className: 'marker-label'
//                                     }}
//                                     onMouseOver={() =>
//                                       handleMarkerMouseOver(vehicle)
//                                     } // Show vehicle number on hover
//                                     onMouseOut={handleMarkerMouseOut} // Hide info window on hover out
//                                   >
//                                     {activeVehicle &&
//                                       activeVehicle.id === vehicle.id && (
//                                         <InfoWindow>
//                                           <div>
//                                             <div>
//                                               <strong>Speed: </strong>
//                                               {vehicle.speed}
//                                             </div>

//                                             <div>
//                                               <strong>Near By: </strong>
//                                               {vehicle.nearme}
//                                             </div>

//                                             <div>
//                                               <strong>Vehicle No: </strong>
//                                               {vehicle.vehicleNo}
//                                             </div>

//                                             <div>
//                                               <strong>Distance: </strong>
//                                               {vehicle.distance}
//                                             </div>

//                                             <div>
//                                               <strong>Date & Time: </strong>
//                                               {vehicle.tracktime}
//                                             </div>
//                                           </div>
//                                         </InfoWindow>
//                                       )}
//                                   </Marker>
//                                 ))}

//                                 <Polyline
//                                   path={vehicles.map((vehicle: any) => ({ lat: vehicle.lat, lng: vehicle.lng }))}
//                                   options={{
//                                     strokeColor: "#6190c9",
//                                     strokeOpacity: 1,
//                                     strokeWeight: 3,

//                                   }}
//                                 />
//                               </GoogleMap>
//                             </div>
//                           </Grid>
//                         )}
//                       </Grid>
//                     </AccordionDetails>
//                   </Accordion>
//                   <br />
//                 </Grid>

//                 {/* Map Section */}
//                 {currentMap && (
//                   <Grid item xs={12} sm={12} lg={12}>
//                     <div
//                       style={{
//                         border: "1px solid black",
//                         boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
//                         marginBottom: "20px",
//                       }}
//                     >
//                       <GoogleMap
//                         mapContainerStyle={containerStyle}
//                         center={center}
//                         zoom={70}
//                         onLoad={(map: any) => (mapRef.current = map)}
//                       >
//                         {vehicles.map((vehicle: any, index: any) => (
//                           <Marker
//                             key={vehicle.id}
//                             position={{
//                               lat: vehicle.lat,
//                               lng: vehicle.lng,
//                             }}
//                             icon={{
//                               url: vehicle.icon,
//                               scaledSize: new window.google.maps.Size(
//                                 50,
//                                 50
//                               ),
//                               origin: new window.google.maps.Point(0, 0),
//                               anchor: new window.google.maps.Point(25, 25),
//                             }}
//                             label={{
//                               text: `${index + 1}`,
//                               fontSize: "14px",
//                               fontWeight: "bold",
//                               color: "#f73905",
//                               className: 'marker-label'
//                             }}
//                             onMouseOver={() =>
//                               handleMarkerMouseOver(vehicle)
//                             }
//                             onMouseOut={handleMarkerMouseOut}
//                           >
//                             {activeVehicle &&
//                               activeVehicle.id === vehicle.id && (
//                                 <InfoWindow>
//                                   <div>
//                                     <div>
//                                       <strong>Speed: </strong>
//                                       {vehicle.speed}
//                                     </div>
//                                     <div>
//                                       <strong>Near By: </strong>
//                                       {vehicle.nearme}
//                                     </div>
//                                     <div>
//                                       <strong>Vehicle No: </strong>
//                                       {vehicle.vehicleNo}
//                                     </div>
//                                     <div>
//                                       <strong>Distance: </strong>
//                                       {vehicle.distance}
//                                     </div>
//                                     <div>
//                                       <strong>Date & Time: </strong>
//                                       {vehicle.tracktime}
//                                     </div>
//                                   </div>
//                                 </InfoWindow>
//                               )}
//                           </Marker>
//                         ))}
//                         <Polyline
//                           path={vehicles.map((vehicle: any) => ({ lat: vehicle.lat, lng: vehicle.lng }))}
//                           options={{
//                             strokeColor: "#6190c9",
//                             strokeOpacity: 1,
//                             strokeWeight: 3,
//                           }}
//                         />
//                       </GoogleMap>
//                     </div>
//                   </Grid>
//                 )}
//               </Grid>

//               {/* Modal Dialogs for Cards */}
//               {/* Fuel Consumed Modal */}
//               <Dialog
//                 open={fuelConsumedOpen}
//                 onClose={handleFuelConsumedClose}
//                 fullWidth
//                 maxWidth="lg"
//                 sx={{
//                   "& .MuiDialogContent-root": {
//                     padding: "20px",
//                     height: "600px",
//                   },
//                 }}
//               >
//                 <DialogTitle
//                   sx={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     padding: "10px",
//                     backgroundColor: `var(--grid-headerBackground, #42b6f5)`,
//                     color: `var(--grid-headerColor, white)`,
//                   }}
//                 >
//                   <Stack direction="row" spacing={2} alignItems="center">
//                     <LocalGasStation />
//                     <Typography variant="h6">
//                       Fuel Consumed Report
//                     </Typography>
//                   </Stack>
//                   <IconButton
//                     edge="end"
//                     onClick={handleFuelConsumedClose}
//                     sx={{ color: "white" }}
//                   >
//                     <CloseIcon />
//                   </IconButton>
//                 </DialogTitle>
//                 <DialogContent>
//                   <Grid container spacing={2} sx={{ mt: 1 }}>
//                     <Grid item xs={12}>
//                       <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
//                         <FormControlLabel
//                           control={
//                             <Checkbox
//                               checked={getTop}
//                               onChange={(e) => {
//                                 setGetTop(e.target.checked);
//                                 setTimeout(() => { }, 500);
//                               }}
//                             />
//                           }
//                           label="Get Top 10 Records"
//                         />
//                         <Button
//                           startIcon={<PrintIcon />}
//                           variant="contained"
//                           sx={{ bgcolor: "#42b6f5", '&:hover': { bgcolor: "#1976d2" } }}
//                           onClick={downloadExcel}
//                         >
//                           Export to Excel
//                         </Button>
//                       </Stack>
//                     </Grid>
//                     <Grid item xs={12}>
//                       {isLoading1 ? (
//                         <Box display="flex" justifyContent="center" alignItems="center" height={400}>
//                           <CircularProgress />
//                         </Box>
//                       ) : (
//                         <>
//                           {zones1 && zones1.length > 0 ? (
//                             <DataGrid
//                               rows={zones1}
//                               columns={adjustedColumns1}
//                               rowSpacingType="border"
//                               autoHeight
//                               slots={{
//                                 toolbar: GridToolbar,
//                               }}
//                               pageSizeOptions={[5, 10, 25, 50, 100]}
//                               initialState={{
//                                 pagination: {
//                                   paginationModel: { pageSize: 10 },
//                                 },
//                               }}
//                               slotProps={{
//                                 toolbar: {
//                                   showQuickFilter: true,
//                                 },
//                               }}
//                               sx={{
//                                 border: 0,
//                                 "& .MuiDataGrid-columnHeaders": {
//                                   backgroundColor: `var(--grid-headerBackground, #42b6f5)`,
//                                   color: `var(--grid-headerColor, white)`,
//                                 },
//                                 "& .MuiDataGrid-columnHeaderTitle": {
//                                   color: "white",
//                                 },
//                               }}
//                             />
//                           ) : (
//                             <Box display="flex" justifyContent="center" alignItems="center" height={400}>
//                               <Typography>No data found</Typography>
//                             </Box>
//                           )}
//                         </>
//                       )}
//                     </Grid>
//                   </Grid>
//                 </DialogContent>
//               </Dialog>

//               {/* Long Idle Vehicle Modal */}
//               <Dialog
//                 open={longIdleOpen}
//                 onClose={handleLongIdleClose}
//                 fullWidth
//                 maxWidth="lg"
//                 sx={{
//                   "& .MuiDialogContent-root": {
//                     padding: "20px",
//                     height: "600px",
//                   },
//                 }}
//               >
//                 <DialogTitle
//                   sx={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     padding: "10px",
//                     backgroundColor: `var(--grid-headerBackground, #42b6f5)`,
//                     color: `var(--grid-headerColor, white)`,
//                   }}
//                 >
//                   <Stack direction="row" spacing={2} alignItems="center">
//                     <FaClock style={{ fontSize: "24px" }} />
//                     <Typography variant="h6">
//                       Long Idle Vehicles
//                     </Typography>
//                   </Stack>
//                   <IconButton
//                     edge="end"
//                     onClick={handleLongIdleClose}
//                     sx={{ color: "white" }}
//                   >
//                     <CloseIcon />
//                   </IconButton>
//                 </DialogTitle>
//                 <DialogContent>
//                   <Grid container spacing={2} sx={{ mt: 1 }}>
//                     <Grid item xs={12}>
//                       <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
//                         <FormControlLabel
//                           control={
//                             <Checkbox
//                               checked={getTop1}
//                               onChange={(e) => {
//                                 setGetTop1(e.target.checked);
//                               }}
//                             />
//                           }
//                           label="Get Top 10 Records"
//                         />
//                         <Button
//                           startIcon={<PrintIcon />}
//                           variant="contained"
//                           sx={{ bgcolor: "#42b6f5", '&:hover': { bgcolor: "#1976d2" } }}
//                           onClick={downloadExcel1}
//                         >
//                           Export to Excel
//                         </Button>
//                       </Stack>
//                     </Grid>
//                     <Grid item xs={12}>
//                       {isLoading2 ? (
//                         <Box display="flex" justifyContent="center" alignItems="center" height={400}>
//                           <CircularProgress />
//                         </Box>
//                       ) : (
//                         <>
//                           {zones2 && zones2.length > 0 ? (
//                             <DataGrid
//                               rows={zones2}
//                               columns={adjustedColumns2}
//                               rowSpacingType="border"
//                               slots={{
//                                 toolbar: GridToolbar,
//                               }}
//                               pageSizeOptions={[5, 10, 25, 50, 100]}
//                               initialState={{
//                                 pagination: {
//                                   paginationModel: { pageSize: 10 },
//                                 },
//                               }}
//                               slotProps={{
//                                 toolbar: {
//                                   showQuickFilter: true,
//                                 },
//                               }}
//                               autoHeight={false}
//                               sx={{
//                                 border: 0,
//                                 "& .MuiDataGrid-columnHeaders": {
//                                   backgroundColor: `var(--grid-headerBackground, #42b6f5)`,
//                                   color: `var(--grid-headerColor, white)`,
//                                   position: "sticky",
//                                   top: 0,
//                                   zIndex: 1,
//                                 },
//                                 "& .MuiDataGrid-columnHeaderTitle": {
//                                   color: "white",
//                                 },
//                                 "& .MuiDataGrid-cell": {
//                                   whiteSpace: "normal",
//                                   wordWrap: "break-word",
//                                   overflowWrap: "break-word",
//                                 },
//                                 height: 400,
//                               }}
//                             />
//                           ) : (
//                             <Box display="flex" justifyContent="center" alignItems="center" height={400}>
//                               <Typography>No data found</Typography>
//                             </Box>
//                           )}
//                         </>
//                       )}
//                     </Grid>
//                   </Grid>
//                 </DialogContent>
//               </Dialog>

//               {/* Probable Wire Tempering Modal */}
//               <Dialog
//                 open={wireTemperingOpen}
//                 onClose={handleWireTemperingClose}
//                 fullWidth
//                 maxWidth="lg"
//                 sx={{
//                   "& .MuiDialogContent-root": {
//                     padding: "20px",
//                     height: "600px",
//                   },
//                 }}
//               >
//                 <DialogTitle
//                   sx={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     padding: "10px",
//                     backgroundColor: `var(--grid-headerBackground, #42b6f5)`,
//                     color: `var(--grid-headerColor, white)`,
//                   }}
//                 >
//                   <Stack direction="row" spacing={2} alignItems="center">
//                     <ReportProblem />
//                     <Typography variant="h6">
//                       Probable Wire Tempering Alerts
//                     </Typography>
//                   </Stack>
//                   <IconButton
//                     edge="end"
//                     onClick={handleWireTemperingClose}
//                     sx={{ color: "white" }}
//                   >
//                     <CloseIcon />
//                   </IconButton>
//                 </DialogTitle>
//                 <DialogContent>
//                   <Grid container spacing={2} sx={{ mt: 1 }}>
//                     <Grid item xs={12}>
//                       {isLoading ? (
//                         <Box display="flex" justifyContent="center" alignItems="center" height={400}>
//                           <CircularProgress />
//                         </Box>
//                       ) : (
//                         <>
//                           {zones && zones.length > 0 ? (
//                             <DataGrid
//                               rows={zones}
//                               columns={adjustedColumns}
//                               rowSpacingType="border"
//                               autoHeight
//                               slots={{
//                                 toolbar: GridToolbar,
//                               }}
//                               pageSizeOptions={[5, 10, 25, 50, 100]}
//                               initialState={{
//                                 pagination: {
//                                   paginationModel: { pageSize: 10 },
//                                 },
//                               }}
//                               slotProps={{
//                                 toolbar: {
//                                   showQuickFilter: true,
//                                 },
//                               }}
//                               sx={{
//                                 border: 0,
//                                 "& .MuiDataGrid-columnHeaders": {
//                                   backgroundColor: `var(--grid-headerBackground, #42b6f5)`,
//                                   color: `var(--grid-headerColor, white)`,
//                                 },
//                                 "& .MuiDataGrid-columnHeaderTitle": {
//                                   color: "white",
//                                 },
//                               }}
//                             />
//                           ) : (
//                             <Box display="flex" justifyContent="center" alignItems="center" height={400}>
//                               <Typography>No data found</Typography>
//                             </Box>
//                           )}
//                         </>
//                       )}
//                     </Grid>
//                   </Grid>
//                 </DialogContent>
//               </Dialog>

//               {/* Existing Modals (Keep them as they are) */}
//               {/* UPDATED: Running Status Modal */}
//               <Grid xs={12} lg={12} sm={12} item>
//                 <Dialog
//                   open={isModal}
//                   onClose={handleClose}
//                   fullWidth
//                   maxWidth="lg"
//                   sx={{
//                     "& .MuiDialogContent-root": {
//                       padding: "20px",
//                       height: "400px",
//                     },
//                   }}
//                 >
//                   <DialogTitle
//                     sx={{
//                       display: "flex",
//                       justifyContent: "space-between",
//                       padding: "10px",
//                       backgroundColor: `var(--grid-headerBackground, #42b6f5)`,
//                       color: `var(--grid-headerColor, white)`,
//                     }}
//                   >
//                     <Typography variant="h6" style={{ color: "#ffff" }}>
//                       Vehicle Status :{" "}
//                       <span style={{ color: "#474d54", fontWeight: "bold" }}>
//                         {isStatus1?.charAt(0).toUpperCase() + isStatus1?.slice(1)}
//                       </span>
//                     </Typography>
//                     <IconButton
//                       edge="end"
//                       onClick={handleClose}
//                       sx={{
//                         color: `var(--grid-headerColor, white)`,
//                       }}
//                     >
//                       <CloseIcon />
//                     </IconButton>
//                   </DialogTitle>
//                   <DialogContent>
//                     <Grid
//                       item
//                       xs={12}
//                       container
//                       spacing={2}
//                       sx={{
//                         padding: "20px",
//                         height: "400px",
//                         overflow: "hidden",
//                       }}
//                     >
//                       <Grid item sm={12} lg={12} xs={12}>
//                         {isLoading4 ? (
//                           <div
//                             style={{
//                               display: "flex",
//                               justifyContent: "center",
//                               alignItems: "center",
//                             }}
//                           >
//                             <CircularProgress />
//                           </div>
//                         ) : (
//                           <>
//                             {zones4 && zones4.length > 0 ? (
//                               <DataGrid
//                                 rows={zones4}
//                                 columns={adjustedColumns4}
//                                 rowSpacingType="border"
//                                 slots={{
//                                   toolbar: GridToolbar,
//                                 }}
//                                 slotProps={{
//                                   toolbar: {
//                                     showQuickFilter: true,
//                                   },
//                                 }}
//                                 autoHeight={false}
//                                 sx={{
//                                   border: 0,
//                                   "& .MuiDataGrid-columnHeaders": {
//                                     backgroundColor: `var(--grid-headerBackground, #42b6f5)`,
//                                     color: `var(--grid-headerColor, white)`,
//                                     position: "sticky",
//                                     top: 0,
//                                     zIndex: 1,
//                                   },
//                                   "& .MuiDataGrid-columnHeaderTitle": {
//                                     color: "white",
//                                   },
//                                   "& .MuiDataGrid-cell": {
//                                     whiteSpace: "normal",
//                                     wordWrap: "break-word",
//                                     overflowWrap: "break-word",
//                                   },
//                                   height: 350,
//                                   overflowY: "auto",
//                                 }}
//                               />
//                             ) : (
//                               <div>No data found</div>
//                             )}
//                           </>
//                         )}
//                       </Grid>
//                     </Grid>
//                   </DialogContent>
//                 </Dialog>
//               </Grid>

//               <Grid xs={12} lg={12} sm={12} item>
//                 <Dialog
//                   open={isModal1}
//                   onClose={handleClose1}
//                   fullWidth
//                   maxWidth="lg"
//                   sx={{
//                     "& .MuiDialogContent-root": {
//                       padding: "20px",
//                       height: "400px",
//                     },
//                   }}
//                 >
//                   <DialogTitle
//                     sx={{
//                       display: "flex",
//                       justifyContent: "space-between",
//                       padding: "10px",
//                       backgroundColor: `var(--grid-headerBackground, #42b6f5)`,
//                       color: `var(--grid-headerColor, white)`,
//                     }}
//                   >
//                     <Typography variant="h6" style={{ color: "#ffff" }}>
//                       Vehicle Ignition :{" "}
//                       <span style={{ color: "#474d54", fontWeight: "bold" }}>
//                         {isStatus}
//                       </span>
//                     </Typography>
//                     <IconButton
//                       edge="end"
//                       onClick={handleClose1}
//                       sx={{
//                         color: `var(--grid-headerColor, white)`,
//                       }}
//                     >
//                       <CloseIcon />
//                     </IconButton>
//                   </DialogTitle>
//                   <DialogContent>
//                     <Grid
//                       item
//                       xs={12}
//                       container
//                       spacing={2}
//                       sx={{
//                         padding: "20px",
//                         height: "400px",
//                         overflow: "hidden",
//                       }}
//                     >
//                       <Grid item sm={12} lg={12} xs={12}>
//                         {isLoading5 ? (
//                           <div
//                             style={{
//                               display: "flex",
//                               justifyContent: "center",
//                               alignItems: "center",
//                             }}
//                           >
//                             <CircularProgress />
//                           </div>
//                         ) : (
//                           <>
//                             {zones5 && zones5.length > 0 ? (
//                               <DataGrid
//                                 rows={zones5}
//                                 columns={adjustedColumns5}
//                                 rowSpacingType="border"
//                                 slots={{
//                                   toolbar: GridToolbar,
//                                 }}
//                                 pageSizeOptions={[5, 10, 25, 50, 100]}
//                                 initialState={{
//                                   pagination: {
//                                     paginationModel: { pageSize: 10 },
//                                   },
//                                 }}
//                                 slotProps={{
//                                   toolbar: {
//                                     showQuickFilter: true,
//                                   },
//                                 }}
//                                 autoHeight={false}
//                                 sx={{
//                                   border: 0,
//                                   "& .MuiDataGrid-columnHeaders": {
//                                     backgroundColor: `var(--grid-headerBackground, #42b6f5)`,
//                                     color: `var(--grid-headerColor, white)`,
//                                     position: "sticky",
//                                     top: 0,
//                                     zIndex: 1,
//                                   },
//                                   "& .MuiDataGrid-columnHeaderTitle": {
//                                     color: "white",
//                                   },
//                                   "& .MuiDataGrid-cell": {
//                                     whiteSpace: "normal",
//                                     wordWrap: "break-word",
//                                     overflowWrap: "break-word",
//                                   },
//                                   height: 350,
//                                   overflowY: "auto",
//                                 }} />
//                             ) : (
//                               <div>No data found</div>
//                             )}
//                           </>
//                         )}
//                       </Grid>
//                     </Grid>
//                   </DialogContent>
//                 </Dialog>
//               </Grid>

//               <Grid xs={12} lg={12} sm={12} item>
//                 <Dialog
//                   open={isVisible}
//                   onClose={handleClose2}
//                   fullWidth
//                   maxWidth="lg"
//                   sx={{
//                     "& .MuiDialogContent-root": {
//                       padding: "20px",
//                       height: "400px",
//                     },
//                   }}
//                 >
//                   <DialogTitle
//                     sx={{
//                       display: "flex",
//                       justifyContent: "space-between",
//                       padding: "10px",
//                       backgroundColor: `var(--grid-headerBackground, #42b6f5)`,
//                       color: `var(--grid-headerColor, white)`,
//                     }}
//                   >
//                     <Typography variant="h6" style={{ color: "#ffff" }}>
//                       <span style={{ color: "#474d54", fontWeight: "bold" }}>
//                         {isLabel}
//                       </span>
//                     </Typography>
//                     <IconButton
//                       edge="end"
//                       onClick={handleClose2}
//                       sx={{
//                         color: `var(--grid-headerColor, white)`,
//                       }}
//                     >
//                       <CloseIcon />
//                     </IconButton>
//                   </DialogTitle>
//                   <DialogContent>
//                     <Grid
//                       item
//                       xs={12}
//                       container
//                       spacing={2}
//                       sx={{
//                         padding: "20px",
//                         height: "400px",
//                         overflow: "hidden",
//                       }}
//                     >
//                       <Grid item sm={12} lg={12} xs={12}>
//                         {isLoading9 ? (
//                           <div
//                             style={{
//                               display: "flex",
//                               justifyContent: "center",
//                               alignItems: "center",
//                             }}
//                           >
//                             <CircularProgress />
//                           </div>
//                         ) : (
//                           <>
//                             {zones9 && zones9.length > 0 ? (
//                               <DataGrid
//                                 rows={zones9}
//                                 columns={adjustedColumns10}
//                                 rowSpacingType="border"
//                                 slots={{
//                                   toolbar: GridToolbar,
//                                 }}
//                                 pageSizeOptions={[5, 10, 25, 50, 100]}
//                                 initialState={{
//                                   pagination: {
//                                     paginationModel: { pageSize: 10 },
//                                   },
//                                 }}
//                                 slotProps={{
//                                   toolbar: {
//                                     showQuickFilter: true,
//                                   },
//                                 }}
//                                 autoHeight={false}
//                                 sx={{
//                                   border: 0,
//                                   "& .MuiDataGrid-columnHeaders": {
//                                     backgroundColor: `var(--grid-headerBackground, #42b6f5)`,
//                                     color: `var(--grid-headerColor, white)`,
//                                     position: "sticky",
//                                     top: 0,
//                                     zIndex: 1,
//                                   },
//                                   "& .MuiDataGrid-columnHeaderTitle": {
//                                     color: "white",
//                                   },
//                                   "& .MuiDataGrid-cell": {
//                                     whiteSpace: "normal",
//                                     wordWrap: "break-word",
//                                     overflowWrap: "break-word",
//                                   },
//                                   height: 400,
//                                   overflowY: "auto",
//                                 }}
//                               />
//                             ) : (
//                               <div>No data found</div>
//                             )}
//                           </>
//                         )}
//                       </Grid>
//                     </Grid>
//                   </DialogContent>
//                 </Dialog>
//               </Grid>
//             </div>
//           )}

//           {value === 1 && <Tracking />}
//           {value === 2 && <Geofacing />}
//           {value === 3 && <Kudaghar />}
//           {value === 4 && <VehicleHistory />}
//           {value === 5 && <VehicleTravelled />}
//         </CardContent>
//       </div>
//     </div>
//   );
// }


























































// import {
//   JSXElementConstructor,
//   Key,
//   ReactElement,
//   ReactNode,
//   ReactPortal,
//   useEffect,
//   useRef,
//   useState,
// } from "react";
// import {
//   Card,
//   Grid,
//   CardContent,
//   Typography,
//   Divider,
//   Button,
//   FormControlLabel,
//   Checkbox,
//   Tab,
//   Tabs,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   IconButton,
//   Box,
//   Paper,
//   Chip,
//   Avatar,
//   Stack,
// } from "@mui/material";

// import "./style.css";

// import { DataGrid, GridColDef, GridToolbar } from "@mui/x-data-grid";

// // import { TableContainer, Table, TableHead, TableBody, TableRow, TableCell } from '@material-ui/core';

// import { PieChart } from "@mui/x-charts/PieChart";
// import api from "../../utils/Url";
// //import { IconButton, Progress, Table } from "rsuite";
// import Accordion from "@mui/material/Accordion";
// import AccordionSummary from "@mui/material/AccordionSummary";
// import AccordionDetails from "@mui/material/AccordionDetails";
// import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
// import { useTranslation } from "react-i18next";
// import PrintIcon from "@mui/icons-material/Print";
// import {
//   GoogleMap,
//   InfoWindow,
//   LoadScript,
//   Marker,
//   Polyline,
// } from "@react-google-maps/api";
// import Tracking from "./Tracking";
// import Geofacing from "./Geofacing";
// import Kudaghar from "./Kudaghar";
// import VehicleHistory from "./VehicleHistory";
// import VehicleTravelled from "./VehicleTravelled";
// import ProgressBar from "@ramonak/react-progress-bar";

// import DashboardIcon from "@mui/icons-material/Dashboard";
// import GpsFixedIcon from "@mui/icons-material/GpsFixed";
// import PlaceIcon from "@mui/icons-material/Place";
// import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
// import CarCrashIcon from "@mui/icons-material/CarCrash";
// import EmojiTransportationIcon from "@mui/icons-material/EmojiTransportation";
// import { motion, useSpring } from "framer-motion";
// import CircularProgress from "@mui/material/CircularProgress";
// import CloseIcon from "@mui/icons-material/Close";
// import { table } from "console";
// import ReactModal from "react-modal";
// import * as XLSX from "xlsx";
// import Modal from "react-animated-modal";
// import { animated } from "react-spring";
// import {
//   FaCar,
//   FaUser,
//   FaBuilding,
//   FaCog,
//   FaCircle,
//   FaTachometerAlt,
//   FaGasPump,
//   FaSortNumericDown,
//   FaCheckCircle,
//   FaHistory,
//   FaIdCard,
//   FaExclamationTriangle,
//   FaClock,
//   FaChartLine,
// } from "react-icons/fa";

// import {
//   ListAlt,
//   DirectionsCar,
//   Work,
//   DirectionsBike,
//   CheckCircle,
//   LocalGasStation,
//   Timeline,
//   ElectricBolt,
//   ReportProblem,
// } from "@mui/icons-material";
// import PersonIcon from "@mui/icons-material/Person";
// import decryptData from "../../utils/crypto";
// import VehicleComponent from "../../utils/VehicleComponent";
// import "./style.css"

// const style = {
//   position: "absolute" as "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: "95%",
//   height: "85%",
//   bgcolor: "#f5f5f5",
//   border: "1px solid #000",
//   boxShadow: 24,
//   p: 4,
//   borderRadius: 10,
// };
// const dotStyle = {
//   width: 12,
//   height: 12,
//   borderRadius: "50%",
//   backgroundColor: "#1976D2",
//   margin: "0 5px",
//   display: "inline-block",
// };

// const containerStyle = {
//   width: "100%",
//   height: "500px",
// };

// interface Department {
//   dept_id: number;
//   dept_name: string;
//   session_year: string;
//   // Add other properties here
// }

// export default function HomePage() {
//   const [chartData, setChartData] = useState<any>([]);

//   const [labelsData, setlabelsData] = useState<any>([]);
//   console.log("labelsData", labelsData);

//   const { t } = useTranslation();

//   const [zones, setZones] = useState([]);
//   const [columns, setColumns] = useState<any>([]);
//   const [isLoading, setIsLoading] = useState(true);

//   const [currentMap, setCurrentMap] = useState(false);

//   const [isVisible, setVisible] = useState(false);

//   const [zones1, setZones1] = useState([]);
//   const [columns1, setColumns1] = useState<any>([]);
//   const [isLoading1, setIsLoading1] = useState(true);
//   const [isChartLoading, setChartIsLoading] = useState(true);

//   const [zones2, setZones2] = useState([]);
//   const [columns2, setColumns2] = useState<any>([]);
//   const [isLoading2, setIsLoading2] = useState(true);

//   const [zones3, setZones3] = useState([]);
//   const [columns3, setColumns3] = useState<any>([]);
//   const [isLoading3, setIsLoading3] = useState(true);

//   const [zones4, setZones4] = useState([]);
//   const [columns4, setColumns4] = useState<any>([]);
//   const [isLoading4, setIsLoading4] = useState(true);

//   const [isLoading6, setIsLoading6] = useState(true);

//   const [zones5, setZones5] = useState([]);
//   const [columns5, setColumns5] = useState<any>([]);
//   const [isLoading5, setIsLoading5] = useState(true);

//   const [zones9, setZones9] = useState([]);
//   const [columns9, setColumns9] = useState<any>([]);
//   const [isLoading9, setIsLoading9] = useState(true);

//   const [getTop, setGetTop] = useState(false);

//   const [getTop1, setGetTop1] = useState(false);

//   const [isRunn, setRunn] = useState<any>(0);

//   const [isIdle, setIdle] = useState<any>(0);
//   const [isStop, setStop] = useState<any>(0);
//   const [totalVeh, setTotalVeh] = useState<any>(0);
//   const [onRoadVeh, setOnRoadVeh] = useState<any>(0);
//   const [gpsStatus, setGpsStatus] = useState<any>(0);
//   const [totalDistance, setTotalDistance] = useState<any>(0);
//   const [isModal, setModal] = useState<any>(false);

//   const [isModal1, setModal1] = useState<any>(false);

//   const [vehicleDrawer, setVehicleDrawer] = useState(false);

//   const [itemId, setItemId] = useState<any>();

//   // New states for card modals
//   const [fuelConsumedOpen, setFuelConsumedOpen] = useState(false);
//   const [longIdleOpen, setLongIdleOpen] = useState(false);
//   const [wireTemperingOpen, setWireTemperingOpen] = useState(false);
//   const [fuelConsumedCount, setFuelConsumedCount] = useState(0);
//   const [longIdleCount, setLongIdleCount] = useState(0);
//   const [wireTemperingCount, setWireTemperingCount] = useState(0);

//   const [accordionExpanded, setAccordionExpanded] = useState<any>({});
//   const handleAccordionToggle = (index: any, isExpanded: any) => {
//     setAccordionExpanded((prev: any) => ({
//       ...prev,
//       [index]: !prev[index],
//     }));

//     if (isExpanded) {
//       if (index === 0) {
//         FuelconsData();
//       } else if (index === 1) {
//         IdleData();
//       } else if (index === 2) {
//         TodayVData();
//       } else if (index === 3) {
//         fetchZonesData();
//       }
//     } else {
//       console.log("function is not working");
//     }
//   };

//   const [value, setValue] = useState<any>(
//     parseInt(localStorage.getItem("dash") || "0", 10)
//   );

//   useEffect(() => {
//     localStorage.setItem("dash", value.toString() || "0");
//   }, [value]);

//   const [isTable, setTable] = useState([]);
//   const [isPrint, setPrint] = useState([]);
//   const [isPrint1, setPrint1] = useState([]);

//   const [isLabel, setlabel] = useState("");
//   const [isStatus, setStatus] = useState("");
//   const [isStatus1, setStatus1] = useState("");

//   const [engineOnCount, setEngineOnCount] = useState(0);
//   const [engineOffCount, setEngineOffCount] = useState(0);

//   const downloadExcel = () => {
//     if (!isPrint || isPrint.length === 0) {
//       console.error("No data to export to Excel.");
//       return;
//     }

//     const ws = XLSX.utils.json_to_sheet(isPrint);

//     const headers = Object.keys(isPrint[0]);

//     headers.forEach((header, index) => {
//       const cellAddress = `${String.fromCharCode(65 + index)}1`;
//     });

//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, "vehicles");

//     XLSX.writeFile(wb, "FuelConsumed.xlsx");
//   };

//   const downloadExcel1 = () => {
//     if (!isPrint1 || isPrint1.length === 0) {
//       console.error("No data to export to Excel.");
//       return;
//     }

//     const ws = XLSX.utils.json_to_sheet(isPrint1);

//     const headers = Object.keys(isPrint1[0]);

//     headers.forEach((header, index) => {
//       const cellAddress = `${String.fromCharCode(65 + index)}1`;
//     });

//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, "vehicles");

//     XLSX.writeFile(wb, "Long_Idle.xlsx");
//   };

//   const handleTab = (event: any, newValue: any) => {
//     console.log(newValue);
//     setValue(newValue);
//   };

//   const items = [
//     { id: 0, text: <strong>{t("text.Dashboard")}</strong>, icon: <DashboardIcon /> },
//     { id: 1, text: <strong>{t("text.Tracking")}</strong>, icon: <GpsFixedIcon /> },
//     { id: 2, text: <strong>{t("text.GeofacingCreate")}</strong>, icon: <PlaceIcon /> },
//     { id: 3, text: <strong>{t("text.KudagharLocation")}</strong>, icon: <DeleteForeverIcon /> },
//     { id: 4, text: <strong>{t("text.VehicleHistory")}</strong>, icon: <CarCrashIcon /> },
//     { id: 5, text: <strong>{t("text.VehicleTravelled")}</strong>, icon: <EmojiTransportationIcon /> },
//   ];

//   const formatTrackTime = (tracktime: string) => {
//     const trackTime = new Date(tracktime);

//     // Check if the date is valid
//     if (isNaN(trackTime.getTime())) {
//       return "Invalid Date"; // Return a fallback message or handle it as needed
//     }

//     const day = trackTime.getDate().toString().padStart(2, "0");
//     const month = (trackTime.getMonth() + 1).toString().padStart(2, "0");
//     const year = trackTime.getFullYear();
//     const hours = trackTime.getHours().toString().padStart(2, "0");
//     const minutes = trackTime.getMinutes().toString().padStart(2, "0");
//     const seconds = trackTime.getSeconds().toString().padStart(2, "0");

//     return `${day}-${month}-${year} (Time:- ${hours}:${minutes}:${seconds})`;
//   };

//   const [vehicles, setVehicles] = useState<any>([]);
//   const [activeVehicle, setActiveVehicle] = useState<any>(null);
//   const [center, setCenter] = useState({ lat: 26.447965, lng: 80.3432 });
//   const mapRef: any = useRef(null);

//   useEffect(() => {
//     if (window.google && window.google.maps) {
//       console.log("Google Maps API loaded");
//     } else {
//       console.error("Google Maps API not loaded");
//     }
//   }, []);

//   // Fetch the vehicle data from API
//   const getCurrentData = (row: any) => {
//     const collectData = {
//       where: "VehicleNo=(@0)",
//       orderby: "",
//       pageNo: 0,
//       pageSize: 0,
//       intnotnullvalue1: 0,
//       userId: "string",
//       parameterValues: [row.vehicleNo],
//       str1: "",
//       str2: "",
//       str3: "",
//       str4: "",
//       str5: "",
//       intvalue1: 0,
//       intvalue2: 0,
//       intvalue3: 0,
//       intvalue4: 0,
//       intnotnullvalue2: 0,
//       intnotnullvalue3: 0,
//       date1: new Date().toISOString(),
//       date2: new Date().toISOString(),
//       date3: new Date().toISOString(),
//       date4: new Date().toISOString(),
//       dec1: 0,
//       dec2: 0,
//       dec3: 0,
//       dec4: 0,
//       flag: true,
//       data: "string",
//       success: true,
//       error: "string",
//       selectPerindex: 0,
//       show: true,
//     };

//     api.post(`Dashboard/GetVehileCurrentDay`, collectData).then((res) => {
//       const arr = res?.data?.data?.map((item: any) => ({
//         lat: item.lattitude,
//         lng: item.longitude,
//         id: item.id,
//         speed: item.speed,
//         tracktime: formatTrackTime(item.trackTime),
//         distance: item.distance,
//         nearme: item?.nearme,
//         vehicleNo: item?.vehicleNo,
//         icon:
//           item.speed === 0
//             ? "https://png.pngtree.com/png-vector/20240128/ourmid/pngtree-red-truck-transportation-png-image_11507611.png"
//             : "https://png.pngtree.com/png-vector/20240128/ourmid/pngtree-green-truck-transport-png-image_11508688.png",
//       }));
//       setVehicles(arr);
//       setCenter(calculateCenter(arr));
//       setCurrentMap(true);
//       if (arr.length > 0) {
//         adjustZoomLevel(arr);
//       }
//     });
//   };

//   const calculateCenter = (vehicles: any) => {
//     if (vehicles.length === 0) {
//       return { lat: 26.447965, lng: 80.3432 }; // Default center if no vehicles
//     }

//     const latitudes = vehicles.map((vehicle: any) => vehicle.lat);
//     const longitudes = vehicles.map((vehicle: any) => vehicle.lng);

//     const avgLat =
//       latitudes.reduce((sum: any, lat: any) => sum + lat, 0) / latitudes.length;
//     const avgLng =
//       longitudes.reduce((sum: any, lng: any) => sum + lng, 0) /
//       longitudes.length;

//     return { lat: avgLat, lng: avgLng }; // Return the center point
//   };

//   // Adjust the zoom level based on the spread of the vehicles
//   const adjustZoomLevel = (vehicles: any) => {
//     const bounds = new window.google.maps.LatLngBounds();

//     vehicles.forEach((vehicle: any) => {
//       bounds.extend(new window.google.maps.LatLng(vehicle.lat, vehicle.lng));
//     });

//     if (mapRef.current) {
//       mapRef.current.fitBounds(bounds); // Fit the map to the bounds of all vehicles
//     }
//   };

//   const handleMarkerMouseOver = (vehicle: any) => {
//     setActiveVehicle(vehicle);
//   };

//   const handleMarkerMouseOut = () => {
//     setActiveVehicle(null);
//   };

//   useEffect(() => {
//     getZoneData();

//     const interval = setInterval(() => {
//       getZoneData();
//     }, 30000);

//     return () => clearInterval(interval);
//   }, []);

//   const handleClose = () => {
//     setModal(false);
//   };

//   const handleClose1 = () => {
//     setModal1(false);
//   };

//   const handleClose2 = () => {
//     setVisible(false);
//   };

//   // Modal handlers for new cards
//   const handleFuelConsumedOpen = () => {
//     setFuelConsumedOpen(true);
//     FuelconsData();
//   };

//   const handleFuelConsumedClose = () => {
//     setFuelConsumedOpen(false);
//   };

//   const handleLongIdleOpen = () => {
//     setLongIdleOpen(true);
//     IdleData();
//   };

//   const handleLongIdleClose = () => {
//     setLongIdleOpen(false);
//   };

//   const handleWireTemperingOpen = () => {
//     setWireTemperingOpen(true);
//     fetchZonesData();
//   };

//   const handleWireTemperingClose = () => {
//     setWireTemperingOpen(false);
//   };

//   const zoneModal = async (Zone: any) => {
//     setlabel(Zone.label);
//     try {
//       const response = await api.get(`NTRead/GetTopFuelConsNTS/zone=${Zone.label}`);
//       const data = response.data.data;

//       const zonesWithIds = data.map((zone: any, index: any) => ({
//         ...zone,
//         serialNo: index + 1,
//         id: index + 1,
//       }));
//       setZones9(zonesWithIds);
//       setIsLoading9(false);

//       if (data.length > 0) {
//         const columns9: GridColDef[] = [
//           {
//             field: "serialNo",
//             headerName: t("text.SrNo"),
//             flex: 0.5,
//             cellClassName: "wrap-text",
//           },
//           {
//             field: "vehicleNo",
//             headerName: t("text.VehicleNo"),
//             flex: 1,
//             cellClassName: "wrap-text",
//           },
//           {
//             field: "driver",
//             renderHeader: () => (
//               <>
//                 <PersonIcon
//                   style={{ marginRight: 8, verticalAlign: "middle" }}
//                 />
//                 <span style={{ verticalAlign: "middle" }}>
//                   {t("text.Driver")}
//                 </span>
//               </>
//             ),
//             flex: 1.5,
//             renderCell: (params) => {
//               const { empName, empMobileNo } = params.row;
//               return `${empName} (${empMobileNo})`;
//             },
//           },
//           {
//             field: "departmentName",
//             headerName: t("text.DepartmentName"),
//             flex: 1,
//             cellClassName: "wrap-text",
//           },
//           {
//             field: "vehicleTypename",
//             headerName: t("text.VehicleTypeName"),
//             flex: 1,
//             cellClassName: "wrap-text",
//           },
//           {
//             field: "flag",
//             headerName: t("text.Status"),
//             flex: 1,
//             cellClassName: "wrap-text",
//             align: "center",
//             headerAlign: "center",
//           },
//           {
//             field: "speed",
//             headerName: t("text.Speed"),
//             flex: 0.5,
//             cellClassName: "wrap-text",
//           },
//           {
//             field: "fuel",
//             headerName: "Fuel",
//             flex: 1,
//             align: "center",
//             headerAlign: "center",
//             valueFormatter: ({ value }) => (value ? value.toFixed(2) : ""),
//             cellClassName: "wrap-text",
//           },
//         ];
//         setColumns9(columns9 as any);
//       }
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   const adjustedColumns10 = columns9.map((column: any) => ({
//     ...column,
//   }));

//   const IgnitionData = async (value: boolean) => {
//     setModal1(true);
//     setIsLoading5(true);
//     try {
//       console.log("Check value", value);
//       const statusText = value ? "On" : "Off";
//       setStatus(statusText);

//       const response = await api.get(`Mng/EngineOnOff?onoff=${value}`);
//       const data = response.data.data || [];

//       const zonesWithIds = data.map((zone: any, index: any) => ({
//         ...zone,
//         serialNo: zone.sno || index + 1,
//         id: zone.itemmasterid || index + 1,
//         vehicleNo: zone.vehicleno,
//         driver: zone.driver,
//         acc: zone.acc ? "On" : "Off"
//       }));

//       setZones5(zonesWithIds);
//       setIsLoading5(false);

//       if (data.length > 0) {
//         const columns2: GridColDef[] = [
//           {
//             field: "serialNo",
//             renderHeader: () => (
//               <>
//                 <ListAlt style={{ marginRight: 8, verticalAlign: "middle" }} />
//                 <span style={{ verticalAlign: "middle" }}>
//                   {t("text.SrNo")}
//                 </span>
//               </>
//             ),
//             cellClassName: "wrap-text",
//             flex: 0.3,
//             valueGetter: (params) => params.row.sno || params.row.serialNo,
//           },
//           {
//             field: "vehicleNo",
//             renderHeader: () => (
//               <>
//                 <DirectionsCar
//                   style={{ marginRight: 8, verticalAlign: "middle" }}
//                 />
//                 <span style={{ verticalAlign: "middle" }}>
//                   {t("text.VehicleNo")}
//                 </span>
//               </>
//             ),
//             cellClassName: "wrap-text",
//             flex: 1,
//             valueGetter: (params) => params.row.vehicleno || params.row.vehicleNo,
//           },
//           {
//             field: "driver",
//             cellClassName: "wrap-text",
//             renderHeader: () => (
//               <>
//                 <PersonIcon
//                   style={{ marginRight: 8, verticalAlign: "middle" }}
//                 />
//                 <span style={{ verticalAlign: "middle" }}>
//                   {t("text.Driver")}
//                 </span>
//               </>
//             ),
//             flex: 1.5,
//             valueGetter: (params) => params.row.driver,
//           },
//           {
//             field: "acc",
//             renderHeader: () => (
//               <>
//                 <CheckCircle
//                   style={{ marginRight: 8, verticalAlign: "middle" }}
//                 />
//                 <span style={{ verticalAlign: "middle" }}>
//                   {t("text.Status")}
//                 </span>
//               </>
//             ),
//             cellClassName: "wrap-text",
//             flex: 0.5,
//             valueGetter: (params) => params.row.acc ? "On" : "Off",
//           },
//         ];
//         setColumns5(columns2 as any);
//       }
//     } catch (error) {
//       console.error("Error fetching data:", error);
//       setIsLoading5(false);
//     }
//   };

//   const adjustedColumns5 = columns5.map((column: any) => ({
//     ...column,
//   }));

//   const runningData = async (value: any) => {
//     setStatus1(value);
//     setModal(true);
//     try {
//       const response = await api.get(`NTRead/GetRunningStatus/stat=${value}`);
//       const data = response.data.data;

//       const zonesWithIds = data.map((zone: any, index: any) => ({
//         ...zone,
//         serialNo: index + 1,
//         id: index + 1,
//       }));
//       setZones4(zonesWithIds);
//       setIsLoading4(false);

//       if (data.length > 0) {
//         const columns2: GridColDef[] = [
//           {
//             field: "serialNo",
//             renderHeader: () => (
//               <>
//                 <ListAlt style={{ marginRight: 8, verticalAlign: "middle" }} />
//                 <span style={{ verticalAlign: "middle" }}>
//                   {t("text.SrNo")}
//                 </span>
//               </>
//             ),
//             flex: 0.5,
//           },
//           {
//             field: "vehicleNo",
//             renderHeader: () => (
//               <>
//                 <DirectionsCar
//                   style={{ marginRight: 8, verticalAlign: "middle" }}
//                 />
//                 <span style={{ verticalAlign: "middle" }}>
//                   {t("text.VehicleNo")}
//                 </span>
//               </>
//             ),
//             flex: 1,
//           },
//           {
//             field: "driver",
//             renderHeader: () => (
//               <>
//                 <PersonIcon
//                   style={{ marginRight: 8, verticalAlign: "middle" }}
//                 />
//                 <span style={{ verticalAlign: "middle" }}>
//                   {t("text.Driver")}
//                 </span>
//               </>
//             ),
//             flex: 1.5,
//             renderCell: (params) => {
//               const { empName, empMobileNo } = params.row;
//               return `${empName} (${empMobileNo})`;
//             },
//           },
//           {
//             field: "departmentName",
//             renderHeader: () => (
//               <>
//                 <Work style={{ marginRight: 8, verticalAlign: "middle" }} />
//                 <span style={{ verticalAlign: "middle" }}>
//                   {t("text.DepartmentName")}
//                 </span>
//               </>
//             ),
//             flex: 1,
//           },
//           {
//             field: "vehicleTypename",
//             renderHeader: () => (
//               <>
//                 <DirectionsBike
//                   style={{ marginRight: 8, verticalAlign: "middle" }}
//                 />
//                 <span style={{ verticalAlign: "middle" }}>
//                   {t("text.VehicleTypeName")}
//                 </span>
//               </>
//             ),
//             flex: 1,
//           },
//         ];
//         setColumns4(columns2 as any);
//       }
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   const adjustedColumns4 = columns4.map((column: any) => ({
//     ...column,
//   }));

//   // Function to fetch engine status counts
//   const fetchEngineStatus = async () => {
//     try {
//       // Fetch engine ON count
//       const onResponse = await api.get(`Mng/EngineOnOff?onoff=true`);
//       const onData = onResponse.data.data || [];
//       const onCount = onData.length;
//       setEngineOnCount(onCount);

//       // Fetch engine OFF count
//       const offResponse = await api.get(`Mng/EngineOnOff?onoff=false`);
//       const offData = offResponse.data.data || [];
//       const offCount = offData.length;
//       setEngineOffCount(offCount);

//       // Update pie chart data
//       const pieChartData = [
//         { id: 1, value: onCount, label: "On" },
//         { id: 2, value: offCount, label: "Off" },
//       ];
//       setlabelsData(pieChartData);

//     } catch (error) {
//       console.error("Error fetching engine status:", error);
//     }
//   };

//   const getZoneData = () => {
//     api
//       .get("NTRead/VehCurrStat")
//       .then((res) => {
//         const data = res.data.data;

//         setRunn(data.runningveh);
//         setIdle(data.idleveh);
//         setStop(data.stopveh);
//         setTotalVeh(data.vehtotal);
//         setOnRoadVeh(data.totalveh);
//         setGpsStatus(data.vehtotal);
//         setTotalDistance(data.totDistance);

//         // Fetch counts for cards
//         fetchCardCounts();

//         // Fetch engine status
//         fetchEngineStatus();

//         if (
//           data.coT3 &&
//           data.labels3 &&
//           data.coT3.length === data.labels3.length
//         ) {
//           const chartData = data.coT3.map((value: any, index: any) => ({
//             value: value,
//             label: data.labels3[index],
//           }));

//           const sortedChartData = chartData.sort((a: any, b: any) => {
//             const zoneA = parseInt(a.label.split(" ")[1], 10);
//             const zoneB = parseInt(b.label.split(" ")[1], 10);
//             return zoneA - zoneB;
//           });

//           setChartData(sortedChartData);
//           setChartIsLoading(false)
//         } else {
//           console.error("Data arrays have different lengths.");
//         }
//       })
//       .catch((error) => {
//         console.error("Error fetching data:", error);
//       });
//   };

//   const fetchCardCounts = async () => {
//     try {
//       // Fetch Fuel Consumed count
//       const fuelResponse = await api.get(`NTRead/GetTopFuelCons/nos=50`);
//       setFuelConsumedCount(fuelResponse.data.data.length);

//       // Fetch Long Idle count
//       const idleResponse = await api.get(`NTRead/GetLongIdleVeh/nos=50`);
//       setLongIdleCount(idleResponse.data.data.length);

//       // Fetch Wire Tempering count
//       const formattedDate = formatDate(new Date());
//       const wireResponse = await api.get(`NTRead/ProbWireTamp/date=${formattedDate}`);
//       setWireTemperingCount(wireResponse.data.data.length);
//     } catch (error) {
//       console.error("Error fetching card counts:", error);
//     }
//   };

//   const formatDate = (date: any) => {
//     const month = ("0" + (date.getMonth() + 1)).slice(-2);
//     const day = ("0" + date.getDate()).slice(-2);
//     const year = date.getFullYear();
//     return `${month}-${day}-${year}`;
//   };

//   const formattedDate = formatDate(new Date());

//   const fetchZonesData = async () => {
//     try {
//       const response = await api.get(`NTRead/ProbWireTamp/date=${formattedDate}`);
//       const data = response.data.data;

//       const zonesWithIds = data?.map((zone: any, index: any) => ({
//         ...zone,
//         serialNo: index + 1,
//         id: index + 1,
//       }));
//       setZones(zonesWithIds);
//       setIsLoading(false);

//       if (data.length > 0) {
//         const columns: GridColDef[] = [
//           {
//             field: "serialNo",
//             headerName: t("text.SrNo"),
//             flex: 0.5,
//           },
//           {
//             field: "vehicleNo",
//             headerName: t("text.VehicleNo"),
//             flex: 1,
//           },
//           {
//             field: "departmentName",
//             headerName: t("text.DepartmentName"),
//             flex: 1,
//           },
//           {
//             field: "date",
//             headerName: t("text.Date"),
//             flex: 1,
//             valueGetter: (params) => {
//               const date = new Date(params.value);
//               const formattedDate = `${String(date.getDate()).padStart(
//                 2,
//                 "0"
//               )}-${String(date.getMonth() + 1).padStart(
//                 2,
//                 "0"
//               )}-${date.getFullYear()}`;
//               const time = `${String(date.getHours()).padStart(
//                 2,
//                 "0"
//               )}:${String(date.getMinutes()).padStart(2, "0")}:${String(
//                 date.getSeconds()
//               ).padStart(2, "0")}`;
//               return `${formattedDate} (Time: ${time})`;
//             },
//           },
//           {
//             field: "devid",
//             headerName: t("text.Devid"),
//             flex: 1,
//           },
//         ];
//         setColumns(columns as any);
//       }
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   const adjustedColumns = columns.map((column: any) => ({
//     ...column,
//   }));

//   useEffect(() => {
//     FuelconsData();
//   }, [getTop]);

//   useEffect(() => {
//     IdleData();
//   }, [getTop1]);

//   const FuelconsData = async () => {
//     try {
//       const recordsCount = getTop ? 10 : 50;
//       const response = await api.get(`NTRead/GetTopFuelCons/nos=${recordsCount}`);
//       const data = response.data.data;

//       setPrint(data);
//       setFuelConsumedCount(data.length);

//       const zonesWithIds = data.map((zone: any, index: any) => ({
//         ...zone,
//         serialNo: index + 1,
//         id: index + 1,
//       }));
//       setZones1(zonesWithIds);
//       setIsLoading1(false);

//       if (data.length > 0) {
//         const columns1: GridColDef[] = [
//           {
//             field: "serialNo",
//             headerName: t("text.SrNo"),
//             flex: 0.5,
//           },
//           {
//             field: "vehicleNo",
//             headerName: t("text.VehicleNo"),
//             flex: 1,
//           },
//           {
//             field: "departmentname",
//             headerName: t("text.DepartmentName"),
//             flex: 1,
//           },
//           {
//             field: "fuelConsumed",
//             headerName: t("text.FuelConsumed"),
//             flex: 1,
//             align: "right",
//             headerAlign: "right",
//             valueFormatter: ({ value }) => (value ? value.toFixed(2) : ""),
//           },
//         ];
//         setColumns1(columns1 as any);
//       }
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   const adjustedColumns1 = columns1.map((column: any) => ({
//     ...column,
//   }));

//   const IdleData = async () => {
//     try {
//       const recordsCount = getTop1 ? 10 : 50;
//       const response = await api.get(`NTRead/GetLongIdleVeh/nos=${recordsCount}`);
//       const data = response?.data?.data;

//       setPrint1(data);
//       setLongIdleCount(data.length);

//       const zonesWithIds = data.map((zone: any, index: any) => ({
//         ...zone,
//         serialNo: index + 1,
//         id: index + 1,
//       }));
//       setZones2(zonesWithIds);
//       setIsLoading2(false);

//       if (data.length > 0) {
//         const columns2: GridColDef[] = [
//           {
//             field: "vehicleNo",
//             headerName: t("text.VehicleNo"),
//             flex: 1,
//             cellClassName: "wrap-text",
//           },
//           {
//             field: "vehicleTypename",
//             headerName: t("text.VehicleType"),
//             flex: 2,
//             cellClassName: "wrap-text",
//           },
//           {
//             field: "idleTime",
//             headerName: t("text.Duration"),
//             flex: 1,
//             cellClassName: "wrap-text",
//           },
//           {
//             field: "departmentname",
//             headerName: t("text.DepartmentName"),
//             flex: 1,
//             cellClassName: "wrap-text",
//           },
//           {
//             field: "empName",
//             headerName: t("text.Driver"),
//             flex: 1.5,
//             cellClassName: "wrap-text",
//             renderCell: (params) => {
//               const { empName, empMobileNo } = params.row;
//               return `${empName} (${empMobileNo})`;
//             },
//           },
//         ];
//         setColumns2(columns2 as any);
//       }
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   const adjustedColumns2 = columns2.map((column: any) => ({
//     ...column,
//   }));

//   const styles = `
//   .wrap-text {
//     white-space: normal !important;
//     word-wrap: break-word !important;
//     overflow-wrap: break-word !important;
//   }
// `;

//   document.head.insertAdjacentHTML("beforeend", `<style>${styles}</style>`);

//   const TodayVData = async () => {
//     try {
//       const response = await api.get(`NTRead/GetNTDashboard`);
//       const data = response.data.data;

//       const zonesWithIds = data.map((zone: any, index: any) => ({
//         ...zone,
//         serialNo: index + 1,
//         id: index + 1,
//       }));
//       setZones3(zonesWithIds);
//       setIsLoading3(false);

//       if (data.length > 0) {
//         const columns2: GridColDef[] = [
//           {
//             field: "serialNo",
//             headerName: t("text.SrNo"),
//             flex: 0.5,
//             cellClassName: "wrap-text",
//           },
//           {
//             field: "vehicleNo",
//             headerName: t("text.VehicleNo"),
//             flex: 1,
//             cellClassName: "wrap-text",
//             renderCell: (params) => (
//               <span
//                 onClick={() => {
//                   getCurrentData(params?.row);
//                 }}
//                 style={{
//                   color: "blue",
//                   textDecoration: "underline",
//                   cursor: "pointer",
//                 }}
//               >
//                 {params.value}
//               </span>
//             ),
//           },
//           {
//             field: "trackTime",
//             headerName: t("text.TrackTime"),
//             flex: 2,
//             cellClassName: "wrap-text",
//             valueGetter: (params) => {
//               const date = new Date(params.value);
//               const formattedDate = `${String(date.getDate()).padStart(
//                 2,
//                 "0"
//               )}-${String(date.getMonth() + 1).padStart(
//                 2,
//                 "0"
//               )}-${date.getFullYear()}`;
//               const time = `${String(date.getHours()).padStart(
//                 2,
//                 "0"
//               )}:${String(date.getMinutes()).padStart(2, "0")}:${String(
//                 date.getSeconds()
//               ).padStart(2, "0")}`;
//               return `${formattedDate} (Time: ${time})`;
//             },
//           },
//           {
//             field: "departmentName",
//             headerName: t("text.DepartmentName"),
//             flex: 1,
//             cellClassName: "wrap-text",
//           },
//           {
//             field: "vehicleTypename",
//             headerName: t("text.VehicleTypeName"),
//             flex: 1,
//             cellClassName: "wrap-text",
//           },
//           {
//             field: "kmPerLitre",
//             headerName: t("text.kmPerLitre"),
//             flex: 1,
//             cellClassName: "wrap-text",
//             align: "right",
//             headerAlign: "right",
//             valueFormatter: ({ value }) => (value ? value.toFixed(2) : ""),
//           },
//           {
//             field: "ignition",
//             headerName: t("text.Ignition"),
//             flex: 0.5,
//             cellClassName: "wrap-text",
//             renderCell: (params) => (
//               <span
//                 onClick={() => {
//                   if (params.row.ignition === "On") {
//                     IgnitionData(true);
//                   } else if (params.row.ignition === "Off") {
//                     IgnitionData(false);
//                   }
//                 }}
//                 style={{
//                   color: "blue",
//                   textDecoration: "underline",
//                   cursor: "pointer",
//                 }}
//               >
//                 {params.value}
//               </span>
//             ),
//           },
//           {
//             field: "distance",
//             headerName: t("text.Distance"),
//             flex: 1,
//             align: "right",
//             headerAlign: "right",
//             valueFormatter: ({ value }) => (value ? value.toFixed(2) : ""),
//             cellClassName: "wrap-text",
//           },
//         ];
//         setColumns3(columns2 as any);
//       }
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   const adjustedColumns3 = columns3.map((column: any) => ({
//     ...column,
//   }));

//   return (
//     <div>
//       {/* Summary Cards Section - Placed above the tabs */}
//       <Grid container spacing={2} style={{ marginBottom: "15px", marginTop: "5px" }}>
//         {/* Fuel Consumed Card */}
//         <Grid item xs={12} sm={6} md={4}>
//           <motion.div
//             whileHover={{
//               scale: 1.05,
//               y: -5,
//               transition: { duration: 0.2 }
//             }}
//             whileTap={{ scale: 0.98 }}
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.3 }}
//           >
//             <Card
//               sx={{
//                 height: '120px',
//                 cursor: 'pointer',
//                 border: '1px solid rgba(66, 182, 245, 0.2)',
//                 borderRadius: '12px',
//                 background: 'linear-gradient(135deg, #ffffff 0%, #f8fbff 100%)',
//                 transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
//                 position: 'relative',
//                 overflow: 'hidden',
//                 '&:before': {
//                   content: '""',
//                   position: 'absolute',
//                   top: 0,
//                   left: 0,
//                   width: '100%',
//                   height: '4px',
//                   background: 'linear-gradient(90deg, #42b6f5, #2196f3)',
//                   transform: 'scaleX(0)',
//                   transformOrigin: 'left',
//                   transition: 'transform 0.4s ease',
//                 },
//                 '&:hover': {
//                   boxShadow: '0 10px 25px rgba(66, 182, 245, 0.2)',
//                   borderColor: 'rgba(66, 182, 245, 0.4)',
//                   transform: 'translateY(-4px)',
//                   '&:before': {
//                     transform: 'scaleX(1)',
//                   },
//                   '& .icon-container': {
//                     transform: 'scale(1.1) rotate(5deg)',
//                     boxShadow: '0 8px 20px rgba(66, 182, 245, 0.3)',
//                   }
//                 }
//               }}
//               onClick={handleFuelConsumedOpen}
//             >
//               <CardContent sx={{
//                 p: 2.5,
//                 height: '100%',
//                 display: 'flex',
//                 alignItems: 'center',
//                 position: 'relative',
//                 zIndex: 1
//               }}>
//                 <Box
//                   className="icon-container"
//                   sx={{
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     width: 70,
//                     height: 70,
//                     borderRadius: '12px',
//                     background: 'linear-gradient(135deg, rgba(66, 182, 245, 0.1) 0%, rgba(66, 182, 245, 0.2) 100%)',
//                     marginRight: 2.5,
//                     flexShrink: 0,
//                     transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
//                     position: 'relative',
//                     overflow: 'hidden',
//                     '&:after': {
//                       content: '""',
//                       position: 'absolute',
//                       top: 0,
//                       left: 0,
//                       width: '100%',
//                       height: '100%',
//                       background: 'linear-gradient(135deg, transparent 30%, rgba(255, 255, 255, 0.4) 100%)',
//                       borderRadius: '12px',
//                     }
//                   }}
//                 >
//                   <LocalGasStation
//                     fontSize="large"
//                     sx={{
//                       color: ' #12286d',
//                       filter: 'drop-shadow(0 2px 4px rgba(66, 182, 245, 0.3))',
//                       zIndex: 1,
//                       position: 'relative'
//                     }}
//                   />
//                 </Box>
//                 <Box sx={{ flexGrow: 1, textAlign: 'left' }}>
//                   <Typography
//                     variant="h6"
//                     sx={{
//                       fontWeight: 700,
//                       color: '#1a237e',
//                       fontSize: '1.1rem',
//                       letterSpacing: '0.5px',
//                       mb: 1,
//                       textTransform: 'uppercase'
//                     }}
//                   >
//                     Fuel Consumed
//                   </Typography>
//                   <Box sx={{ display: 'flex', alignItems: 'baseline' }}>
//                     <Typography
//                       variant="h3"
//                       sx={{
//                         fontWeight: 800,
//                         color: '#12286d',
//                         fontSize: '2.5rem',
//                         lineHeight: 1,
//                         mr: 1,
//                         textShadow: '0 2px 4px rgba(66, 182, 245, 0.2)'
//                       }}
//                     >
//                       {fuelConsumedCount}
//                     </Typography>
//                     <Typography
//                       variant="caption"
//                       sx={{
//                         fontWeight: 600,
//                         color: '#666',
//                         fontSize: '0.75rem',
//                         letterSpacing: '0.5px'
//                       }}
//                     >
//                       Vehicles
//                     </Typography>
//                   </Box>
//                 </Box>
//               </CardContent>
//             </Card>
//           </motion.div>
//         </Grid>

//         {/* Long Idle Vehicle Card */}
//         <Grid item xs={12} sm={6} md={4}>
//           <motion.div
//             whileHover={{
//               scale: 1.05,
//               y: -5,
//               transition: { duration: 0.2 }
//             }}
//             whileTap={{ scale: 0.98 }}
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.3, delay: 0.1 }}
//           >
//             <Card
//               sx={{
//                 height: '120px',
//                 cursor: 'pointer',
//                 border: '1px solid rgba(66, 182, 245, 0.2)',
//                 borderRadius: '12px',
//                 background: 'linear-gradient(135deg, #ffffff 0%, #f8fbff 100%)',
//                 transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
//                 position: 'relative',
//                 overflow: 'hidden',
//                 '&:before': {
//                   content: '""',
//                   position: 'absolute',
//                   top: 0,
//                   left: 0,
//                   width: '100%',
//                   height: '4px',
//                   background: 'linear-gradient(90deg, #42b6f5, #2196f3)',
//                   transform: 'scaleX(0)',
//                   transformOrigin: 'left',
//                   transition: 'transform 0.4s ease',
//                 },
//                 '&:hover': {
//                   boxShadow: '0 10px 25px rgba(66, 182, 245, 0.2)',
//                   borderColor: 'rgba(66, 182, 245, 0.4)',
//                   transform: 'translateY(-4px)',
//                   '&:before': {
//                     transform: 'scaleX(1)',
//                   },
//                   '& .icon-container': {
//                     transform: 'scale(1.1) rotate(5deg)',
//                     boxShadow: '0 8px 20px rgba(66, 182, 245, 0.3)',
//                   }
//                 }
//               }}
//               onClick={handleLongIdleOpen}
//             >
//               <CardContent sx={{
//                 p: 2.5,
//                 height: '100%',
//                 display: 'flex',
//                 alignItems: 'center',
//                 position: 'relative',
//                 zIndex: 1
//               }}>
//                 <Box
//                   className="icon-container"
//                   sx={{
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     width: 70,
//                     height: 70,
//                     borderRadius: '12px',
//                     background: 'linear-gradient(135deg, rgba(66, 182, 245, 0.1) 0%, rgba(66, 182, 245, 0.2) 100%)',
//                     marginRight: 2.5,
//                     flexShrink: 0,
//                     transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
//                     position: 'relative',
//                     overflow: 'hidden',
//                     '&:after': {
//                       content: '""',
//                       position: 'absolute',
//                       top: 0,
//                       left: 0,
//                       width: '100%',
//                       height: '100%',
//                       background: 'linear-gradient(135deg, transparent 30%, rgba(255, 255, 255, 0.4) 100%)',
//                       borderRadius: '12px',
//                     }
//                   }}
//                 >
//                   <FaClock
//                     style={{
//                       fontSize: "28px",
//                       color: '#12286d',
//                       filter: 'drop-shadow(0 2px 4px rgba(66, 182, 245, 0.3))',
//                       zIndex: 1,
//                       position: 'relative'
//                     }}
//                   />
//                 </Box>
//                 <Box sx={{ flexGrow: 1, textAlign: 'left' }}>
//                   <Typography
//                     variant="h6"
//                     sx={{
//                       fontWeight: 700,
//                       color: '#1a237e',
//                       fontSize: '1.1rem',
//                       letterSpacing: '0.5px',
//                       mb: 1,
//                       textTransform: 'uppercase'
//                     }}
//                   >
//                     Long Idle Vehicle
//                   </Typography>
//                   <Box sx={{ display: 'flex', alignItems: 'baseline' }}>
//                     <Typography
//                       variant="h3"
//                       sx={{
//                         fontWeight: 800,
//                         color: '#12286d',
//                         fontSize: '2.5rem',
//                         lineHeight: 1,
//                         mr: 1,
//                         textShadow: '0 2px 4px rgba(66, 182, 245, 0.2)'
//                       }}
//                     >
//                       {longIdleCount}
//                     </Typography>
//                     <Typography
//                       variant="caption"
//                       sx={{
//                         fontWeight: 600,
//                         color: '#666',
//                         fontSize: '0.75rem',
//                         letterSpacing: '0.5px'
//                       }}
//                     >
//                       Vehicles
//                     </Typography>
//                   </Box>
//                 </Box>
//               </CardContent>
//             </Card>
//           </motion.div>
//         </Grid>

//         {/* Probable Wire Tempering Card */}
//         <Grid item xs={12} sm={6} md={4}>
//           <motion.div
//             whileHover={{
//               scale: 1.05,
//               y: -5,
//               transition: { duration: 0.2 }
//             }}
//             whileTap={{ scale: 0.98 }}
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.3, delay: 0.2 }}
//           >
//             <Card
//               sx={{
//                 height: '120px',
//                 cursor: 'pointer',
//                 border: '1px solid rgba(66, 182, 245, 0.2)',
//                 borderRadius: '12px',
//                 background: 'linear-gradient(135deg, #ffffff 0%, #f8fbff 100%)',
//                 transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
//                 position: 'relative',
//                 overflow: 'hidden',
//                 '&:before': {
//                   content: '""',
//                   position: 'absolute',
//                   top: 0,
//                   left: 0,
//                   width: '100%',
//                   height: '4px',
//                   background: 'linear-gradient(90deg, #42b6f5, #2196f3)',
//                   transform: 'scaleX(0)',
//                   transformOrigin: 'left',
//                   transition: 'transform 0.4s ease',
//                 },
//                 '&:hover': {
//                   boxShadow: '0 10px 25px rgba(66, 182, 245, 0.2)',
//                   borderColor: 'rgba(66, 182, 245, 0.4)',
//                   transform: 'translateY(-4px)',
//                   '&:before': {
//                     transform: 'scaleX(1)',
//                   },
//                   '& .icon-container': {
//                     transform: 'scale(1.1) rotate(5deg)',
//                     boxShadow: '0 8px 20px rgba(66, 182, 245, 0.3)',
//                   }
//                 }
//               }}
//               onClick={handleWireTemperingOpen}
//             >
//               <CardContent sx={{
//                 p: 2.5,
//                 height: '100%',
//                 display: 'flex',
//                 alignItems: 'center',
//                 position: 'relative',
//                 zIndex: 1
//               }}>
//                 <Box
//                   className="icon-container"
//                   sx={{
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     width: 70,
//                     height: 70,
//                     borderRadius: '12px',
//                     background: 'linear-gradient(135deg, rgba(66, 182, 245, 0.1) 0%, rgba(66, 182, 245, 0.2) 100%)',
//                     marginRight: 2.5,
//                     flexShrink: 0,
//                     transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
//                     position: 'relative',
//                     overflow: 'hidden',
//                     '&:after': {
//                       content: '""',
//                       position: 'absolute',
//                       top: 0,
//                       left: 0,
//                       width: '100%',
//                       height: '100%',
//                       background: 'linear-gradient(135deg, transparent 30%, rgba(255, 255, 255, 0.4) 100%)',
//                       borderRadius: '12px',
//                     }
//                   }}
//                 >
//                   <ReportProblem
//                     fontSize="large"
//                     sx={{
//                       color: '#12286d',
//                       filter: 'drop-shadow(0 2px 4px rgba(66, 182, 245, 0.3))',
//                       zIndex: 1,
//                       position: 'relative'
//                     }}
//                   />
//                 </Box>
//                 <Box sx={{ flexGrow: 1, textAlign: 'left' }}>
//                   <Typography
//                     variant="h6"
//                     sx={{
//                       fontWeight: 700,
//                       color: '#1a237e',
//                       fontSize: '1.1rem',
//                       letterSpacing: '0.5px',
//                       mb: 1,
//                       textTransform: 'uppercase'
//                     }}
//                   >
//                     Wire Tempering
//                   </Typography>
//                   <Box sx={{ display: 'flex', alignItems: 'baseline' }}>
//                     <Typography
//                       variant="h3"
//                       sx={{
//                         fontWeight: 800,
//                         color: '#12286d',
//                         fontSize: '2.5rem',
//                         lineHeight: 1,
//                         mr: 1,
//                         textShadow: '0 2px 4px rgba(66, 182, 245, 0.2)'
//                       }}
//                     >
//                       {wireTemperingCount}
//                     </Typography>
//                     <Typography
//                       variant="caption"
//                       sx={{
//                         fontWeight: 600,
//                         color: '#666',
//                         fontSize: '0.75rem',
//                         letterSpacing: '0.5px'
//                       }}
//                     >
//                       Alerts
//                     </Typography>
//                   </Box>
//                 </Box>
//               </CardContent>
//             </Card>
//           </motion.div>
//         </Grid>
//       </Grid>

//       {/* Tabs Section */}
//       <div
//         style={{
//           backgroundColor: "#ebf2f5",
//           borderRadius: "15px",
//           marginTop: "5px",
//           boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
//           borderTop: "2px solid",
//           borderImage: "linear-gradient(45deg, #ff0000, #0000ff) 1",
//           borderTopColor: "2px solid blue",
//           borderLeft: "solid 2px transparent",
//           borderRight: "solid 2px transparent",
//           borderImageSource: "linear-gradient(to bottom, #ff8000, transparent)",
//           borderImageSlice: "1",
//         }}
//       >
//         <CardContent>
//           <Grid
//             item
//             sm={4}
//             md={6}
//             xs={12}
//             alignItems="center"
//             justifyContent="center"
//             display="flex"
//           >
//             <Tabs
//               value={value}
//               onChange={handleTab}
//               indicatorColor="primary"
//               textColor="primary"
//               variant="scrollable"
//               scrollButtons="auto"
//             >
//               {items.map((item, index) => (
//                 <Tab
//                   key={item.id}
//                   icon={item.icon}
//                   label={item.text}
//                   iconPosition="start"
//                 />
//               ))}
//             </Tabs>
//           </Grid>
//         </CardContent>
//       </div>

//       <div
//         style={{
//           backgroundColor: "#ebf2f5",
//           borderRadius: "5px",
//           marginTop: "5px",
//           position: "relative",
//         }}
//       >
//         <div
//           style={{
//             position: "absolute",
//             top: 0,
//             left: 0,
//             width: "100%",
//             height: "2px",
//             background: "linear-gradient(to right, transparent,rgb(0, 13, 255) 50%, transparent)",
//             borderTopLeftRadius: "5px",
//             borderTopRightRadius: "5px",
//           }}
//         ></div>
//         <CardContent>
//           {value === 0 && (
//             <div>
//               <Grid
//                 container
//                 spacing={1.5}
//               >
//                 {/* Charts and Running Status Grid */}
//                 <Grid xs={12} sm={6} md={4} item>
//                   <motion.div
//                     initial="hidden"
//                     whileHover={{ scale: 1.05 }}
//                     whileTap={{ scale: 0.95 }}
//                   >
//                     <Card
//                       elevation={4}
//                       style={{
//                         marginLeft: "1%",
//                         border: ".5px solid transparent",
//                         borderRadius: "10px",
//                       }}
//                     >
//                       <Grid
//                         style={{
//                           width: "100%",
//                           height: "53vh",
//                           backgroundColor: "#e9f4f7",
//                         }}
//                       >
//                         <Typography
//                           variant="h6"
//                           component="div"
//                           sx={{
//                             padding: "17px",
//                             background: "linear-gradient(to right, #ffffff,rgb(27, 174, 253))",
//                           }}
//                         >
//                           Zones
//                         </Typography>
//                         {isChartLoading ? (
//                           <Box display="flex" justifyContent="center" alignItems="center" height={220}>
//                             <motion.span
//                               animate={{ opacity: [1, 0.3, 1] }}
//                               transition={{ duration: 1, repeat: Infinity }}
//                               style={dotStyle}
//                             />
//                             <motion.span
//                               animate={{ opacity: [1, 0.3, 1] }}
//                               transition={{ duration: 1, repeat: Infinity, delay: 0.2 }}
//                               style={dotStyle}
//                             />
//                             <motion.span
//                               animate={{ opacity: [1, 0.3, 1] }}
//                               transition={{ duration: 1, repeat: Infinity, delay: 0.4 }}
//                               style={dotStyle}
//                             />
//                           </Box>
//                         ) : (
//                           <PieChart
//                             series={[
//                               {
//                                 data: chartData,
//                                 highlightScope: {
//                                   faded: "global",
//                                   highlighted: "item",
//                                 },
//                                 faded: {
//                                   innerRadius: 30,
//                                   additionalRadius: -30,
//                                   color: "gray",
//                                 },
//                               },
//                             ]}
//                             height={220}
//                             onItemClick={(e: any, d: any) => {
//                               const clickedData = chartData[d.dataIndex];
//                               zoneModal(clickedData);
//                               setVisible(true);
//                             }}
//                           />
//                         )}
//                       </Grid>
//                     </Card>
//                   </motion.div>
//                 </Grid>

//                 <Grid xs={12} sm={6} md={4} item>
//                   <motion.div
//                     initial="hidden"
//                     whileHover={{ scale: 1.05 }}
//                     whileTap={{ scale: 0.95 }}
//                   >
//                     <Card
//                       elevation={4}
//                       style={{
//                         marginLeft: "1%",
//                         border: ".5px solid transparent",
//                         borderRadius: "10px",
//                       }}
//                     >
//                       <Grid
//                         style={{
//                           width: "100%",
//                           height: "53vh",
//                           backgroundColor: "#e9f4f7",
//                         }}
//                       >
//                         <Typography
//                           variant="h6"
//                           component="div"
//                           sx={{
//                             padding: "17px",
//                             background: "linear-gradient(to right, #ffffff,rgb(27, 174, 253))",
//                           }}
//                         >
//                           Vehicles Ignition Status
//                         </Typography>
//                         {isChartLoading ? (
//                           <Box display="flex" justifyContent="center" alignItems="center" height={220}>
//                             <motion.span
//                               animate={{ opacity: [1, 0.3, 1] }}
//                               transition={{ duration: 1, repeat: Infinity }}
//                               style={dotStyle}
//                             />
//                             <motion.span
//                               animate={{ opacity: [1, 0.3, 1] }}
//                               transition={{ duration: 1, repeat: Infinity, delay: 0.2 }}
//                               style={dotStyle}
//                             />
//                             <motion.span
//                               animate={{ opacity: [1, 0.3, 1] }}
//                               transition={{ duration: 1, repeat: Infinity, delay: 0.4 }}
//                               style={dotStyle}
//                             />
//                           </Box>
//                         ) : (
//                           <PieChart
//                             series={[{ data: labelsData }]}
//                             width={350}
//                             height={200}
//                             onItemClick={(e: any, d: any) => {
//                               const clickedData = labelsData[d.dataIndex];
//                               if (clickedData.label === "On") {
//                                 IgnitionData(true);
//                               } else if (clickedData.label === "Off") {
//                                 IgnitionData(false);
//                               }
//                             }}
//                           />
//                         )}
//                         <Box sx={{ p: 2, textAlign: "center" }}>
//                           <Typography variant="body2" color="text.secondary">
//                             Engine ON: {engineOnCount} | Engine OFF: {engineOffCount}
//                           </Typography>
//                         </Box>
//                       </Grid>
//                     </Card>
//                   </motion.div>
//                 </Grid>

//                 <Grid xs={12} sm={6} md={4} item>
//                   <motion.div
//                     initial="hidden"
//                     whileHover={{ scale: 1.05 }}
//                     whileTap={{ scale: 0.95 }}
//                   >
//                     <Card
//                       elevation={4}
//                       style={{
//                         marginLeft: "1%",
//                         border: ".5px solid transparent",
//                         borderRadius: "10px",
//                       }}
//                     >
//                       <Grid
//                         style={{
//                           width: "100%",
//                           height: "53vh",
//                           backgroundColor: "#e9f4f7",
//                           overflow: "auto",
//                         }}
//                       >
//                         <Typography
//                           variant="h6"
//                           component="div"
//                           sx={{
//                             padding: "17px",
//                             background: "linear-gradient(to right, #ffffff,rgb(27, 174, 253))",
//                           }}
//                         >
//                           Vehicles Running Status
//                         </Typography>
//                         <div style={{ padding: "5px" }}>
//                           <Typography
//                             variant="h6"
//                             sx={{
//                               color: "green",
//                               cursor: "pointer",
//                               transition: "all 0.3s ease-in-out",
//                               "&:hover": {
//                                 color: "blue",
//                                 transform: "translateY(-3px)",
//                               },
//                             }}
//                             onClick={() => {
//                               runningData("running");
//                             }}
//                           >
//                             Running: {isRunn}
//                           </Typography>
//                           <ProgressBar
//                             completed={Math.round((isRunn / totalVeh || 0) * 100)}
//                             bgColor="green"
//                           />

//                           <Typography
//                             variant="h6"
//                             sx={{
//                               color: "#EF9B0F",
//                               cursor: "pointer",
//                               transition: "all 0.3s ease-in-out",
//                               "&:hover": {
//                                 color: "blue",
//                                 transform: "translateY(-3px)",
//                               },
//                             }}
//                             onClick={() => {
//                               runningData("idle");
//                             }}
//                           >
//                             Idle: {isIdle}{" "}
//                           </Typography>
//                           <ProgressBar
//                             completed={Math.round((isIdle / totalVeh || 0) * 100)}
//                             bgColor="#e3be29"
//                           />

//                           <Typography
//                             variant="h6"
//                             sx={{
//                               color: "#f04848",
//                               cursor: "pointer",
//                               transition: "all 0.3s ease-in-out",
//                               "&:hover": {
//                                 color: "blue",
//                                 transform: "translateY(-3px)",
//                               },
//                             }}
//                             onClick={() => {
//                               runningData("stop");
//                             }}
//                           >
//                             Stop: {isStop}
//                           </Typography>
//                           <ProgressBar
//                             completed={Math.round((isStop / totalVeh || 0) * 100)}
//                             bgColor="#f04848"
//                           />

//                           <Typography
//                             variant="h6"
//                             fontWeight="bold"
//                             fontSize={"16px"}
//                             style={{ color: "blue" }}
//                           >
//                             Total Vehicles:{" "}
//                             <span style={{ color: "#474d54" }}>{totalVeh}</span>
//                           </Typography>

//                           <Typography
//                             variant="h6"
//                             fontWeight="bold"
//                             fontSize={"16px"}
//                             style={{ color: "blue" }}
//                           >
//                             Total Vehicles on Road:{" "}
//                             <span style={{ color: "#474d54" }}>{onRoadVeh}</span>{" "}
//                             out of{" "}
//                             <span style={{ color: "#474d54" }}>{totalVeh}</span>
//                           </Typography>

//                           <Typography
//                             variant="h6"
//                             fontWeight="bold"
//                             fontSize={"16px"}
//                             style={{ color: "blue" }}
//                           >
//                             GPS Installation Status:{" "}
//                             <span style={{ color: "#474d54" }}>{gpsStatus}</span>{" "}
//                             out of{" "}
//                             <span style={{ color: "#474d54" }}>{totalVeh}</span>
//                           </Typography>

//                           <Typography
//                             variant="h6"
//                             fontWeight="bold"
//                             fontSize={"16px"}
//                             style={{ color: "blue" }}
//                           >
//                             Total Distance Today:{" "}
//                             <span style={{ color: "#474d54" }}>
//                               {totalDistance}
//                             </span>{" "}
//                             Km
//                           </Typography>
//                         </div>
//                       </Grid>
//                     </Card>
//                   </motion.div>
//                 </Grid>

//                 {/* Today Vehicle Status Accordion */}
//                 <Grid xs={12} lg={12} sm={12} item >
//                   <Accordion
//                     expanded={accordionExpanded[2]}
//                     onChange={(e, expended) => {
//                       handleAccordionToggle(2, expended);
//                     }}
//                   >
//                     <AccordionSummary
//                       expandIcon={<ArrowDropDownIcon />}
//                       aria-controls="panel2-content"
//                       id="panel2-header"
//                       sx={{
//                         background: "linear-gradient(to right, #ffffff,rgb(27, 174, 253))",
//                       }}
//                     >
//                       <Typography style={{ fontWeight: 600, fontSize: "16px" }}>
//                         Today Vehicle Status
//                       </Typography>
//                     </AccordionSummary>
//                     <AccordionDetails style={{ background: "#f2f8fa" }}>
//                       <Grid
//                         item
//                         xs={12}
//                         container
//                         spacing={2}
//                         sx={{ marginTop: "5px" }}
//                       >
//                         <Grid item xs={12} sm={12} lg={12}>
//                           {isLoading3 ? (
//                             <div
//                               style={{
//                                 display: "flex",
//                                 justifyContent: "center",
//                                 alignItems: "center",
//                               }}
//                             >
//                               <CircularProgress />
//                             </div>
//                           ) : (
//                             <>
//                               {zones3 && zones3.length > 0 ? (
//                                 <DataGrid
//                                   rows={zones3}
//                                   columns={adjustedColumns3}
//                                   rowSpacingType="border"
//                                   autoHeight
//                                   slots={{
//                                     toolbar: GridToolbar,
//                                   }}
//                                   pageSizeOptions={[5, 10, 25, 50, 100].map(
//                                     (size) => ({
//                                       value: size,
//                                       label: `${size}`,
//                                     })
//                                   )}
//                                   initialState={{
//                                     pagination: {
//                                       paginationModel: { pageSize: 5 },
//                                     },
//                                   }}
//                                   slotProps={{
//                                     toolbar: {
//                                       showQuickFilter: true,
//                                     },
//                                   }}
//                                   sx={{
//                                     border: 0,
//                                     "& .MuiDataGrid-columnHeaders": {
//                                       backgroundColor: "#42b6f5", // Header background color
//                                       color: "white", // Header text color
//                                     },
//                                     "& .MuiDataGrid-columnHeaderTitle": {
//                                       color: "white", // Header title text color
//                                     },
//                                     "& .MuiDataGrid-cell": {
//                                       whiteSpace: "normal", // Ensure text wraps inside the cell
//                                       wordWrap: "break-word", // Break words to avoid overflow
//                                       overflowWrap: "break-word", // Ensure long words wrap correctly
//                                     },
//                                   }}
//                                 />
//                               ) : (
//                                 <div>No data found</div>
//                               )}
//                             </>
//                           )}
//                         </Grid>

//                         {currentMap && (
//                           <Grid item xs={12} sm={12} lg={12}>
//                             <div
//                               style={{
//                                 border: "1px solid black",
//                                 boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
//                               }}
//                             >
//                               <GoogleMap
//                                 mapContainerStyle={containerStyle}
//                                 center={center}
//                                 zoom={70} // Default zoom, will be adjusted by `fitBounds`
//                                 onLoad={(map: any) => (mapRef.current = map)}
//                               >
//                                 {vehicles.map((vehicle: any, index: any) => (
//                                   <Marker
//                                     key={vehicle.id}
//                                     position={{
//                                       lat: vehicle.lat,
//                                       lng: vehicle.lng,
//                                     }}
//                                     icon={{
//                                       url: vehicle.icon,
//                                       scaledSize: new window.google.maps.Size(
//                                         50,
//                                         50
//                                       ),
//                                       origin: new window.google.maps.Point(0, 0),
//                                       anchor: new window.google.maps.Point(25, 25),
//                                     }}

//                                     label={{
//                                       text: `${index + 1}`,
//                                       fontSize: "14px",
//                                       fontWeight: "bold",
//                                       color: "#f73905",
//                                       className: 'marker-label'
//                                     }}
//                                     onMouseOver={() =>
//                                       handleMarkerMouseOver(vehicle)
//                                     } // Show vehicle number on hover
//                                     onMouseOut={handleMarkerMouseOut} // Hide info window on hover out
//                                   >
//                                     {activeVehicle &&
//                                       activeVehicle.id === vehicle.id && (
//                                         <InfoWindow>
//                                           <div>
//                                             <div>
//                                               <strong>Speed: </strong>
//                                               {vehicle.speed}
//                                             </div>

//                                             <div>
//                                               <strong>Near By: </strong>
//                                               {vehicle.nearme}
//                                             </div>

//                                             <div>
//                                               <strong>Vehicle No: </strong>
//                                               {vehicle.vehicleNo}
//                                             </div>

//                                             <div>
//                                               <strong>Distance: </strong>
//                                               {vehicle.distance}
//                                             </div>

//                                             <div>
//                                               <strong>Date & Time: </strong>
//                                               {vehicle.tracktime}
//                                             </div>
//                                           </div>
//                                         </InfoWindow>
//                                       )}
//                                   </Marker>
//                                 ))}

//                                 <Polyline
//                                   path={vehicles.map((vehicle: any) => ({ lat: vehicle.lat, lng: vehicle.lng }))}
//                                   options={{
//                                     strokeColor: "#6190c9",
//                                     strokeOpacity: 1,
//                                     strokeWeight: 3,

//                                   }}
//                                 />
//                               </GoogleMap>
//                             </div>
//                           </Grid>
//                         )}
//                       </Grid>
//                     </AccordionDetails>
//                   </Accordion>
//                   <br />
//                 </Grid>

//                 {/* Map Section */}
//                 {currentMap && (
//                   <Grid item xs={12} sm={12} lg={12}>
//                     <div
//                       style={{
//                         border: "1px solid black",
//                         boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
//                         marginBottom: "20px",
//                       }}
//                     >
//                       <GoogleMap
//                         mapContainerStyle={containerStyle}
//                         center={center}
//                         zoom={70}
//                         onLoad={(map: any) => (mapRef.current = map)}
//                       >
//                         {vehicles.map((vehicle: any, index: any) => (
//                           <Marker
//                             key={vehicle.id}
//                             position={{
//                               lat: vehicle.lat,
//                               lng: vehicle.lng,
//                             }}
//                             icon={{
//                               url: vehicle.icon,
//                               scaledSize: new window.google.maps.Size(
//                                 50,
//                                 50
//                               ),
//                               origin: new window.google.maps.Point(0, 0),
//                               anchor: new window.google.maps.Point(25, 25),
//                             }}
//                             label={{
//                               text: `${index + 1}`,
//                               fontSize: "14px",
//                               fontWeight: "bold",
//                               color: "#f73905",
//                               className: 'marker-label'
//                             }}
//                             onMouseOver={() =>
//                               handleMarkerMouseOver(vehicle)
//                             }
//                             onMouseOut={handleMarkerMouseOut}
//                           >
//                             {activeVehicle &&
//                               activeVehicle.id === vehicle.id && (
//                                 <InfoWindow>
//                                   <div>
//                                     <div>
//                                       <strong>Speed: </strong>
//                                       {vehicle.speed}
//                                     </div>
//                                     <div>
//                                       <strong>Near By: </strong>
//                                       {vehicle.nearme}
//                                     </div>
//                                     <div>
//                                       <strong>Vehicle No: </strong>
//                                       {vehicle.vehicleNo}
//                                     </div>
//                                     <div>
//                                       <strong>Distance: </strong>
//                                       {vehicle.distance}
//                                     </div>
//                                     <div>
//                                       <strong>Date & Time: </strong>
//                                       {vehicle.tracktime}
//                                     </div>
//                                   </div>
//                                 </InfoWindow>
//                               )}
//                           </Marker>
//                         ))}
//                         <Polyline
//                           path={vehicles.map((vehicle: any) => ({ lat: vehicle.lat, lng: vehicle.lng }))}
//                           options={{
//                             strokeColor: "#6190c9",
//                             strokeOpacity: 1,
//                             strokeWeight: 3,
//                           }}
//                         />
//                       </GoogleMap>
//                     </div>
//                   </Grid>
//                 )}
//               </Grid>

//               {/* Modal Dialogs for Cards */}
//               {/* Fuel Consumed Modal */}
//               <Dialog
//                 open={fuelConsumedOpen}
//                 onClose={handleFuelConsumedClose}
//                 fullWidth
//                 maxWidth="lg"
//                 sx={{
//                   "& .MuiDialogContent-root": {
//                     padding: "20px",
//                     height: "600px",
//                   },
//                 }}
//               >
//                 <DialogTitle
//                   sx={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     padding: "10px",
//                     backgroundColor: `var(--grid-headerBackground, #42b6f5)`,
//                     color: `var(--grid-headerColor, white)`,
//                   }}
//                 >
//                   <Stack direction="row" spacing={2} alignItems="center">
//                     <LocalGasStation />
//                     <Typography variant="h6">
//                       Fuel Consumed Report
//                     </Typography>
//                   </Stack>
//                   <IconButton
//                     edge="end"
//                     onClick={handleFuelConsumedClose}
//                     sx={{ color: "white" }}
//                   >
//                     <CloseIcon />
//                   </IconButton>
//                 </DialogTitle>
//                 <DialogContent>
//                   <Grid container spacing={2} sx={{ mt: 1 }}>
//                     <Grid item xs={12}>
//                       <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
//                         <FormControlLabel
//                           control={
//                             <Checkbox
//                               checked={getTop}
//                               onChange={(e) => {
//                                 setGetTop(e.target.checked);
//                                 setTimeout(() => { }, 500);
//                               }}
//                             />
//                           }
//                           label="Get Top 10 Records"
//                         />
//                         <Button
//                           startIcon={<PrintIcon />}
//                           variant="contained"
//                           sx={{ bgcolor: "#42b6f5", '&:hover': { bgcolor: "#1976d2" } }}
//                           onClick={downloadExcel}
//                         >
//                           Export to Excel
//                         </Button>
//                       </Stack>
//                     </Grid>
//                     <Grid item xs={12}>
//                       {isLoading1 ? (
//                         <Box display="flex" justifyContent="center" alignItems="center" height={400}>
//                           <CircularProgress />
//                         </Box>
//                       ) : (
//                         <>
//                           {zones1 && zones1.length > 0 ? (
//                             <DataGrid
//                               rows={zones1}
//                               columns={adjustedColumns1}
//                               rowSpacingType="border"
//                               autoHeight
//                               slots={{
//                                 toolbar: GridToolbar,
//                               }}
//                               pageSizeOptions={[5, 10, 25, 50, 100]}
//                               initialState={{
//                                 pagination: {
//                                   paginationModel: { pageSize: 10 },
//                                 },
//                               }}
//                               slotProps={{
//                                 toolbar: {
//                                   showQuickFilter: true,
//                                 },
//                               }}
//                               sx={{
//                                 border: 0,
//                                 "& .MuiDataGrid-columnHeaders": {
//                                   backgroundColor: `var(--grid-headerBackground, #42b6f5)`,
//                                   color: `var(--grid-headerColor, white)`,
//                                 },
//                                 "& .MuiDataGrid-columnHeaderTitle": {
//                                   color: "white",
//                                 },
//                               }}
//                             />
//                           ) : (
//                             <Box display="flex" justifyContent="center" alignItems="center" height={400}>
//                               <Typography>No data found</Typography>
//                             </Box>
//                           )}
//                         </>
//                       )}
//                     </Grid>
//                   </Grid>
//                 </DialogContent>
//               </Dialog>

//               {/* Long Idle Vehicle Modal */}
//               <Dialog
//                 open={longIdleOpen}
//                 onClose={handleLongIdleClose}
//                 fullWidth
//                 maxWidth="lg"
//                 sx={{
//                   "& .MuiDialogContent-root": {
//                     padding: "20px",
//                     height: "600px",
//                   },
//                 }}
//               >
//                 <DialogTitle
//                   sx={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     padding: "10px",
//                     backgroundColor: `var(--grid-headerBackground, #42b6f5)`,
//                     color: `var(--grid-headerColor, white)`,
//                   }}
//                 >
//                   <Stack direction="row" spacing={2} alignItems="center">
//                     <FaClock style={{ fontSize: "24px" }} />
//                     <Typography variant="h6">
//                       Long Idle Vehicles
//                     </Typography>
//                   </Stack>
//                   <IconButton
//                     edge="end"
//                     onClick={handleLongIdleClose}
//                     sx={{ color: "white" }}
//                   >
//                     <CloseIcon />
//                   </IconButton>
//                 </DialogTitle>
//                 <DialogContent>
//                   <Grid container spacing={2} sx={{ mt: 1 }}>
//                     <Grid item xs={12}>
//                       <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
//                         <FormControlLabel
//                           control={
//                             <Checkbox
//                               checked={getTop1}
//                               onChange={(e) => {
//                                 setGetTop1(e.target.checked);
//                               }}
//                             />
//                           }
//                           label="Get Top 10 Records"
//                         />
//                         <Button
//                           startIcon={<PrintIcon />}
//                           variant="contained"
//                           sx={{ bgcolor: "#42b6f5", '&:hover': { bgcolor: "#1976d2" } }}
//                           onClick={downloadExcel1}
//                         >
//                           Export to Excel
//                         </Button>
//                       </Stack>
//                     </Grid>
//                     <Grid item xs={12}>
//                       {isLoading2 ? (
//                         <Box display="flex" justifyContent="center" alignItems="center" height={400}>
//                           <CircularProgress />
//                         </Box>
//                       ) : (
//                         <>
//                           {zones2 && zones2.length > 0 ? (
//                             <DataGrid
//                               rows={zones2}
//                               columns={adjustedColumns2}
//                               rowSpacingType="border"
//                               slots={{
//                                 toolbar: GridToolbar,
//                               }}
//                               pageSizeOptions={[5, 10, 25, 50, 100]}
//                               initialState={{
//                                 pagination: {
//                                   paginationModel: { pageSize: 10 },
//                                 },
//                               }}
//                               slotProps={{
//                                 toolbar: {
//                                   showQuickFilter: true,
//                                 },
//                               }}
//                               autoHeight={false}
//                               sx={{
//                                 border: 0,
//                                 "& .MuiDataGrid-columnHeaders": {
//                                   backgroundColor: `var(--grid-headerBackground, #42b6f5)`,
//                                   color: `var(--grid-headerColor, white)`,
//                                   position: "sticky",
//                                   top: 0,
//                                   zIndex: 1,
//                                 },
//                                 "& .MuiDataGrid-columnHeaderTitle": {
//                                   color: "white",
//                                 },
//                                 "& .MuiDataGrid-cell": {
//                                   whiteSpace: "normal",
//                                   wordWrap: "break-word",
//                                   overflowWrap: "break-word",
//                                 },
//                                 height: 400,
//                               }}
//                             />
//                           ) : (
//                             <Box display="flex" justifyContent="center" alignItems="center" height={400}>
//                               <Typography>No data found</Typography>
//                             </Box>
//                           )}
//                         </>
//                       )}
//                     </Grid>
//                   </Grid>
//                 </DialogContent>
//               </Dialog>

//               {/* Probable Wire Tempering Modal */}
//               <Dialog
//                 open={wireTemperingOpen}
//                 onClose={handleWireTemperingClose}
//                 fullWidth
//                 maxWidth="lg"
//                 sx={{
//                   "& .MuiDialogContent-root": {
//                     padding: "20px",
//                     height: "600px",
//                   },
//                 }}
//               >
//                 <DialogTitle
//                   sx={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     padding: "10px",
//                     backgroundColor: `var(--grid-headerBackground, #42b6f5)`,
//                     color: `var(--grid-headerColor, white)`,
//                   }}
//                 >
//                   <Stack direction="row" spacing={2} alignItems="center">
//                     <ReportProblem />
//                     <Typography variant="h6">
//                       Probable Wire Tempering Alerts
//                     </Typography>
//                   </Stack>
//                   <IconButton
//                     edge="end"
//                     onClick={handleWireTemperingClose}
//                     sx={{ color: "white" }}
//                   >
//                     <CloseIcon />
//                   </IconButton>
//                 </DialogTitle>
//                 <DialogContent>
//                   <Grid container spacing={2} sx={{ mt: 1 }}>
//                     <Grid item xs={12}>
//                       {isLoading ? (
//                         <Box display="flex" justifyContent="center" alignItems="center" height={400}>
//                           <CircularProgress />
//                         </Box>
//                       ) : (
//                         <>
//                           {zones && zones.length > 0 ? (
//                             <DataGrid
//                               rows={zones}
//                               columns={adjustedColumns}
//                               rowSpacingType="border"
//                               autoHeight
//                               slots={{
//                                 toolbar: GridToolbar,
//                               }}
//                               pageSizeOptions={[5, 10, 25, 50, 100]}
//                               initialState={{
//                                 pagination: {
//                                   paginationModel: { pageSize: 10 },
//                                 },
//                               }}
//                               slotProps={{
//                                 toolbar: {
//                                   showQuickFilter: true,
//                                 },
//                               }}
//                               sx={{
//                                 border: 0,
//                                 "& .MuiDataGrid-columnHeaders": {
//                                   backgroundColor: `var(--grid-headerBackground, #42b6f5)`,
//                                   color: `var(--grid-headerColor, white)`,
//                                 },
//                                 "& .MuiDataGrid-columnHeaderTitle": {
//                                   color: "white",
//                                 },
//                               }}
//                             />
//                           ) : (
//                             <Box display="flex" justifyContent="center" alignItems="center" height={400}>
//                               <Typography>No data found</Typography>
//                             </Box>
//                           )}
//                         </>
//                       )}
//                     </Grid>
//                   </Grid>
//                 </DialogContent>
//               </Dialog>

//               {/* Existing Modals (Keep them as they are) */}
//               <Grid xs={12} lg={12} sm={12} item>
//                 <Dialog
//                   open={isModal}
//                   onClose={handleClose}
//                   fullWidth
//                   maxWidth="lg"
//                   sx={{
//                     "& .MuiDialogContent-root": {
//                       padding: "20px",
//                       height: "400px",
//                     },
//                   }}
//                 >
//                   <DialogTitle
//                     sx={{
//                       display: "flex",
//                       justifyContent: "space-between",
//                       padding: "10px",
//                       backgroundColor: `var(--grid-headerBackground, #42b6f5)`,
//                       color: `var(--grid-headerColor, white)`,
//                     }}
//                   >
//                     <Typography variant="h6" style={{ color: "#ffff" }}>
//                       Vehicle Status :{" "}
//                       <span style={{ color: "#474d54", fontWeight: "bold" }}>
//                         {isStatus1}
//                       </span>
//                     </Typography>
//                     <IconButton
//                       edge="end"
//                       onClick={handleClose}
//                       sx={{
//                         color: `var(--grid-headerColor, white)`,
//                       }}
//                     >
//                       <CloseIcon />
//                     </IconButton>
//                   </DialogTitle>
//                   <DialogContent>
//                     <Grid
//                       item
//                       xs={12}
//                       container
//                       spacing={2}
//                       sx={{
//                         padding: "20px",
//                         height: "400px",
//                         overflow: "hidden",
//                       }}
//                     >
//                       <Grid item sm={12} lg={12} xs={12}>
//                         {isLoading4 ? (
//                           <div
//                             style={{
//                               display: "flex",
//                               justifyContent: "center",
//                               alignItems: "center",
//                             }}
//                           >
//                             <CircularProgress />
//                           </div>
//                         ) : (
//                           <>
//                             {zones4 && zones4.length > 0 ? (
//                               <DataGrid
//                                 rows={zones4}
//                                 columns={adjustedColumns4}
//                                 rowSpacingType="border"
//                                 slots={{
//                                   toolbar: GridToolbar,
//                                 }}
//                                 slotProps={{
//                                   toolbar: {
//                                     showQuickFilter: true,
//                                   },
//                                 }}
//                                 autoHeight={false}
//                                 sx={{
//                                   border: 0,
//                                   "& .MuiDataGrid-columnHeaders": {
//                                     backgroundColor: `var(--grid-headerBackground, #42b6f5)`,
//                                     color: `var(--grid-headerColor, white)`,
//                                     position: "sticky",
//                                     top: 0,
//                                     zIndex: 1,
//                                   },
//                                   "& .MuiDataGrid-columnHeaderTitle": {
//                                     color: "white",
//                                   },
//                                   "& .MuiDataGrid-cell": {
//                                     whiteSpace: "normal",
//                                     wordWrap: "break-word",
//                                     overflowWrap: "break-word",
//                                   },
//                                   height: 400,
//                                   overflowY: "auto",
//                                 }}
//                               />
//                             ) : (
//                               <div>No data found</div>
//                             )}
//                           </>
//                         )}
//                       </Grid>
//                     </Grid>
//                   </DialogContent>
//                 </Dialog>
//               </Grid>

//               <Grid xs={12} lg={12} sm={12} item>
//                 <Dialog
//                   open={isModal1}
//                   onClose={handleClose1}
//                   fullWidth
//                   maxWidth="lg"
//                   sx={{
//                     "& .MuiDialogContent-root": {
//                       padding: "20px",
//                       height: "400px",
//                     },
//                   }}
//                 >
//                   <DialogTitle
//                     sx={{
//                       display: "flex",
//                       justifyContent: "space-between",
//                       padding: "10px",
//                       backgroundColor: `var(--grid-headerBackground, #42b6f5)`,
//                       color: `var(--grid-headerColor, white)`,
//                     }}
//                   >
//                     <Typography variant="h6" style={{ color: "#ffff" }}>
//                       Vehicle Ignition :{" "}
//                       <span style={{ color: "#474d54", fontWeight: "bold" }}>
//                         {isStatus}
//                       </span>
//                     </Typography>
//                     <IconButton
//                       edge="end"
//                       onClick={handleClose1}
//                       sx={{
//                         color: `var(--grid-headerColor, white)`,
//                       }}
//                     >
//                       <CloseIcon />
//                     </IconButton>
//                   </DialogTitle>
//                   <DialogContent>
//                     <Grid
//                       item
//                       xs={12}
//                       container
//                       spacing={2}
//                       sx={{
//                         padding: "20px",
//                         height: "400px",
//                         overflow: "hidden",
//                       }}
//                     >
//                       <Grid item sm={12} lg={12} xs={12}>
//                         {isLoading5 ? (
//                           <div
//                             style={{
//                               display: "flex",
//                               justifyContent: "center",
//                               alignItems: "center",
//                             }}
//                           >
//                             <CircularProgress />
//                           </div>
//                         ) : (
//                           <>
//                             {zones5 && zones5.length > 0 ? (
//                               <DataGrid
//                                 rows={zones5}
//                                 columns={adjustedColumns5}
//                                 rowSpacingType="border"
//                                 slots={{
//                                   toolbar: GridToolbar,
//                                 }}
//                                 slotProps={{
//                                   toolbar: {
//                                     showQuickFilter: true,
//                                   },
//                                 }}
//                                 autoHeight={false}
//                                 sx={{
//                                   border: 0,
//                                   "& .MuiDataGrid-columnHeaders": {
//                                     backgroundColor: `var(--grid-headerBackground, #42b6f5)`,
//                                     color: `var(--grid-headerColor, white)`,
//                                     position: "sticky",
//                                     top: 0,
//                                     zIndex: 1,
//                                   },
//                                   "& .MuiDataGrid-columnHeaderTitle": {
//                                     color: "white",
//                                   },
//                                   "& .MuiDataGrid-cell": {
//                                     whiteSpace: "normal",
//                                     wordWrap: "break-word",
//                                     overflowWrap: "break-word",
//                                   },
//                                   height: 400,
//                                   overflowY: "auto",
//                                 }} />
//                             ) : (
//                               <div>No data found</div>
//                             )}
//                           </>
//                         )}
//                       </Grid>
//                     </Grid>
//                   </DialogContent>
//                 </Dialog>
//               </Grid>

//               <Grid xs={12} lg={12} sm={12} item>
//                 <Dialog
//                   open={isVisible}
//                   onClose={handleClose2}
//                   fullWidth
//                   maxWidth="lg"
//                   sx={{
//                     "& .MuiDialogContent-root": {
//                       padding: "20px",
//                       height: "400px",
//                     },
//                   }}
//                 >
//                   <DialogTitle
//                     sx={{
//                       display: "flex",
//                       justifyContent: "space-between",
//                       padding: "10px",
//                       backgroundColor: `var(--grid-headerBackground, #42b6f5)`,
//                       color: `var(--grid-headerColor, white)`,
//                     }}
//                   >
//                     <Typography variant="h6" style={{ color: "#ffff" }}>
//                       <span style={{ color: "#474d54", fontWeight: "bold" }}>
//                         {isLabel}
//                       </span>
//                     </Typography>
//                     <IconButton
//                       edge="end"
//                       onClick={handleClose2}
//                       sx={{
//                         color: `var(--grid-headerColor, white)`,
//                       }}
//                     >
//                       <CloseIcon />
//                     </IconButton>
//                   </DialogTitle>
//                   <DialogContent>
//                     <Grid
//                       item
//                       xs={12}
//                       container
//                       spacing={2}
//                       sx={{
//                         padding: "20px",
//                         height: "400px",
//                         overflow: "hidden",
//                       }}
//                     >
//                       <Grid item sm={12} lg={12} xs={12}>
//                         {isLoading9 ? (
//                           <div
//                             style={{
//                               display: "flex",
//                               justifyContent: "center",
//                               alignItems: "center",
//                             }}
//                           >
//                             <CircularProgress />
//                           </div>
//                         ) : (
//                           <>
//                             {zones9 && zones9.length > 0 ? (
//                               <DataGrid
//                                 rows={zones9}
//                                 columns={adjustedColumns10}
//                                 rowSpacingType="border"
//                                 slots={{
//                                   toolbar: GridToolbar,
//                                 }}
//                                 slotProps={{
//                                   toolbar: {
//                                     showQuickFilter: true,
//                                   },
//                                 }}
//                                 autoHeight={false}
//                                 sx={{
//                                   border: 0,
//                                   "& .MuiDataGrid-columnHeaders": {
//                                     backgroundColor: `var(--grid-headerBackground, #42b6f5)`,
//                                     color: `var(--grid-headerColor, white)`,
//                                     position: "sticky",
//                                     top: 0,
//                                     zIndex: 1,
//                                   },
//                                   "& .MuiDataGrid-columnHeaderTitle": {
//                                     color: "white",
//                                   },
//                                   "& .MuiDataGrid-cell": {
//                                     whiteSpace: "normal",
//                                     wordWrap: "break-word",
//                                     overflowWrap: "break-word",
//                                   },
//                                   height: 400,
//                                   overflowY: "auto",
//                                 }}
//                               />
//                             ) : (
//                               <div>No data found</div>
//                             )}
//                           </>
//                         )}
//                       </Grid>
//                     </Grid>
//                   </DialogContent>
//                 </Dialog>
//               </Grid>
//             </div>
//           )}

//           {value === 1 && <Tracking />}
//           {value === 2 && <Geofacing />}
//           {value === 3 && <Kudaghar />}
//           {value === 4 && <VehicleHistory />}
//           {value === 5 && <VehicleTravelled />}
//         </CardContent>
//       </div>
//     </div>
//   );
// }






















// // import {
// //   JSXElementConstructor,
// //   Key,
// //   ReactElement,
// //   ReactNode,
// //   ReactPortal,
// //   useEffect,
// //   useRef,
// //   useState,
// // } from "react";
// // import {
// //   Card,
// //   Grid,
// //   CardContent,
// //   Typography,
// //   Divider,
// //   Button,
// //   FormControlLabel,
// //   Checkbox,
// //   Tab,
// //   Tabs,
// //   Dialog,
// //   DialogTitle,
// //   DialogContent,
// //   IconButton,
// //   Box,
// //   Paper,
// //   Chip,
// //   Avatar,
// //   Stack,
// // } from "@mui/material";

// // import "./style.css";

// // import { DataGrid, GridColDef, GridToolbar } from "@mui/x-data-grid";

// // // import { TableContainer, Table, TableHead, TableBody, TableRow, TableCell } from '@material-ui/core';

// // import { PieChart } from "@mui/x-charts/PieChart";
// // import api, { Node } from "../../utils/Url";
// // //import { IconButton, Progress, Table } from "rsuite";
// // import Accordion from "@mui/material/Accordion";
// // import AccordionSummary from "@mui/material/AccordionSummary";
// // import AccordionDetails from "@mui/material/AccordionDetails";
// // import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
// // import { useTranslation } from "react-i18next";
// // import PrintIcon from "@mui/icons-material/Print";
// // import {
// //   GoogleMap,
// //   InfoWindow,
// //   LoadScript,
// //   Marker,
// //   Polyline,
// // } from "@react-google-maps/api";
// // import Tracking from "./Tracking";
// // import Geofacing from "./Geofacing";
// // import Kudaghar from "./Kudaghar";
// // import VehicleHistory from "./VehicleHistory";
// // import VehicleTravelled from "./VehicleTravelled";
// // import ProgressBar from "@ramonak/react-progress-bar";

// // import DashboardIcon from "@mui/icons-material/Dashboard";
// // import GpsFixedIcon from "@mui/icons-material/GpsFixed";
// // import PlaceIcon from "@mui/icons-material/Place";
// // import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
// // import CarCrashIcon from "@mui/icons-material/CarCrash";
// // import EmojiTransportationIcon from "@mui/icons-material/EmojiTransportation";
// // import { motion, useSpring } from "framer-motion";
// // import CircularProgress from "@mui/material/CircularProgress";
// // import CloseIcon from "@mui/icons-material/Close";
// // import { table } from "console";
// // import ReactModal from "react-modal";
// // import * as XLSX from "xlsx";
// // import Modal from "react-animated-modal";
// // import { animated } from "react-spring";
// // import {
// //   FaCar,
// //   FaUser,
// //   FaBuilding,
// //   FaCog,
// //   FaCircle,
// //   FaTachometerAlt,
// //   FaGasPump,
// //   FaSortNumericDown,
// //   FaCheckCircle,
// //   FaHistory,
// //   FaIdCard,
// //   FaExclamationTriangle,
// //   FaClock,
// //   FaChartLine,
// // } from "react-icons/fa";

// // import {
// //   ListAlt,
// //   DirectionsCar,
// //   Work,
// //   DirectionsBike,
// //   CheckCircle,
// //   LocalGasStation,
// //   Timeline,
// //   ElectricBolt,
// //   ReportProblem,
// // } from "@mui/icons-material";
// // import PersonIcon from "@mui/icons-material/Person";
// // import decryptData from "../../utils/crypto";
// // import VehicleComponent from "../../utils/VehicleComponent";
// // import "./style.css"

// // const style = {
// //   position: "absolute" as "absolute",
// //   top: "50%",
// //   left: "50%",
// //   transform: "translate(-50%, -50%)",
// //   width: "95%",
// //   height: "85%",
// //   bgcolor: "#f5f5f5",
// //   border: "1px solid #000",
// //   boxShadow: 24,
// //   p: 4,
// //   borderRadius: 10,
// // };
// // const dotStyle = {
// //   width: 12,
// //   height: 12,
// //   borderRadius: "50%",
// //   backgroundColor: "#1976D2",
// //   margin: "0 5px",
// //   display: "inline-block",
// // };

// // const containerStyle = {
// //   width: "100%",
// //   height: "500px",
// // };

// // interface Department {
// //   dept_id: number;
// //   dept_name: string;
// //   session_year: string;
// //   // Add other properties here
// // }

// // export default function HomePage() {
// //   const [chartData, setChartData] = useState<any>([]);

// //   const [labelsData, setlabelsData] = useState<any>([]);
// //   console.log("labelsData", labelsData);

// //   const { t } = useTranslation();

// //   const [zones, setZones] = useState([]);
// //   const [columns, setColumns] = useState<any>([]);
// //   const [isLoading, setIsLoading] = useState(true);

// //   const [currentMap, setCurrentMap] = useState(false);

// //   const [isVisible, setVisible] = useState(false);

// //   const [zones1, setZones1] = useState([]);
// //   const [columns1, setColumns1] = useState<any>([]);
// //   const [isLoading1, setIsLoading1] = useState(true);
// //   const [isChartLoading, setChartIsLoading] = useState(true);

// //   const [zones2, setZones2] = useState([]);
// //   const [columns2, setColumns2] = useState<any>([]);
// //   const [isLoading2, setIsLoading2] = useState(true);

// //   const [zones3, setZones3] = useState([]);
// //   const [columns3, setColumns3] = useState<any>([]);
// //   const [isLoading3, setIsLoading3] = useState(true);

// //   const [zones4, setZones4] = useState([]);
// //   const [columns4, setColumns4] = useState<any>([]);
// //   const [isLoading4, setIsLoading4] = useState(true);

// //   const [isLoading6, setIsLoading6] = useState(true);

// //   const [zones5, setZones5] = useState([]);
// //   const [columns5, setColumns5] = useState<any>([]);
// //   const [isLoading5, setIsLoading5] = useState(true);

// //   const [zones9, setZones9] = useState([]);
// //   const [columns9, setColumns9] = useState<any>([]);
// //   const [isLoading9, setIsLoading9] = useState(true);

// //   const [getTop, setGetTop] = useState(false);

// //   const [getTop1, setGetTop1] = useState(false);

// //   const [isRunn, setRunn] = useState<any>(0);

// //   const [isIdle, setIdle] = useState<any>(0);
// //   const [isStop, setStop] = useState<any>(0);
// //   const [totalVeh, setTotalVeh] = useState<any>(0);
// //   const [onRoadVeh, setOnRoadVeh] = useState<any>(0);
// //   const [gpsStatus, setGpsStatus] = useState<any>(0);
// //   const [totalDistance, setTotalDistance] = useState<any>(0);
// //   const [isModal, setModal] = useState<any>(false);

// //   const [isModal1, setModal1] = useState<any>(false);

// //   const [vehicleDrawer, setVehicleDrawer] = useState(false);

// //   const [itemId, setItemId] = useState<any>();

// //   // New states for card modals
// //   const [fuelConsumedOpen, setFuelConsumedOpen] = useState(false);
// //   const [longIdleOpen, setLongIdleOpen] = useState(false);
// //   const [wireTemperingOpen, setWireTemperingOpen] = useState(false);
// //   const [fuelConsumedCount, setFuelConsumedCount] = useState(0);
// //   const [longIdleCount, setLongIdleCount] = useState(0);
// //   const [wireTemperingCount, setWireTemperingCount] = useState(0);

// //   const [accordionExpanded, setAccordionExpanded] = useState<any>({});
// //   const handleAccordionToggle = (index: any, isExpanded: any) => {
// //     setAccordionExpanded((prev: any) => ({
// //       ...prev,
// //       [index]: !prev[index],
// //     }));

// //     if (isExpanded) {
// //       if (index === 0) {
// //         FuelconsData();
// //       } else if (index === 1) {
// //         IdleData();
// //       } else if (index === 2) {
// //         TodayVData();
// //       } else if (index === 3) {
// //         fetchZonesData();
// //       }
// //     } else {
// //       console.log("function is not working");
// //     }
// //   };

// //   const [value, setValue] = useState<any>(
// //     parseInt(localStorage.getItem("dash") || "0", 10)
// //   );

// //   useEffect(() => {
// //     localStorage.setItem("dash", value.toString() || "0");
// //   }, [value]);

// //   const [isTable, setTable] = useState([]);
// //   const [isPrint, setPrint] = useState([]);
// //   const [isPrint1, setPrint1] = useState([]);

// //   const [isLabel, setlabel] = useState("");
// //   const [isStatus, setStatus] = useState("");
// //   const [isStatus1, setStatus1] = useState("");

// //   const downloadExcel = () => {
// //     if (!isPrint || isPrint.length === 0) {
// //       console.error("No data to export to Excel.");
// //       return;
// //     }

// //     const ws = XLSX.utils.json_to_sheet(isPrint);

// //     const headers = Object.keys(isPrint[0]);

// //     headers.forEach((header, index) => {
// //       const cellAddress = `${String.fromCharCode(65 + index)}1`;
// //     });

// //     const wb = XLSX.utils.book_new();
// //     XLSX.utils.book_append_sheet(wb, ws, "vehicles");

// //     XLSX.writeFile(wb, "FuelConsumed.xlsx");
// //   };

// //   const downloadExcel1 = () => {
// //     if (!isPrint1 || isPrint1.length === 0) {
// //       console.error("No data to export to Excel.");
// //       return;
// //     }

// //     const ws = XLSX.utils.json_to_sheet(isPrint1);

// //     const headers = Object.keys(isPrint1[0]);

// //     headers.forEach((header, index) => {
// //       const cellAddress = `${String.fromCharCode(65 + index)}1`;
// //     });

// //     const wb = XLSX.utils.book_new();
// //     XLSX.utils.book_append_sheet(wb, ws, "vehicles");

// //     XLSX.writeFile(wb, "Long_Idle.xlsx");
// //   };

// //   const handleTab = (event: any, newValue: any) => {
// //     console.log(newValue);
// //     setValue(newValue);
// //   };

// //   const items = [
// //     { id: 0, text: <strong>{t("text.Dashboard")}</strong>, icon: <DashboardIcon /> },
// //     { id: 1, text: <strong>{t("text.Tracking")}</strong>, icon: <GpsFixedIcon /> },
// //     { id: 2, text: <strong>{t("text.GeofacingCreate")}</strong>, icon: <PlaceIcon /> },
// //     { id: 3, text: <strong>{t("text.KudagharLocation")}</strong>, icon: <DeleteForeverIcon /> },
// //     { id: 4, text: <strong>{t("text.VehicleHistory")}</strong>, icon: <CarCrashIcon /> },
// //     { id: 5, text: <strong>{t("text.VehicleTravelled")}</strong>, icon: <EmojiTransportationIcon /> },
// //   ];

// //   const formatTrackTime = (tracktime: string) => {
// //     const trackTime = new Date(tracktime);

// //     // Check if the date is valid
// //     if (isNaN(trackTime.getTime())) {
// //       return "Invalid Date"; // Return a fallback message or handle it as needed
// //     }

// //     const day = trackTime.getDate().toString().padStart(2, "0");
// //     const month = (trackTime.getMonth() + 1).toString().padStart(2, "0");
// //     const year = trackTime.getFullYear();
// //     const hours = trackTime.getHours().toString().padStart(2, "0");
// //     const minutes = trackTime.getMinutes().toString().padStart(2, "0");
// //     const seconds = trackTime.getSeconds().toString().padStart(2, "0");

// //     return `${day}-${month}-${year} (Time:- ${hours}:${minutes}:${seconds})`;
// //   };

// //   const [vehicles, setVehicles] = useState<any>([]);
// //   const [activeVehicle, setActiveVehicle] = useState<any>(null);
// //   const [center, setCenter] = useState({ lat: 26.447965, lng: 80.3432 });
// //   const mapRef: any = useRef(null);

// //   useEffect(() => {
// //     if (window.google && window.google.maps) {
// //       console.log("Google Maps API loaded");
// //     } else {
// //       console.error("Google Maps API not loaded");
// //     }
// //   }, []);

// //   // Fetch the vehicle data from API
// //   const getCurrentData = (row: any) => {
// //     const collectData = {
// //       where: "VehicleNo=(@0)",
// //       orderby: "",
// //       pageNo: 0,
// //       pageSize: 0,
// //       intnotnullvalue1: 0,
// //       userId: "string",
// //       parameterValues: [row.vehicleNo],
// //       str1: "",
// //       str2: "",
// //       str3: "",
// //       str4: "",
// //       str5: "",
// //       intvalue1: 0,
// //       intvalue2: 0,
// //       intvalue3: 0,
// //       intvalue4: 0,
// //       intnotnullvalue2: 0,
// //       intnotnullvalue3: 0,
// //       date1: new Date().toISOString(),
// //       date2: new Date().toISOString(),
// //       date3: new Date().toISOString(),
// //       date4: new Date().toISOString(),
// //       dec1: 0,
// //       dec2: 0,
// //       dec3: 0,
// //       dec4: 0,
// //       flag: true,
// //       data: "string",
// //       success: true,
// //       error: "string",
// //       selectPerindex: 0,
// //       show: true,
// //     };

// //     api.post(`Dashboard/GetVehileCurrentDay`, collectData).then((res) => {
// //       const arr = res?.data?.data?.map((item: any) => ({
// //         lat: item.lattitude,
// //         lng: item.longitude,
// //         id: item.id,
// //         speed: item.speed,
// //         tracktime: formatTrackTime(item.trackTime),
// //         distance: item.distance,
// //         nearme: item?.nearme,
// //         vehicleNo: item?.vehicleNo,
// //         icon:
// //           item.speed === 0
// //             ? "https://png.pngtree.com/png-vector/20240128/ourmid/pngtree-red-truck-transportation-png-image_11507611.png"
// //             : "https://png.pngtree.com/png-vector/20240128/ourmid/pngtree-green-truck-transport-png-image_11508688.png",
// //       }));
// //       setVehicles(arr);
// //       setCenter(calculateCenter(arr));
// //       setCurrentMap(true);
// //       if (arr.length > 0) {
// //         adjustZoomLevel(arr);
// //       }
// //     });
// //   };

// //   const calculateCenter = (vehicles: any) => {
// //     if (vehicles.length === 0) {
// //       return { lat: 26.447965, lng: 80.3432 }; // Default center if no vehicles
// //     }

// //     const latitudes = vehicles.map((vehicle: any) => vehicle.lat);
// //     const longitudes = vehicles.map((vehicle: any) => vehicle.lng);

// //     const avgLat =
// //       latitudes.reduce((sum: any, lat: any) => sum + lat, 0) / latitudes.length;
// //     const avgLng =
// //       longitudes.reduce((sum: any, lng: any) => sum + lng, 0) /
// //       longitudes.length;

// //     return { lat: avgLat, lng: avgLng }; // Return the center point
// //   };

// //   // Adjust the zoom level based on the spread of the vehicles
// //   const adjustZoomLevel = (vehicles: any) => {
// //     const bounds = new window.google.maps.LatLngBounds();

// //     vehicles.forEach((vehicle: any) => {
// //       bounds.extend(new window.google.maps.LatLng(vehicle.lat, vehicle.lng));
// //     });

// //     if (mapRef.current) {
// //       mapRef.current.fitBounds(bounds); // Fit the map to the bounds of all vehicles
// //     }
// //   };

// //   const handleMarkerMouseOver = (vehicle: any) => {
// //     setActiveVehicle(vehicle);
// //   };

// //   const handleMarkerMouseOut = () => {
// //     setActiveVehicle(null);
// //   };

// //   useEffect(() => {
// //     getZoneData();

// //     const interval = setInterval(() => {
// //       getZoneData();
// //     }, 30000);

// //     return () => clearInterval(interval);
// //   }, []);

// //   const handleClose = () => {
// //     setModal(false);
// //   };

// //   const handleClose1 = () => {
// //     setModal1(false);
// //   };

// //   const handleClose2 = () => {
// //     setVisible(false);
// //   };

// //   // Modal handlers for new cards
// //   const handleFuelConsumedOpen = () => {
// //     setFuelConsumedOpen(true);
// //     FuelconsData();
// //   };

// //   const handleFuelConsumedClose = () => {
// //     setFuelConsumedOpen(false);
// //   };

// //   const handleLongIdleOpen = () => {
// //     setLongIdleOpen(true);
// //     IdleData();
// //   };

// //   const handleLongIdleClose = () => {
// //     setLongIdleOpen(false);
// //   };

// //   const handleWireTemperingOpen = () => {
// //     setWireTemperingOpen(true);
// //     fetchZonesData();
// //   };

// //   const handleWireTemperingClose = () => {
// //     setWireTemperingOpen(false);
// //   };

// //   const zoneModal = async (Zone: any) => {
// //     setlabel(Zone.label);
// //     try {
// //       const response = await api.get(`NTRead/GetTopFuelConsNTS/zone=${Zone.label}`);
// //       const data = response.data.data;

// //       const zonesWithIds = data.map((zone: any, index: any) => ({
// //         ...zone,
// //         serialNo: index + 1,
// //         id: index + 1,
// //       }));
// //       setZones9(zonesWithIds);
// //       setIsLoading9(false);

// //       if (data.length > 0) {
// //         const columns9: GridColDef[] = [
// //           {
// //             field: "serialNo",
// //             headerName: t("text.SrNo"),
// //             flex: 0.5,
// //             cellClassName: "wrap-text",
// //           },
// //           {
// //             field: "vehicleNo",
// //             headerName: t("text.VehicleNo"),
// //             flex: 1,
// //             cellClassName: "wrap-text",
// //           },
// //           {
// //             field: "driver",
// //             renderHeader: () => (
// //               <>
// //                 <PersonIcon
// //                   style={{ marginRight: 8, verticalAlign: "middle" }}
// //                 />
// //                 <span style={{ verticalAlign: "middle" }}>
// //                   {t("text.Driver")}
// //                 </span>
// //               </>
// //             ),
// //             flex: 1.5,
// //             renderCell: (params) => {
// //               const { empName, empMobileNo } = params.row;
// //               return `${empName} (${empMobileNo})`;
// //             },
// //           },
// //           {
// //             field: "departmentName",
// //             headerName: t("text.DepartmentName"),
// //             flex: 1,
// //             cellClassName: "wrap-text",
// //           },
// //           {
// //             field: "vehicleTypename",
// //             headerName: t("text.VehicleTypeName"),
// //             flex: 1,
// //             cellClassName: "wrap-text",
// //           },
// //           {
// //             field: "flag",
// //             headerName: t("text.Status"),
// //             flex: 1,
// //             cellClassName: "wrap-text",
// //             align: "center",
// //             headerAlign: "center",
// //           },
// //           {
// //             field: "speed",
// //             headerName: t("text.Speed"),
// //             flex: 0.5,
// //             cellClassName: "wrap-text",
// //           },
// //           {
// //             field: "fuel",
// //             headerName: "Fuel",
// //             flex: 1,
// //             align: "center",
// //             headerAlign: "center",
// //             valueFormatter: ({ value }) => (value ? value.toFixed(2) : ""),
// //             cellClassName: "wrap-text",
// //           },
// //         ];
// //         setColumns9(columns9 as any);
// //       }
// //     } catch (error) {
// //       console.error("Error fetching data:", error);
// //     }
// //   };

// //   const adjustedColumns10 = columns9.map((column: any) => ({
// //     ...column,
// //   }));

// //   const IgnitionData = async (value: boolean) => {
// //     setModal1(true);
// //     try {
// //       console.log("Check value", value);
// //       value === true ? setStatus("On") : setStatus("Off");
// //       const response = await api.get(
// //         `NTRead/GetTopFuelConsNTOnOff/onoff=${value}`
// //       );
// //       const data = response.data.data;

// //       const zonesWithIds = data.map((zone: any, index: any) => ({
// //         ...zone,
// //         serialNo: index + 1,
// //         id: index + 1,
// //       }));
// //       setZones5(zonesWithIds);
// //       setIsLoading5(false);

// //       if (data.length > 0) {
// //         const columns2: GridColDef[] = [
// //           {
// //             field: "serialNo",
// //             renderHeader: () => (
// //               <>
// //                 <ListAlt style={{ marginRight: 8, verticalAlign: "middle" }} />
// //                 <span style={{ verticalAlign: "middle" }}>
// //                   {t("text.SrNo")}
// //                 </span>
// //               </>
// //             ),
// //             cellClassName: "wrap-text",
// //             flex: 0.3,
// //           },
// //           {
// //             field: "vehicleNo",
// //             renderHeader: () => (
// //               <>
// //                 <DirectionsCar
// //                   style={{ marginRight: 8, verticalAlign: "middle" }}
// //                 />
// //                 <span style={{ verticalAlign: "middle" }}>
// //                   {t("text.VehicleNo")}
// //                 </span>
// //               </>
// //             ),
// //             cellClassName: "wrap-text",
// //             flex: 1,
// //           },
// //           {
// //             field: "vehicleTypename",
// //             renderHeader: () => (
// //               <>
// //                 <DirectionsBike
// //                   style={{ marginRight: 8, verticalAlign: "middle" }}
// //                 />
// //                 <span style={{ verticalAlign: "middle" }}>
// //                   {t("text.VehicleTypeName")}
// //                 </span>
// //               </>
// //             ),
// //             cellClassName: "wrap-text",
// //             flex: 1.5,
// //           },
// //           {
// //             field: "driver",
// //             cellClassName: "wrap-text",
// //             renderHeader: () => (
// //               <>
// //                 <PersonIcon
// //                   style={{ marginRight: 8, verticalAlign: "middle" }}
// //                 />
// //                 <span style={{ verticalAlign: "middle" }}>
// //                   {t("text.Driver")}
// //                 </span>
// //               </>
// //             ),
// //             flex: 1.5,
// //             renderCell: (params) => {
// //               const { empName, empMobileNo } = params.row;
// //               return `${empName} (${empMobileNo})`;
// //             },
// //           },
// //           {
// //             field: "flag",
// //             renderHeader: () => (
// //               <>
// //                 <CheckCircle
// //                   style={{ marginRight: 8, verticalAlign: "middle" }}
// //                 />
// //                 <span style={{ verticalAlign: "middle" }}>
// //                   {t("text.Status")}
// //                 </span>
// //               </>
// //             ),
// //             cellClassName: "wrap-text",
// //             flex: 0.5,
// //           },
// //         ];
// //         setColumns5(columns2 as any);
// //       }
// //     } catch (error) {
// //       console.error("Error fetching data:", error);
// //     }
// //   };

// //   const adjustedColumns5 = columns5.map((column: any) => ({
// //     ...column,
// //   }));

// //   const runningData = async (value: any) => {
// //     setStatus1(value);
// //     setModal(true);
// //     try {
// //       const response = await api.get(`NTRead/GetRunningStatus/stat=${value}`);
// //       const data = response.data.data;

// //       const zonesWithIds = data.map((zone: any, index: any) => ({
// //         ...zone,
// //         serialNo: index + 1,
// //         id: index + 1,
// //       }));
// //       setZones4(zonesWithIds);
// //       setIsLoading4(false);

// //       if (data.length > 0) {
// //         const columns2: GridColDef[] = [
// //           {
// //             field: "serialNo",
// //             renderHeader: () => (
// //               <>
// //                 <ListAlt style={{ marginRight: 8, verticalAlign: "middle" }} />
// //                 <span style={{ verticalAlign: "middle" }}>
// //                   {t("text.SrNo")}
// //                 </span>
// //               </>
// //             ),
// //             flex: 0.5,
// //           },
// //           {
// //             field: "vehicleNo",
// //             renderHeader: () => (
// //               <>
// //                 <DirectionsCar
// //                   style={{ marginRight: 8, verticalAlign: "middle" }}
// //                 />
// //                 <span style={{ verticalAlign: "middle" }}>
// //                   {t("text.VehicleNo")}
// //                 </span>
// //               </>
// //             ),
// //             flex: 1,
// //           },
// //           {
// //             field: "driver",
// //             renderHeader: () => (
// //               <>
// //                 <PersonIcon
// //                   style={{ marginRight: 8, verticalAlign: "middle" }}
// //                 />
// //                 <span style={{ verticalAlign: "middle" }}>
// //                   {t("text.Driver")}
// //                 </span>
// //               </>
// //             ),
// //             flex: 1.5,
// //             renderCell: (params) => {
// //               const { empName, empMobileNo } = params.row;
// //               return `${empName} (${empMobileNo})`;
// //             },
// //           },
// //           {
// //             field: "departmentName",
// //             renderHeader: () => (
// //               <>
// //                 <Work style={{ marginRight: 8, verticalAlign: "middle" }} />
// //                 <span style={{ verticalAlign: "middle" }}>
// //                   {t("text.DepartmentName")}
// //                 </span>
// //               </>
// //             ),
// //             flex: 1,
// //           },
// //           {
// //             field: "vehicleTypename",
// //             renderHeader: () => (
// //               <>
// //                 <DirectionsBike
// //                   style={{ marginRight: 8, verticalAlign: "middle" }}
// //                 />
// //                 <span style={{ verticalAlign: "middle" }}>
// //                   {t("text.VehicleTypeName")}
// //                 </span>
// //               </>
// //             ),
// //             flex: 1,
// //           },
// //         ];
// //         setColumns4(columns2 as any);
// //       }
// //     } catch (error) {
// //       console.error("Error fetching data:", error);
// //     }
// //   };

// //   const adjustedColumns4 = columns4.map((column: any) => ({
// //     ...column,
// //   }));

// //   const getZoneData = () => {
// //     api
// //       .get("NTRead/VehCurrStat")
// //       .then((res) => {
// //         const data = res.data.data;

// //         setRunn(data.runningveh);
// //         setIdle(data.idleveh);
// //         setStop(data.stopveh);
// //         setTotalVeh(data.vehtotal);
// //         setOnRoadVeh(data.totalveh);
// //         setGpsStatus(data.vehtotal);
// //         setTotalDistance(data.totDistance);

// //         // Fetch counts for cards
// //         fetchCardCounts();

// //         if (
// //           data.coT3 &&
// //           data.labels3 &&
// //           data.coT3.length === data.labels3.length
// //         ) {
// //           const chartData = data.coT3.map((value: any, index: any) => ({
// //             value: value,
// //             label: data.labels3[index],
// //           }));

// //           const sortedChartData = chartData.sort((a: any, b: any) => {
// //             const zoneA = parseInt(a.label.split(" ")[1], 10);
// //             const zoneB = parseInt(b.label.split(" ")[1], 10);
// //             return zoneA - zoneB;
// //           });

// //           setChartData(sortedChartData);
// //           setChartIsLoading(false)
// //         } else {
// //           console.error("Data arrays have different lengths.");
// //         }

// //         if (data.labels1) {
// //           let onCount = 0;
// //           let offCount = 0;

// //           data.labels1.forEach((label: string) => {
// //             const parts = label.split(" - ");
// //             const count = parseInt(parts[0]);
// //             const status = parts[1];

// //             if (status === "On") {
// //               onCount += count;
// //             } else if (status === "Off") {
// //               offCount += count;
// //             }
// //           });

// //           if (onCount === 0 && offCount === 0) {
// //             setlabelsData([]);
// //           } else {
// //             const pieChartData = [
// //               { id: 1, value: onCount, label: "On" },
// //               { id: 2, value: offCount, label: "Off" },
// //             ];
// //             setlabelsData(pieChartData);
// //           }
// //         } else {
// //           console.error("Labels1 data is missing or incorrect.");
// //         }
// //       })
// //       .catch((error) => {
// //         console.error("Error fetching data:", error);
// //       });
// //   };

// //   const fetchCardCounts = async () => {
// //     try {
// //       // Fetch Fuel Consumed count
// //       const fuelResponse = await api.get(`NTRead/GetTopFuelCons/nos=50`);
// //       setFuelConsumedCount(fuelResponse.data.data.length);

// //       // Fetch Long Idle count
// //       const idleResponse = await api.get(`NTRead/GetLongIdleVeh/nos=50`);
// //       setLongIdleCount(idleResponse.data.data.length);

// //       // Fetch Wire Tempering count
// //       const formattedDate = formatDate(new Date());
// //       const wireResponse = await api.get(`NTRead/ProbWireTamp/date=${formattedDate}`);
// //       setWireTemperingCount(wireResponse.data.data.length);
// //     } catch (error) {
// //       console.error("Error fetching card counts:", error);
// //     }
// //   };

// //   const formatDate = (date: any) => {
// //     const month = ("0" + (date.getMonth() + 1)).slice(-2);
// //     const day = ("0" + date.getDate()).slice(-2);
// //     const year = date.getFullYear();
// //     return `${month}-${day}-${year}`;
// //   };

// //   const formattedDate = formatDate(new Date());

// //   const fetchZonesData = async () => {
// //     try {
// //       const response = await api.get(`NTRead/ProbWireTamp/date=${formattedDate}`);
// //       const data = response.data.data;

// //       const zonesWithIds = data?.map((zone: any, index: any) => ({
// //         ...zone,
// //         serialNo: index + 1,
// //         id: index + 1,
// //       }));
// //       setZones(zonesWithIds);
// //       setIsLoading(false);

// //       if (data.length > 0) {
// //         const columns: GridColDef[] = [
// //           {
// //             field: "serialNo",
// //             headerName: t("text.SrNo"),
// //             flex: 0.5,
// //           },
// //           {
// //             field: "vehicleNo",
// //             headerName: t("text.VehicleNo"),
// //             flex: 1,
// //           },
// //           {
// //             field: "departmentName",
// //             headerName: t("text.DepartmentName"),
// //             flex: 1,
// //           },
// //           {
// //             field: "date",
// //             headerName: t("text.Date"),
// //             flex: 1,
// //             valueGetter: (params) => {
// //               const date = new Date(params.value);
// //               const formattedDate = `${String(date.getDate()).padStart(
// //                 2,
// //                 "0"
// //               )}-${String(date.getMonth() + 1).padStart(
// //                 2,
// //                 "0"
// //               )}-${date.getFullYear()}`;
// //               const time = `${String(date.getHours()).padStart(
// //                 2,
// //                 "0"
// //               )}:${String(date.getMinutes()).padStart(2, "0")}:${String(
// //                 date.getSeconds()
// //               ).padStart(2, "0")}`;
// //               return `${formattedDate} (Time: ${time})`;
// //             },
// //           },
// //           {
// //             field: "devid",
// //             headerName: t("text.Devid"),
// //             flex: 1,
// //           },
// //         ];
// //         setColumns(columns as any);
// //       }
// //     } catch (error) {
// //       console.error("Error fetching data:", error);
// //     }
// //   };

// //   const adjustedColumns = columns.map((column: any) => ({
// //     ...column,
// //   }));

// //   useEffect(() => {
// //     FuelconsData();
// //   }, [getTop]);

// //   useEffect(() => {
// //     IdleData();
// //   }, [getTop1]);

// //   const FuelconsData = async () => {
// //     try {
// //       const recordsCount = getTop ? 10 : 50;
// //       const response = await api.get(`NTRead/GetTopFuelCons/nos=${recordsCount}`);
// //       const data = response.data.data;

// //       setPrint(data);
// //       setFuelConsumedCount(data.length);

// //       const zonesWithIds = data.map((zone: any, index: any) => ({
// //         ...zone,
// //         serialNo: index + 1,
// //         id: index + 1,
// //       }));
// //       setZones1(zonesWithIds);
// //       setIsLoading1(false);

// //       if (data.length > 0) {
// //         const columns1: GridColDef[] = [
// //           {
// //             field: "serialNo",
// //             headerName: t("text.SrNo"),
// //             flex: 0.5,
// //           },
// //           {
// //             field: "vehicleNo",
// //             headerName: t("text.VehicleNo"),
// //             flex: 1,
// //           },
// //           {
// //             field: "departmentname",
// //             headerName: t("text.DepartmentName"),
// //             flex: 1,
// //           },
// //           {
// //             field: "fuelConsumed",
// //             headerName: t("text.FuelConsumed"),
// //             flex: 1,
// //             align: "right",
// //             headerAlign: "right",
// //             valueFormatter: ({ value }) => (value ? value.toFixed(2) : ""),
// //           },
// //         ];
// //         setColumns1(columns1 as any);
// //       }
// //     } catch (error) {
// //       console.error("Error fetching data:", error);
// //     }
// //   };

// //   const adjustedColumns1 = columns1.map((column: any) => ({
// //     ...column,
// //   }));

// //   const IdleData = async () => {
// //     try {
// //       const recordsCount = getTop1 ? 10 : 50;
// //       const response = await api.get(`NTRead/GetLongIdleVeh/nos=${recordsCount}`);
// //       const data = response?.data?.data;

// //       setPrint1(data);
// //       setLongIdleCount(data.length);

// //       const zonesWithIds = data.map((zone: any, index: any) => ({
// //         ...zone,
// //         serialNo: index + 1,
// //         id: index + 1,
// //       }));
// //       setZones2(zonesWithIds);
// //       setIsLoading2(false);

// //       if (data.length > 0) {
// //         const columns2: GridColDef[] = [
// //           {
// //             field: "vehicleNo",
// //             headerName: t("text.VehicleNo"),
// //             flex: 1,
// //             cellClassName: "wrap-text",
// //           },
// //           {
// //             field: "vehicleTypename",
// //             headerName: t("text.VehicleType"),
// //             flex: 2,
// //             cellClassName: "wrap-text",
// //           },
// //           {
// //             field: "idleTime",
// //             headerName: t("text.Duration"),
// //             flex: 1,
// //             cellClassName: "wrap-text",
// //           },
// //           {
// //             field: "departmentname",
// //             headerName: t("text.DepartmentName"),
// //             flex: 1,
// //             cellClassName: "wrap-text",
// //           },
// //           {
// //             field: "empName",
// //             headerName: t("text.Driver"),
// //             flex: 1.5,
// //             cellClassName: "wrap-text",
// //             renderCell: (params) => {
// //               const { empName, empMobileNo } = params.row;
// //               return `${empName} (${empMobileNo})`;
// //             },
// //           },
// //         ];
// //         setColumns2(columns2 as any);
// //       }
// //     } catch (error) {
// //       console.error("Error fetching data:", error);
// //     }
// //   };

// //   const adjustedColumns2 = columns2.map((column: any) => ({
// //     ...column,
// //   }));

// //   const styles = `
// //   .wrap-text {
// //     white-space: normal !important;
// //     word-wrap: break-word !important;
// //     overflow-wrap: break-word !important;
// //   }
// // `;

// //   document.head.insertAdjacentHTML("beforeend", `<style>${styles}</style>`);

// //   const TodayVData = async () => {
// //     try {
// //       const response = await api.get(`NTRead/GetNTDashboard`);
// //       const data = response.data.data;

// //       const zonesWithIds = data.map((zone: any, index: any) => ({
// //         ...zone,
// //         serialNo: index + 1,
// //         id: index + 1,
// //       }));
// //       setZones3(zonesWithIds);
// //       setIsLoading3(false);

// //       if (data.length > 0) {
// //         const columns2: GridColDef[] = [
// //           {
// //             field: "serialNo",
// //             headerName: t("text.SrNo"),
// //             flex: 0.5,
// //             cellClassName: "wrap-text",
// //           },
// //           {
// //             field: "vehicleNo",
// //             headerName: t("text.VehicleNo"),
// //             flex: 1,
// //             cellClassName: "wrap-text",
// //             renderCell: (params) => (
// //               <span
// //                 onClick={() => {
// //                   getCurrentData(params?.row);
// //                 }}
// //                 style={{
// //                   color: "blue",
// //                   textDecoration: "underline",
// //                   cursor: "pointer",
// //                 }}
// //               >
// //                 {params.value}
// //               </span>
// //             ),
// //           },
// //           {
// //             field: "trackTime",
// //             headerName: t("text.TrackTime"),
// //             flex: 2,
// //             cellClassName: "wrap-text",
// //             valueGetter: (params) => {
// //               const date = new Date(params.value);
// //               const formattedDate = `${String(date.getDate()).padStart(
// //                 2,
// //                 "0"
// //               )}-${String(date.getMonth() + 1).padStart(
// //                 2,
// //                 "0"
// //               )}-${date.getFullYear()}`;
// //               const time = `${String(date.getHours()).padStart(
// //                 2,
// //                 "0"
// //               )}:${String(date.getMinutes()).padStart(2, "0")}:${String(
// //                 date.getSeconds()
// //               ).padStart(2, "0")}`;
// //               return `${formattedDate} (Time: ${time})`;
// //             },
// //           },
// //           {
// //             field: "departmentName",
// //             headerName: t("text.DepartmentName"),
// //             flex: 1,
// //             cellClassName: "wrap-text",
// //           },
// //           {
// //             field: "vehicleTypename",
// //             headerName: t("text.VehicleTypeName"),
// //             flex: 1,
// //             cellClassName: "wrap-text",
// //           },
// //           {
// //             field: "kmPerLitre",
// //             headerName: t("text.kmPerLitre"),
// //             flex: 1,
// //             cellClassName: "wrap-text",
// //             align: "right",
// //             headerAlign: "right",
// //             valueFormatter: ({ value }) => (value ? value.toFixed(2) : ""),
// //           },
// //           {
// //             field: "ignition",
// //             headerName: t("text.Ignition"),
// //             flex: 0.5,
// //             cellClassName: "wrap-text",
// //             renderCell: (params) => (
// //               <span
// //                 onClick={() => {
// //                   if (params.row.ignition === "On") {
// //                     IgnitionData(true);
// //                   } else if (params.row.ignition === "Off") {
// //                     IgnitionData(false);
// //                   }
// //                 }}
// //                 style={{
// //                   color: "blue",
// //                   textDecoration: "underline",
// //                   cursor: "pointer",
// //                 }}
// //               >
// //                 {params.value}
// //               </span>
// //             ),
// //           },
// //           {
// //             field: "distance",
// //             headerName: t("text.Distance"),
// //             flex: 1,
// //             align: "right",
// //             headerAlign: "right",
// //             valueFormatter: ({ value }) => (value ? value.toFixed(2) : ""),
// //             cellClassName: "wrap-text",
// //           },
// //         ];
// //         setColumns3(columns2 as any);
// //       }
// //     } catch (error) {
// //       console.error("Error fetching data:", error);
// //     }
// //   };

// //   const adjustedColumns3 = columns3.map((column: any) => ({
// //     ...column,
// //   }));

// //   return (
// //     <div>
// //       {/* Summary Cards Section - Placed above the tabs */}
// //       <Grid container spacing={2} style={{ marginBottom: "15px", marginTop: "5px" }}>
// //         {/* Fuel Consumed Card */}
// //         <Grid item xs={12} sm={6} md={4}>
// //           <motion.div
// //             whileHover={{
// //               scale: 1.05,
// //               y: -5,
// //               transition: { duration: 0.2 }
// //             }}
// //             whileTap={{ scale: 0.98 }}
// //             initial={{ opacity: 0, y: 20 }}
// //             animate={{ opacity: 1, y: 0 }}
// //             transition={{ duration: 0.3 }}
// //           >
// //             <Card
// //               sx={{
// //                 height: '120px',
// //                 cursor: 'pointer',
// //                 border: '1px solid rgba(66, 182, 245, 0.2)',
// //                 borderRadius: '12px',
// //                 background: 'linear-gradient(135deg, #ffffff 0%, #f8fbff 100%)',
// //                 transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
// //                 position: 'relative',
// //                 overflow: 'hidden',
// //                 '&:before': {
// //                   content: '""',
// //                   position: 'absolute',
// //                   top: 0,
// //                   left: 0,
// //                   width: '100%',
// //                   height: '4px',
// //                   background: 'linear-gradient(90deg, #42b6f5, #2196f3)',
// //                   transform: 'scaleX(0)',
// //                   transformOrigin: 'left',
// //                   transition: 'transform 0.4s ease',
// //                 },
// //                 '&:hover': {
// //                   boxShadow: '0 10px 25px rgba(66, 182, 245, 0.2)',
// //                   borderColor: 'rgba(66, 182, 245, 0.4)',
// //                   transform: 'translateY(-4px)',
// //                   '&:before': {
// //                     transform: 'scaleX(1)',
// //                   },
// //                   '& .icon-container': {
// //                     transform: 'scale(1.1) rotate(5deg)',
// //                     boxShadow: '0 8px 20px rgba(66, 182, 245, 0.3)',
// //                   }
// //                 }
// //               }}
// //               onClick={handleFuelConsumedOpen}
// //             >
// //               <CardContent sx={{
// //                 p: 2.5,
// //                 height: '100%',
// //                 display: 'flex',
// //                 alignItems: 'center',
// //                 position: 'relative',
// //                 zIndex: 1
// //               }}>
// //                 <Box
// //                   className="icon-container"
// //                   sx={{
// //                     display: 'flex',
// //                     alignItems: 'center',
// //                     justifyContent: 'center',
// //                     width: 70,
// //                     height: 70,
// //                     borderRadius: '12px',
// //                     background: 'linear-gradient(135deg, rgba(66, 182, 245, 0.1) 0%, rgba(66, 182, 245, 0.2) 100%)',
// //                     marginRight: 2.5,
// //                     flexShrink: 0,
// //                     transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
// //                     position: 'relative',
// //                     overflow: 'hidden',
// //                     '&:after': {
// //                       content: '""',
// //                       position: 'absolute',
// //                       top: 0,
// //                       left: 0,
// //                       width: '100%',
// //                       height: '100%',
// //                       background: 'linear-gradient(135deg, transparent 30%, rgba(255, 255, 255, 0.4) 100%)',
// //                       borderRadius: '12px',
// //                     }
// //                   }}
// //                 >
// //                   <LocalGasStation
// //                     fontSize="large"
// //                     sx={{
// //                       color: ' #12286d',
// //                       filter: 'drop-shadow(0 2px 4px rgba(66, 182, 245, 0.3))',
// //                       zIndex: 1,
// //                       position: 'relative'
// //                     }}
// //                   />
// //                 </Box>
// //                 <Box sx={{ flexGrow: 1, textAlign: 'left' }}>
// //                   <Typography
// //                     variant="h6"
// //                     sx={{
// //                       fontWeight: 700,
// //                       color: '#1a237e',
// //                       fontSize: '1.1rem',
// //                       letterSpacing: '0.5px',
// //                       mb: 1,
// //                       textTransform: 'uppercase'
// //                     }}
// //                   >
// //                     Fuel Consumed
// //                   </Typography>
// //                   <Box sx={{ display: 'flex', alignItems: 'baseline' }}>
// //                     <Typography
// //                       variant="h3"
// //                       sx={{
// //                         fontWeight: 800,
// //                         color: '#12286d',
// //                         fontSize: '2.5rem',
// //                         lineHeight: 1,
// //                         mr: 1,
// //                         textShadow: '0 2px 4px rgba(66, 182, 245, 0.2)'
// //                       }}
// //                     >
// //                       {fuelConsumedCount}
// //                     </Typography>
// //                     <Typography
// //                       variant="caption"
// //                       sx={{
// //                         fontWeight: 600,
// //                         color: '#666',
// //                         fontSize: '0.75rem',
// //                         letterSpacing: '0.5px'
// //                       }}
// //                     >
// //                       Vehicles
// //                     </Typography>
// //                   </Box>
// //                 </Box>
// //               </CardContent>
// //             </Card>
// //           </motion.div>
// //         </Grid>

// //         {/* Long Idle Vehicle Card */}
// //         <Grid item xs={12} sm={6} md={4}>
// //           <motion.div
// //             whileHover={{
// //               scale: 1.05,
// //               y: -5,
// //               transition: { duration: 0.2 }
// //             }}
// //             whileTap={{ scale: 0.98 }}
// //             initial={{ opacity: 0, y: 20 }}
// //             animate={{ opacity: 1, y: 0 }}
// //             transition={{ duration: 0.3, delay: 0.1 }}
// //           >
// //             <Card
// //               sx={{
// //                 height: '120px',
// //                 cursor: 'pointer',
// //                 border: '1px solid rgba(66, 182, 245, 0.2)',
// //                 borderRadius: '12px',
// //                 background: 'linear-gradient(135deg, #ffffff 0%, #f8fbff 100%)',
// //                 transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
// //                 position: 'relative',
// //                 overflow: 'hidden',
// //                 '&:before': {
// //                   content: '""',
// //                   position: 'absolute',
// //                   top: 0,
// //                   left: 0,
// //                   width: '100%',
// //                   height: '4px',
// //                   background: 'linear-gradient(90deg, #42b6f5, #2196f3)',
// //                   transform: 'scaleX(0)',
// //                   transformOrigin: 'left',
// //                   transition: 'transform 0.4s ease',
// //                 },
// //                 '&:hover': {
// //                   boxShadow: '0 10px 25px rgba(66, 182, 245, 0.2)',
// //                   borderColor: 'rgba(66, 182, 245, 0.4)',
// //                   transform: 'translateY(-4px)',
// //                   '&:before': {
// //                     transform: 'scaleX(1)',
// //                   },
// //                   '& .icon-container': {
// //                     transform: 'scale(1.1) rotate(5deg)',
// //                     boxShadow: '0 8px 20px rgba(66, 182, 245, 0.3)',
// //                   }
// //                 }
// //               }}
// //               onClick={handleLongIdleOpen}
// //             >
// //               <CardContent sx={{
// //                 p: 2.5,
// //                 height: '100%',
// //                 display: 'flex',
// //                 alignItems: 'center',
// //                 position: 'relative',
// //                 zIndex: 1
// //               }}>
// //                 <Box
// //                   className="icon-container"
// //                   sx={{
// //                     display: 'flex',
// //                     alignItems: 'center',
// //                     justifyContent: 'center',
// //                     width: 70,
// //                     height: 70,
// //                     borderRadius: '12px',
// //                     background: 'linear-gradient(135deg, rgba(66, 182, 245, 0.1) 0%, rgba(66, 182, 245, 0.2) 100%)',
// //                     marginRight: 2.5,
// //                     flexShrink: 0,
// //                     transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
// //                     position: 'relative',
// //                     overflow: 'hidden',
// //                     '&:after': {
// //                       content: '""',
// //                       position: 'absolute',
// //                       top: 0,
// //                       left: 0,
// //                       width: '100%',
// //                       height: '100%',
// //                       background: 'linear-gradient(135deg, transparent 30%, rgba(255, 255, 255, 0.4) 100%)',
// //                       borderRadius: '12px',
// //                     }
// //                   }}
// //                 >
// //                   <FaClock
// //                     style={{
// //                       fontSize: "28px",
// //                       color: '#12286d',
// //                       filter: 'drop-shadow(0 2px 4px rgba(66, 182, 245, 0.3))',
// //                       zIndex: 1,
// //                       position: 'relative'
// //                     }}
// //                   />
// //                 </Box>
// //                 <Box sx={{ flexGrow: 1, textAlign: 'left' }}>
// //                   <Typography
// //                     variant="h6"
// //                     sx={{
// //                       fontWeight: 700,
// //                       color: '#1a237e',
// //                       fontSize: '1.1rem',
// //                       letterSpacing: '0.5px',
// //                       mb: 1,
// //                       textTransform: 'uppercase'
// //                     }}
// //                   >
// //                     Long Idle Vehicle
// //                   </Typography>
// //                   <Box sx={{ display: 'flex', alignItems: 'baseline' }}>
// //                     <Typography
// //                       variant="h3"
// //                       sx={{
// //                         fontWeight: 800,
// //                         color: '#12286d',
// //                         fontSize: '2.5rem',
// //                         lineHeight: 1,
// //                         mr: 1,
// //                         textShadow: '0 2px 4px rgba(66, 182, 245, 0.2)'
// //                       }}
// //                     >
// //                       {longIdleCount}
// //                     </Typography>
// //                     <Typography
// //                       variant="caption"
// //                       sx={{
// //                         fontWeight: 600,
// //                         color: '#666',
// //                         fontSize: '0.75rem',
// //                         letterSpacing: '0.5px'
// //                       }}
// //                     >
// //                       Vehicles
// //                     </Typography>
// //                   </Box>
// //                 </Box>
// //               </CardContent>
// //             </Card>
// //           </motion.div>
// //         </Grid>

// //         {/* Probable Wire Tempering Card */}
// //         <Grid item xs={12} sm={6} md={4}>
// //           <motion.div
// //             whileHover={{
// //               scale: 1.05,
// //               y: -5,
// //               transition: { duration: 0.2 }
// //             }}
// //             whileTap={{ scale: 0.98 }}
// //             initial={{ opacity: 0, y: 20 }}
// //             animate={{ opacity: 1, y: 0 }}
// //             transition={{ duration: 0.3, delay: 0.2 }}
// //           >
// //             <Card
// //               sx={{
// //                 height: '120px',
// //                 cursor: 'pointer',
// //                 border: '1px solid rgba(66, 182, 245, 0.2)',
// //                 borderRadius: '12px',
// //                 background: 'linear-gradient(135deg, #ffffff 0%, #f8fbff 100%)',
// //                 transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
// //                 position: 'relative',
// //                 overflow: 'hidden',
// //                 '&:before': {
// //                   content: '""',
// //                   position: 'absolute',
// //                   top: 0,
// //                   left: 0,
// //                   width: '100%',
// //                   height: '4px',
// //                   background: 'linear-gradient(90deg, #42b6f5, #2196f3)',
// //                   transform: 'scaleX(0)',
// //                   transformOrigin: 'left',
// //                   transition: 'transform 0.4s ease',
// //                 },
// //                 '&:hover': {
// //                   boxShadow: '0 10px 25px rgba(66, 182, 245, 0.2)',
// //                   borderColor: 'rgba(66, 182, 245, 0.4)',
// //                   transform: 'translateY(-4px)',
// //                   '&:before': {
// //                     transform: 'scaleX(1)',
// //                   },
// //                   '& .icon-container': {
// //                     transform: 'scale(1.1) rotate(5deg)',
// //                     boxShadow: '0 8px 20px rgba(66, 182, 245, 0.3)',
// //                   }
// //                 }
// //               }}
// //               onClick={handleWireTemperingOpen}
// //             >
// //               <CardContent sx={{
// //                 p: 2.5,
// //                 height: '100%',
// //                 display: 'flex',
// //                 alignItems: 'center',
// //                 position: 'relative',
// //                 zIndex: 1
// //               }}>
// //                 <Box
// //                   className="icon-container"
// //                   sx={{
// //                     display: 'flex',
// //                     alignItems: 'center',
// //                     justifyContent: 'center',
// //                     width: 70,
// //                     height: 70,
// //                     borderRadius: '12px',
// //                     background: 'linear-gradient(135deg, rgba(66, 182, 245, 0.1) 0%, rgba(66, 182, 245, 0.2) 100%)',
// //                     marginRight: 2.5,
// //                     flexShrink: 0,
// //                     transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
// //                     position: 'relative',
// //                     overflow: 'hidden',
// //                     '&:after': {
// //                       content: '""',
// //                       position: 'absolute',
// //                       top: 0,
// //                       left: 0,
// //                       width: '100%',
// //                       height: '100%',
// //                       background: 'linear-gradient(135deg, transparent 30%, rgba(255, 255, 255, 0.4) 100%)',
// //                       borderRadius: '12px',
// //                     }
// //                   }}
// //                 >
// //                   <ReportProblem
// //                     fontSize="large"
// //                     sx={{
// //                       color: '#12286d',
// //                       filter: 'drop-shadow(0 2px 4px rgba(66, 182, 245, 0.3))',
// //                       zIndex: 1,
// //                       position: 'relative'
// //                     }}
// //                   />
// //                 </Box>
// //                 <Box sx={{ flexGrow: 1, textAlign: 'left' }}>
// //                   <Typography
// //                     variant="h6"
// //                     sx={{
// //                       fontWeight: 700,
// //                       color: '#1a237e',
// //                       fontSize: '1.1rem',
// //                       letterSpacing: '0.5px',
// //                       mb: 1,
// //                       textTransform: 'uppercase'
// //                     }}
// //                   >
// //                     Wire Tempering
// //                   </Typography>
// //                   <Box sx={{ display: 'flex', alignItems: 'baseline' }}>
// //                     <Typography
// //                       variant="h3"
// //                       sx={{
// //                         fontWeight: 800,
// //                         color: '#12286d',
// //                         fontSize: '2.5rem',
// //                         lineHeight: 1,
// //                         mr: 1,
// //                         textShadow: '0 2px 4px rgba(66, 182, 245, 0.2)'
// //                       }}
// //                     >
// //                       {wireTemperingCount}
// //                     </Typography>
// //                     <Typography
// //                       variant="caption"
// //                       sx={{
// //                         fontWeight: 600,
// //                         color: '#666',
// //                         fontSize: '0.75rem',
// //                         letterSpacing: '0.5px'
// //                       }}
// //                     >
// //                       Alerts
// //                     </Typography>
// //                   </Box>
// //                 </Box>
// //               </CardContent>
// //             </Card>
// //           </motion.div>
// //         </Grid>
// //       </Grid>

// //       {/* Tabs Section */}
// //       <div
// //         style={{
// //           backgroundColor: "#ebf2f5",
// //           borderRadius: "15px",
// //           marginTop: "5px",
// //           boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
// //           borderTop: "2px solid",
// //           borderImage: "linear-gradient(45deg, #ff0000, #0000ff) 1",
// //           borderTopColor: "2px solid blue",
// //           borderLeft: "solid 2px transparent",
// //           borderRight: "solid 2px transparent",
// //           borderImageSource: "linear-gradient(to bottom, #ff8000, transparent)",
// //           borderImageSlice: "1",
// //         }}
// //       >
// //         <CardContent>
// //           <Grid
// //             item
// //             sm={4}
// //             md={6}
// //             xs={12}
// //             alignItems="center"
// //             justifyContent="center"
// //             display="flex"
// //           >
// //             <Tabs
// //               value={value}
// //               onChange={handleTab}
// //               indicatorColor="primary"
// //               textColor="primary"
// //               variant="scrollable"
// //               scrollButtons="auto"
// //             >
// //               {items.map((item, index) => (
// //                 <Tab
// //                   key={item.id}
// //                   icon={item.icon}
// //                   label={item.text}
// //                   iconPosition="start"
// //                 />
// //               ))}
// //             </Tabs>
// //           </Grid>
// //         </CardContent>
// //       </div>

// //       <div
// //         style={{
// //           backgroundColor: "#ebf2f5",
// //           borderRadius: "5px",
// //           marginTop: "5px",
// //           position: "relative",
// //         }}
// //       >
// //         <div
// //           style={{
// //             position: "absolute",
// //             top: 0,
// //             left: 0,
// //             width: "100%",
// //             height: "2px",
// //             background: "linear-gradient(to right, transparent,rgb(0, 13, 255) 50%, transparent)",
// //             borderTopLeftRadius: "5px",
// //             borderTopRightRadius: "5px",
// //           }}
// //         ></div>
// //         <CardContent>
// //           {value === 0 && (
// //             <div>
// //               <Grid
// //                 container
// //                 spacing={1.5}
// //               >
// //                 {/* Charts and Running Status Grid */}
// //                 <Grid xs={12} sm={6} md={4} item>
// //                   <motion.div
// //                     initial="hidden"
// //                     whileHover={{ scale: 1.05 }}
// //                     whileTap={{ scale: 0.95 }}
// //                   >
// //                     <Card
// //                       elevation={4}
// //                       style={{
// //                         marginLeft: "1%",
// //                         border: ".5px solid transparent",
// //                         borderRadius: "10px",
// //                       }}
// //                     >
// //                       <Grid
// //                         style={{
// //                           width: "100%",
// //                           height: "53vh",
// //                           backgroundColor: "#e9f4f7",
// //                         }}
// //                       >
// //                         <Typography
// //                           variant="h6"
// //                           component="div"
// //                           sx={{
// //                             padding: "17px",
// //                             background: "linear-gradient(to right, #ffffff,rgb(27, 174, 253))",
// //                           }}
// //                         >
// //                           Zones
// //                         </Typography>
// //                         {isChartLoading ? (
// //                           <Box display="flex" justifyContent="center" alignItems="center" height={220}>
// //                             <motion.span
// //                               animate={{ opacity: [1, 0.3, 1] }}
// //                               transition={{ duration: 1, repeat: Infinity }}
// //                               style={dotStyle}
// //                             />
// //                             <motion.span
// //                               animate={{ opacity: [1, 0.3, 1] }}
// //                               transition={{ duration: 1, repeat: Infinity, delay: 0.2 }}
// //                               style={dotStyle}
// //                             />
// //                             <motion.span
// //                               animate={{ opacity: [1, 0.3, 1] }}
// //                               transition={{ duration: 1, repeat: Infinity, delay: 0.4 }}
// //                               style={dotStyle}
// //                             />
// //                           </Box>
// //                         ) : (
// //                           <PieChart
// //                             series={[
// //                               {
// //                                 data: chartData,
// //                                 highlightScope: {
// //                                   faded: "global",
// //                                   highlighted: "item",
// //                                 },
// //                                 faded: {
// //                                   innerRadius: 30,
// //                                   additionalRadius: -30,
// //                                   color: "gray",
// //                                 },
// //                               },
// //                             ]}
// //                             height={220}
// //                             onItemClick={(e: any, d: any) => {
// //                               const clickedData = chartData[d.dataIndex];
// //                               zoneModal(clickedData);
// //                               setVisible(true);
// //                             }}
// //                           />
// //                         )}
// //                       </Grid>
// //                     </Card>
// //                   </motion.div>
// //                 </Grid>

// //                 <Grid xs={12} sm={6} md={4} item>
// //                   <motion.div
// //                     initial="hidden"
// //                     whileHover={{ scale: 1.05 }}
// //                     whileTap={{ scale: 0.95 }}
// //                   >
// //                     <Card
// //                       elevation={4}
// //                       style={{
// //                         marginLeft: "1%",
// //                         border: ".5px solid transparent",
// //                         borderRadius: "10px",
// //                       }}
// //                     >
// //                       <Grid
// //                         style={{
// //                           width: "100%",
// //                           height: "53vh",
// //                           backgroundColor: "#e9f4f7",
// //                         }}
// //                       >
// //                         <Typography
// //                           variant="h6"
// //                           component="div"
// //                           sx={{
// //                             padding: "17px",
// //                             background: "linear-gradient(to right, #ffffff,rgb(27, 174, 253))",
// //                           }}
// //                         >
// //                           Vehicles Ignition Status
// //                         </Typography>
// //                         {isChartLoading ? (
// //                           <Box display="flex" justifyContent="center" alignItems="center" height={220}>
// //                             <motion.span
// //                               animate={{ opacity: [1, 0.3, 1] }}
// //                               transition={{ duration: 1, repeat: Infinity }}
// //                               style={dotStyle}
// //                             />
// //                             <motion.span
// //                               animate={{ opacity: [1, 0.3, 1] }}
// //                               transition={{ duration: 1, repeat: Infinity, delay: 0.2 }}
// //                               style={dotStyle}
// //                             />
// //                             <motion.span
// //                               animate={{ opacity: [1, 0.3, 1] }}
// //                               transition={{ duration: 1, repeat: Infinity, delay: 0.4 }}
// //                               style={dotStyle}
// //                             />
// //                           </Box>
// //                         ) : (
// //                           <PieChart
// //                             series={[{ data: labelsData }]}
// //                             width={350}
// //                             height={200}
// //                             onItemClick={(e: any, d: any) => {
// //                               const clickedData = labelsData[d.dataIndex];
// //                               if (clickedData.label === "On") {
// //                                 IgnitionData(true);
// //                               } else if (clickedData.label === "Off") {
// //                                 IgnitionData(false);
// //                               }
// //                             }}
// //                           />
// //                         )}
// //                       </Grid>
// //                     </Card>
// //                   </motion.div>
// //                 </Grid>

// //                 <Grid xs={12} sm={6} md={4} item>
// //                   <motion.div
// //                     initial="hidden"
// //                     whileHover={{ scale: 1.05 }}
// //                     whileTap={{ scale: 0.95 }}
// //                   >
// //                     <Card
// //                       elevation={4}
// //                       style={{
// //                         marginLeft: "1%",
// //                         border: ".5px solid transparent",
// //                         borderRadius: "10px",
// //                       }}
// //                     >
// //                       <Grid
// //                         style={{
// //                           width: "100%",
// //                           height: "53vh",
// //                           backgroundColor: "#e9f4f7",
// //                           overflow: "auto",
// //                         }}
// //                       >
// //                         <Typography
// //                           variant="h6"
// //                           component="div"
// //                           sx={{
// //                             padding: "17px",
// //                             background: "linear-gradient(to right, #ffffff,rgb(27, 174, 253))",
// //                           }}
// //                         >
// //                           Vehicles Running Status
// //                         </Typography>
// //                         <div style={{ padding: "5px" }}>
// //                           <Typography
// //                             variant="h6"
// //                             sx={{
// //                               color: "green",
// //                               cursor: "pointer",
// //                               transition: "all 0.3s ease-in-out",
// //                               "&:hover": {
// //                                 color: "blue",
// //                                 transform: "translateY(-3px)",
// //                               },
// //                             }}
// //                             onClick={() => {
// //                               runningData("running");
// //                             }}
// //                           >
// //                             Running: {isRunn}
// //                           </Typography>
// //                           <ProgressBar
// //                             completed={Math.round((isRunn / totalVeh || 0) * 100)}
// //                             bgColor="green"
// //                           />

// //                           <Typography
// //                             variant="h6"
// //                             sx={{
// //                               color: "#EF9B0F",
// //                               cursor: "pointer",
// //                               transition: "all 0.3s ease-in-out",
// //                               "&:hover": {
// //                                 color: "blue",
// //                                 transform: "translateY(-3px)",
// //                               },
// //                             }}
// //                             onClick={() => {
// //                               runningData("idle");
// //                             }}
// //                           >
// //                             Idle: {isIdle}{" "}
// //                           </Typography>
// //                           <ProgressBar
// //                             completed={Math.round((isIdle / totalVeh || 0) * 100)}
// //                             bgColor="#e3be29"
// //                           />

// //                           <Typography
// //                             variant="h6"
// //                             sx={{
// //                               color: "#f04848",
// //                               cursor: "pointer",
// //                               transition: "all 0.3s ease-in-out",
// //                               "&:hover": {
// //                                 color: "blue",
// //                                 transform: "translateY(-3px)",
// //                               },
// //                             }}
// //                             onClick={() => {
// //                               runningData("stop");
// //                             }}
// //                           >
// //                             Stop: {isStop}
// //                           </Typography>
// //                           <ProgressBar
// //                             completed={Math.round((isStop / totalVeh || 0) * 100)}
// //                             bgColor="#f04848"
// //                           />

// //                           <Typography
// //                             variant="h6"
// //                             fontWeight="bold"
// //                             fontSize={"16px"}
// //                             style={{ color: "blue" }}
// //                           >
// //                             Total Vehicles:{" "}
// //                             <span style={{ color: "#474d54" }}>{totalVeh}</span>
// //                           </Typography>

// //                           <Typography
// //                             variant="h6"
// //                             fontWeight="bold"
// //                             fontSize={"16px"}
// //                             style={{ color: "blue" }}
// //                           >
// //                             Total Vehicles on Road:{" "}
// //                             <span style={{ color: "#474d54" }}>{onRoadVeh}</span>{" "}
// //                             out of{" "}
// //                             <span style={{ color: "#474d54" }}>{totalVeh}</span>
// //                           </Typography>

// //                           <Typography
// //                             variant="h6"
// //                             fontWeight="bold"
// //                             fontSize={"16px"}
// //                             style={{ color: "blue" }}
// //                           >
// //                             GPS Installation Status:{" "}
// //                             <span style={{ color: "#474d54" }}>{gpsStatus}</span>{" "}
// //                             out of{" "}
// //                             <span style={{ color: "#474d54" }}>{totalVeh}</span>
// //                           </Typography>

// //                           <Typography
// //                             variant="h6"
// //                             fontWeight="bold"
// //                             fontSize={"16px"}
// //                             style={{ color: "blue" }}
// //                           >
// //                             Total Distance Today:{" "}
// //                             <span style={{ color: "#474d54" }}>
// //                               {totalDistance}
// //                             </span>{" "}
// //                             Km
// //                           </Typography>
// //                         </div>
// //                       </Grid>
// //                     </Card>
// //                   </motion.div>
// //                 </Grid>

// //                 {/* Today Vehicle Status Accordion */}
// //                 <Grid xs={12} lg={12} sm={12} item >
// //                   <Accordion
// //                     expanded={accordionExpanded[2]}
// //                     onChange={(e, expended) => {
// //                       handleAccordionToggle(2, expended);
// //                     }}
// //                   >
// //                     <AccordionSummary
// //                       expandIcon={<ArrowDropDownIcon />}
// //                       aria-controls="panel2-content"
// //                       id="panel2-header"
// //                       sx={{
// //                         background: "linear-gradient(to right, #ffffff,rgb(27, 174, 253))",
// //                       }}
// //                     >
// //                       <Typography style={{ fontWeight: 600, fontSize: "16px" }}>
// //                         Today Vehicle Status
// //                       </Typography>
// //                     </AccordionSummary>
// //                     <AccordionDetails style={{ background: "#f2f8fa" }}>
// //                       <Grid
// //                         item
// //                         xs={12}
// //                         container
// //                         spacing={2}
// //                         sx={{ marginTop: "5px" }}
// //                       >
// //                         <Grid item xs={12} sm={12} lg={12}>
// //                           {isLoading3 ? (
// //                             <div
// //                               style={{
// //                                 display: "flex",
// //                                 justifyContent: "center",
// //                                 alignItems: "center",
// //                               }}
// //                             >
// //                               <CircularProgress />
// //                             </div>
// //                           ) : (
// //                             <>
// //                               {zones3 && zones3.length > 0 ? (
// //                                 <DataGrid
// //                                   rows={zones3}
// //                                   columns={adjustedColumns3}
// //                                   rowSpacingType="border"
// //                                   autoHeight
// //                                   slots={{
// //                                     toolbar: GridToolbar,
// //                                   }}
// //                                   pageSizeOptions={[5, 10, 25, 50, 100].map(
// //                                     (size) => ({
// //                                       value: size,
// //                                       label: `${size}`,
// //                                     })
// //                                   )}
// //                                   initialState={{
// //                                     pagination: {
// //                                       paginationModel: { pageSize: 5 },
// //                                     },
// //                                   }}
// //                                   slotProps={{
// //                                     toolbar: {
// //                                       showQuickFilter: true,
// //                                     },
// //                                   }}
// //                                   sx={{
// //                                     border: 0,
// //                                     "& .MuiDataGrid-columnHeaders": {
// //                                       backgroundColor: "#42b6f5", // Header background color
// //                                       color: "white", // Header text color
// //                                     },
// //                                     "& .MuiDataGrid-columnHeaderTitle": {
// //                                       color: "white", // Header title text color
// //                                     },
// //                                     "& .MuiDataGrid-cell": {
// //                                       whiteSpace: "normal", // Ensure text wraps inside the cell
// //                                       wordWrap: "break-word", // Break words to avoid overflow
// //                                       overflowWrap: "break-word", // Ensure long words wrap correctly
// //                                     },
// //                                   }}
// //                                 />
// //                               ) : (
// //                                 <div>No data found</div>
// //                               )}
// //                             </>
// //                           )}
// //                         </Grid>

// //                         {currentMap && (
// //                           <Grid item xs={12} sm={12} lg={12}>
// //                             <div
// //                               style={{
// //                                 border: "1px solid black",
// //                                 boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
// //                               }}
// //                             >
// //                               <GoogleMap
// //                                 mapContainerStyle={containerStyle}
// //                                 center={center}
// //                                 zoom={70} // Default zoom, will be adjusted by `fitBounds`
// //                                 onLoad={(map: any) => (mapRef.current = map)}
// //                               >
// //                                 {vehicles.map((vehicle: any, index: any) => (
// //                                   <Marker
// //                                     key={vehicle.id}
// //                                     position={{
// //                                       lat: vehicle.lat,
// //                                       lng: vehicle.lng,
// //                                     }}
// //                                     icon={{
// //                                       url: vehicle.icon,
// //                                       scaledSize: new window.google.maps.Size(
// //                                         50,
// //                                         50
// //                                       ),
// //                                       origin: new window.google.maps.Point(0, 0),
// //                                       anchor: new window.google.maps.Point(25, 25),
// //                                     }}

// //                                     label={{
// //                                       text: `${index + 1}`,
// //                                       fontSize: "14px",
// //                                       fontWeight: "bold",
// //                                       color: "#f73905",
// //                                       className: 'marker-label'
// //                                     }}
// //                                     onMouseOver={() =>
// //                                       handleMarkerMouseOver(vehicle)
// //                                     } // Show vehicle number on hover
// //                                     onMouseOut={handleMarkerMouseOut} // Hide info window on hover out
// //                                   >
// //                                     {activeVehicle &&
// //                                       activeVehicle.id === vehicle.id && (
// //                                         <InfoWindow>
// //                                           <div>
// //                                             <div>
// //                                               <strong>Speed: </strong>
// //                                               {vehicle.speed}
// //                                             </div>

// //                                             <div>
// //                                               <strong>Near By: </strong>
// //                                               {vehicle.nearme}
// //                                             </div>

// //                                             <div>
// //                                               <strong>Vehicle No: </strong>
// //                                               {vehicle.vehicleNo}
// //                                             </div>

// //                                             <div>
// //                                               <strong>Distance: </strong>
// //                                               {vehicle.distance}
// //                                             </div>

// //                                             <div>
// //                                               <strong>Date & Time: </strong>
// //                                               {vehicle.tracktime}
// //                                             </div>
// //                                           </div>
// //                                         </InfoWindow>
// //                                       )}
// //                                   </Marker>
// //                                 ))}

// //                                 <Polyline
// //                                   path={vehicles.map((vehicle: any) => ({ lat: vehicle.lat, lng: vehicle.lng }))}
// //                                   options={{
// //                                     strokeColor: "#6190c9",
// //                                     strokeOpacity: 1,
// //                                     strokeWeight: 3,

// //                                   }}
// //                                 />
// //                               </GoogleMap>
// //                             </div>
// //                           </Grid>
// //                         )}
// //                       </Grid>
// //                     </AccordionDetails>
// //                   </Accordion>
// //                   <br />
// //                 </Grid>

// //                 {/* Map Section */}
// //                 {currentMap && (
// //                   <Grid item xs={12} sm={12} lg={12}>
// //                     <div
// //                       style={{
// //                         border: "1px solid black",
// //                         boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
// //                         marginBottom: "20px",
// //                       }}
// //                     >
// //                       <GoogleMap
// //                         mapContainerStyle={containerStyle}
// //                         center={center}
// //                         zoom={70}
// //                         onLoad={(map: any) => (mapRef.current = map)}
// //                       >
// //                         {vehicles.map((vehicle: any, index: any) => (
// //                           <Marker
// //                             key={vehicle.id}
// //                             position={{
// //                               lat: vehicle.lat,
// //                               lng: vehicle.lng,
// //                             }}
// //                             icon={{
// //                               url: vehicle.icon,
// //                               scaledSize: new window.google.maps.Size(
// //                                 50,
// //                                 50
// //                               ),
// //                               origin: new window.google.maps.Point(0, 0),
// //                               anchor: new window.google.maps.Point(25, 25),
// //                             }}
// //                             label={{
// //                               text: `${index + 1}`,
// //                               fontSize: "14px",
// //                               fontWeight: "bold",
// //                               color: "#f73905",
// //                               className: 'marker-label'
// //                             }}
// //                             onMouseOver={() =>
// //                               handleMarkerMouseOver(vehicle)
// //                             }
// //                             onMouseOut={handleMarkerMouseOut}
// //                           >
// //                             {activeVehicle &&
// //                               activeVehicle.id === vehicle.id && (
// //                                 <InfoWindow>
// //                                   <div>
// //                                     <div>
// //                                       <strong>Speed: </strong>
// //                                       {vehicle.speed}
// //                                     </div>
// //                                     <div>
// //                                       <strong>Near By: </strong>
// //                                       {vehicle.nearme}
// //                                     </div>
// //                                     <div>
// //                                       <strong>Vehicle No: </strong>
// //                                       {vehicle.vehicleNo}
// //                                     </div>
// //                                     <div>
// //                                       <strong>Distance: </strong>
// //                                       {vehicle.distance}
// //                                     </div>
// //                                     <div>
// //                                       <strong>Date & Time: </strong>
// //                                       {vehicle.tracktime}
// //                                     </div>
// //                                   </div>
// //                                 </InfoWindow>
// //                               )}
// //                           </Marker>
// //                         ))}
// //                         <Polyline
// //                           path={vehicles.map((vehicle: any) => ({ lat: vehicle.lat, lng: vehicle.lng }))}
// //                           options={{
// //                             strokeColor: "#6190c9",
// //                             strokeOpacity: 1,
// //                             strokeWeight: 3,
// //                           }}
// //                         />
// //                       </GoogleMap>
// //                     </div>
// //                   </Grid>
// //                 )}
// //               </Grid>

// //               {/* Modal Dialogs for Cards */}
// //               {/* Fuel Consumed Modal */}
// //               <Dialog
// //                 open={fuelConsumedOpen}
// //                 onClose={handleFuelConsumedClose}
// //                 fullWidth
// //                 maxWidth="lg"
// //                 sx={{
// //                   "& .MuiDialogContent-root": {
// //                     padding: "20px",
// //                     height: "600px",
// //                   },
// //                 }}
// //               >
// //                 <DialogTitle
// //                   sx={{
// //                     display: "flex",
// //                     justifyContent: "space-between",
// //                     padding: "10px",
// //                     backgroundColor: `var(--grid-headerBackground, #42b6f5)`,
// //                     color: `var(--grid-headerColor, white)`,
// //                   }}
// //                 >
// //                   <Stack direction="row" spacing={2} alignItems="center">
// //                     <LocalGasStation />
// //                     <Typography variant="h6">
// //                       Fuel Consumed Report
// //                     </Typography>
// //                   </Stack>
// //                   <IconButton
// //                     edge="end"
// //                     onClick={handleFuelConsumedClose}
// //                     sx={{ color: "white" }}
// //                   >
// //                     <CloseIcon />
// //                   </IconButton>
// //                 </DialogTitle>
// //                 <DialogContent>
// //                   <Grid container spacing={2} sx={{ mt: 1 }}>
// //                     <Grid item xs={12}>
// //                       <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
// //                         <FormControlLabel
// //                           control={
// //                             <Checkbox
// //                               checked={getTop}
// //                               onChange={(e) => {
// //                                 setGetTop(e.target.checked);
// //                                 setTimeout(() => { }, 500);
// //                               }}
// //                             />
// //                           }
// //                           label="Get Top 10 Records"
// //                         />
// //                         <Button
// //                           startIcon={<PrintIcon />}
// //                           variant="contained"
// //                           sx={{ bgcolor: "#42b6f5", '&:hover': { bgcolor: "#1976d2" } }}
// //                           onClick={downloadExcel}
// //                         >
// //                           Export to Excel
// //                         </Button>
// //                       </Stack>
// //                     </Grid>
// //                     <Grid item xs={12}>
// //                       {isLoading1 ? (
// //                         <Box display="flex" justifyContent="center" alignItems="center" height={400}>
// //                           <CircularProgress />
// //                         </Box>
// //                       ) : (
// //                         <>
// //                           {zones1 && zones1.length > 0 ? (
// //                             <DataGrid
// //                               rows={zones1}
// //                               columns={adjustedColumns1}
// //                               rowSpacingType="border"
// //                               autoHeight
// //                               slots={{
// //                                 toolbar: GridToolbar,
// //                               }}
// //                               pageSizeOptions={[5, 10, 25, 50, 100]}
// //                               initialState={{
// //                                 pagination: {
// //                                   paginationModel: { pageSize: 10 },
// //                                 },
// //                               }}
// //                               slotProps={{
// //                                 toolbar: {
// //                                   showQuickFilter: true,
// //                                 },
// //                               }}
// //                               sx={{
// //                                 border: 0,
// //                                 "& .MuiDataGrid-columnHeaders": {
// //                                   backgroundColor: `var(--grid-headerBackground, #42b6f5)`,
// //                                   color: `var(--grid-headerColor, white)`,
// //                                 },
// //                                 "& .MuiDataGrid-columnHeaderTitle": {
// //                                   color: "white",
// //                                 },
// //                               }}
// //                             />
// //                           ) : (
// //                             <Box display="flex" justifyContent="center" alignItems="center" height={400}>
// //                               <Typography>No data found</Typography>
// //                             </Box>
// //                           )}
// //                         </>
// //                       )}
// //                     </Grid>
// //                   </Grid>
// //                 </DialogContent>
// //               </Dialog>

// //               {/* Long Idle Vehicle Modal */}
// //               <Dialog
// //                 open={longIdleOpen}
// //                 onClose={handleLongIdleClose}
// //                 fullWidth
// //                 maxWidth="lg"
// //                 sx={{
// //                   "& .MuiDialogContent-root": {
// //                     padding: "20px",
// //                     height: "600px",
// //                   },
// //                 }}
// //               >
// //                 <DialogTitle
// //                   sx={{
// //                     display: "flex",
// //                     justifyContent: "space-between",
// //                     padding: "10px",
// //                     backgroundColor: `var(--grid-headerBackground, #42b6f5)`,
// //                     color: `var(--grid-headerColor, white)`,
// //                   }}
// //                 >
// //                   <Stack direction="row" spacing={2} alignItems="center">
// //                     <FaClock style={{ fontSize: "24px" }} />
// //                     <Typography variant="h6">
// //                       Long Idle Vehicles
// //                     </Typography>
// //                   </Stack>
// //                   <IconButton
// //                     edge="end"
// //                     onClick={handleLongIdleClose}
// //                     sx={{ color: "white" }}
// //                   >
// //                     <CloseIcon />
// //                   </IconButton>
// //                 </DialogTitle>
// //                 <DialogContent>
// //                   <Grid container spacing={2} sx={{ mt: 1 }}>
// //                     <Grid item xs={12}>
// //                       <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
// //                         <FormControlLabel
// //                           control={
// //                             <Checkbox
// //                               checked={getTop1}
// //                               onChange={(e) => {
// //                                 setGetTop1(e.target.checked);
// //                               }}
// //                             />
// //                           }
// //                           label="Get Top 10 Records"
// //                         />
// //                         <Button
// //                           startIcon={<PrintIcon />}
// //                           variant="contained"
// //                           sx={{ bgcolor: "#42b6f5", '&:hover': { bgcolor: "#1976d2" } }}
// //                           onClick={downloadExcel1}
// //                         >
// //                           Export to Excel
// //                         </Button>
// //                       </Stack>
// //                     </Grid>
// //                     <Grid item xs={12}>
// //                       {isLoading2 ? (
// //                         <Box display="flex" justifyContent="center" alignItems="center" height={400}>
// //                           <CircularProgress />
// //                         </Box>
// //                       ) : (
// //                         <>
// //                           {zones2 && zones2.length > 0 ? (
// //                             <DataGrid
// //                               rows={zones2}
// //                               columns={adjustedColumns2}
// //                               rowSpacingType="border"
// //                               slots={{
// //                                 toolbar: GridToolbar,
// //                               }}
// //                               pageSizeOptions={[5, 10, 25, 50, 100]}
// //                               initialState={{
// //                                 pagination: {
// //                                   paginationModel: { pageSize: 10 },
// //                                 },
// //                               }}
// //                               slotProps={{
// //                                 toolbar: {
// //                                   showQuickFilter: true,
// //                                 },
// //                               }}
// //                               autoHeight={false}
// //                               sx={{
// //                                 border: 0,
// //                                 "& .MuiDataGrid-columnHeaders": {
// //                                   backgroundColor: `var(--grid-headerBackground, #42b6f5)`,
// //                                   color: `var(--grid-headerColor, white)`,
// //                                   position: "sticky",
// //                                   top: 0,
// //                                   zIndex: 1,
// //                                 },
// //                                 "& .MuiDataGrid-columnHeaderTitle": {
// //                                   color: "white",
// //                                 },
// //                                 "& .MuiDataGrid-cell": {
// //                                   whiteSpace: "normal",
// //                                   wordWrap: "break-word",
// //                                   overflowWrap: "break-word",
// //                                 },
// //                                 height: 400,
// //                               }}
// //                             />
// //                           ) : (
// //                             <Box display="flex" justifyContent="center" alignItems="center" height={400}>
// //                               <Typography>No data found</Typography>
// //                             </Box>
// //                           )}
// //                         </>
// //                       )}
// //                     </Grid>
// //                   </Grid>
// //                 </DialogContent>
// //               </Dialog>

// //               {/* Probable Wire Tempering Modal */}
// //               <Dialog
// //                 open={wireTemperingOpen}
// //                 onClose={handleWireTemperingClose}
// //                 fullWidth
// //                 maxWidth="lg"
// //                 sx={{
// //                   "& .MuiDialogContent-root": {
// //                     padding: "20px",
// //                     height: "600px",
// //                   },
// //                 }}
// //               >
// //                 <DialogTitle
// //                   sx={{
// //                     display: "flex",
// //                     justifyContent: "space-between",
// //                     padding: "10px",
// //                     backgroundColor: `var(--grid-headerBackground, #42b6f5)`,
// //                     color: `var(--grid-headerColor, white)`,
// //                   }}
// //                 >
// //                   <Stack direction="row" spacing={2} alignItems="center">
// //                     <ReportProblem />
// //                     <Typography variant="h6">
// //                       Probable Wire Tempering Alerts
// //                     </Typography>
// //                   </Stack>
// //                   <IconButton
// //                     edge="end"
// //                     onClick={handleWireTemperingClose}
// //                     sx={{ color: "white" }}
// //                   >
// //                     <CloseIcon />
// //                   </IconButton>
// //                 </DialogTitle>
// //                 <DialogContent>
// //                   <Grid container spacing={2} sx={{ mt: 1 }}>
// //                     <Grid item xs={12}>
// //                       {isLoading ? (
// //                         <Box display="flex" justifyContent="center" alignItems="center" height={400}>
// //                           <CircularProgress />
// //                         </Box>
// //                       ) : (
// //                         <>
// //                           {zones && zones.length > 0 ? (
// //                             <DataGrid
// //                               rows={zones}
// //                               columns={adjustedColumns}
// //                               rowSpacingType="border"
// //                               autoHeight
// //                               slots={{
// //                                 toolbar: GridToolbar,
// //                               }}
// //                               pageSizeOptions={[5, 10, 25, 50, 100]}
// //                               initialState={{
// //                                 pagination: {
// //                                   paginationModel: { pageSize: 10 },
// //                                 },
// //                               }}
// //                               slotProps={{
// //                                 toolbar: {
// //                                   showQuickFilter: true,
// //                                 },
// //                               }}
// //                               sx={{
// //                                 border: 0,
// //                                 "& .MuiDataGrid-columnHeaders": {
// //                                   backgroundColor: `var(--grid-headerBackground, #42b6f5)`,
// //                                   color: `var(--grid-headerColor, white)`,
// //                                 },
// //                                 "& .MuiDataGrid-columnHeaderTitle": {
// //                                   color: "white",
// //                                 },
// //                               }}
// //                             />
// //                           ) : (
// //                             <Box display="flex" justifyContent="center" alignItems="center" height={400}>
// //                               <Typography>No data found</Typography>
// //                             </Box>
// //                           )}
// //                         </>
// //                       )}
// //                     </Grid>
// //                   </Grid>
// //                 </DialogContent>
// //               </Dialog>

// //               {/* Existing Modals (Keep them as they are) */}
// //               <Grid xs={12} lg={12} sm={12} item>
// //                 <Dialog
// //                   open={isModal}
// //                   onClose={handleClose}
// //                   fullWidth
// //                   maxWidth="lg"
// //                   sx={{
// //                     "& .MuiDialogContent-root": {
// //                       padding: "20px",
// //                       height: "400px",
// //                     },
// //                   }}
// //                 >
// //                   <DialogTitle
// //                     sx={{
// //                       display: "flex",
// //                       justifyContent: "space-between",
// //                       padding: "10px",
// //                       backgroundColor: `var(--grid-headerBackground, #42b6f5)`,
// //                       color: `var(--grid-headerColor, white)`,
// //                     }}
// //                   >
// //                     <Typography variant="h6" style={{ color: "#ffff" }}>
// //                       Vehicle Status :{" "}
// //                       <span style={{ color: "#474d54", fontWeight: "bold" }}>
// //                         {isStatus1}
// //                       </span>
// //                     </Typography>
// //                     <IconButton
// //                       edge="end"
// //                       onClick={handleClose}
// //                       sx={{
// //                         color: `var(--grid-headerColor, white)`,
// //                       }}
// //                     >
// //                       <CloseIcon />
// //                     </IconButton>
// //                   </DialogTitle>
// //                   <DialogContent>
// //                     <Grid
// //                       item
// //                       xs={12}
// //                       container
// //                       spacing={2}
// //                       sx={{
// //                         padding: "20px",
// //                         height: "400px",
// //                         overflow: "hidden",
// //                       }}
// //                     >
// //                       <Grid item sm={12} lg={12} xs={12}>
// //                         {isLoading4 ? (
// //                           <div
// //                             style={{
// //                               display: "flex",
// //                               justifyContent: "center",
// //                               alignItems: "center",
// //                             }}
// //                           >
// //                             <CircularProgress />
// //                           </div>
// //                         ) : (
// //                           <>
// //                             {zones4 && zones4.length > 0 ? (
// //                               <DataGrid
// //                                 rows={zones4}
// //                                 columns={adjustedColumns4}
// //                                 rowSpacingType="border"
// //                                 slots={{
// //                                   toolbar: GridToolbar,
// //                                 }}
// //                                 slotProps={{
// //                                   toolbar: {
// //                                     showQuickFilter: true,
// //                                   },
// //                                 }}
// //                                 autoHeight={false}
// //                                 sx={{
// //                                   border: 0,
// //                                   "& .MuiDataGrid-columnHeaders": {
// //                                     backgroundColor: `var(--grid-headerBackground, #42b6f5)`,
// //                                     color: `var(--grid-headerColor, white)`,
// //                                     position: "sticky",
// //                                     top: 0,
// //                                     zIndex: 1,
// //                                   },
// //                                   "& .MuiDataGrid-columnHeaderTitle": {
// //                                     color: "white",
// //                                   },
// //                                   "& .MuiDataGrid-cell": {
// //                                     whiteSpace: "normal",
// //                                     wordWrap: "break-word",
// //                                     overflowWrap: "break-word",
// //                                   },
// //                                   height: 400,
// //                                   overflowY: "auto",
// //                                 }}
// //                               />
// //                             ) : (
// //                               <div>No data found</div>
// //                             )}
// //                           </>
// //                         )}
// //                       </Grid>
// //                     </Grid>
// //                   </DialogContent>
// //                 </Dialog>
// //               </Grid>

// //               <Grid xs={12} lg={12} sm={12} item>
// //                 <Dialog
// //                   open={isModal1}
// //                   onClose={handleClose1}
// //                   fullWidth
// //                   maxWidth="lg"
// //                   sx={{
// //                     "& .MuiDialogContent-root": {
// //                       padding: "20px",
// //                       height: "400px",
// //                     },
// //                   }}
// //                 >
// //                   <DialogTitle
// //                     sx={{
// //                       display: "flex",
// //                       justifyContent: "space-between",
// //                       padding: "10px",
// //                       backgroundColor: `var(--grid-headerBackground, #42b6f5)`,
// //                       color: `var(--grid-headerColor, white)`,
// //                     }}
// //                   >
// //                     <Typography variant="h6" style={{ color: "#ffff" }}>
// //                       Vehicle Ignition :{" "}
// //                       <span style={{ color: "#474d54", fontWeight: "bold" }}>
// //                         {isStatus}
// //                       </span>
// //                     </Typography>
// //                     <IconButton
// //                       edge="end"
// //                       onClick={handleClose1}
// //                       sx={{
// //                         color: `var(--grid-headerColor, white)`,
// //                       }}
// //                     >
// //                       <CloseIcon />
// //                     </IconButton>
// //                   </DialogTitle>
// //                   <DialogContent>
// //                     <Grid
// //                       item
// //                       xs={12}
// //                       container
// //                       spacing={2}
// //                       sx={{
// //                         padding: "20px",
// //                         height: "400px",
// //                         overflow: "hidden",
// //                       }}
// //                     >
// //                       <Grid item sm={12} lg={12} xs={12}>
// //                         {isLoading5 ? (
// //                           <div
// //                             style={{
// //                               display: "flex",
// //                               justifyContent: "center",
// //                               alignItems: "center",
// //                             }}
// //                           >
// //                             <CircularProgress />
// //                           </div>
// //                         ) : (
// //                           <>
// //                             {zones5 && zones5.length > 0 ? (
// //                               <DataGrid
// //                                 rows={zones5}
// //                                 columns={adjustedColumns5}
// //                                 rowSpacingType="border"
// //                                 slots={{
// //                                   toolbar: GridToolbar,
// //                                 }}
// //                                 slotProps={{
// //                                   toolbar: {
// //                                     showQuickFilter: true,
// //                                   },
// //                                 }}
// //                                 autoHeight={false}
// //                                 sx={{
// //                                   border: 0,
// //                                   "& .MuiDataGrid-columnHeaders": {
// //                                     backgroundColor: `var(--grid-headerBackground, #42b6f5)`,
// //                                     color: `var(--grid-headerColor, white)`,
// //                                     position: "sticky",
// //                                     top: 0,
// //                                     zIndex: 1,
// //                                   },
// //                                   "& .MuiDataGrid-columnHeaderTitle": {
// //                                     color: "white",
// //                                   },
// //                                   "& .MuiDataGrid-cell": {
// //                                     whiteSpace: "normal",
// //                                     wordWrap: "break-word",
// //                                     overflowWrap: "break-word",
// //                                   },
// //                                   height: 400,
// //                                   overflowY: "auto",
// //                                 }} />
// //                             ) : (
// //                               <div>No data found</div>
// //                             )}
// //                           </>
// //                         )}
// //                       </Grid>
// //                     </Grid>
// //                   </DialogContent>
// //                 </Dialog>
// //               </Grid>

// //               <Grid xs={12} lg={12} sm={12} item>
// //                 <Dialog
// //                   open={isVisible}
// //                   onClose={handleClose2}
// //                   fullWidth
// //                   maxWidth="lg"
// //                   sx={{
// //                     "& .MuiDialogContent-root": {
// //                       padding: "20px",
// //                       height: "400px",
// //                     },
// //                   }}
// //                 >
// //                   <DialogTitle
// //                     sx={{
// //                       display: "flex",
// //                       justifyContent: "space-between",
// //                       padding: "10px",
// //                       backgroundColor: `var(--grid-headerBackground, #42b6f5)`,
// //                       color: `var(--grid-headerColor, white)`,
// //                     }}
// //                   >
// //                     <Typography variant="h6" style={{ color: "#ffff" }}>
// //                       <span style={{ color: "#474d54", fontWeight: "bold" }}>
// //                         {isLabel}
// //                       </span>
// //                     </Typography>
// //                     <IconButton
// //                       edge="end"
// //                       onClick={handleClose2}
// //                       sx={{
// //                         color: `var(--grid-headerColor, white)`,
// //                       }}
// //                     >
// //                       <CloseIcon />
// //                     </IconButton>
// //                   </DialogTitle>
// //                   <DialogContent>
// //                     <Grid
// //                       item
// //                       xs={12}
// //                       container
// //                       spacing={2}
// //                       sx={{
// //                         padding: "20px",
// //                         height: "400px",
// //                         overflow: "hidden",
// //                       }}
// //                     >
// //                       <Grid item sm={12} lg={12} xs={12}>
// //                         {isLoading9 ? (
// //                           <div
// //                             style={{
// //                               display: "flex",
// //                               justifyContent: "center",
// //                               alignItems: "center",
// //                             }}
// //                           >
// //                             <CircularProgress />
// //                           </div>
// //                         ) : (
// //                           <>
// //                             {zones9 && zones9.length > 0 ? (
// //                               <DataGrid
// //                                 rows={zones9}
// //                                 columns={adjustedColumns10}
// //                                 rowSpacingType="border"
// //                                 slots={{
// //                                   toolbar: GridToolbar,
// //                                 }}
// //                                 slotProps={{
// //                                   toolbar: {
// //                                     showQuickFilter: true,
// //                                   },
// //                                 }}
// //                                 autoHeight={false}
// //                                 sx={{
// //                                   border: 0,
// //                                   "& .MuiDataGrid-columnHeaders": {
// //                                     backgroundColor: `var(--grid-headerBackground, #42b6f5)`,
// //                                     color: `var(--grid-headerColor, white)`,
// //                                     position: "sticky",
// //                                     top: 0,
// //                                     zIndex: 1,
// //                                   },
// //                                   "& .MuiDataGrid-columnHeaderTitle": {
// //                                     color: "white",
// //                                   },
// //                                   "& .MuiDataGrid-cell": {
// //                                     whiteSpace: "normal",
// //                                     wordWrap: "break-word",
// //                                     overflowWrap: "break-word",
// //                                   },
// //                                   height: 400,
// //                                   overflowY: "auto",
// //                                 }}
// //                               />
// //                             ) : (
// //                               <div>No data found</div>
// //                             )}
// //                           </>
// //                         )}
// //                       </Grid>
// //                     </Grid>
// //                   </DialogContent>
// //                 </Dialog>
// //               </Grid>
// //             </div>
// //           )}

// //           {value === 1 && <Tracking />}
// //           {value === 2 && <Geofacing />}
// //           {value === 3 && <Kudaghar />}
// //           {value === 4 && <VehicleHistory />}
// //           {value === 5 && <VehicleTravelled />}
// //         </CardContent>
// //       </div>
// //     </div>
// //   );
// // }

















// // import {
// //   JSXElementConstructor,
// //   Key,
// //   ReactElement,
// //   ReactNode,
// //   ReactPortal,
// //   useEffect,
// //   useRef,
// //   useState,
// // } from "react";
// // import {
// //   Card,
// //   Grid,
// //   CardContent,
// //   Typography,
// //   Divider,
// //   Button,
// //   FormControlLabel,
// //   Checkbox,
// //   Tab,
// //   Tabs,
// //   Dialog,
// //   DialogTitle,
// //   DialogContent,
// //   IconButton,
// //   Box,
// // } from "@mui/material";

// // import "./style.css";

// // import { DataGrid, GridColDef, GridToolbar } from "@mui/x-data-grid";

// // // import { TableContainer, Table, TableHead, TableBody, TableRow, TableCell } from '@material-ui/core';

// // import { PieChart } from "@mui/x-charts/PieChart";
// // import api, { Node } from "../../utils/Url";
// // //import { IconButton, Progress, Table } from "rsuite";
// // import Accordion from "@mui/material/Accordion";
// // import AccordionSummary from "@mui/material/AccordionSummary";
// // import AccordionDetails from "@mui/material/AccordionDetails";
// // import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
// // import { useTranslation } from "react-i18next";
// // import PrintIcon from "@mui/icons-material/Print";
// // import {
// //   GoogleMap,
// //   InfoWindow,
// //   LoadScript,
// //   Marker,
// //   Polyline,
// // } from "@react-google-maps/api";
// // import Tracking from "./Tracking";
// // import Geofacing from "./Geofacing";
// // import Kudaghar from "./Kudaghar";
// // import VehicleHistory from "./VehicleHistory";
// // import VehicleTravelled from "./VehicleTravelled";
// // import ProgressBar from "@ramonak/react-progress-bar";

// // import DashboardIcon from "@mui/icons-material/Dashboard";
// // import GpsFixedIcon from "@mui/icons-material/GpsFixed";
// // import PlaceIcon from "@mui/icons-material/Place";
// // import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
// // import CarCrashIcon from "@mui/icons-material/CarCrash";
// // import EmojiTransportationIcon from "@mui/icons-material/EmojiTransportation";
// // import { motion, useSpring } from "framer-motion";
// // import CircularProgress from "@mui/material/CircularProgress";
// // import CloseIcon from "@mui/icons-material/Close";
// // import { table } from "console";
// // import ReactModal from "react-modal";
// // import * as XLSX from "xlsx";
// // import Modal from "react-animated-modal";
// // import { animated } from "react-spring";
// // import {
// //   FaCar,
// //   FaUser,
// //   FaBuilding,
// //   FaCog,
// //   FaCircle,
// //   FaTachometerAlt,
// //   FaGasPump,
// //   FaSortNumericDown,
// //   FaCheckCircle,
// // } from "react-icons/fa";

// // import {
// //   ListAlt,
// //   DirectionsCar,
// //   Work,
// //   DirectionsBike,
// //   CheckCircle,
// // } from "@mui/icons-material";
// // import PersonIcon from "@mui/icons-material/Person";
// // import decryptData from "../../utils/crypto";
// // import VehicleComponent from "../../utils/VehicleComponent";
// // import "./style.css"

// // const style = {
// //   position: "absolute" as "absolute",
// //   top: "50%",
// //   left: "50%",
// //   transform: "translate(-50%, -50%)",
// //   width: "95%",
// //   height: "85%",
// //   bgcolor: "#f5f5f5",
// //   border: "1px solid #000",
// //   boxShadow: 24,
// //   p: 4,
// //   borderRadius: 10,
// // };
// // const dotStyle = {
// //   width: 12,
// //   height: 12,
// //   borderRadius: "50%",
// //   backgroundColor: "#1976D2",
// //   margin: "0 5px",
// //   display: "inline-block",
// // };

// // const containerStyle = {
// //   width: "100%",
// //   height: "500px",
// // };

// // interface Department {
// //   dept_id: number;
// //   dept_name: string;
// //   session_year: string;
// //   // Add other properties here
// // }

// // export default function HomePage() {
// //   const [chartData, setChartData] = useState<any>([]);

// //   const [labelsData, setlabelsData] = useState<any>([]);
// //   console.log("labelsData", labelsData);

// //   const { t } = useTranslation();

// //   const [zones, setZones] = useState([]);
// //   const [columns, setColumns] = useState<any>([]);
// //   const [isLoading, setIsLoading] = useState(true);

// //   const [currentMap, setCurrentMap] = useState(false);

// //   const [isVisible, setVisible] = useState(false);

// //   const [zones1, setZones1] = useState([]);
// //   const [columns1, setColumns1] = useState<any>([]);
// //   const [isLoading1, setIsLoading1] = useState(true);
// //   const [isChartLoading, setChartIsLoading] = useState(true);

// //   const [zones2, setZones2] = useState([]);
// //   const [columns2, setColumns2] = useState<any>([]);
// //   const [isLoading2, setIsLoading2] = useState(true);

// //   const [zones3, setZones3] = useState([]);
// //   const [columns3, setColumns3] = useState<any>([]);
// //   const [isLoading3, setIsLoading3] = useState(true);

// //   const [zones4, setZones4] = useState([]);
// //   const [columns4, setColumns4] = useState<any>([]);
// //   const [isLoading4, setIsLoading4] = useState(true);

// //   const [isLoading6, setIsLoading6] = useState(true);

// //   const [zones5, setZones5] = useState([]);
// //   const [columns5, setColumns5] = useState<any>([]);
// //   const [isLoading5, setIsLoading5] = useState(true);

// //   const [zones9, setZones9] = useState([]);
// //   const [columns9, setColumns9] = useState<any>([]);
// //   const [isLoading9, setIsLoading9] = useState(true);

// //   const [getTop, setGetTop] = useState(false);

// //   const [getTop1, setGetTop1] = useState(false);

// //   const [isRunn, setRunn] = useState<any>(0);

// //   const [isIdle, setIdle] = useState<any>(0);
// //   const [isStop, setStop] = useState<any>(0);
// //   const [totalVeh, setTotalVeh] = useState<any>(0);
// //   const [onRoadVeh, setOnRoadVeh] = useState<any>(0);
// //   const [gpsStatus, setGpsStatus] = useState<any>(0);
// //   const [totalDistance, setTotalDistance] = useState<any>(0);
// //   const [isModal, setModal] = useState<any>(false);

// //   const [isModal1, setModal1] = useState<any>(false);

// //   const [vehicleDrawer, setVehicleDrawer] = useState(false);

// //   const [itemId, setItemId] = useState<any>();

// //   const [accordionExpanded, setAccordionExpanded] = useState<any>({});
// //   const handleAccordionToggle = (index: any, isExpanded: any) => {
// //     setAccordionExpanded((prev: any) => ({
// //       ...prev,
// //       [index]: !prev[index],
// //     }));

// //     if (isExpanded) {
// //       if (index === 0) {
// //         FuelconsData();
// //       } else if (index === 1) {
// //         IdleData();
// //       } else if (index === 2) {
// //         TodayVData();
// //       } else if (index === 3) {
// //         fetchZonesData();
// //       }
// //     } else {
// //       console.log("function is not working");
// //     }
// //   };

// //   const [value, setValue] = useState<any>(
// //     parseInt(localStorage.getItem("dash") || "0", 10)
// //   );

// //   useEffect(() => {
// //     localStorage.setItem("dash", value.toString() || "0");
// //   }, [value]);

// //   const [isTable, setTable] = useState([]);
// //   const [isPrint, setPrint] = useState([]);
// //   const [isPrint1, setPrint1] = useState([]);

// //   const [isLabel, setlabel] = useState("");
// //   const [isStatus, setStatus] = useState("");
// //   const [isStatus1, setStatus1] = useState("");

// //   const downloadExcel = () => {
// //     if (!isPrint || isPrint.length === 0) {
// //       console.error("No data to export to Excel.");
// //       return;
// //     }

// //     const ws = XLSX.utils.json_to_sheet(isPrint);

// //     const headers = Object.keys(isPrint[0]);

// //     headers.forEach((header, index) => {
// //       const cellAddress = `${String.fromCharCode(65 + index)}1`;
// //     });

// //     const wb = XLSX.utils.book_new();
// //     XLSX.utils.book_append_sheet(wb, ws, "vehicles");

// //     XLSX.writeFile(wb, "FuelConsumed.xlsx");
// //   };

// //   const downloadExcel1 = () => {
// //     if (!isPrint1 || isPrint1.length === 0) {
// //       console.error("No data to export to Excel.");
// //       return;
// //     }

// //     const ws = XLSX.utils.json_to_sheet(isPrint1);

// //     const headers = Object.keys(isPrint1[0]);

// //     headers.forEach((header, index) => {
// //       const cellAddress = `${String.fromCharCode(65 + index)}1`;
// //     });

// //     const wb = XLSX.utils.book_new();
// //     XLSX.utils.book_append_sheet(wb, ws, "vehicles");

// //     XLSX.writeFile(wb, "Long_Idle.xlsx");
// //   };

// //   // const handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
// //   //     setValue(newValue);
// //   // };

// //   const handleTab = (event: any, newValue: any) => {
// //     console.log(newValue);
// //     setValue(newValue);
// //   };

// //   const items = [
// //     { id: 0, text: <strong>{t("text.Dashboard")}</strong>, icon: <DashboardIcon /> },
// //     { id: 1, text: <strong>{t("text.Tracking")}</strong>, icon: <GpsFixedIcon /> },
// //     { id: 2, text: <strong>{t("text.GeofacingCreate")}</strong>, icon: <PlaceIcon /> },
// //     { id: 3, text: <strong>{t("text.KudagharLocation")}</strong>, icon: <DeleteForeverIcon /> },
// //     { id: 4, text: <strong>{t("text.VehicleHistory")}</strong>, icon: <CarCrashIcon /> },
// //     { id: 5, text: <strong>{t("text.VehicleTravelled")}</strong>, icon: <EmojiTransportationIcon /> },
// //   ];



// //   const formatTrackTime = (tracktime: string) => {
// //     const trackTime = new Date(tracktime);

// //     // Check if the date is valid
// //     if (isNaN(trackTime.getTime())) {
// //       return "Invalid Date"; // Return a fallback message or handle it as needed
// //     }

// //     const day = trackTime.getDate().toString().padStart(2, "0");
// //     const month = (trackTime.getMonth() + 1).toString().padStart(2, "0");
// //     const year = trackTime.getFullYear();
// //     const hours = trackTime.getHours().toString().padStart(2, "0");
// //     const minutes = trackTime.getMinutes().toString().padStart(2, "0");
// //     const seconds = trackTime.getSeconds().toString().padStart(2, "0");

// //     return `${day}-${month}-${year} (Time:- ${hours}:${minutes}:${seconds})`;
// //   };

// //   const [vehicles, setVehicles] = useState<any>([]);
// //   const [activeVehicle, setActiveVehicle] = useState<any>(null);
// //   const [center, setCenter] = useState({ lat: 26.447965, lng: 80.3432 });
// //   const mapRef: any = useRef(null);

// //   useEffect(() => {
// //     if (window.google && window.google.maps) {
// //       console.log("Google Maps API loaded");
// //     } else {
// //       console.error("Google Maps API not loaded");
// //     }
// //   }, []);
// //   // Fetch the vehicle data from API
// //   const getCurrentData = (row: any) => {
// //     const collectData = {
// //       where: "VehicleNo=(@0)",
// //       orderby: "",
// //       pageNo: 0,
// //       pageSize: 0,
// //       intnotnullvalue1: 0,
// //       userId: "string",
// //       parameterValues: [row.vehicleNo],
// //       str1: "",
// //       str2: "",
// //       str3: "",
// //       str4: "",
// //       str5: "",
// //       intvalue1: 0,
// //       intvalue2: 0,
// //       intvalue3: 0,
// //       intvalue4: 0,
// //       intnotnullvalue2: 0,
// //       intnotnullvalue3: 0,
// //       date1: new Date().toISOString(),
// //       date2: new Date().toISOString(),
// //       date3: new Date().toISOString(),
// //       date4: new Date().toISOString(),
// //       dec1: 0,
// //       dec2: 0,
// //       dec3: 0,
// //       dec4: 0,
// //       flag: true,
// //       data: "string",
// //       success: true,
// //       error: "string",
// //       selectPerindex: 0,
// //       show: true,
// //     };

// //     api.post(`Dashboard/GetVehileCurrentDay`, collectData).then((res) => {
// //       const arr = res?.data?.data?.map((item: any) => ({
// //         //vehicleNo: item.vehicleno || "No ID",
// //         lat: item.lattitude,
// //         lng: item.longitude,
// //         id: item.id,
// //         speed: item.speed,
// //         tracktime: formatTrackTime(item.trackTime),
// //         distance: item.distance,
// //         nearme: item?.nearme,
// //         vehicleNo: item?.vehicleNo,

// //         icon:
// //           item.speed === 0
// //             ? "https://png.pngtree.com/png-vector/20240128/ourmid/pngtree-red-truck-transportation-png-image_11507611.png"
// //             : "https://png.pngtree.com/png-vector/20240128/ourmid/pngtree-green-truck-transport-png-image_11508688.png",
// //       }));
// //       setVehicles(arr);
// //       setCenter(calculateCenter(arr));
// //       setCurrentMap(true);
// //       if (arr.length > 0) {
// //         adjustZoomLevel(arr);
// //       }
// //     });
// //   };

// //   const calculateCenter = (vehicles: any) => {
// //     if (vehicles.length === 0) {
// //       return { lat: 26.447965, lng: 80.3432 }; // Default center if no vehicles
// //     }

// //     const latitudes = vehicles.map((vehicle: any) => vehicle.lat);
// //     const longitudes = vehicles.map((vehicle: any) => vehicle.lng);

// //     const avgLat =
// //       latitudes.reduce((sum: any, lat: any) => sum + lat, 0) / latitudes.length;
// //     const avgLng =
// //       longitudes.reduce((sum: any, lng: any) => sum + lng, 0) /
// //       longitudes.length;

// //     return { lat: avgLat, lng: avgLng }; // Return the center point
// //   };

// //   // Adjust the zoom level based on the spread of the vehicles
// //   const adjustZoomLevel = (vehicles: any) => {
// //     const bounds = new window.google.maps.LatLngBounds();

// //     vehicles.forEach((vehicle: any) => {
// //       bounds.extend(new window.google.maps.LatLng(vehicle.lat, vehicle.lng));
// //     });

// //     if (mapRef.current) {
// //       mapRef.current.fitBounds(bounds); // Fit the map to the bounds of all vehicles
// //     }
// //   };

// //   const handleMarkerMouseOver = (vehicle: any) => {
// //     setActiveVehicle(vehicle);
// //   };

// //   const handleMarkerMouseOut = () => {
// //     setActiveVehicle(null);
// //   };

// //   useEffect(() => {
// //     getZoneData();

// //     const interval = setInterval(() => {
// //       getZoneData();
// //     }, 30000);

// //     return () => clearInterval(interval);
// //   }, []);

// //   const handleClose = () => {
// //     setModal(false);
// //   };

// //   const handleClose1 = () => {
// //     setModal1(false);
// //   };

// //   const handleClose2 = () => {
// //     setVisible(false);
// //   };

// //   // const modalAnimation = useSpring({
// //   //   opacity: isVisible ? 1 : 0, // Fades in and out
// //   //   transform: isVisible ? "translateY(0)" : "translateY(-100%)", // Slides in from top
// //   //   config: { tension: 250, friction: 30 },
// //   // });

// //   // const zoneModal = (Zone: any) => {
// //   //   api.get(`NTRead/GetTopFuelConsNTS/zone=${Zone.label}`).then((res: any) => {
// //   //     setlabel(Zone.label);
// //   //     const data = res?.data?.data;

// //   //     console.log("ZoneModal", data);

// //   //     const tableData = data.map((item: any, index: any) => ({
// //   //       //id: index + 1,
// //   //       vehicleNo: item?.vehicleNo,
// //   //       empName: item?.empName,
// //   //       departmentName: item?.departmentName,
// //   //       vehicleTypename: item?.vehicleTypename,
// //   //       flag: item?.flag,
// //   //       speed: item?.speed,
// //   //       fuelConsumed: item?.fuelConsumed,
// //   //       empMobileNo: item?.empMobileNo,
// //   //     }));

// //   //     setTable(tableData);

// //   //     setIsLoading6(false);
// //   //   });
// //   // };




// //   const zoneModal = async (Zone: any) => {

// //     setlabel(Zone.label);
// //     //console.log('Zone.label',Zone.label)
// //     try {
// //       const response = await api.get(`NTRead/GetTopFuelConsNTS/zone=${Zone.label}`);
// //       const data = response.data.data;

// //       const zonesWithIds = data.map((zone: any, index: any) => ({
// //         ...zone,
// //         serialNo: index + 1,
// //         id: index + 1,
// //       }));
// //       setZones9(zonesWithIds);

// //       // setSelectedRows(zonesWithIds.map((zone: any) => zone.id));
// //       setIsLoading9(false);

// //       if (data.length > 0) {
// //         const columns9: GridColDef[] = [
// //           {
// //             field: "serialNo",
// //             headerName: t("text.SrNo"),
// //             flex: 0.5,
// //             // headerClassName: "MuiDataGrid-colCell",
// //             cellClassName: "wrap-text",
// //           },
// //           {
// //             field: "vehicleNo",
// //             headerName: t("text.VehicleNo"),
// //             flex: 1,
// //             // headerClassName: "MuiDataGrid-colCell",
// //             cellClassName: "wrap-text",
// //             // renderCell: (params) => (
// //             //   <span
// //             //     onClick={() => {
// //             //       getCurrentData(params?.row);
// //             //     }}
// //             //     style={{
// //             //       color: "blue",
// //             //       textDecoration: "underline",
// //             //       cursor: "pointer",
// //             //     }}
// //             //   >
// //             //     {params.value}
// //             //   </span>
// //             // ),
// //           },

// //           {
// //             field: "driver", // You can use any name for the field
// //             renderHeader: () => (
// //               <>
// //                 <PersonIcon
// //                   style={{ marginRight: 8, verticalAlign: "middle" }}
// //                 />
// //                 <span style={{ verticalAlign: "middle" }}>
// //                   {t("text.Driver")}
// //                 </span>
// //               </>
// //             ),
// //             flex: 1.5,
// //             renderCell: (params) => {
// //               // Assuming params.row has empName and empMobileNo
// //               const { empName, empMobileNo } = params.row;
// //               return `${empName} (${empMobileNo})`; // Concatenate name and mobile number
// //             },
// //           },
// //           {
// //             field: "departmentName",
// //             headerName: t("text.DepartmentName"),
// //             flex: 1,
// //             // headerClassName: "MuiDataGrid-colCell",
// //             cellClassName: "wrap-text",
// //           },

// //           {
// //             field: "vehicleTypename",
// //             headerName: t("text.VehicleTypeName"),
// //             flex: 1,
// //             // headerClassName: "MuiDataGrid-colCell",
// //             cellClassName: "wrap-text",
// //           },

// //           {
// //             field: "flag",
// //             headerName: t("text.Status"),
// //             flex: 1,
// //             // headerClassName: "MuiDataGrid-colCell",
// //             cellClassName: "wrap-text",

// //             align: "center",
// //             headerAlign: "center",
// //             //valueFormatter: ({ value }) => (value ? value.toFixed(2) : ""),
// //           },

// //           {
// //             field: "speed",
// //             headerName: t("text.Speed"),
// //             flex: 0.5,
// //             // headerClassName: "MuiDataGrid-colCell",
// //             cellClassName: "wrap-text",

// //           },

// //           {
// //             field: "fuel",
// //             headerName: "Fuel",
// //             flex: 1,
// //             // headerClassName: "MuiDataGrid-colCell",
// //             align: "center",
// //             headerAlign: "center",
// //             valueFormatter: ({ value }) => (value ? value.toFixed(2) : ""),
// //             cellClassName: "wrap-text",
// //           },
// //         ];
// //         setColumns9(columns9 as any);
// //       }
// //     } catch (error) {
// //       console.error("Error fetching data:", error);
// //     }
// //   };

// //   const adjustedColumns10 = columns9.map((column: any) => ({
// //     ...column,
// //   }));

// //   // console.log('vehstatus',isStatus);

// //   const IgnitionData = async (value: boolean) => {
// //     setModal1(true);
// //     try {
// //       console.log("Check value", value);
// //       value === true ? setStatus("On") : setStatus("Off");
// //       const response = await api.get(
// //         `NTRead/GetTopFuelConsNTOnOff/onoff=${value}`
// //       );
// //       const data = response.data.data;
// //       // setStatus(data[0]?.ignition);

// //       const zonesWithIds = data.map((zone: any, index: any) => ({
// //         ...zone,
// //         serialNo: index + 1,
// //         id: index + 1,
// //       }));
// //       setZones5(zonesWithIds);

// //       // setSelectedRows(zonesWithIds.map((zone: any) => zone.id));
// //       setIsLoading5(false);

// //       if (data.length > 0) {
// //         const columns2: GridColDef[] = [
// //           {
// //             field: "serialNo",
// //             renderHeader: () => (
// //               <>
// //                 <ListAlt style={{ marginRight: 8, verticalAlign: "middle" }} />
// //                 <span style={{ verticalAlign: "middle" }}>
// //                   {t("text.SrNo")}
// //                 </span>
// //               </>
// //             ),
// //             cellClassName: "wrap-text",
// //             flex: 0.3,
// //           },
// //           {
// //             field: "vehicleNo",
// //             renderHeader: () => (
// //               <>
// //                 <DirectionsCar
// //                   style={{ marginRight: 8, verticalAlign: "middle" }}
// //                 />
// //                 <span style={{ verticalAlign: "middle" }}>
// //                   {t("text.VehicleNo")}
// //                 </span>
// //               </>
// //             ),
// //             cellClassName: "wrap-text",
// //             flex: 1,
// //           },

// //           {
// //             field: "vehicleTypename",
// //             renderHeader: () => (
// //               <>
// //                 <DirectionsBike
// //                   style={{ marginRight: 8, verticalAlign: "middle" }}
// //                 />
// //                 <span style={{ verticalAlign: "middle" }}>
// //                   {t("text.VehicleTypeName")}
// //                 </span>
// //               </>
// //             ),

// //             cellClassName: "wrap-text",
// //             flex: 1.5,
// //           },

// //           {
// //             field: "driver", // You can use any name for the field

// //             cellClassName: "wrap-text",
// //             renderHeader: () => (
// //               <>
// //                 <PersonIcon
// //                   style={{ marginRight: 8, verticalAlign: "middle" }}
// //                 />
// //                 <span style={{ verticalAlign: "middle" }}>
// //                   {t("text.Driver")}
// //                 </span>
// //               </>
// //             ),
// //             flex: 1.5,
// //             renderCell: (params) => {
// //               // Assuming params.row has empName and empMobileNo
// //               const { empName, empMobileNo } = params.row;
// //               return `${empName} (${empMobileNo})`; // Concatenate name and mobile number
// //             },
// //           },
// //           {
// //             field: "flag",
// //             renderHeader: () => (
// //               <>
// //                 <CheckCircle
// //                   style={{ marginRight: 8, verticalAlign: "middle" }}
// //                 />
// //                 <span style={{ verticalAlign: "middle" }}>
// //                   {t("text.Status")}
// //                 </span>
// //               </>
// //             ),

// //             cellClassName: "wrap-text",
// //             flex: 0.5,
// //           },
// //           // {
// //           //   field: "ignition",
// //           //   headerName: t("text.Ignition"),
// //           //   flex: 0.5,
// //           //   // headerClassName: "MuiDataGrid-colCell",
// //           // },
// //         ];
// //         setColumns5(columns2 as any);
// //       }
// //     } catch (error) {
// //       console.error("Error fetching data:", error);
// //     }
// //   };

// //   const adjustedColumns5 = columns5.map((column: any) => ({
// //     ...column,
// //   }));

// //   const runningData = async (value: any) => {
// //     setStatus1(value);
// //     setModal(true);
// //     try {
// //       const response = await api.get(`NTRead/GetRunningStatus/stat=${value}`);
// //       const data = response.data.data;

// //       const zonesWithIds = data.map((zone: any, index: any) => ({
// //         ...zone,
// //         serialNo: index + 1,
// //         id: index + 1,
// //       }));
// //       setZones4(zonesWithIds);

// //       // setSelectedRows(zonesWithIds.map((zone: any) => zone.id));
// //       setIsLoading4(false);

// //       if (data.length > 0) {
// //         const columns2: GridColDef[] = [
// //           {
// //             field: "serialNo",
// //             renderHeader: () => (
// //               <>
// //                 <ListAlt style={{ marginRight: 8, verticalAlign: "middle" }} />
// //                 <span style={{ verticalAlign: "middle" }}>
// //                   {t("text.SrNo")}
// //                 </span>
// //               </>
// //             ),
// //             flex: 0.5,
// //           },
// //           {
// //             field: "vehicleNo",
// //             renderHeader: () => (
// //               <>
// //                 <DirectionsCar
// //                   style={{ marginRight: 8, verticalAlign: "middle" }}
// //                 />
// //                 <span style={{ verticalAlign: "middle" }}>
// //                   {t("text.VehicleNo")}
// //                 </span>
// //               </>
// //             ),
// //             flex: 1,
// //           },

// //           {
// //             field: "driver", // You can use any name for the field
// //             renderHeader: () => (
// //               <>
// //                 <PersonIcon
// //                   style={{ marginRight: 8, verticalAlign: "middle" }}
// //                 />
// //                 <span style={{ verticalAlign: "middle" }}>
// //                   {t("text.Driver")}
// //                 </span>
// //               </>
// //             ),
// //             flex: 1.5,
// //             renderCell: (params) => {
// //               // Assuming params.row has empName and empMobileNo
// //               const { empName, empMobileNo } = params.row;
// //               return `${empName} (${empMobileNo})`; // Concatenate name and mobile number
// //             },
// //           },
// //           {
// //             field: "departmentName",
// //             renderHeader: () => (
// //               <>
// //                 <Work style={{ marginRight: 8, verticalAlign: "middle" }} />
// //                 <span style={{ verticalAlign: "middle" }}>
// //                   {t("text.DepartmentName")}
// //                 </span>
// //               </>
// //             ),
// //             flex: 1,
// //           },
// //           {
// //             field: "vehicleTypename",
// //             renderHeader: () => (
// //               <>
// //                 <DirectionsBike
// //                   style={{ marginRight: 8, verticalAlign: "middle" }}
// //                 />
// //                 <span style={{ verticalAlign: "middle" }}>
// //                   {t("text.VehicleTypeName")}
// //                 </span>
// //               </>
// //             ),
// //             flex: 1,
// //           },

// //           // {
// //           //   field: "flag",
// //           //   headerName: t("text.Status"),
// //           //   flex: 1,
// //           //   // headerClassName: "MuiDataGrid-colCell",
// //           // },
// //         ];
// //         setColumns4(columns2 as any);
// //       }
// //     } catch (error) {
// //       console.error("Error fetching data:", error);
// //     }
// //   };

// //   const adjustedColumns4 = columns4.map((column: any) => ({
// //     ...column,
// //   }));

// //   const getZoneData = () => {
// //     // Make sure to replace the URL with your actual API endpoint
// //     api
// //       .get("NTRead/VehCurrStat")
// //       .then((res) => {
// //         const data = res.data.data;

// //         setRunn(data.runningveh);
// //         setIdle(data.idleveh);
// //         setStop(data.stopveh);
// //         setTotalVeh(data.vehtotal);
// //         setOnRoadVeh(
// //           data.totalveh
// //           //data.onRoadZone.reduce((sum: number, value: number) => sum + value, 0)
// //         ); // Example for total on-road vehicles
// //         setGpsStatus(data.vehtotal);
// //         setTotalDistance(data.totDistance);

// //         // Ensure that the lengths of coT3 and labels3 match
// //         if (
// //           data.coT3 &&
// //           data.labels3 &&
// //           data.coT3.length === data.labels3.length
// //         ) {
// //           const chartData = data.coT3.map((value: any, index: any) => ({
// //             value: value,
// //             label: data.labels3[index],
// //           }));

// //           const sortedChartData = chartData.sort((a: any, b: any) => {
// //             const zoneA = parseInt(a.label.split(" ")[1], 10);
// //             const zoneB = parseInt(b.label.split(" ")[1], 10);

// //             // console.log({zoneA,zoneB})
// //             return zoneA - zoneB;
// //           });

// //           setChartData(sortedChartData);
// //           setChartIsLoading(false)

// //         } else {
// //           console.error("Data arrays have different lengths.");
// //         }

// //         // Process labels1 data to extract numeric values for PieChart
// //         if (data.labels1) {
// //           let onCount = 0;
// //           let offCount = 0;

// //           data.labels1.forEach((label: string) => {
// //             const parts = label.split(" - ");
// //             const count = parseInt(parts[0]);
// //             const status = parts[1];

// //             if (status === "On") {
// //               onCount += count;
// //             } else if (status === "Off") {
// //               offCount += count;
// //             }
// //           });

// //           if (onCount === 0 && offCount === 0) {
// //             setlabelsData([]);
// //             //console.log("No data found");
// //           } else {
// //             const pieChartData = [
// //               { id: 1, value: onCount, label: "On" },
// //               { id: 2, value: offCount, label: "Off" },
// //             ];

// //             setlabelsData(pieChartData);
// //             console.log("Pie Chart Data:", pieChartData);
// //           }
// //         } else {
// //           console.error("Labels1 data is missing or incorrect.");
// //         }
// //       })
// //       .catch((error) => {
// //         console.error("Error fetching data:", error);
// //       });
// //   };

// //   const getRandomColor = () => {
// //     return "#" + Math.floor(Math.random() * 16777215).toString(16);
// //   };

// //   const formatDate = (date: any) => {
// //     const month = ("0" + (date.getMonth() + 1)).slice(-2); // Add leading zero if needed
// //     const day = ("0" + date.getDate()).slice(-2); // Add leading zero if needed
// //     const year = date.getFullYear();

// //     return `${month}-${day}-${year}`;
// //   };

// //   // Get the current date and format it
// //   const formattedDate = formatDate(new Date());

// //   const fetchZonesData = async () => {
// //     try {
// //       const response = await api.get(
// //         `NTRead/ProbWireTamp/date=${formattedDate}`

// //         //`NTRead/ProbWireTamp?date=${"03-12-2024"}`
// //       );


// //       // const response: any = await Node.get(`v1/data/data?date=${"12-03-2024"}`);
// //       const data = response.data.data;
// //       // console.log("Response is : ", response);
// //       // const { encryptedData, iv } = response?.data?.data;
// //       // console.log("Decription is started");
// //       // const data = decryptData(encryptedData, iv);

// //       // console.log("findData is this", data);

// //       // const zonesWithIds = data?.recordset?.map((zone: any, index: any) => ({
// //       const zonesWithIds = data?.map((zone: any, index: any) => ({
// //         ...zone,
// //         serialNo: index + 1,
// //         id: index + 1,
// //       }));
// //       setZones(zonesWithIds);

// //       setIsLoading(false);

// //       if (data.length > 0) {
// //         const columns: GridColDef[] = [
// //           {
// //             field: "serialNo",
// //             headerName: t("text.SrNo"),
// //             flex: 0.5,
// //             // headerClassName: "MuiDataGrid-colCell",
// //           },
// //           {
// //             field: "vehicleNo",
// //             headerName: t("text.VehicleNo"),
// //             flex: 1,
// //             // headerClassName: "MuiDataGrid-colCell",
// //             // renderCell: (params) => (
// //             //   <span
// //             //     onClick={() => {
// //             //       setVehicleDrawer(true);
// //             //       setItemId(params?.row?.ItemMasterId);
// //             //     }}
// //             //     style={{
// //             //       color: "blue",
// //             //       textDecoration: "underline",
// //             //       cursor: "pointer",
// //             //     }}
// //             //   >
// //             //     {params.value}
// //             //   </span>
// //             // ),
// //           },
// //           {
// //             field: "departmentName",
// //             headerName: t("text.DepartmentName"),
// //             flex: 1,
// //             // headerClassName: "MuiDataGrid-colCell",
// //           },

// //           {
// //             field: "date",
// //             headerName: t("text.Date"),
// //             flex: 1,
// //             // headerClassName: "MuiDataGrid-colCell",
// //             valueGetter: (params) => {
// //               const date = new Date(params.value);
// //               const formattedDate = `${String(date.getDate()).padStart(
// //                 2,
// //                 "0"
// //               )}-${String(date.getMonth() + 1).padStart(
// //                 2,
// //                 "0"
// //               )}-${date.getFullYear()}`;
// //               const time = `${String(date.getHours()).padStart(
// //                 2,
// //                 "0"
// //               )}:${String(date.getMinutes()).padStart(2, "0")}:${String(
// //                 date.getSeconds()
// //               ).padStart(2, "0")}`;
// //               return `${formattedDate} (Time: ${time})`;
// //             },
// //           },

// //           {
// //             field: "devid",
// //             headerName: t("text.Devid"),
// //             flex: 1,
// //             // headerClassName: "MuiDataGrid-colCell",
// //           },
// //         ];
// //         setColumns(columns as any);
// //       }
// //     } catch (error) {
// //       console.error("Error fetching data:", error);
// //     }
// //   };

// //   const adjustedColumns = columns.map((column: any) => ({
// //     ...column,
// //   }));

// //   useEffect(() => {
// //     FuelconsData();
// //   }, [getTop]);

// //   useEffect(() => {
// //     IdleData();
// //   }, [getTop1]);

// //   const FuelconsData = async () => {
// //     try {
// //       const recordsCount = getTop ? 10 : 50;
// //       console.log("recordsCount", getTop);
// //       const response = await api.get(
// //         `NTRead/GetTopFuelCons/nos=${recordsCount}`
// //       );
// //       const data = response.data.data;

// //       setPrint(data);

// //       const zonesWithIds = data.map((zone: any, index: any) => ({
// //         ...zone,
// //         serialNo: index + 1,
// //         id: index + 1,
// //       }));
// //       setZones1(zonesWithIds);

// //       // setSelectedRows(zonesWithIds.map((zone: any) => zone.id));
// //       setIsLoading1(false);

// //       if (data.length > 0) {
// //         const columns1: GridColDef[] = [
// //           {
// //             field: "serialNo",
// //             headerName: t("text.SrNo"),
// //             flex: 0.5,
// //             // headerClassName: "MuiDataGrid-colCell",
// //           },
// //           {
// //             field: "vehicleNo",
// //             headerName: t("text.VehicleNo"),
// //             flex: 1,
// //             // headerClassName: "MuiDataGrid-colCell",
// //           },
// //           {
// //             field: "departmentname",
// //             headerName: t("text.DepartmentName"),
// //             flex: 1,
// //             // headerClassName: "MuiDataGrid-colCell",
// //           },

// //           {
// //             field: "fuelConsumed",
// //             headerName: t("text.FuelConsumed"),
// //             flex: 1,
// //             align: "right",
// //             headerAlign: "right",
// //             valueFormatter: ({ value }) => (value ? value.toFixed(2) : ""),
// //           },
// //         ];
// //         setColumns1(columns1 as any);
// //       }
// //     } catch (error) {
// //       console.error("Error fetching data:", error);
// //     }
// //   };

// //   const adjustedColumns1 = columns1.map((column: any) => ({
// //     ...column,
// //   }));

// //   const IdleData = async () => {
// //     try {
// //       const recordsCount = getTop1 ? 10 : 50;
// //       //console.log("recordsCount", recordsCount);
// //       const response = await api.get(
// //         `NTRead/GetLongIdleVeh/nos=${recordsCount}`
// //       );
// //       const data = response?.data?.data;

// //       setPrint1(data);

// //       const zonesWithIds = data.map((zone: any, index: any) => ({
// //         ...zone,
// //         serialNo: index + 1,
// //         id: index + 1,
// //       }));
// //       setZones2(zonesWithIds);

// //       // setSelectedRows(zonesWithIds.map((zone: any) => zone.id));
// //       setIsLoading2(false);

// //       if (data.length > 0) {
// //         const columns2: GridColDef[] = [
// //           {
// //             field: "vehicleNo",
// //             headerName: t("text.VehicleNo"),
// //             flex: 1,
// //             cellClassName: "wrap-text",
// //           },
// //           {
// //             field: "vehicleTypename",
// //             headerName: t("text.VehicleType"),
// //             flex: 2,
// //             cellClassName: "wrap-text",
// //           },
// //           {
// //             field: "idleTime",
// //             headerName: t("text.Duration"),
// //             flex: 1,
// //             cellClassName: "wrap-text",
// //           },
// //           {
// //             field: "departmentname",
// //             headerName: t("text.DepartmentName"),
// //             flex: 1,
// //             cellClassName: "wrap-text",
// //           },
// //           {
// //             field: "empName",
// //             headerName: t("text.Driver"),
// //             flex: 1.5,
// //             cellClassName: "wrap-text",

// //             renderCell: (params) => {
// //               // Assuming params.row has empName and empMobileNo
// //               const { empName, empMobileNo } = params.row;
// //               return `${empName} (${empMobileNo})`; // Concatenate name and mobile number
// //             },
// //           },
// //         ];
// //         setColumns2(columns2 as any);
// //       }
// //     } catch (error) {
// //       console.error("Error fetching data:", error);
// //     }
// //   };

// //   const adjustedColumns2 = columns2.map((column: any) => ({
// //     ...column,
// //   }));

// //   const styles = `
// //   .wrap-text {
// //     white-space: normal !important;
// //     word-wrap: break-word !important;
// //     overflow-wrap: break-word !important;
// //   }
// // `;

// //   document.head.insertAdjacentHTML("beforeend", `<style>${styles}</style>`);

// //   const TodayVData = async () => {
// //     try {
// //       const response = await api.get(`NTRead/GetNTDashboard`);
// //       const data = response.data.data;

// //       const zonesWithIds = data.map((zone: any, index: any) => ({
// //         ...zone,
// //         serialNo: index + 1,
// //         id: index + 1,
// //       }));
// //       setZones3(zonesWithIds);

// //       // setSelectedRows(zonesWithIds.map((zone: any) => zone.id));
// //       setIsLoading3(false);

// //       if (data.length > 0) {
// //         const columns2: GridColDef[] = [
// //           {
// //             field: "serialNo",
// //             headerName: t("text.SrNo"),
// //             flex: 0.5,
// //             // headerClassName: "MuiDataGrid-colCell",
// //             cellClassName: "wrap-text",
// //           },
// //           {
// //             field: "vehicleNo",
// //             headerName: t("text.VehicleNo"),
// //             flex: 1,
// //             // headerClassName: "MuiDataGrid-colCell",
// //             cellClassName: "wrap-text",
// //             renderCell: (params) => (
// //               <span
// //                 onClick={() => {
// //                   getCurrentData(params?.row);
// //                 }}
// //                 style={{
// //                   color: "blue",
// //                   textDecoration: "underline",
// //                   cursor: "pointer",
// //                 }}
// //               >
// //                 {params.value}
// //               </span>
// //             ),
// //           },

// //           {
// //             field: "trackTime",
// //             headerName: t("text.TrackTime"),
// //             flex: 2,
// //             // headerClassName: "MuiDataGrid-colCell",
// //             cellClassName: "wrap-text",
// //             valueGetter: (params) => {
// //               const date = new Date(params.value);
// //               const formattedDate = `${String(date.getDate()).padStart(
// //                 2,
// //                 "0"
// //               )}-${String(date.getMonth() + 1).padStart(
// //                 2,
// //                 "0"
// //               )}-${date.getFullYear()}`;
// //               const time = `${String(date.getHours()).padStart(
// //                 2,
// //                 "0"
// //               )}:${String(date.getMinutes()).padStart(2, "0")}:${String(
// //                 date.getSeconds()
// //               ).padStart(2, "0")}`;
// //               return `${formattedDate} (Time: ${time})`;
// //             },
// //           },
// //           {
// //             field: "departmentName",
// //             headerName: t("text.DepartmentName"),
// //             flex: 1,
// //             // headerClassName: "MuiDataGrid-colCell",
// //             cellClassName: "wrap-text",
// //           },

// //           {
// //             field: "vehicleTypename",
// //             headerName: t("text.VehicleTypeName"),
// //             flex: 1,
// //             // headerClassName: "MuiDataGrid-colCell",
// //             cellClassName: "wrap-text",
// //           },

// //           {
// //             field: "kmPerLitre",
// //             headerName: t("text.kmPerLitre"),
// //             flex: 1,
// //             // headerClassName: "MuiDataGrid-colCell",
// //             cellClassName: "wrap-text",

// //             align: "right",
// //             headerAlign: "right",
// //             valueFormatter: ({ value }) => (value ? value.toFixed(2) : ""),
// //           },

// //           {
// //             field: "ignition",
// //             headerName: t("text.Ignition"),
// //             flex: 0.5,
// //             // headerClassName: "MuiDataGrid-colCell",
// //             cellClassName: "wrap-text",
// //             renderCell: (params) => (
// //               <span
// //                 onClick={() => {
// //                   if (params.row.ignition === "On") {
// //                     IgnitionData(true);
// //                   } else if (params.row.ignition === "Off") {
// //                     IgnitionData(false);
// //                   }
// //                 }}
// //                 style={{
// //                   color: "blue",
// //                   textDecoration: "underline",
// //                   cursor: "pointer",
// //                 }}
// //               >
// //                 {params.value}
// //               </span>
// //             ),
// //           },

// //           {
// //             field: "distance",
// //             headerName: t("text.Distance"),
// //             flex: 1,
// //             // headerClassName: "MuiDataGrid-colCell",
// //             align: "right",
// //             headerAlign: "right",
// //             valueFormatter: ({ value }) => (value ? value.toFixed(2) : ""),
// //             cellClassName: "wrap-text",
// //           },
// //         ];
// //         setColumns3(columns2 as any);
// //       }
// //     } catch (error) {
// //       console.error("Error fetching data:", error);
// //     }
// //   };

// //   const adjustedColumns3 = columns3.map((column: any) => ({
// //     ...column,
// //   }));

// //   // const MapData = (row: any) => {
// //   //   const collectData = {
// //   //     orderby: "",
// //   //     pageNo: 0,
// //   //     pageSize: 0,
// //   //     intnotnullvalue1: 0,
// //   //     userId: "",
// //   //     parameterValues: [row?.vehicleNo],
// //   //     str1: "",
// //   //     str2: "",
// //   //     str3: "",
// //   //     str4: "",
// //   //     str5: "",
// //   //     intvalue1: 0,
// //   //     intvalue2: 0,
// //   //     intvalue3: 0,
// //   //     intvalue4: 0,
// //   //     intnotnullvalue2: 0,
// //   //     intnotnullvalue3: 0,
// //   //     date1: new Date().toISOString(),
// //   //     date2: new Date().toISOString(),
// //   //     date3: new Date().toISOString(),
// //   //     date4: new Date().toISOString(),
// //   //     dec1: 0,
// //   //     dec2: 0,
// //   //     dec3: 0,
// //   //     dec4: 0,
// //   //     flag: true,
// //   //     data: "",
// //   //     success: true,
// //   //     error: "",
// //   //     selectPerindex: 0,
// //   //     show: true,
// //   //   };
// //   //   api.post(`Dashboard/GetVehileCurrentDay`, collectData).then((res) => {
// //   //     const arr = res?.data?.data.map((item: any) => ({
// //   //       label: item.vehicleTypename,
// //   //       value: item.vehicleTypeId,
// //   //     }));
// //   //     setMap(arr);
// //   //   });
// //   // };

// //   return (
// //     <div>
// //       <div>
// //         <div
// //           style={{
// //             backgroundColor: "#ebf2f5",
// //             borderRadius: "15px",
// //             marginTop: "5px",
// //             boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
// //             borderTop: "2px solid",
// //             borderImage: "linear-gradient(45deg, #ff0000, #0000ff) 1",
// //             borderTopColor: "2px solid blue",
// //             borderLeft: "solid 2px transparent",
// //             borderRight: "solid 2px transparent",
// //             borderImageSource: "linear-gradient(to bottom, #ff8000, transparent)",
// //             borderImageSlice: "1",
// //           }}
// //         >
// //           <CardContent>
// //             <Grid
// //               item
// //               sm={4}
// //               md={6}
// //               xs={12}
// //               alignItems="center"
// //               justifyContent="center"
// //               display="flex"
// //             >
// //               <Tabs
// //                 value={value}
// //                 onChange={handleTab}
// //                 indicatorColor="primary"
// //                 textColor="primary"
// //                 variant="scrollable"
// //                 scrollButtons="auto"
// //               >
// //                 {items.map((item, index) => (
// //                   <Tab
// //                     key={item.id}
// //                     icon={item.icon}
// //                     label={item.text}
// //                     iconPosition="start"
// //                   />
// //                 ))}
// //               </Tabs>
// //             </Grid>
// //           </CardContent>
// //         </div>
// //       </div>

// //       <div
// //         style={{
// //           backgroundColor: "#ebf2f5",
// //           borderRadius: "5px",
// //           marginTop: "5px",
// //           position: "relative",

// //         }}
// //       >
// //         <div
// //           style={{
// //             position: "absolute",
// //             top: 0,
// //             left: 0,
// //             width: "100%",
// //             height: "2px",
// //             background: "linear-gradient(to right, transparent,rgb(0, 13, 255) 50%, transparent)",
// //             borderTopLeftRadius: "5px",
// //             borderTopRightRadius: "5px",
// //           }}
// //         ></div>
// //         <CardContent>
// //           {value === 0 && (
// //             <div>
// //               <Grid
// //                 container
// //                 spacing={1.5}
// //                 style={{
// //                   // backgroundColor:'red',
// //                   //marginTop: "2vh",
// //                 }}
// //               >
// //                 <Grid xs={12} sm={6} md={4} item>
// //                   <motion.div
// //                     initial="hidden"
// //                     whileHover={{ scale: 1.05 }}
// //                     whileTap={{ scale: 0.95 }}
// //                   >
// //                     <Card
// //                       elevation={4}
// //                       style={{
// //                         marginLeft: "1%",
// //                         border: ".5px solid transparent",
// //                         borderRadius: "10px",
// //                       }}
// //                     >
// //                       <Grid
// //                         style={{
// //                           width: "100%",
// //                           height: "53vh",
// //                           //color:"white",
// //                           backgroundColor: "#e9f4f7",
// //                         }}
// //                       >
// //                         <Typography
// //                           variant="h6"
// //                           component="div"
// //                           sx={{
// //                             padding: "17px",
// //                             background: "linear-gradient(to right, #ffffff,rgb(27, 174, 253))",
// //                             //marginBottom: "4.5%",
// //                           }}

// //                         >
// //                           Zones
// //                         </Typography>


// //                         {isChartLoading ? (
// //                           <Box display="flex" justifyContent="center" alignItems="center" height={220}>
// //                             <motion.span
// //                               animate={{ opacity: [1, 0.3, 1] }}
// //                               transition={{ duration: 1, repeat: Infinity }}
// //                               style={dotStyle}
// //                             />
// //                             <motion.span
// //                               animate={{ opacity: [1, 0.3, 1] }}
// //                               transition={{ duration: 1, repeat: Infinity, delay: 0.2 }}
// //                               style={dotStyle}
// //                             />
// //                             <motion.span
// //                               animate={{ opacity: [1, 0.3, 1] }}
// //                               transition={{ duration: 1, repeat: Infinity, delay: 0.4 }}
// //                               style={dotStyle}
// //                             />
// //                           </Box>
// //                         ) : (
// //                           <PieChart
// //                             series={[
// //                               {
// //                                 data: chartData,
// //                                 highlightScope: {
// //                                   faded: "global",
// //                                   highlighted: "item",
// //                                 },
// //                                 faded: {
// //                                   innerRadius: 30,
// //                                   additionalRadius: -30,
// //                                   color: "gray",
// //                                 },
// //                               },
// //                             ]}
// //                             height={220}
// //                             onItemClick={(e: any, d: any) => {
// //                               const clickedData = chartData[d.dataIndex];
// //                               zoneModal(clickedData);
// //                               setVisible(true);
// //                             }}
// //                           />
// //                         )}
// //                       </Grid>
// //                     </Card>
// //                   </motion.div>
// //                 </Grid>

// //                 <Grid xs={12} sm={6} md={4} item>
// //                   <motion.div
// //                     initial="hidden"
// //                     whileHover={{ scale: 1.05 }}
// //                     whileTap={{ scale: 0.95 }}
// //                   >
// //                     <Card
// //                       elevation={4}
// //                       style={{
// //                         marginLeft: "1%",
// //                         border: ".5px solid transparent",
// //                         borderRadius: "10px",
// //                       }}
// //                     >
// //                       <Grid
// //                         style={{
// //                           width: "100%",
// //                           height: "53vh",
// //                           backgroundColor: "#e9f4f7",
// //                         }}
// //                       >
// //                         <Typography
// //                           variant="h6"
// //                           component="div"
// //                           sx={{
// //                             padding: "17px",
// //                             background: "linear-gradient(to right, #ffffff,rgb(27, 174, 253))",
// //                             //marginBottom: "4.5%",
// //                           }}
// //                         >
// //                           Vehicles Ignition Status
// //                         </Typography>

// //                         {isChartLoading ? (
// //                           <Box display="flex" justifyContent="center" alignItems="center" height={220}>
// //                             <motion.span
// //                               animate={{ opacity: [1, 0.3, 1] }}
// //                               transition={{ duration: 1, repeat: Infinity }}
// //                               style={dotStyle}
// //                             />
// //                             <motion.span
// //                               animate={{ opacity: [1, 0.3, 1] }}
// //                               transition={{ duration: 1, repeat: Infinity, delay: 0.2 }}
// //                               style={dotStyle}
// //                             />
// //                             <motion.span
// //                               animate={{ opacity: [1, 0.3, 1] }}
// //                               transition={{ duration: 1, repeat: Infinity, delay: 0.4 }}
// //                               style={dotStyle}
// //                             />
// //                           </Box>
// //                         ) : (
// //                           <PieChart
// //                             series={[{ data: labelsData }]}
// //                             width={350}
// //                             height={200}
// //                             //sx={{marginTop:"7px"}}
// //                             onItemClick={(e: any, d: any) => {
// //                               console.log(d);
// //                               console.log(d.dataIndex);

// //                               const clickedData = labelsData[d.dataIndex];
// //                               console.log("ID:", clickedData.id);

// //                               if (clickedData.label === "On") {
// //                                 IgnitionData(true);
// //                               } else if (clickedData.label === "Off") {
// //                                 IgnitionData(false);
// //                               }
// //                             }}
// //                           />
// //                         )}
// //                       </Grid>
// //                     </Card>
// //                   </motion.div>
// //                 </Grid>

// //                 <Grid xs={12} sm={6} md={4} item>
// //                   <motion.div
// //                     initial="hidden"
// //                     whileHover={{ scale: 1.05 }}
// //                     whileTap={{ scale: 0.95 }}
// //                   >
// //                     <Card
// //                       elevation={4}
// //                       style={{
// //                         marginLeft: "1%",
// //                         border: ".5px solid transparent",
// //                         borderRadius: "10px",
// //                       }}
// //                     >
// //                       <Grid
// //                         style={{
// //                           width: "100%",
// //                           height: "53vh",
// //                           backgroundColor: "#e9f4f7",
// //                           overflow: "auto",
// //                         }}
// //                       >
// //                         <Typography
// //                           variant="h6"
// //                           component="div"
// //                           sx={{
// //                             padding: "17px",
// //                             background: "linear-gradient(to right, #ffffff,rgb(27, 174, 253))",
// //                             //marginBottom: "4.5%",
// //                           }}
// //                         >
// //                           Vehicles Running Status
// //                         </Typography>
// //                         <div style={{ padding: "5px" }}>
// //                           {/* Running Status */}
// //                           <Typography
// //                             variant="h6"
// //                             sx={{
// //                               color: "green",
// //                               cursor: "pointer",
// //                               transition: "all 0.3s ease-in-out",
// //                               "&:hover": {
// //                                 color: "blue",
// //                                 transform: "translateY(-3px)", // Moves text slightly up
// //                               },
// //                             }}
// //                             onClick={() => {
// //                               runningData("running");
// //                             }}
// //                           >
// //                             Running: {isRunn}

// //                           </Typography>
// //                           <ProgressBar
// //                             completed={Math.round((isRunn / totalVeh || 0) * 100)}
// //                             bgColor="green"
// //                           />

// //                           {/* Idle Status */}
// //                           <Typography
// //                             variant="h6"
// //                             sx={{
// //                               color: "#EF9B0F",
// //                               cursor: "pointer",
// //                               transition: "all 0.3s ease-in-out",
// //                               "&:hover": {
// //                                 color: "blue",
// //                                 transform: "translateY(-3px)",
// //                               },
// //                             }}
// //                             onClick={() => {
// //                               runningData("idle");
// //                             }}
// //                           >
// //                             Idle: {isIdle}{" "}
// //                           </Typography>
// //                           <ProgressBar
// //                             completed={Math.round((isIdle / totalVeh || 0) * 100)}
// //                             bgColor="#e3be29"
// //                           />

// //                           {/* Stop Status */}
// //                           <Typography
// //                             variant="h6"
// //                             sx={{
// //                               color: "#f04848",
// //                               cursor: "pointer",
// //                               transition: "all 0.3s ease-in-out",
// //                               "&:hover": {
// //                                 color: "blue",
// //                                 transform: "translateY(-3px)", // Moves text slightly up
// //                               },
// //                             }}
// //                             onClick={() => {
// //                               runningData("stop");
// //                             }}
// //                           >
// //                             Stop: {isStop}
// //                           </Typography>

// //                           <ProgressBar
// //                             completed={Math.round((isStop / totalVeh || 0) * 100)}
// //                             bgColor="#f04848"
// //                           />



// //                           <Typography
// //                             variant="h6"
// //                             fontWeight="bold"
// //                             fontSize={"16px"}
// //                             style={{ color: "blue" }}
// //                           >
// //                             Total Vehicles:{" "}
// //                             <span style={{ color: "#474d54" }}>{totalVeh}</span>
// //                           </Typography>

// //                           <Typography
// //                             variant="h6"
// //                             fontWeight="bold"
// //                             fontSize={"16px"}
// //                             style={{ color: "blue" }}
// //                           >
// //                             Total Vehicles on Road:{" "}
// //                             <span style={{ color: "#474d54" }}>{onRoadVeh}</span>{" "}
// //                             out of{" "}
// //                             <span style={{ color: "#474d54" }}>{totalVeh}</span>
// //                           </Typography>

// //                           <Typography
// //                             variant="h6"
// //                             fontWeight="bold"
// //                             fontSize={"16px"}
// //                             style={{ color: "blue" }}
// //                           >
// //                             GPS Installation Status:{" "}
// //                             <span style={{ color: "#474d54" }}>{gpsStatus}</span>{" "}
// //                             out of{" "}
// //                             <span style={{ color: "#474d54" }}>{totalVeh}</span>
// //                           </Typography>

// //                           <Typography
// //                             variant="h6"
// //                             fontWeight="bold"
// //                             fontSize={"16px"}
// //                             style={{ color: "blue" }}
// //                           >
// //                             Total Distance Today:{" "}
// //                             <span style={{ color: "#474d54" }}>
// //                               {totalDistance}
// //                             </span>{" "}
// //                             Km
// //                           </Typography>
// //                         </div>
// //                       </Grid>
// //                     </Card>
// //                   </motion.div>
// //                 </Grid>



// //                 <Grid xs={12} lg={6} sm={6} item >
// //                   <Accordion
// //                     expanded={accordionExpanded[0]}
// //                     onChange={(e, expended) => {
// //                       handleAccordionToggle(0, expended);
// //                       // FuelconsData();
// //                     }}
// //                   >
// //                     <AccordionSummary
// //                       expandIcon={<ArrowDropDownIcon />}
// //                       aria-controls="panel2-content"
// //                       id="panel2-header"
// //                       sx={{
// //                         //padding: "17px",
// //                         background: "linear-gradient(to right, #ffffff,rgb(27, 174, 253))",
// //                         //marginBottom: "4.5%",
// //                       }}
// //                     >
// //                       <Typography style={{ fontWeight: 600, fontSize: "16px" }}>
// //                         Fuel Consumed
// //                       </Typography>
// //                     </AccordionSummary>
// //                     <AccordionDetails style={{ background: "#f2f8fa" }}>
// //                       <Grid
// //                         item
// //                         xs={12}
// //                         container
// //                         spacing={2}
// //                         sx={{ marginTop: "5px" }}
// //                       >
// //                         <Grid item xs={12} sm={2} lg={2}>
// //                           <PrintIcon
// //                             fontSize="large"
// //                             sx={{ color: "blue" }}
// //                             onClick={() => {
// //                               downloadExcel();
// //                             }}
// //                           />
// //                         </Grid>

// //                         <FormControlLabel
// //                           control={
// //                             <Checkbox
// //                               checked={getTop}
// //                               onChange={(e) => {
// //                                 setGetTop(e.target.checked);
// //                                 setTimeout(() => { }, 500);
// //                               }}
// //                             />
// //                           }
// //                           label="Get Top 10 Records"
// //                         />

// //                         <Grid item xs={12} sm={12} lg={12}>
// //                           {isLoading1 ? (
// //                             <div
// //                               style={{
// //                                 display: "flex",
// //                                 justifyContent: "center",
// //                                 alignItems: "center",
// //                               }}
// //                             >
// //                               <CircularProgress />
// //                             </div>
// //                           ) : (
// //                             <>
// //                               {zones1 && zones1.length > 0 ? (
// //                                 <DataGrid
// //                                   rows={zones1}
// //                                   columns={adjustedColumns1}
// //                                   rowSpacingType="border"
// //                                   autoHeight
// //                                   slots={{
// //                                     toolbar: GridToolbar,
// //                                   }}
// //                                   pageSizeOptions={[5, 10, 25, 50, 100].map(
// //                                     (size) => ({
// //                                       value: size,
// //                                       label: `${size}`,
// //                                     })
// //                                   )}
// //                                   initialState={{
// //                                     pagination: {
// //                                       paginationModel: { pageSize: 5 },
// //                                     },
// //                                   }}
// //                                   slotProps={{
// //                                     toolbar: {
// //                                       showQuickFilter: true,
// //                                     },
// //                                   }}
// //                                   sx={{
// //                                     border: 0,
// //                                     "& .MuiDataGrid-columnHeaders": {
// //                                       backgroundColor: "#42b6f5", // Header background color
// //                                       color: "white", // Header text color
// //                                     },
// //                                     "& .MuiDataGrid-columnHeaderTitle": {
// //                                       color: "white", // Header title text color
// //                                     },
// //                                   }}
// //                                 />
// //                               ) : (
// //                                 <div>No data found</div>
// //                               )}
// //                             </>
// //                           )}
// //                         </Grid>
// //                       </Grid>
// //                     </AccordionDetails>
// //                   </Accordion>
// //                   <br />
// //                 </Grid>

// //                 <Grid xs={12} lg={6} sm={6} item

// //                 >
// //                   <Accordion
// //                     expanded={accordionExpanded[1]}
// //                     onChange={(e, expended) => {
// //                       handleAccordionToggle(1, expended);
// //                       // IdleData();
// //                     }}
// //                   >
// //                     <AccordionSummary
// //                       expandIcon={<ArrowDropDownIcon />}
// //                       aria-controls="panel2-content"
// //                       id="panel2-header"
// //                       sx={{
// //                         //padding: "17px",
// //                         background: "linear-gradient(to right, #ffffff,rgb(27, 174, 253))",
// //                         // marginBottom: "4.5%",
// //                       }}
// //                     >
// //                       <Typography style={{ fontWeight: 600, fontSize: "16px" }}>
// //                         Long Idle Vehicle
// //                       </Typography>
// //                     </AccordionSummary>
// //                     <AccordionDetails style={{ background: "#f2f8fa" }}>
// //                       <Grid
// //                         item
// //                         xs={12}
// //                         container
// //                         spacing={2}
// //                         sx={{ marginTop: "5px" }}
// //                       >
// //                         <Grid item xs={12} sm={2} lg={2}>
// //                           <PrintIcon
// //                             fontSize="large"
// //                             sx={{ color: "blue" }}
// //                             onClick={() => {
// //                               downloadExcel1();
// //                             }}
// //                           />
// //                         </Grid>
// //                         <FormControlLabel
// //                           control={
// //                             <Checkbox
// //                               checked={getTop1}
// //                               onChange={(e) => {
// //                                 setGetTop1(e.target.checked);
// //                                 //FuelconsData();
// //                               }}
// //                             />
// //                           }
// //                           label="Get Top 10 Records"
// //                         />

// //                         <Grid item xs={12} sm={12} lg={12}>
// //                           {isLoading2 ? (
// //                             <div
// //                               style={{
// //                                 display: "flex",
// //                                 justifyContent: "center",
// //                                 alignItems: "center",
// //                               }}
// //                             >
// //                               <CircularProgress />
// //                             </div>
// //                           ) : (
// //                             <>
// //                               {zones2 && zones2.length > 0 ? (

// //                                 <DataGrid
// //                                   rows={zones2}
// //                                   columns={adjustedColumns2}
// //                                   rowSpacingType="border"
// //                                   //autoHeight
// //                                   slots={{
// //                                     toolbar: GridToolbar,
// //                                   }}
// //                                   pageSizeOptions={[5, 10, 25, 50, 100].map(
// //                                     (size) => ({
// //                                       value: size,
// //                                       label: `${size}`,
// //                                     })
// //                                   )}
// //                                   initialState={{
// //                                     pagination: {
// //                                       paginationModel: { pageSize: 5 },
// //                                     },
// //                                   }}
// //                                   slotProps={{
// //                                     toolbar: {
// //                                       showQuickFilter: true,
// //                                     },
// //                                   }}
// //                                   autoHeight
// //                                   sx={{
// //                                     border: 0,
// //                                     "& .MuiDataGrid-columnHeaders": {
// //                                       backgroundColor: `var(--grid-headerBackground)`,
// //                                       color: `var(--grid-headerColor)`,
// //                                       position: "sticky",
// //                                       top: 0,
// //                                       zIndex: 1,
// //                                     },
// //                                     "& .MuiDataGrid-columnHeaderTitle": {
// //                                       color: "white",
// //                                     },
// //                                     "& .MuiDataGrid-cell": {
// //                                       whiteSpace: "normal",
// //                                       wordWrap: "break-word",
// //                                       overflowWrap: "break-word",
// //                                     },
// //                                     height: 400,
// //                                     // width:450,
// //                                     //overflowX: "auto",
// //                                   }}
// //                                 />
// //                               ) : (
// //                                 <div>No data found</div>
// //                               )}
// //                             </>
// //                           )}
// //                         </Grid>
// //                       </Grid>
// //                     </AccordionDetails>
// //                   </Accordion>
// //                   <br />
// //                 </Grid>

// //                 <Grid xs={12} lg={12} sm={12} item >
// //                   <Accordion
// //                     expanded={accordionExpanded[2]}
// //                     onChange={(e, expended) => {
// //                       handleAccordionToggle(2, expended);
// //                       //TodayVData();
// //                     }}
// //                   >
// //                     <AccordionSummary
// //                       expandIcon={<ArrowDropDownIcon />}
// //                       aria-controls="panel2-content"
// //                       id="panel2-header"
// //                       // sx={{ background: "#7fd1eb", color: "black" }}
// //                       sx={{
// //                         background: "linear-gradient(to right, #ffffff,rgb(27, 174, 253))",
// //                       }}
// //                     >
// //                       <Typography style={{ fontWeight: 600, fontSize: "16px" }}>
// //                         Today Vehicle Status
// //                       </Typography>
// //                     </AccordionSummary>
// //                     <AccordionDetails style={{ background: "#f2f8fa" }}>
// //                       <Grid
// //                         item
// //                         xs={12}
// //                         container
// //                         spacing={2}
// //                         sx={{ marginTop: "5px" }}

// //                       >
// //                         <Grid item xs={12} sm={12} lg={12}>
// //                           {isLoading3 ? (
// //                             <div
// //                               style={{
// //                                 display: "flex",
// //                                 justifyContent: "center",
// //                                 alignItems: "center",
// //                               }}
// //                             >
// //                               <CircularProgress />
// //                             </div>
// //                           ) : (
// //                             <>
// //                               {zones3 && zones3.length > 0 ? (
// //                                 <DataGrid
// //                                   rows={zones3}
// //                                   columns={adjustedColumns3}
// //                                   rowSpacingType="border"
// //                                   autoHeight
// //                                   slots={{
// //                                     toolbar: GridToolbar,
// //                                   }}
// //                                   pageSizeOptions={[5, 10, 25, 50, 100].map(
// //                                     (size) => ({
// //                                       value: size,
// //                                       label: `${size}`,
// //                                     })
// //                                   )}
// //                                   initialState={{
// //                                     pagination: {
// //                                       paginationModel: { pageSize: 5 },
// //                                     },
// //                                   }}
// //                                   slotProps={{
// //                                     toolbar: {
// //                                       showQuickFilter: true,
// //                                     },
// //                                   }}
// //                                   sx={{
// //                                     border: 0,
// //                                     "& .MuiDataGrid-columnHeaders": {
// //                                       backgroundColor: "#42b6f5", // Header background color
// //                                       color: "white", // Header text color
// //                                     },
// //                                     "& .MuiDataGrid-columnHeaderTitle": {
// //                                       color: "white", // Header title text color
// //                                     },
// //                                     "& .MuiDataGrid-cell": {
// //                                       whiteSpace: "normal", // Ensure text wraps inside the cell
// //                                       wordWrap: "break-word", // Break words to avoid overflow
// //                                       overflowWrap: "break-word", // Ensure long words wrap correctly
// //                                     },
// //                                   }}
// //                                 />
// //                               ) : (
// //                                 <div>No data found</div>
// //                               )}
// //                             </>
// //                           )}
// //                         </Grid>

// //                         {currentMap && (
// //                           <Grid item xs={12} sm={12} lg={12}>
// //                             <div
// //                               style={{
// //                                 border: "1px solid black",
// //                                 boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
// //                               }}
// //                             >
// //                               {/* <LoadScript googleMapsApiKey="AIzaSyDxp8MamOh_0gBNHBq4m3bgCIgksc4YYgQ"> */}
// //                               <GoogleMap
// //                                 mapContainerStyle={containerStyle}
// //                                 center={center}
// //                                 zoom={70} // Default zoom, will be adjusted by `fitBounds`
// //                                 onLoad={(map: any) => (mapRef.current = map)}
// //                               >
// //                                 {vehicles.map((vehicle: any, index: any) => (
// //                                   <Marker
// //                                     key={vehicle.id}
// //                                     position={{
// //                                       lat: vehicle.lat,
// //                                       lng: vehicle.lng,
// //                                     }}
// //                                     icon={{
// //                                       url: vehicle.icon,
// //                                       scaledSize: new window.google.maps.Size(
// //                                         50,
// //                                         50
// //                                       ),
// //                                       origin: new window.google.maps.Point(0, 0),
// //                                       anchor: new window.google.maps.Point(25, 25),
// //                                     }}

// //                                     label={{
// //                                       text: `${index + 1}`,
// //                                       fontSize: "14px",
// //                                       fontWeight: "bold",
// //                                       color: "#f73905",
// //                                       className: 'marker-label'
// //                                     }}
// //                                     onMouseOver={() =>
// //                                       handleMarkerMouseOver(vehicle)
// //                                     } // Show vehicle number on hover
// //                                     onMouseOut={handleMarkerMouseOut} // Hide info window on hover out
// //                                   >
// //                                     {activeVehicle &&
// //                                       activeVehicle.id === vehicle.id && (
// //                                         <InfoWindow>
// //                                           <div>
// //                                             <div>
// //                                               <strong>Speed: </strong>
// //                                               {vehicle.speed}
// //                                             </div>

// //                                             <div>
// //                                               <strong>Near By: </strong>
// //                                               {vehicle.nearme}
// //                                             </div>

// //                                             <div>
// //                                               <strong>Vehicle No: </strong>
// //                                               {vehicle.vehicleNo}
// //                                             </div>

// //                                             <div>
// //                                               <strong>Distance: </strong>
// //                                               {vehicle.distance}
// //                                             </div>

// //                                             <div>
// //                                               <strong>Date & Time: </strong>
// //                                               {vehicle.tracktime}
// //                                             </div>
// //                                           </div>
// //                                         </InfoWindow>
// //                                       )}
// //                                   </Marker>
// //                                 ))}

// //                                 <Polyline
// //                                   path={vehicles.map((vehicle: any) => ({ lat: vehicle.lat, lng: vehicle.lng }))}
// //                                   options={{
// //                                     strokeColor: "#6190c9",
// //                                     strokeOpacity: 1,
// //                                     strokeWeight: 3,

// //                                   }}
// //                                 />
// //                               </GoogleMap>
// //                               {/* </LoadScript> */}
// //                             </div>
// //                           </Grid>
// //                         )}
// //                       </Grid>
// //                     </AccordionDetails>
// //                   </Accordion>

// //                   <br />
// //                 </Grid>

// //                 <Grid xs={12} lg={6} sm={6} item style={{ marginBottom: "0px" }}>
// //                   <Accordion
// //                     expanded={accordionExpanded[3]}
// //                     onChange={(e, expended) => {
// //                       handleAccordionToggle(3, expended);
// //                       //fetchZonesData();
// //                     }}
// //                   >
// //                     <AccordionSummary
// //                       expandIcon={<ArrowDropDownIcon />}
// //                       aria-controls="panel2-content"
// //                       id="panel2-header"
// //                       // sx={{ background: "#7fd1eb", color: "black" }}
// //                       sx={{
// //                         background: "linear-gradient(to right, #ffffff,rgb(27, 174, 253))",
// //                       }}
// //                     >
// //                       <Typography style={{ fontWeight: 600, fontSize: "16px" }}>
// //                         Probable Wire Tempering
// //                       </Typography>
// //                     </AccordionSummary>
// //                     <AccordionDetails style={{ background: "#f2f8fa" }}>
// //                       <Grid
// //                         item
// //                         xs={12}
// //                         container
// //                         spacing={2}
// //                         sx={{ marginTop: "5px" }}
// //                       >
// //                         <Grid item xs={12} sm={12} lg={12}>
// //                           {isLoading ? (
// //                             <div
// //                               style={{
// //                                 display: "flex",
// //                                 justifyContent: "center",
// //                                 alignItems: "center",
// //                               }}
// //                             >
// //                               <CircularProgress />
// //                             </div>
// //                           ) : (
// //                             <>
// //                               {zones && zones.length > 0 ? (
// //                                 <DataGrid
// //                                   rows={zones}
// //                                   columns={adjustedColumns}
// //                                   rowSpacingType="border"
// //                                   autoHeight
// //                                   slots={{
// //                                     toolbar: GridToolbar,
// //                                   }}
// //                                   pageSizeOptions={[5, 10, 25, 50, 100].map(
// //                                     (size) => ({
// //                                       value: size,
// //                                       label: `${size}`,
// //                                     })
// //                                   )}
// //                                   initialState={{
// //                                     pagination: {
// //                                       paginationModel: { pageSize: 5 },
// //                                     },
// //                                   }}
// //                                   slotProps={{
// //                                     toolbar: {
// //                                       showQuickFilter: true,
// //                                     },
// //                                   }}
// //                                   sx={{
// //                                     border: 0,
// //                                     "& .MuiDataGrid-columnHeaders": {
// //                                       backgroundColor: "#42b6f5", // Header background color
// //                                       color: "white", // Header text color
// //                                     },
// //                                     "& .MuiDataGrid-columnHeaderTitle": {
// //                                       color: "white", // Header title text color
// //                                     },
// //                                   }}
// //                                 />
// //                               ) : (
// //                                 <div>No data found</div>
// //                               )}
// //                             </>
// //                           )}
// //                         </Grid>
// //                       </Grid>
// //                     </AccordionDetails>
// //                   </Accordion>
// //                   <br />
// //                 </Grid>

// //                 <Grid xs={12} lg={12} sm={12} item>
// //                   <Dialog
// //                     open={isModal}
// //                     onClose={handleClose}
// //                     fullWidth
// //                     maxWidth="lg"
// //                     sx={{
// //                       "& .MuiDialogContent-root": {
// //                         padding: "20px",
// //                         height: "400px",
// //                       },
// //                     }}
// //                   >
// //                     <DialogTitle
// //                       sx={{
// //                         display: "flex",
// //                         justifyContent: "space-between",
// //                         padding: "10px",
// //                         backgroundColor: `var(--grid-headerBackground)`,
// //                         color: `var(--grid-headerColor)`,
// //                       }}
// //                     >
// //                       <Typography variant="h6" style={{ color: "#ffff" }}>
// //                         Vehicle Status :{" "}
// //                         <span style={{ color: "#474d54", fontWeight: "bold" }}>
// //                           {isStatus1}
// //                         </span>
// //                       </Typography>
// //                       <IconButton
// //                         edge="end"
// //                         onClick={handleClose}
// //                         sx={{
// //                           color: `var(--grid-headerColor)`,
// //                         }}
// //                       >
// //                         <CloseIcon />
// //                       </IconButton>
// //                     </DialogTitle>
// //                     <DialogContent>
// //                       <Grid
// //                         item
// //                         xs={12}
// //                         container
// //                         spacing={2}
// //                         sx={{
// //                           padding: "20px",
// //                           height: "400px",
// //                           overflow: "hidden",
// //                         }}
// //                       >
// //                         <Grid item sm={12} lg={12} xs={12}>
// //                           {isLoading4 ? (
// //                             <div
// //                               style={{
// //                                 display: "flex",
// //                                 justifyContent: "center",
// //                                 alignItems: "center",
// //                               }}
// //                             >
// //                               <CircularProgress />
// //                             </div>
// //                           ) : (
// //                             <>
// //                               {zones4 && zones4.length > 0 ? (
// //                                 <DataGrid
// //                                   rows={zones4}
// //                                   columns={adjustedColumns4}
// //                                   rowSpacingType="border"
// //                                   //autoHeight
// //                                   // checkboxSelection
// //                                   slots={{
// //                                     toolbar: GridToolbar,
// //                                   }}

// //                                   slotProps={{
// //                                     toolbar: {
// //                                       showQuickFilter: true,
// //                                     },
// //                                   }}

// //                                   autoHeight={false}
// //                                   sx={{
// //                                     border: 0,
// //                                     "& .MuiDataGrid-columnHeaders": {
// //                                       backgroundColor: `var(--grid-headerBackground)`,
// //                                       color: `var(--grid-headerColor)`,
// //                                       position: "sticky",
// //                                       top: 0,
// //                                       zIndex: 1,
// //                                     },
// //                                     "& .MuiDataGrid-columnHeaderTitle": {
// //                                       color: "white",
// //                                     },
// //                                     "& .MuiDataGrid-cell": {
// //                                       whiteSpace: "normal",
// //                                       wordWrap: "break-word",
// //                                       overflowWrap: "break-word",
// //                                     },
// //                                     height: 400,
// //                                     overflowY: "auto",
// //                                   }}
// //                                 />
// //                               ) : (
// //                                 <div>No data found</div>
// //                               )}
// //                             </>
// //                           )}
// //                         </Grid>
// //                       </Grid>
// //                     </DialogContent>
// //                   </Dialog>
// //                 </Grid>

// //                 <Grid xs={12} lg={12} sm={12} item>
// //                   <Dialog
// //                     open={isModal1}
// //                     onClose={handleClose1}
// //                     fullWidth
// //                     maxWidth="lg"
// //                     sx={{
// //                       "& .MuiDialogContent-root": {
// //                         padding: "20px",
// //                         height: "400px",
// //                       },
// //                     }}
// //                   >
// //                     <DialogTitle
// //                       sx={{
// //                         display: "flex",
// //                         justifyContent: "space-between",
// //                         padding: "10px",
// //                         backgroundColor: `var(--grid-headerBackground)`,
// //                         color: `var(--grid-headerColor)`,
// //                       }}
// //                     >
// //                       <Typography variant="h6" style={{ color: "#ffff" }}>
// //                         Vehicle Ignition :{" "}
// //                         <span style={{ color: "#474d54", fontWeight: "bold" }}>
// //                           {isStatus}
// //                         </span>
// //                       </Typography>
// //                       <IconButton
// //                         edge="end"
// //                         onClick={handleClose1}
// //                         sx={{
// //                           color: `var(--grid-headerColor)`,
// //                         }}
// //                       >
// //                         <CloseIcon />
// //                       </IconButton>
// //                     </DialogTitle>
// //                     <DialogContent>
// //                       <Grid
// //                         item
// //                         xs={12}
// //                         container
// //                         spacing={2}
// //                         sx={{
// //                           padding: "20px",
// //                           height: "400px",
// //                           overflow: "hidden",
// //                         }}
// //                       >
// //                         <Grid item sm={12} lg={12} xs={12}>
// //                           {isLoading5 ? (
// //                             <div
// //                               style={{
// //                                 display: "flex",
// //                                 justifyContent: "center",
// //                                 alignItems: "center",
// //                               }}
// //                             >
// //                               <CircularProgress />
// //                             </div>
// //                           ) : (
// //                             <>
// //                               {zones5 && zones5.length > 0 ? (
// //                                 <DataGrid
// //                                   rows={zones5}
// //                                   columns={adjustedColumns5}
// //                                   rowSpacingType="border"
// //                                   // autoHeight
// //                                   // checkboxSelection

// //                                   slots={{
// //                                     toolbar: GridToolbar,
// //                                   }}


// //                                   slotProps={{
// //                                     toolbar: {
// //                                       showQuickFilter: true,
// //                                     },
// //                                   }}

// //                                   autoHeight={false}
// //                                   sx={{
// //                                     border: 0,
// //                                     "& .MuiDataGrid-columnHeaders": {
// //                                       backgroundColor: `var(--grid-headerBackground)`,
// //                                       color: `var(--grid-headerColor)`,
// //                                       position: "sticky",
// //                                       top: 0,
// //                                       zIndex: 1,
// //                                     },
// //                                     "& .MuiDataGrid-columnHeaderTitle": {
// //                                       color: "white",
// //                                     },
// //                                     "& .MuiDataGrid-cell": {
// //                                       whiteSpace: "normal",
// //                                       wordWrap: "break-word",
// //                                       overflowWrap: "break-word",
// //                                     },
// //                                     height: 400,
// //                                     overflowY: "auto",
// //                                   }} />
// //                               ) : (
// //                                 <div>No data found</div> // Message when no data is present
// //                               )}
// //                             </>
// //                           )}
// //                         </Grid>
// //                       </Grid>
// //                     </DialogContent>
// //                   </Dialog>
// //                 </Grid>

// //                 <Grid xs={12} lg={12} sm={12} item>
// //                   <Dialog
// //                     open={isVisible}
// //                     onClose={handleClose2}
// //                     fullWidth
// //                     maxWidth="lg"
// //                     sx={{
// //                       "& .MuiDialogContent-root": {
// //                         padding: "20px",
// //                         height: "400px",
// //                       },
// //                     }}
// //                   >
// //                     <DialogTitle
// //                       sx={{
// //                         display: "flex",
// //                         justifyContent: "space-between",
// //                         padding: "10px",
// //                         backgroundColor: `var(--grid-headerBackground)`,
// //                         color: `var(--grid-headerColor)`,
// //                       }}
// //                     >
// //                       <Typography variant="h6" style={{ color: "#ffff" }}>
// //                         <span style={{ color: "#474d54", fontWeight: "bold" }}>
// //                           {isLabel}
// //                         </span>
// //                       </Typography>
// //                       <IconButton
// //                         edge="end"
// //                         onClick={handleClose2}
// //                         sx={{
// //                           color: `var(--grid-headerColor)`,
// //                         }}
// //                       >
// //                         <CloseIcon />
// //                       </IconButton>
// //                     </DialogTitle>
// //                     <DialogContent>
// //                       <Grid
// //                         item
// //                         xs={12}
// //                         container
// //                         spacing={2}

// //                         sx={{
// //                           padding: "20px",
// //                           height: "400px",
// //                           overflow: "hidden",
// //                         }}
// //                       //sx={{ marginTop: "2%" }}
// //                       >
// //                         <Grid item sm={12} lg={12} xs={12}>
// //                           {isLoading9 ? (
// //                             <div
// //                               style={{
// //                                 display: "flex",
// //                                 justifyContent: "center",
// //                                 alignItems: "center",
// //                               }}
// //                             >
// //                               <CircularProgress />
// //                             </div>
// //                           ) : (
// //                             <>
// //                               {zones9 && zones9.length > 0 ? (
// //                                 <DataGrid
// //                                   rows={zones9}
// //                                   columns={adjustedColumns10}
// //                                   rowSpacingType="border"
// //                                   // autoHeight
// //                                   // checkboxSelection

// //                                   slots={{
// //                                     toolbar: GridToolbar,
// //                                   }}


// //                                   slotProps={{
// //                                     toolbar: {
// //                                       showQuickFilter: true,
// //                                     },
// //                                   }}

// //                                   autoHeight={false}
// //                                   sx={{
// //                                     border: 0,
// //                                     "& .MuiDataGrid-columnHeaders": {
// //                                       backgroundColor: `var(--grid-headerBackground)`,
// //                                       color: `var(--grid-headerColor)`,
// //                                       position: "sticky",
// //                                       top: 0,
// //                                       zIndex: 1,
// //                                     },
// //                                     "& .MuiDataGrid-columnHeaderTitle": {
// //                                       color: "white",
// //                                     },
// //                                     "& .MuiDataGrid-cell": {
// //                                       whiteSpace: "normal",
// //                                       wordWrap: "break-word",
// //                                       overflowWrap: "break-word",
// //                                     },
// //                                     height: 400,
// //                                     overflowY: "auto",
// //                                   }}
// //                                 />
// //                               ) : (
// //                                 <div>No data found</div> // Message when no data is present
// //                               )}
// //                             </>
// //                           )}
// //                         </Grid>
// //                       </Grid>
// //                     </DialogContent>
// //                   </Dialog>
// //                 </Grid>

// //                 {/* <Grid xs={12} lg={12} sm={12} item>
// //               <VehicleComponent
// //                 open={vehicleDrawer}
// //                 onClose={() => {
// //                   setVehicleDrawer(false);
// //                 }}
// //                 itemId={itemId}
// //               />
// //             </Grid> */}
// //               </Grid>
// //             </div>
// //           )}

// //           {value === 1 && <Tracking />}
// //           {value === 2 && <Geofacing />}
// //           {value === 3 && <Kudaghar />}
// //           {value === 4 && <VehicleHistory />}
// //           {value === 5 && <VehicleTravelled />}
// //         </CardContent>
// //       </div>
// //     </div>
// //   );
// // }
